
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bkD6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $236c4035c385328a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lf2Au = parcelRequire("lf2Au");

var $97Kan = parcelRequire("97Kan");

var $cNtP3 = parcelRequire("cNtP3");


var $iXVV6 = parcelRequire("iXVV6");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $kF1SN = parcelRequire("kF1SN");

var $1HPno = parcelRequire("1HPno");

var $i7Vrl = parcelRequire("i7Vrl");

var $cOeC9 = parcelRequire("cOeC9");

var $bF6vO = parcelRequire("bF6vO");

var $3XoQX = parcelRequire("3XoQX");

var $byz9x = parcelRequire("byz9x");

var $dvqTC = parcelRequire("dvqTC");

var $5otrc = parcelRequire("5otrc");
const $236c4035c385328a$var$ChildIssuesPanelBaseOld = (props)=>{
    const { associatedIssuesContextActions: associatedIssuesContextActions, appEditions: appEditions, baseUrl: baseUrl, childIssuesPanelType: childIssuesPanelType, customFieldIdRank: customFieldIdRank, epicLinkFieldKey: epicLinkFieldKey, fetchIssueTypesStatus: fetchIssueTypesStatus, fieldConfigActions: fieldConfigActions, fieldValuesActions: fieldValuesActions, filterSubtasks: filterSubtasks, isIssueViewComplete: isIssueViewComplete = false, isSimplifiedProject: isSimplifiedProject, issueHierarchyLevel: issueHierarchyLevel, issues: issues = [], issueTypes: issueTypes = [], locale: locale, messages: messages, onChange: onChange, onEditAssociatedIssue: onEditAssociatedIssue, onNavigateToNewIssue: onNavigateToNewIssue, parentId: parentId, parentIssueTypeId: parentIssueTypeId, parentKey: parentKey, projectId: projectId, projectType: projectType, quickAddClickCount: quickAddClickCount, supportsIssueCreation: supportsIssueCreation, triggeredViaHotKey: triggeredViaHotKey, user: user } = props;
    const store = (0, $5uXOq.useMemo)(()=>{
        return (0, $byz9x.default)((0, $cOeC9.default)(associatedIssuesContextActions, fieldValuesActions, fieldConfigActions), parentKey, childIssuesPanelType);
    }, [
        associatedIssuesContextActions,
        childIssuesPanelType,
        fieldConfigActions,
        fieldValuesActions,
        parentKey
    ]);
    const hasMounted = (0, $5uXOq.useRef)(false);
    const prevQuickAddClickCount = (0, $5uXOq.useRef)(quickAddClickCount);
    (0, $5uXOq.useEffect)(()=>{
        // Prevent concurrent mode rerunning this useEffect and making multiple api calls
        if (hasMounted.current) return;
        // TODO: Remove on cleanup of jira-issue-view-child-issues-panel-performance
        const oldContext = {
            baseUrl: baseUrl,
            locale: locale,
            user: user,
            projectId: projectId,
            parentId: parentId,
            parentKey: parentKey,
            parentIssueTypeId: parentIssueTypeId,
            customFieldIdRank: customFieldIdRank,
            epicLinkFieldKey: epicLinkFieldKey,
            supportsIssueCreation: supportsIssueCreation,
            messages: messages,
            onNavigateToNewIssue: onNavigateToNewIssue,
            onChange: onChange,
            childIssuesPanelType: childIssuesPanelType,
            isIssueViewComplete: isIssueViewComplete,
            projectType: projectType,
            application: projectType !== null ? (0, $efvDm.getApplicationForProject)(projectType) : null,
            edition: projectType !== null ? (0, $ldyPw.getEdition)((0, $efvDm.getApplicationForProject)(projectType), appEditions) : null,
            // Optimistically assume full create not needed
            requiresFullCreate: false,
            filterSubtasks: // TODO: Remove on jira-issue-view-child-issues-panel-merge-subtasks cleanup
            filterSubtasks,
            // if the endpoint doesn't return data quick enough, optimistically assume full create not needed
            requiresFullCreateByIssueType: {},
            onEditAssociatedIssue: onEditAssociatedIssue,
            isSimplifiedProject: isSimplifiedProject
        };
        const newContext = {
            baseUrl: baseUrl,
            user: user,
            projectId: projectId,
            parentId: parentId,
            parentKey: parentKey,
            parentIssueTypeId: parentIssueTypeId,
            epicLinkFieldKey: epicLinkFieldKey,
            supportsIssueCreation: supportsIssueCreation,
            messages: messages,
            onChange: onChange,
            childIssuesPanelType: childIssuesPanelType,
            projectType: projectType,
            application: projectType !== null ? (0, $efvDm.getApplicationForProject)(projectType) : null,
            edition: projectType !== null ? (0, $ldyPw.getEdition)((0, $efvDm.getApplicationForProject)(projectType), appEditions) : null,
            // Optimistically assume full create not needed
            requiresFullCreate: false,
            filterSubtasks: // TODO: Remove on jira-issue-view-child-issues-panel-merge-subtasks cleanup
            filterSubtasks,
            // if the endpoint doesn't return data quick enough, optimistically assume full create not needed
            requiresFullCreateByIssueType: {},
            isSimplifiedProject: isSimplifiedProject
        };
        const context = (0, $4R6GH.fg)('jira-issue-view-child-issues-panel-performance') ? newContext : oldContext;
        store.dispatch((0, $bF6vO.setContext)(context));
        store.dispatch((0, $bF6vO.requiresFullCreateCheckRequest)());
        store.dispatch((0, $3XoQX.setEntities)({
            issueTypes: issueTypes.map((issueType)=>(0, $1HPno.transformIssueType)(issueType, epicLinkFieldKey)),
            issues: issues,
            issueHierarchyLevel: issueHierarchyLevel
        }));
        if (childIssuesPanelType !== (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS && issues.length > 0) store.dispatch((0, $3XoQX.fetchDetailsForIssuesRequest)());
        if (fetchIssueTypesStatus) store.dispatch((0, $dvqTC.setFetchIssueTypesStatus)(fetchIssueTypesStatus));
        if (quickAddClickCount > 0) {
            if ((0, $6s1PB.expVal)('quick_actions_m3_experiment', 'hotKeysEnabled', false)) store.dispatch((0, $dvqTC.showInlineCreate)({
                triggeredViaHotKey: triggeredViaHotKey
            }));
            else store.dispatch((0, $dvqTC.showInlineCreate)());
        }
        hasMounted.current = true;
    }, [
        appEditions,
        baseUrl,
        childIssuesPanelType,
        customFieldIdRank,
        epicLinkFieldKey,
        fetchIssueTypesStatus,
        filterSubtasks,
        isIssueViewComplete,
        isSimplifiedProject,
        issueHierarchyLevel,
        issueTypes,
        issues,
        locale,
        messages,
        onChange,
        onEditAssociatedIssue,
        onNavigateToNewIssue,
        parentId,
        parentIssueTypeId,
        parentKey,
        projectId,
        projectType,
        props.appEditions,
        quickAddClickCount,
        store,
        supportsIssueCreation,
        triggeredViaHotKey,
        user
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (quickAddClickCount > prevQuickAddClickCount.current) {
            if ((0, $6s1PB.expVal)('quick_actions_m3_experiment', 'hotKeysEnabled', false)) store.dispatch((0, $dvqTC.showInlineCreate)({
                triggeredViaHotKey: triggeredViaHotKey
            }));
            else store.dispatch((0, $dvqTC.showInlineCreate)());
        }
        prevQuickAddClickCount.current = quickAddClickCount;
    }, [
        quickAddClickCount,
        triggeredViaHotKey,
        store,
        props
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (fetchIssueTypesStatus) store.dispatch((0, $dvqTC.setFetchIssueTypesStatus)(fetchIssueTypesStatus || (0, $d938a6f4f1d90c4d$export$e0428a74c92c3e81)));
    }, [
        fetchIssueTypesStatus,
        store
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (onChange) store.dispatch((0, $bF6vO.setOnChange)(onChange));
    }, [
        onChange,
        store
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (issues.length || fetchIssueTypesStatus) store.dispatch((0, $3XoQX.setEntities)({
            issueTypes: issueTypes.map((issueType)=>(0, $1HPno.transformIssueType)(issueType, epicLinkFieldKey)),
            issues: issues,
            issueHierarchyLevel: issueHierarchyLevel
        }));
    }, [
        issues,
        fetchIssueTypesStatus,
        issueTypes,
        epicLinkFieldKey,
        issueHierarchyLevel,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNtP3.default), {
        store: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "childIssuesPanel",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            childIssuesPanelType: childIssuesPanelType,
            issueHierarchyLevel: issueHierarchyLevel - 1,
            analyticsSource: `issue-view (${props.analyticsSource})`,
            location: 'jiraChildIssues'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5otrc.default), {
        // @ts-expect-error - onAddChildClick is AddChildEventHandler | undefined
        onAddChildClick: props.onAddChildClick,
        onIssueBreakdownClick: props.onIssueBreakdownClick,
        sourceName: "childIssuesPanel",
        childIssuesLimitUrl: props.childIssuesLimitUrl,
        hasExceededIssuesLimitAfterLoad: props.hasExceededIssuesLimitAfterLoad,
        totalChildIssueCount: props.totalChildIssueCount,
        issueCreateSessionId: props.issueCreateSessionId,
        rootRelayFragment: props.rootRelayFragment,
        hasMultipleChildPanels: props.hasMultipleChildPanels
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97Kan.FlagsDispatcher), {
        mapper: (0, $i7Vrl.default)
    }))));
};
var $236c4035c385328a$export$2e2bcd8739ae039 = $236c4035c385328a$var$ChildIssuesPanelBaseOld;

});
parcelRegister("97Kan", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $4ddeb9f500a62e17$export$9e60e3d40b6e758f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fpHHI = parcelRequire("fpHHI");
const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpHHI.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $pa9q9.showFlag),
        dismissFlag: (0, $pa9q9.dismissFlag)
    });

});
parcelRegister("fpHHI", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $eef6139685bfb64e$export$ab054a1ef92eeb01);

var $5uXOq = parcelRequire("5uXOq");

var $1kijq = parcelRequire("1kijq");
const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, $1kijq.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("1kijq", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $c324e875f8c6fe8f$export$7b259d28468da15b);

var $5uXOq = parcelRequire("5uXOq");

var $kVVL1 = parcelRequire("kVVL1");

var $pa9q9 = parcelRequire("pa9q9");
const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $pa9q9.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $pa9q9.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $pa9q9.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $kVVL1.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
};

});



const $d938a6f4f1d90c4d$export$e0428a74c92c3e81 = 'NONE';
const $d938a6f4f1d90c4d$export$a2494662262ff756 = 'PENDING';
const $d938a6f4f1d90c4d$export$1e006e11f4ec3452 = 'COMPLETE';
const $d938a6f4f1d90c4d$export$47b522ce8df73846 = 'FAILED';

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("1HPno", function(module, exports) {

$parcel$export(module.exports, "transformIssueType", () => $5c2827aaa0d83be3$export$96520244689f81c1);
// for the creation of an issue, but are considered as 'provided' since
// the data for these fields is supplied by Jira.
const $5c2827aaa0d83be3$var$providedRequiredFields = [
    'summary',
    'issuetype',
    'parent',
    'project'
];
const $5c2827aaa0d83be3$var$isRequiredFieldProvided = (fieldName)=>$5c2827aaa0d83be3$var$providedRequiredFields.find((providedFieldName)=>fieldName === providedFieldName);
const $5c2827aaa0d83be3$var$listUnsupportedRequiredFields = (fields)=>{
    const unsupportedRequiredFields = [];
    Object.keys(fields).forEach((fieldName)=>{
        if (!$5c2827aaa0d83be3$var$isRequiredFieldProvided(fieldName) && !fields[fieldName].hasDefaultValue && fields[fieldName].required) unsupportedRequiredFields.push(fieldName);
    });
    return unsupportedRequiredFields;
};
const $5c2827aaa0d83be3$export$96520244689f81c1 = (issueType, epicLinkFieldKey)=>{
    const { fields: fields, ...otherProps } = issueType;
    const requiredFields = fields ? $5c2827aaa0d83be3$var$listUnsupportedRequiredFields(fields) : [];
    // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    const hasEpicLinkField = fields ? Object.keys(fields).includes(epicLinkFieldKey) : false;
    return {
        ...otherProps,
        hasRequiredField: requiredFields.length > 0,
        hasEpicLinkField: hasEpicLinkField,
        requiredFields: requiredFields
    };
};

});

parcelRegister("i7Vrl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b62702a5ea17d78$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $7aTeE = parcelRequire("7aTeE");

var $3XoQX = parcelRequire("3XoQX");

var $cXGkG = parcelRequire("cXGkG");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b62702a5ea17d78$export$2e2bcd8739ae039 = (action)=>{
    switch(action.type){
        case 0, $3XoQX.LINK_PARENT_FAILURE:
            return {
                messageId: 'issue-view-common-views.child-issues-panel.flags.flag.error.link-parent-error',
                messageType: 'transactional',
                type: 'error',
                title: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cXGkG.default).linkParentErrorTitleIssueTermRefresh : (0, $cXGkG.default).linkParentErrorTitle,
                description: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cXGkG.default).linkParentErrorDescriptionIssueTermRefresh : (0, $cXGkG.default).linkParentErrorDescription
            };
        case 0, $3XoQX.REORDER_CHILDREN_FAILED:
            return {
                messageId: 'issue-view-common-views.child-issues-panel.flags.flag.error.reorder-error',
                messageType: 'transactional',
                type: 'error',
                title: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7aTeE.default).reorderErrorTitleIssueTermRefresh : (0, $7aTeE.default).reorderErrorTitle,
                description: (0, $7aTeE.default).reorderErrorDescription
            };
        default:
            return undefined;
    }
};

});
parcelRegister("7aTeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $30769a6fd34d9795$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $30769a6fd34d9795$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    configureColumnsErrorTitle: {
        "id": "issue-view-child-issues-panel.common.flags.configure-columns-error-title",
        "defaultMessage": "We couldn't configure the columns"
    },
    columnConfigMutationErrorDescription: {
        "id": "issue-view-child-issues-panel.common.flags.column-config-mutation-error-description",
        "defaultMessage": "Refresh and try again."
    },
    columnResizeMutationErrorTitle: {
        "id": "issue-view-child-issues-panel.common.flags.column-resize-mutation-error-title",
        "defaultMessage": "We couldn't resize the column"
    },
    columnResizeMutationErrorDescription: {
        "id": "issue-view-child-issues-panel.common.flags.column-resize-mutation-error-description",
        "defaultMessage": "Refresh and try again."
    },
    reorderErrorTitle: {
        "id": "issue-view-child-issues-panel.common.flags.reorder-error-title",
        "defaultMessage": "We couldn't reorder those issues"
    },
    reorderErrorDescription: {
        "id": "issue-view-child-issues-panel.common.flags.reorder-error-description",
        "defaultMessage": "Wait a few moments, then give it another try."
    },
    reorderErrorTitleIssueTermRefresh: {
        "id": "issue-view-child-issues-panel.common.flags.reorder-error-title-issue-term-refresh",
        "defaultMessage": "We couldn't reorder those work items"
    }
});

});

parcelRegister("3XoQX", function(module, exports) {

$parcel$export(module.exports, "SET_ENTITIES", () => $e6a5e5655c384a33$export$6ff5c7e9ad238d7b);
$parcel$export(module.exports, "setEntities", () => $e6a5e5655c384a33$export$3a3eaaf831701b06);
$parcel$export(module.exports, "UPDATE_ISSUE", () => $e6a5e5655c384a33$export$d46fd8e9a2a59b28);
$parcel$export(module.exports, "updateIssue", () => $e6a5e5655c384a33$export$3bcffab6dd70dbbc);
$parcel$export(module.exports, "CREATE_CHILD_REQUEST", () => $e6a5e5655c384a33$export$cde178fa0b730257);
$parcel$export(module.exports, "createChildRequest", () => $e6a5e5655c384a33$export$56a83114eed61301);
$parcel$export(module.exports, "CREATE_CHILD_SUCCESS", () => $e6a5e5655c384a33$export$6bf3907f9509f743);
$parcel$export(module.exports, "createChildSuccess", () => $e6a5e5655c384a33$export$6ac0f43016450864);
$parcel$export(module.exports, "CREATE_CHILD_FAILURE", () => $e6a5e5655c384a33$export$3774a7672ce38a05);
$parcel$export(module.exports, "createChildFailure", () => $e6a5e5655c384a33$export$d4cd431dc26e3c12);
$parcel$export(module.exports, "LINK_CHILD_SUCCESS", () => $e6a5e5655c384a33$export$b40dd0be7a77f0f3);
$parcel$export(module.exports, "linkChildSuccess", () => $e6a5e5655c384a33$export$ded81828ca52473a);
$parcel$export(module.exports, "LINKING_ISSUE_FAILURE", () => $e6a5e5655c384a33$export$47c6dfa79c4061d8);
$parcel$export(module.exports, "LINKING_ISSUE_RETRY", () => $e6a5e5655c384a33$export$fd85926d413f992b);
$parcel$export(module.exports, "linkingIssueRetry", () => $e6a5e5655c384a33$export$ca92b776109d5e7d);
$parcel$export(module.exports, "LINKING_ISSUE_RETRY_FAILURE", () => $e6a5e5655c384a33$export$c33db15c3b1ab3fb);
$parcel$export(module.exports, "linkingIssueRetryFailure", () => $e6a5e5655c384a33$export$a0e1af024aeb6d77);
$parcel$export(module.exports, "CREATE_CHILD_RETRY", () => $e6a5e5655c384a33$export$5e3fc100fb741cb0);
$parcel$export(module.exports, "createChildRetry", () => $e6a5e5655c384a33$export$8d4df1d2707a600b);
$parcel$export(module.exports, "LINK_PARENT_FAILURE", () => $e6a5e5655c384a33$export$4bfb333b7484411e);
$parcel$export(module.exports, "linkParentFailure", () => $e6a5e5655c384a33$export$911b287d4216522e);
$parcel$export(module.exports, "CHILD_CREATED_IN_FULL_DIALOG", () => $e6a5e5655c384a33$export$a9a4c75ff8c87ff1);
$parcel$export(module.exports, "childCreatedInFullDialog", () => $e6a5e5655c384a33$export$7cc6e2003a15927);
$parcel$export(module.exports, "FETCH_SINGLE_CHILD_SUCCESS", () => $e6a5e5655c384a33$export$e01e2ee4c55a60c2);
$parcel$export(module.exports, "fetchSingleChildSuccess", () => $e6a5e5655c384a33$export$da5e1a7189ae4b18);
$parcel$export(module.exports, "FETCH_GRAPHQL_ISSUE_SUCCESS", () => $e6a5e5655c384a33$export$2591bae714c7bcfa);
$parcel$export(module.exports, "fetchGraphqlIssueSuccess", () => $e6a5e5655c384a33$export$cf34d76a5f5f76c3);
$parcel$export(module.exports, "CANCEL_OPTIMISTIC_CHILD", () => $e6a5e5655c384a33$export$7ba41b0f859cd9de);
$parcel$export(module.exports, "cancelOptimisticChild", () => $e6a5e5655c384a33$export$98d5ec7cac55724a);
$parcel$export(module.exports, "FETCH_DETAILS_FOR_ISSUES_REQUEST", () => $e6a5e5655c384a33$export$c81d530f36bbff54);
$parcel$export(module.exports, "fetchDetailsForIssuesRequest", () => $e6a5e5655c384a33$export$d7bd258f937d3f97);
$parcel$export(module.exports, "FETCH_DETAILS_FOR_ISSUES_SUCCESS", () => $e6a5e5655c384a33$export$f06e411231cc9e0f);
$parcel$export(module.exports, "fetchDetailsForIssuesSuccess", () => $e6a5e5655c384a33$export$f8212515c1fa259b);
$parcel$export(module.exports, "REORDER_CHILDREN_REQUEST", () => $e6a5e5655c384a33$export$1ad8075453e254e8);
$parcel$export(module.exports, "reorderChildrenRequest", () => $e6a5e5655c384a33$export$956b72f97bc996b2);
$parcel$export(module.exports, "REORDER_CHILDREN_FAILED", () => $e6a5e5655c384a33$export$90fd6e557d95c194);
$parcel$export(module.exports, "reorderChildrenFailed", () => $e6a5e5655c384a33$export$7b24762ac1cea786);
$parcel$export(module.exports, "REORDER_CHILDREN_SUCCESS", () => $e6a5e5655c384a33$export$114e6969a338330e);
$parcel$export(module.exports, "reorderChildrenSuccess", () => $e6a5e5655c384a33$export$e3b2b5621f591898);
$parcel$export(module.exports, "ADD_EXISTING_CHILD_ISSUE_REQUEST", () => $e6a5e5655c384a33$export$5998f11ce66975f8);
$parcel$export(module.exports, "addExistingChildIssueRequest", () => $e6a5e5655c384a33$export$3cd83357f07e71c2);
const $e6a5e5655c384a33$export$6ff5c7e9ad238d7b = 'state.entities.SET_ENTITIES';
const $e6a5e5655c384a33$export$3a3eaaf831701b06 = (payload)=>({
        type: $e6a5e5655c384a33$export$6ff5c7e9ad238d7b,
        payload: payload
    });
const $e6a5e5655c384a33$export$d46fd8e9a2a59b28 = 'state.entities.UPDATE_ISSUE';
const $e6a5e5655c384a33$export$3bcffab6dd70dbbc = (payload)=>({
        type: $e6a5e5655c384a33$export$d46fd8e9a2a59b28,
        payload: payload
    });
const $e6a5e5655c384a33$export$cde178fa0b730257 = 'state.entities.CREATE_CHILD_REQUEST';
const $e6a5e5655c384a33$export$56a83114eed61301 = (optimisticUiChildIssue, analyticsEvent, additionalAttributes = {})=>({
        type: $e6a5e5655c384a33$export$cde178fa0b730257,
        payload: {
            optimisticUiChildIssue: optimisticUiChildIssue
        },
        meta: {
            analyticsEvent: analyticsEvent,
            additionalAttributes: additionalAttributes
        }
    });
const $e6a5e5655c384a33$export$6bf3907f9509f743 = 'state.entities.CREATE_CHILD_SUCCESS';
const $e6a5e5655c384a33$export$6ac0f43016450864 = (optimisticId, createdChild, analyticsEvent, usedGlobalCreateDialog = false, additionalAttributes = {})=>({
        type: $e6a5e5655c384a33$export$6bf3907f9509f743,
        payload: {
            optimisticId: optimisticId,
            createdChild: createdChild,
            usedGlobalCreateDialog: usedGlobalCreateDialog
        },
        meta: {
            analyticsEvent: analyticsEvent,
            additionalAttributes: additionalAttributes
        }
    });
const $e6a5e5655c384a33$export$3774a7672ce38a05 = 'state.entities.CREATE_CHILD_FAILURE';
const $e6a5e5655c384a33$export$d4cd431dc26e3c12 = (optimisticId, error)=>({
        type: $e6a5e5655c384a33$export$3774a7672ce38a05,
        payload: {
            optimisticId: optimisticId,
            error: error
        }
    });
const $e6a5e5655c384a33$export$b40dd0be7a77f0f3 = 'state.entities.LINK_CHILD_SUCCESS';
const $e6a5e5655c384a33$export$ded81828ca52473a = (issueId, linkedChild, analyticsEvent)=>({
        type: $e6a5e5655c384a33$export$b40dd0be7a77f0f3,
        payload: {
            issueId: issueId,
            linkedChild: linkedChild
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $e6a5e5655c384a33$export$47c6dfa79c4061d8 = 'state.entities.LINKING_ISSUE_FAILURE';
const $e6a5e5655c384a33$export$6d095d2c37bf917c = (createdChild, optimisticId, error)=>({
        type: $e6a5e5655c384a33$export$47c6dfa79c4061d8,
        payload: {
            createdChild: createdChild,
            optimisticId: optimisticId,
            error: error
        }
    });
const $e6a5e5655c384a33$export$fd85926d413f992b = 'state.entities.LINKING_ISSUE_RETRY';
const $e6a5e5655c384a33$export$ca92b776109d5e7d = (issueId, analyticsEvent)=>({
        type: $e6a5e5655c384a33$export$fd85926d413f992b,
        payload: {
            issueId: issueId
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $e6a5e5655c384a33$export$c33db15c3b1ab3fb = 'state.entities.LINKING_ISSUE_RETRY_FAILURE';
const $e6a5e5655c384a33$export$a0e1af024aeb6d77 = (issueId)=>({
        type: $e6a5e5655c384a33$export$c33db15c3b1ab3fb,
        payload: {
            issueId: issueId
        }
    });
const $e6a5e5655c384a33$export$5e3fc100fb741cb0 = 'state.entities.CREATE_CHILD_RETRY';
const $e6a5e5655c384a33$export$8d4df1d2707a600b = (optimisticId, analyticsEvent)=>({
        type: $e6a5e5655c384a33$export$5e3fc100fb741cb0,
        payload: {
            optimisticId: optimisticId
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $e6a5e5655c384a33$export$4bfb333b7484411e = 'state.entities.LINK_PARENT_FAILURE';
const $e6a5e5655c384a33$export$911b287d4216522e = (optimisticId, error)=>({
        type: $e6a5e5655c384a33$export$4bfb333b7484411e,
        payload: {
            optimisticId: optimisticId,
            error: error
        }
    });
const $e6a5e5655c384a33$export$a9a4c75ff8c87ff1 = 'state.entities.CHILD_CREATED_IN_FULL_DIALOG';
const $e6a5e5655c384a33$export$7cc6e2003a15927 = (optimisticId, createdChild, analyticsEvent, additionalAttributes = {})=>({
        type: $e6a5e5655c384a33$export$a9a4c75ff8c87ff1,
        payload: {
            optimisticId: optimisticId,
            createdChild: createdChild
        },
        meta: {
            analyticsEvent: analyticsEvent,
            additionalAttributes: additionalAttributes
        }
    });
const $e6a5e5655c384a33$export$e01e2ee4c55a60c2 = 'state.entities.FETCH_SINGLE_CHILD_SUCCESS';
const $e6a5e5655c384a33$export$da5e1a7189ae4b18 = (childIssue)=>({
        type: $e6a5e5655c384a33$export$e01e2ee4c55a60c2,
        payload: {
            childIssue: childIssue
        }
    });
const $e6a5e5655c384a33$export$2591bae714c7bcfa = 'state.entities.FETCH_GRAPHQL_ISSUE_SUCCESS';
const $e6a5e5655c384a33$export$cf34d76a5f5f76c3 = (payload)=>({
        type: $e6a5e5655c384a33$export$2591bae714c7bcfa,
        payload: payload
    });
const $e6a5e5655c384a33$export$7ba41b0f859cd9de = 'state.entities.CANCEL_OPTIMISTIC_CHILD';
const $e6a5e5655c384a33$export$98d5ec7cac55724a = (optimisticId)=>({
        type: $e6a5e5655c384a33$export$7ba41b0f859cd9de,
        payload: {
            optimisticId: optimisticId
        }
    });
const $e6a5e5655c384a33$export$c81d530f36bbff54 = 'state.entities.FETCH_DETAILS_FOR_ISSUES_REQUEST';
const $e6a5e5655c384a33$export$d7bd258f937d3f97 = ()=>({
        type: $e6a5e5655c384a33$export$c81d530f36bbff54
    });
const $e6a5e5655c384a33$export$f06e411231cc9e0f = 'state.entities.FETCH_DETAILS_FOR_ISSUES_SUCCESS';
const $e6a5e5655c384a33$export$f8212515c1fa259b = (issues)=>({
        type: $e6a5e5655c384a33$export$f06e411231cc9e0f,
        payload: {
            issues: issues
        }
    });
const $e6a5e5655c384a33$export$1ad8075453e254e8 = 'state.entities.REORDER_CHILDREN_REQUEST';
const $e6a5e5655c384a33$export$956b72f97bc996b2 = (currentOrder, newOrder, currentIndex, newIndex, analyticsEvent)=>({
        type: $e6a5e5655c384a33$export$1ad8075453e254e8,
        payload: {
            currentOrder: currentOrder,
            newOrder: newOrder,
            currentIndex: currentIndex,
            newIndex: newIndex
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $e6a5e5655c384a33$export$90fd6e557d95c194 = 'state.entities.REORDER_CHILDREN_FAILED';
const $e6a5e5655c384a33$export$7b24762ac1cea786 = (originalOrder, newOrder, originalIndex, newIndex)=>({
        type: $e6a5e5655c384a33$export$90fd6e557d95c194,
        payload: {
            originalOrder: originalOrder,
            newOrder: newOrder,
            originalIndex: originalIndex,
            newIndex: newIndex
        }
    });
const $e6a5e5655c384a33$export$114e6969a338330e = 'state.entities.REORDER_CHILDREN_SUCCESS';
const $e6a5e5655c384a33$export$e3b2b5621f591898 = (newOrder)=>({
        type: $e6a5e5655c384a33$export$114e6969a338330e,
        payload: {
            newOrder: newOrder
        }
    });
const $e6a5e5655c384a33$export$5998f11ce66975f8 = 'state.entities.ADD_EXISTING_CHILD_ISSUE_REQUEST';
const $e6a5e5655c384a33$export$3cd83357f07e71c2 = (issue, analyticsEvent)=>({
        type: $e6a5e5655c384a33$export$5998f11ce66975f8,
        payload: issue,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("cXGkG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eb78e887626e81a$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $7eb78e887626e81a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    linkParentErrorTitle: {
        "id": "issue.views.common.child-issues-panel.flags.link-parent-error-title",
        "defaultMessage": "We couldn't link the child issue"
    },
    linkParentErrorDescription: {
        "id": "issue.views.common.child-issues-panel.flags.link-parent-error-description",
        "defaultMessage": "The issue was created but the linking failed. Head over to your board and try again."
    },
    linkParentErrorTitleIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.flags.link-parent-error-title-issue-term-refresh",
        "defaultMessage": "We couldn't link the child work item"
    },
    linkParentErrorDescriptionIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.flags.link-parent-error-description-issue-term-refresh",
        "defaultMessage": "The work item was created but the linking failed. Head over to your board and try again."
    }
});

});


parcelRegister("cOeC9", function(module, exports) {

$parcel$export(module.exports, "default", () => $56c82ca3f52978da$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $4R6GH = parcelRequire("4R6GH");

var $kgiLY = parcelRequire("kgiLY");

var $cQDik = parcelRequire("cQDik");

var $aJIud = parcelRequire("aJIud");

var $6F8Mn = parcelRequire("6F8Mn");

var $59dzX = parcelRequire("59dzX");

var $jMoSD = parcelRequire("jMoSD");

var $14sEt = parcelRequire("14sEt");

var $fcGCP = parcelRequire("fcGCP");

var $cGWwT = parcelRequire("cGWwT");

var $cFs5z = parcelRequire("cFs5z");

var $5EIeG = parcelRequire("5EIeG");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$56c82ca3f52978da$export$2e2bcd8739ae039 = (associatedIssuesContextActions, fieldsValuesActions, fieldConfigActions)=>(0, $e1AU2.combineEpics)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $6F8Mn.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $jMoSD.default)(associatedIssuesContextActions, fieldsValuesActions, fieldConfigActions), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $aJIud.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $59dzX.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $cQDik.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $5EIeG.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $kgiLY.default), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $fcGCP.default)(fieldsValuesActions, associatedIssuesContextActions), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $cGWwT.default)(associatedIssuesContextActions, fieldsValuesActions, fieldConfigActions), ...(0, $4R6GH.fg)('jira-issue-view-child-issues-panel-performance') ? [] : [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $14sEt.default),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cFs5z.default)
    ]);

});
parcelRegister("kgiLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15ec97aa66755c7$export$2e2bcd8739ae039);
parcelRequire("64ZAE");
parcelRequire("hZWgu");

var $2YZCu = parcelRequire("2YZCu");

var $g5X3G = parcelRequire("g5X3G");

var $kF1SN = parcelRequire("kF1SN");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e15ec97aa66755c7$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3XoQX.LINK_CHILD_SUCCESS), (0, $3XoQX.REORDER_CHILDREN_REQUEST), (0, $3XoQX.REORDER_CHILDREN_FAILED), (0, $3XoQX.FETCH_GRAPHQL_ISSUE_SUCCESS), (0, $3XoQX.UPDATE_ISSUE)).do((action)=>{
        try {
            const state = store.getState();
            const onChange = (0, $58aTF.getOnChangeCallback)(state);
            const panelType = (0, $58aTF.getChildIssuesPanelType)(state);
            switch(action.type){
                case 0, $3XoQX.FETCH_GRAPHQL_ISSUE_SUCCESS:
                    onChange({
                        type: (0, $kF1SN.CHANGE_EVENT_TYPES).CHILD_ISSUE_ADDED,
                        meta: {
                            childIssue: action.payload.childIssue,
                            fieldsData: action.payload.fieldsData
                        }
                    });
                    break;
                case 0, $3XoQX.LINK_CHILD_SUCCESS:
                    onChange({
                        type: (0, $kF1SN.CHANGE_EVENT_TYPES).CHILD_ISSUE_ADDED,
                        meta: {
                            childIssue: action.payload.linkedChild
                        }
                    });
                    break;
                case 0, $3XoQX.REORDER_CHILDREN_REQUEST:
                    {
                        const { currentOrder: currentOrder, newOrder: optimisticOrder, currentIndex: currentIndex, newIndex: newIndex } = action.payload;
                        const { id: issueId } = currentOrder[currentIndex];
                        const issueIds = issueId ? [
                            (0, $g5X3G.toIssueId)(issueId)
                        ] : [];
                        const isRankAfter = newIndex > currentIndex;
                        const rankId = Number((optimisticOrder[isRankAfter ? newIndex - 1 : newIndex + 1] || {}).id);
                        if (panelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL || panelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS) onChange({
                            type: (0, $kF1SN.CHANGE_EVENT_TYPES).ISSUE_CHILDREN_ORDER_CHANGED,
                            meta: {
                                issueIds: issueIds,
                                rankId: rankId,
                                isRankAfter: isRankAfter
                            }
                        });
                        break;
                    }
                case 0, $3XoQX.REORDER_CHILDREN_FAILED:
                    {
                        const { originalOrder: currentOrder, originalIndex: currentIndex, newIndex: newIndex } = action.payload;
                        const { id: issueId } = currentOrder[currentIndex];
                        const issueIds = issueId ? [
                            (0, $g5X3G.toIssueId)(issueId)
                        ] : [];
                        const isRankAfter = currentIndex > newIndex;
                        const rankId = Number((currentOrder[isRankAfter ? currentIndex - 1 : currentIndex + 1] || {}).id);
                        if ((panelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL || panelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS) && rankId) onChange({
                            type: (0, $kF1SN.CHANGE_EVENT_TYPES).ISSUE_CHILDREN_ORDER_CHANGED,
                            meta: {
                                issueIds: issueIds,
                                rankId: rankId,
                                isRankAfter: isRankAfter
                            }
                        });
                        break;
                    }
                case 0, $3XoQX.UPDATE_ISSUE:
                    if (panelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS) onChange({
                        type: (0, $kF1SN.CHANGE_EVENT_TYPES).CHILD_ISSUE_FIELD_UPDATED,
                        meta: {
                            childIssueId: action.payload.id
                        }
                    });
                    break;
                default:
                    break;
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.change-notification', 'Failed to call onChange callback', error);
        }
    }).ignoreElements();

});
parcelRegister("58aTF", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $db22f8e239335625$export$f654b28f82155665);
$parcel$export(module.exports, "getChildIssuesPanelType", () => $db22f8e239335625$export$58f272e135fd4a2a);
$parcel$export(module.exports, "getIsClassicSubtaskPanel", () => $db22f8e239335625$export$362c51097d1ac897);
$parcel$export(module.exports, "getIsClassicProjectEpicPanel", () => $db22f8e239335625$export$df61b3bae2c25541);
$parcel$export(module.exports, "getIsChildrenIssuesPanel", () => $db22f8e239335625$export$cc98fcceda2f1b92);
$parcel$export(module.exports, "getSupportsIssueCreation", () => $db22f8e239335625$export$5d22022f20ecc75);
$parcel$export(module.exports, "getRequiresFullCreateByIssueType", () => $db22f8e239335625$export$5c419da88cdde9ba);
$parcel$export(module.exports, "getIssueTypeWFValidators", () => $db22f8e239335625$export$7be48c18184ffec7);
$parcel$export(module.exports, "getParentKey", () => $db22f8e239335625$export$2e0384ad620a9485);
$parcel$export(module.exports, "getOnEditAssociatedIssue", () => $db22f8e239335625$export$b9241eafc69d2f56);
$parcel$export(module.exports, "getParentId", () => $db22f8e239335625$export$e6e327a97512715e);
$parcel$export(module.exports, "getParentIssueTypeId", () => $db22f8e239335625$export$766d1f024f870894);
$parcel$export(module.exports, "getFilterSubtasks", () => $db22f8e239335625$export$2c71c9839e4a8fc8);
$parcel$export(module.exports, "getCustomFieldIdRank", () => $db22f8e239335625$export$b4a1bb130a305ed0);
$parcel$export(module.exports, "getEpicLinkFieldKey", () => $db22f8e239335625$export$72066b419d5854aa);
$parcel$export(module.exports, "getProjectId", () => $db22f8e239335625$export$89040d072f281f85);
$parcel$export(module.exports, "getTitle", () => $db22f8e239335625$export$70d1bf7729efff40);
$parcel$export(module.exports, "getChildTitle", () => $db22f8e239335625$export$6bf60d64df87ed9d);
$parcel$export(module.exports, "getNoValueText", () => $db22f8e239335625$export$5cf7889ebf5af181);
$parcel$export(module.exports, "getOnNavigateToNewIssue", () => $db22f8e239335625$export$4f00588fd185469a);
$parcel$export(module.exports, "getOnChangeCallback", () => $db22f8e239335625$export$cf929e78a123defa);
$parcel$export(module.exports, "getChildIssuesPanelProjectType", () => $db22f8e239335625$export$f5cb43929ffb0af0);
$parcel$export(module.exports, "getIsSimplifiedProject", () => $db22f8e239335625$export$b41c098b7c73fb56);
$parcel$export(module.exports, "getChildIssuesPanelApplication", () => $db22f8e239335625$export$28174589e3e7cc20);
$parcel$export(module.exports, "getChildIssuesPanelEdition", () => $db22f8e239335625$export$9056dd489d9c3df1);
$parcel$export(module.exports, "isCompatibleSortingPanel", () => $db22f8e239335625$export$4acf3379abca38c8);

var $dGvGJ = parcelRequire("dGvGJ");

var $6s1PB = parcelRequire("6s1PB");

var $kF1SN = parcelRequire("kF1SN");

var $i1Qm6 = parcelRequire("i1Qm6");

var $dtS0b = parcelRequire("dtS0b");
const $db22f8e239335625$export$f654b28f82155665 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.baseUrl);
const $db22f8e239335625$export$180605366c04f0cd = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.locale);
const $db22f8e239335625$export$58f272e135fd4a2a = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.childIssuesPanelType);
const $db22f8e239335625$export$362c51097d1ac897 = (0, $dGvGJ.createSelector)($db22f8e239335625$export$58f272e135fd4a2a, (childIssuesPanelType)=>childIssuesPanelType ? childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS : false);
const $db22f8e239335625$export$df61b3bae2c25541 = (0, $dGvGJ.createSelector)($db22f8e239335625$export$58f272e135fd4a2a, (childIssuesPanelType)=>childIssuesPanelType ? childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_PROJECT_EPIC_CHILDREN : false);
const $db22f8e239335625$export$cc98fcceda2f1b92 = (0, $dGvGJ.createSelector)($db22f8e239335625$export$58f272e135fd4a2a, (childIssuesPanelType)=>childIssuesPanelType ? childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL : false);
const $db22f8e239335625$export$5d22022f20ecc75 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.supportsIssueCreation);
const $db22f8e239335625$export$f755f1954c0227bf = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.user === null || contextState.user === '');
const $db22f8e239335625$export$5c419da88cdde9ba = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (0, $dtS0b.getSelectedIssueType), (0, $dtS0b.isFetchIssueTypesComplete), $db22f8e239335625$export$f755f1954c0227bf, (context, selectedIssueType, fetchIssueTypesComplete, anonymousUser)=>{
    const requiresFullCreateByIssueType = selectedIssueType?.id && context.requiresFullCreateByIssueType[selectedIssueType.id];
    return anonymousUser || requiresFullCreateByIssueType || !fetchIssueTypesComplete;
});
const $db22f8e239335625$export$7be48c18184ffec7 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (0, $dtS0b.isFetchIssueTypesComplete), (context, fetchIssueTypesComplete)=>fetchIssueTypesComplete ? context.requiresFullCreateByIssueType : undefined);
const $db22f8e239335625$export$2e0384ad620a9485 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.parentKey);
const $db22f8e239335625$export$b9241eafc69d2f56 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.onEditAssociatedIssue);
const $db22f8e239335625$export$e6e327a97512715e = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.parentId);
const $db22f8e239335625$export$766d1f024f870894 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.parentIssueTypeId);
const $db22f8e239335625$export$2c71c9839e4a8fc8 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.filterSubtasks);
const $db22f8e239335625$export$b4a1bb130a305ed0 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.customFieldIdRank);
const $db22f8e239335625$export$72066b419d5854aa = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.epicLinkFieldKey);
const $db22f8e239335625$export$89040d072f281f85 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.projectId);
const $db22f8e239335625$var$getMessages = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.messages || {});
const $db22f8e239335625$export$70d1bf7729efff40 = (0, $dGvGJ.createSelector)($db22f8e239335625$var$getMessages, (messages)=>{
    if (// @ts-expect-error - TS2339 - Property 'title' does not exist on type '{}'.
    messages.titleIssueTerminologyRefreshM4 && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) // @ts-expect-error - TS2339 - Property 'title' does not exist on type '{}'.
    return messages.titleIssueTerminologyRefreshM4;
    // @ts-expect-error - TS2339 - Property 'title' does not exist on type '{}'.
    return messages.titleIssueTermRefresh && (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? messages.titleIssueTermRefresh : messages.title;
});
const $db22f8e239335625$export$6bf60d64df87ed9d = (0, $dGvGJ.createSelector)($db22f8e239335625$var$getMessages, (messages)=>messages.titleChildIssues);
const $db22f8e239335625$export$5cf7889ebf5af181 = (0, $dGvGJ.createSelector)($db22f8e239335625$var$getMessages, // @ts-expect-error - TS2339 - Property 'noValueText' does not exist on type '{}'.
(messages)=>messages.noValueText || null);
const $db22f8e239335625$export$4f00588fd185469a = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.onNavigateToNewIssue);
const $db22f8e239335625$export$cf929e78a123defa = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.onChange);
const $db22f8e239335625$export$79abb288cd093340 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.isIssueViewComplete);
const $db22f8e239335625$export$f5cb43929ffb0af0 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.projectType);
const $db22f8e239335625$export$b41c098b7c73fb56 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.isSimplifiedProject);
const $db22f8e239335625$export$28174589e3e7cc20 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.application);
const $db22f8e239335625$export$9056dd489d9c3df1 = (0, $dGvGJ.createSelector)((0, $i1Qm6.contextSelector), (contextState)=>contextState.edition);
const $db22f8e239335625$export$fc2a233dc51b3d65 = (panelType)=>panelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL || panelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_PROJECT_EPIC_CHILDREN;
const $db22f8e239335625$export$4acf3379abca38c8 = (0, $dGvGJ.createSelector)($db22f8e239335625$export$58f272e135fd4a2a, $db22f8e239335625$export$fc2a233dc51b3d65);

});
parcelRegister("i1Qm6", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $d331f6209abc4171$export$c420c9f40402ab6d);
$parcel$export(module.exports, "entitiesSelector", () => $d331f6209abc4171$export$ccebe5cc5854d0fa);
$parcel$export(module.exports, "uiSelector", () => $d331f6209abc4171$export$185c0864c82372e3);
const $d331f6209abc4171$export$c420c9f40402ab6d = (state)=>state.context;
const $d331f6209abc4171$export$ccebe5cc5854d0fa = (state)=>state.entities;
const $d331f6209abc4171$export$185c0864c82372e3 = (state)=>state.ui;

});

parcelRegister("dtS0b", function(module, exports) {

$parcel$export(module.exports, "getAddClickCount", () => $1236548d02973e26$export$eed45924747949f3);
$parcel$export(module.exports, "getTriggeredViaHotKey", () => $1236548d02973e26$export$10752593be296a82);
$parcel$export(module.exports, "getChildPanelView", () => $1236548d02973e26$export$c51eccd230709f7a);
$parcel$export(module.exports, "getChildCreateSummary", () => $1236548d02973e26$export$2bb2803416fb800a);
$parcel$export(module.exports, "getSelectedIssueType", () => $1236548d02973e26$export$9122bf637eb6acc2);
$parcel$export(module.exports, "getHideDone", () => $1236548d02973e26$export$6107c714db0feff9);
$parcel$export(module.exports, "isFetchIssueTypesComplete", () => $1236548d02973e26$export$41816b36ca49fe1d);

var $dGvGJ = parcelRequire("dGvGJ");


var $2iFnS = parcelRequire("2iFnS");

var $i1Qm6 = parcelRequire("i1Qm6");
const $1236548d02973e26$export$eed45924747949f3 = (0, $dGvGJ.createSelector)((0, $i1Qm6.uiSelector), (uiState)=>uiState.addClickCount);
const $1236548d02973e26$export$10752593be296a82 = (0, $dGvGJ.createSelector)((0, $i1Qm6.uiSelector), (uiState)=>{
    return uiState.triggeredViaHotKey;
});
const $1236548d02973e26$export$c51eccd230709f7a = (0, $dGvGJ.createSelector)((0, $i1Qm6.uiSelector), (uiState)=>uiState.childPanelView);
const $1236548d02973e26$export$2bb2803416fb800a = (0, $dGvGJ.createSelector)((0, $i1Qm6.uiSelector), (uiState)=>uiState.childCreateSummary);
const $1236548d02973e26$export$9122bf637eb6acc2 = (0, $dGvGJ.createSelector)((0, $i1Qm6.uiSelector), (0, $2iFnS.getIssueTypes), ({ selectedIssueType: selectedIssueType }, issueTypes)=>// to maintain "single source of truth" return issueType matching selectedIssueType
    selectedIssueType && issueTypes.find((it)=>it.id === selectedIssueType.id) || issueTypes[0]);
const $1236548d02973e26$export$6107c714db0feff9 = (0, $dGvGJ.createSelector)((0, $i1Qm6.uiSelector), (uiState)=>uiState.hideDone);
const $1236548d02973e26$var$getFetchIssueTypesStatus = (0, $dGvGJ.createSelector)((0, $i1Qm6.uiSelector), (uiState)=>uiState.fetchIssueTypesStatus);
const $1236548d02973e26$export$41816b36ca49fe1d = (0, $dGvGJ.createSelector)($1236548d02973e26$var$getFetchIssueTypesStatus, (status)=>status === (0, $d938a6f4f1d90c4d$export$1e006e11f4ec3452));

});
parcelRegister("2iFnS", function(module, exports) {

$parcel$export(module.exports, "getAllIssues", () => $80fead73b5bb715c$export$7d1865fcc78ac59e);
$parcel$export(module.exports, "getCompletedIssues", () => $80fead73b5bb715c$export$e20ffa1eb575f585);
$parcel$export(module.exports, "getIncompleteIssues", () => $80fead73b5bb715c$export$15e314e1acee6ed8);
$parcel$export(module.exports, "getInProgressIssues", () => $80fead73b5bb715c$export$5cd854cfeba74b7f);
$parcel$export(module.exports, "getIssueHierarchyLevel", () => $80fead73b5bb715c$export$c9886db3e23d0fc3);
$parcel$export(module.exports, "getIssue", () => $80fead73b5bb715c$export$34403cb88b30d33b);
$parcel$export(module.exports, "getRecentlyCreatedIssue", () => $80fead73b5bb715c$export$5e1f984a876bd0f4);
$parcel$export(module.exports, "getRecentlyLinkedChildIssue", () => $80fead73b5bb715c$export$baa05ccde448ead3);
$parcel$export(module.exports, "getIssueTypes", () => $80fead73b5bb715c$export$4cf4b24b88599615);
$parcel$export(module.exports, "getNextGenChildrenIssueTypesJql", () => $80fead73b5bb715c$export$1567f3d9a2fdded3);

var $dGvGJ = parcelRequire("dGvGJ");

var $1sWm7 = parcelRequire("1sWm7");

var $gULOk = parcelRequire("gULOk");

var $i1Qm6 = parcelRequire("i1Qm6");
const $80fead73b5bb715c$export$7d1865fcc78ac59e = (0, $dGvGJ.createSelector)((0, $i1Qm6.entitiesSelector), (entitiesState)=>entitiesState.issues || []);
const $80fead73b5bb715c$export$e20ffa1eb575f585 = (0, $dGvGJ.createSelector)($80fead73b5bb715c$export$7d1865fcc78ac59e, (issues)=>issues.filter((issue)=>issue.statusCategory === (0, $gULOk.DONE)));
const $80fead73b5bb715c$export$15e314e1acee6ed8 = (0, $dGvGJ.createSelector)($80fead73b5bb715c$export$7d1865fcc78ac59e, (issues)=>issues.filter((issue)=>issue.statusCategory !== (0, $gULOk.DONE)));
const $80fead73b5bb715c$export$5cd854cfeba74b7f = (0, $dGvGJ.createSelector)($80fead73b5bb715c$export$7d1865fcc78ac59e, (issues)=>issues.filter((issue)=>issue.statusCategory === (0, $gULOk.IN_PROGRESS)));
const $80fead73b5bb715c$export$c9886db3e23d0fc3 = (0, $dGvGJ.createSelector)((0, $i1Qm6.entitiesSelector), (entitiesState)=>entitiesState.issueHierarchyLevel);
const $80fead73b5bb715c$export$34403cb88b30d33b = (id)=>(0, $dGvGJ.createSelector)($80fead73b5bb715c$export$7d1865fcc78ac59e, (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(issues, (issue)=>issue.id === id));
const $80fead73b5bb715c$export$5e1f984a876bd0f4 = (0, $dGvGJ.createSelector)((0, $i1Qm6.entitiesSelector), (entitiesState)=>entitiesState.recentlyCreatedIssue);
const $80fead73b5bb715c$export$baa05ccde448ead3 = (0, $dGvGJ.createSelector)((0, $i1Qm6.entitiesSelector), (entitiesState)=>entitiesState.recentlyLinkedChildIssue);
const $80fead73b5bb715c$export$4cf4b24b88599615 = (0, $dGvGJ.createSelector)((0, $i1Qm6.entitiesSelector), (entitiesState)=>entitiesState.issueTypes);
const $80fead73b5bb715c$export$1567f3d9a2fdded3 = (0, $dGvGJ.createSelector)($80fead73b5bb715c$export$4cf4b24b88599615, (issueTypes)=>`issuetype in (${issueTypes.map((issueType)=>issueType.id).join(',')})`);

});




parcelRegister("cQDik", function(module, exports) {

$parcel$export(module.exports, "default", () => $c05c0fb4bc319949$export$2e2bcd8739ae039);
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");

var $ay5Oo = parcelRequire("ay5Oo");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c05c0fb4bc319949$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3XoQX.CHILD_CREATED_IN_FULL_DIALOG)).mergeMap(({ payload: payload, meta: meta })=>{
        const state = store.getState();
        const { optimisticId: optimisticId, createdChild: createdChild } = payload;
        const isChildrenIssuesPanel = (0, $58aTF.getIsChildrenIssuesPanel)(state);
        // For non-NextGen issues the child creation is a one-step process, so once the
        // child issue is created, we can dispatch the createChildSuccess action
        if (!isChildrenIssuesPanel) return (0, $kVLXA.Observable).of((0, $3XoQX.createChildSuccess)(optimisticId, createdChild, meta.analyticsEvent, true, meta.additionalAttributes));
        // If the child a NextGen issue, it requires an additional "link to parent" step
        // before we can dispatch createChildSuccess
        // Note: this is temporary (https://hello.atlassian.net/wiki/spaces/JPLAT/pages/376819072/DACI+How+to+create+next-gen+subtasks)
        // Note: CMP issues can reach this codepath (https://jira.atlassian.com/browse/JRACLOUD-93290)
        const parentId = (0, $58aTF.getParentId)(state);
        if (!parentId) throw new Error('Attempted to link a child issue without a parent issue ID');
        return (0, $kVLXA.Observable).from((0, $ay5Oo.default)(parentId, createdChild.id)).map(()=>(0, $3XoQX.createChildSuccess)(optimisticId, createdChild, meta.analyticsEvent, true, meta.additionalAttributes)).catch((error)=>(0, $kVLXA.Observable).of((0, $3XoQX.linkParentFailure)(optimisticId, error)));
    });

});
parcelRegister("ay5Oo", function(module, exports) {

$parcel$export(module.exports, "default", () => $32109e854a01f357$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
function $32109e854a01f357$export$2e2bcd8739ae039(parentId, childId) {
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${childId}`, {
        body: JSON.stringify({
            fields: {
                parent: {
                    id: parentId
                }
            }
        })
    });
}

});


parcelRegister("aJIud", function(module, exports) {

$parcel$export(module.exports, "default", () => $5178f2771387cfaf$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("64ZAE");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $gXz4p = parcelRequire("gXz4p");

var $2YZCu = parcelRequire("2YZCu");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5178f2771387cfaf$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3XoQX.CREATE_CHILD_FAILURE), (0, $3XoQX.LINK_PARENT_FAILURE), (0, $3XoQX.LINKING_ISSUE_FAILURE)).do(({ type: type, payload: { error: error } })=>{
        const state = store.getState();
        const childIssuePanelType = (0, $58aTF.getChildIssuesPanelType)(state) || 'unknown_child';
        const application = (0, $58aTF.getChildIssuesPanelApplication)(state);
        const edition = (0, $58aTF.getChildIssuesPanelEdition)(state);
        /*
				SLA Monitoring

				We track all 4xx as part of taskFail events, which are filtered at SLO level.
				We have detectors added to track this 4xx error spikes.
			 */ if ((0, $4R6GH.fg)('bento_send_4xx_to_task_fail_gate_1')) {
            // add logging for all errors
            (0, $2YZCu.default).safeErrorWithoutCustomerData('createIssue.child_issues_pannel.child_create_failure', error.message, error);
            (0, $gXz4p.sendExperienceAnalytics)({
                experience: 'createIssue',
                wasExperienceSuccesful: false,
                analyticsSource: childIssuePanelType,
                application: application,
                edition: edition,
                additionalAttributes: {
                    // @ts-expect-error - TS2339 - Property 'traceId' does not exist on type 'Error | ValidationError'.
                    traceId: error?.traceId,
                    errorMessage: `${type} ${error.message}`,
                    ...'statusCode' in error && (0, $4R6GH.fg)('thor_add_missing_attributes_across_issue_view_1') ? {
                        statusCode: error.statusCode
                    } : {}
                }
            });
        } else if (type === (0, $3XoQX.CREATE_CHILD_FAILURE) && error.name === (0, $jJZqs.VALIDATION_ERROR_NAME)) /*
				SLA Monitoring

				Almost any time these FAILURE actions are sent, we send a createIssue failure event.

				Except: it is possible for an admin to misconfigure their project in such a way that
				the Global Issue Create dialog doesn't handle all required fields, and the Issue Create
				API request still returns a 400 BAD REQUEST. This is "expected", and so we track it
				as a "success" and not a failure.

				Also, any AbortError or TypeError is a result of an operation being cancelled by the
				user (e.g. navigating away from the page before the request is complete) and so we
				do not count these in our frontend SLA events at all.
			 */ (0, $gXz4p.sendExperienceAnalytics)({
            experience: 'createIssue',
            wasExperienceSuccesful: true,
            analyticsSource: childIssuePanelType,
            application: application,
            edition: edition,
            additionalAttributes: {
                // @ts-expect-error - TS2339 - Property 'traceId' does not exist on type 'Error | ValidationError'.
                traceId: error?.traceId,
                errorMessage: `${type} ${error?.message}`
            }
        });
        else if (error.name !== (0, $jJZqs.ABORT_ERROR_NAME) && !(0, $fZneA.isClientFetchError)(error)) {
            // add logging for all errors
            (0, $2YZCu.default).safeErrorWithoutCustomerData('createIssue.child_issues_pannel.child_create_failure', error.message, error);
            if ((0, $fZneA.isHttpClientErrorResponse)(error)) return;
            (0, $gXz4p.sendExperienceAnalytics)({
                experience: 'createIssue',
                wasExperienceSuccesful: false,
                analyticsSource: childIssuePanelType,
                application: application,
                edition: edition,
                additionalAttributes: {
                    // @ts-expect-error - TS2339 - Property 'traceId' does not exist on type 'Error | ValidationError'.
                    traceId: error.traceId,
                    errorMessage: `${type} ${error.message}`,
                    ...error instanceof (0, $jJZqs.default) && (0, $4R6GH.fg)('thor_add_missing_attributes_across_issue_view_1') ? {
                        statusCode: error.statusCode
                    } : {}
                }
            });
        }
    }).switchMap(()=>(0, $kVLXA.Observable).empty());

});

parcelRegister("6F8Mn", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc5cf431c29da27e$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $gXz4p = parcelRequire("gXz4p");

var $efvDm = parcelRequire("efvDm");

var $4R6GH = parcelRequire("4R6GH");

var $6VGst = parcelRequire("6VGst");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");
const $dc5cf431c29da27e$var$createChildIssue = (state, optimisticUiChildIssue, analyticsEvent, additionalAttributes = {})=>{
    const baseUrl = (0, $58aTF.getBaseUrl)(state);
    const projectId = (0, $58aTF.getProjectId)(state);
    const parentIssueId = (0, $58aTF.getParentId)(state);
    const isClassicSubtaskPanel = (0, $58aTF.getIsClassicSubtaskPanel)(state);
    const isChildrenIssuesPanel = (0, $58aTF.getIsChildrenIssuesPanel)(state);
    const isClassicProjectEpicPanel = (0, $58aTF.getIsClassicProjectEpicPanel)(state);
    if (!projectId || !parentIssueId) throw new Error('Attempted to create a new child issue without a project or parent issue ID');
    const shouldIncludeParentId = isClassicSubtaskPanel || isChildrenIssuesPanel || isClassicProjectEpicPanel;
    const createPayload = {
        fields: {
            project: {
                id: projectId
            },
            issuetype: {
                id: optimisticUiChildIssue.issueTypeId
            },
            summary: optimisticUiChildIssue.issueSummary,
            ...shouldIncludeParentId ? {
                parent: {
                    id: parentIssueId
                }
            } : null
        }
    };
    return (0, $kVLXA.Observable).from((0, $6VGst.default)(baseUrl, createPayload, optimisticUiChildIssue)).mergeMap((createdChild)=>(0, $kVLXA.Observable).of((0, $3XoQX.createChildSuccess)(optimisticUiChildIssue.id, createdChild, analyticsEvent, false, additionalAttributes))).catch((error)=>{
        if ((0, $4R6GH.fg)('child_issue_creation_failure_analytics')) (0, $gXz4p.sendExperienceAnalytics)({
            experience: 'issueViewChildIssuesPanel-createIssue',
            wasExperienceSuccesful: false,
            analyticsSource: 'jiraIssueViewChildIssuesPanel',
            application: (0, $efvDm.JIRA_SOFTWARE),
            edition: null,
            additionalAttributes: {
                statusCode: error?.statusCode || 0,
                errorMessage: error?.message || 'UNKNOWN_ERROR',
                traceId: error?.traceId || ''
            }
        });
        return (0, $kVLXA.Observable).of((0, $3XoQX.createChildFailure)(optimisticUiChildIssue.id, error));
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc5cf431c29da27e$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3XoQX.CREATE_CHILD_REQUEST)).mergeMap(({ payload: payload, meta: meta })=>{
        const state = store.getState();
        const { optimisticUiChildIssue: optimisticUiChildIssue } = payload;
        return $dc5cf431c29da27e$var$createChildIssue(state, optimisticUiChildIssue, meta.analyticsEvent, meta.additionalAttributes);
    });

});
parcelRegister("6VGst", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a07361ba3b6775$export$2e2bcd8739ae039);

var $4WXhE = parcelRequire("4WXhE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a9a07361ba3b6775$export$2e2bcd8739ae039 = (baseUrl, createPayload, optimisticUiChildIssue)=>(0, $4WXhE.default)(baseUrl, createPayload).then((createdIssue)=>({
            id: createdIssue.id,
            issueKey: createdIssue.key,
            issueLink: `${baseUrl}/browse/${createdIssue.key}`,
            issueSummary: optimisticUiChildIssue.issueSummary,
            issueTypeIconUrl: optimisticUiChildIssue.issueTypeIconUrl,
            issueTypeName: optimisticUiChildIssue.issueTypeName,
            assigneeUrl: optimisticUiChildIssue.assigneeUrl,
            assigneeDisplayName: optimisticUiChildIssue.assigneeDisplayName,
            isLoading: false,
            errorType: undefined
        }));

});
parcelRegister("4WXhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a958bdd72114a2d$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8a958bdd72114a2d$export$2e2bcd8739ae039 = (baseUrl, createPayload)=>(0, $eusud.performPostRequest)(`${baseUrl}/rest/api/2/issue`, {
        body: JSON.stringify(createPayload)
    });

});



parcelRegister("59dzX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bdfc742ed752663$export$2e2bcd8739ae039);
parcelRequire("d0pqD");

var $3XoQX = parcelRequire("3XoQX");

var $2iFnS = parcelRequire("2iFnS");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8bdfc742ed752663$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3XoQX.CREATE_CHILD_RETRY)).map(({ payload: { optimisticId: optimisticId }, meta: meta })=>{
        const state = store.getState();
        const issue = (0, $2iFnS.getIssue)(optimisticId)(state);
        // @ts-expect-error - TS2339 - Property 'isLoading' does not exist on type 'ChildIssue | undefined'. | TS2339 - Property 'hasError' does not exist on type 'ChildIssue | undefined'.
        const { isLoading: isLoading, hasError: hasError, ...issueDetails } = issue;
        // @ts-expect-error - TS2345 - Argument of type '{ id: string; issueId?: string | undefined; issueKey?: string | undefined; issueLink?: string | undefined; assigneeUrl?: string | null | undefined; assigneeDisplayName?: string | null | undefined; ... 17 more ...; updated?: Date | undefined; }' is not assignable to parameter of type 'OptimisticUiChildIssue'.
        return (0, $3XoQX.createChildRequest)(issueDetails, meta.analyticsEvent);
    });

});

parcelRegister("jMoSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7b359f32f6414d7$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("c66Ur");
parcelRequire("64ZAE");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("6cbqE");

var $hhweD = parcelRequire("hhweD");

var $2YZCu = parcelRequire("2YZCu");

var $6s1D9 = parcelRequire("6s1D9");

var $k3PbQ = parcelRequire("k3PbQ");

var $5v60M = parcelRequire("5v60M");

var $ilOZS = parcelRequire("ilOZS");

var $NJMaZ = parcelRequire("NJMaZ");

var $Br4he = parcelRequire("Br4he");

var $g5X3G = parcelRequire("g5X3G");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d7b359f32f6414d7$export$2e2bcd8739ae039 = (associatedIssuesContextActions, fieldsValuesActions, fieldConfigActions)=>(action$, store)=>action$.ofType((0, $3XoQX.CREATE_CHILD_SUCCESS)).do(({ payload: { createdChild: createdChild, usedGlobalCreateDialog: usedGlobalCreateDialog }, meta: meta })=>{
            const state = store.getState();
            // Global issue create dialog also fires its own `issue created` event.
            // To avoid duplication, suppressing the issue view event version in case the modal was opened
            // Only fire if the child issue was created inline.
            if (!usedGlobalCreateDialog) {
                // Feature monitoring
                const isClassicSubtask = (0, $58aTF.getIsClassicSubtaskPanel)(state);
                const additionalAttributes = meta.additionalAttributes ?? {};
                const attributes = {
                    action: 'created',
                    actionSubjectId: createdChild.id,
                    attributes: {
                        isInlineCreatedOnIssue: true,
                        isClassicSubtask: isClassicSubtask,
                        ...additionalAttributes
                    }
                };
                (0, $hhweD.fireTrackAnalytics)(meta.analyticsEvent, attributes);
            }
            /**
					SLA monitoring

					Ordinarily the Global Create dialog would fire its own Create Issue SLA events.
					However in the child issues panel we bind the `issueCreated` event which overrides
					this default behaviour. So we send the event here in both (global and inline) cases.
					*/ const childIssuePanelType = (0, $58aTF.getChildIssuesPanelType)(state) || 'unknown_child';
            const application = (0, $58aTF.getChildIssuesPanelApplication)(state);
            const edition = (0, $58aTF.getChildIssuesPanelEdition)(state);
            (0, $6s1D9.sendExperienceAnalytics)({
                getExperienceDescription: ()=>({
                        experience: 'createIssue',
                        wasExperienceSuccesful: true,
                        analyticsSource: childIssuePanelType,
                        application: application,
                        edition: edition,
                        additionalAttributes: {
                            isCreated: true,
                            wasCreatedInline: !usedGlobalCreateDialog
                        }
                    })
            });
        }).mergeMap(({ payload: { createdChild: createdChild } })=>{
            const state = store.getState();
            const baseUrl = (0, $58aTF.getBaseUrl)(state);
            const issueKey = createdChild.issueKey !== undefined && createdChild.issueKey !== null ? (0, $g5X3G.toIssueKey)(createdChild.issueKey) : undefined;
            const projectKey = issueKey !== undefined ? (0, $k3PbQ.extractProjectKey)(issueKey) : undefined;
            if (!issueKey || !projectKey) {
                const errorMessage = 'Issue or project key missing when handling create child success';
                (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.create-child-success.missing-key', errorMessage, new Error(errorMessage));
                return (0, $kVLXA.Observable).empty();
            }
            const fetchIssueFromGraphQL$ = ()=>(0, $kVLXA.Observable).from((0, $5v60M.fetchIssueGraphQlData)(baseUrl, issueKey, projectKey)).map(({ data: graphqlData })=>{
                    const fieldsData = (0, $Br4he.getGraphQlFields)(graphqlData);
                    const issue = {
                        id: graphqlData.issue.id,
                        key: issueKey,
                        self: '',
                        fields: Object.values(fieldsData),
                        // Added to satisfy Flow; `transformChild` will not use these fields
                        agile: {},
                        customFields: {
                            textareaAdf: []
                        },
                        systemFields: {}
                    };
                    const transformedData = (0, $NJMaZ.transformChild)(issue, (0, $58aTF.getIsSimplifiedProject)(state));
                    associatedIssuesContextActions && associatedIssuesContextActions.mergeLocalAssociatedIssuesContext({
                        [issueKey]: {
                            estimateFieldId: transformedData.estimateFieldId,
                            isResolved: transformedData.isResolved ?? false
                        }
                    });
                    if (fieldsData && fieldsValuesActions && fieldConfigActions) {
                        const { fieldValues: fieldValues, fieldConfigs: fieldConfigs } = (0, $ilOZS.extractFromObject)(fieldsData);
                        fieldsValuesActions.setIssue(issueKey, fieldValues);
                        fieldConfigActions.setIssueConfig(issueKey, fieldConfigs);
                    }
                    return (0, $3XoQX.fetchGraphqlIssueSuccess)({
                        childIssue: transformedData,
                        fieldsData: fieldsData
                    });
                }).catch((error)=>{
                    (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.create-child-success.fetch-issue-graphql', 'Failed to fetch issue after a successful create', error);
                    return (0, $kVLXA.Observable).empty();
                });
            return fetchIssueFromGraphQL$();
        });

});
parcelRegister("6s1D9", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $ea62fd53ca447690$export$4a95ada1b8228562);



var $fZneA = parcelRequire("fZneA");

var $4R6GH = parcelRequire("4R6GH");

var $gXz4p = parcelRequire("gXz4p");
const $ea62fd53ca447690$var$successfulErrorStatusCodes = [
    (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977),
    (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07),
    (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)
];
const $ea62fd53ca447690$var$abortableStatusCodes = [
    (0, $3cd8a0ece36fbae5$export$6763168a631449a2)
];
const $ea62fd53ca447690$var$classificationPayload = {
    ANALYTICS_SUCCESS: {
        wasSuccessful: true,
        action: (0, $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a)
    },
    ANALYTICS_ABORT: {
        wasSuccessful: true,
        action: (0, $c0ec49ac5a1e4009$export$aeeb00d0845d24d8)
    },
    ANALYTICS_FAIL: {
        wasSuccessful: false,
        action: (0, $c0ec49ac5a1e4009$export$b48b3d1872522384)
    }
};
const $ea62fd53ca447690$var$isErrorOmitted = (error)=>error === null;
const $ea62fd53ca447690$var$isStatusCodeConsideredSuccessful = (error)=>// @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    $ea62fd53ca447690$var$successfulErrorStatusCodes.includes(error?.statusCode);
const $ea62fd53ca447690$var$isStatusCodeAbortable = (error)=>// @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    $ea62fd53ca447690$var$abortableStatusCodes.includes(error?.statusCode);
const $ea62fd53ca447690$var$reduceClassificationOld = (error)=>{
    if ($ea62fd53ca447690$var$isErrorOmitted(error) || $ea62fd53ca447690$var$isStatusCodeConsideredSuccessful(error)) return 'ANALYTICS_SUCCESS';
    if ($ea62fd53ca447690$var$isStatusCodeAbortable(error)) return 'ANALYTICS_ABORT';
    return 'ANALYTICS_FAIL';
};
const $ea62fd53ca447690$var$reduceClassificationNew = (error)=>{
    if ($ea62fd53ca447690$var$isErrorOmitted(error)) return 'ANALYTICS_SUCCESS';
    return 'ANALYTICS_FAIL';
};
const $ea62fd53ca447690$var$getReduceClassification = ()=>(0, $4R6GH.fg)('bento_send_4xx_to_task_fail_gate_1') ? $ea62fd53ca447690$var$reduceClassificationNew : $ea62fd53ca447690$var$reduceClassificationOld;
const $ea62fd53ca447690$export$4a95ada1b8228562 = ({ getExperienceDescription: getExperienceDescription, error: error = null })=>{
    // We intentionally do not capture analytics during a client a fetch error. However, we do
    // return the successful state so external flows can record logs
    if (!$ea62fd53ca447690$var$isErrorOmitted(error) && (0, $fZneA.isClientFetchError)(error) && !(0, $4R6GH.fg)('bento_send_4xx_to_task_fail_gate_1')) {
        getExperienceDescription({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            wasSuccessful: $ea62fd53ca447690$var$isErrorOmitted(error),
            statusCode: error?.statusCode
        });
        return;
    }
    const reduceClassification = $ea62fd53ca447690$var$getReduceClassification();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const classification = reduceClassification(error);
    const { action: action, wasSuccessful: wasSuccessful } = $ea62fd53ca447690$var$classificationPayload[classification];
    (0, $gXz4p.sendExperienceAnalytics)({
        ...getExperienceDescription({
            wasSuccessful: wasSuccessful,
            statusCode: error?.statusCode
        }),
        action: action
    });
};

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

const $c0ec49ac5a1e4009$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $c0ec49ac5a1e4009$export$b48b3d1872522384 = 'taskFail';
const $c0ec49ac5a1e4009$export$aeeb00d0845d24d8 = 'taskAbort';


parcelRegister("5v60M", function(module, exports) {

$parcel$export(module.exports, "fetchIssueGraphQlData", () => $bd36c8d3a13fb6b3$export$eece611cf467b9ce);

var $dGrdR = parcelRequire("dGrdR");

var $7f4tk = parcelRequire("7f4tk");

var $iZIvy = parcelRequire("iZIvy");

var $eDXka = parcelRequire("eDXka");

var $9kbEN = parcelRequire("9kbEN");
const $bd36c8d3a13fb6b3$var$ISSUE_GRAPHQL_DATA = 'issue-graphql-data';
const $bd36c8d3a13fb6b3$var$timeToFetchIssueGraphQlDataMetric = (0, $dGrdR.metrics).custom({
    key: $bd36c8d3a13fb6b3$var$ISSUE_GRAPHQL_DATA
});
const $bd36c8d3a13fb6b3$export$eece611cf467b9ce = (baseUrl, issueKey, projectKey)=>{
    if ((0, $9kbEN.isInSample)()) $bd36c8d3a13fb6b3$var$timeToFetchIssueGraphQlDataMetric.start();
    const issueGraphqlDataPromise = (0, $7f4tk.default)((0, $iZIvy.getGraphQlUrl)(baseUrl, (0, $eDXka.IssueViewFetchOperations).INITIAL_GRAPHQL), (0, $iZIvy.getFieldDataOptions)(issueKey, projectKey)).then((response)=>{
        // Best-effort attempt to provide `issueId` and is not guaranteed
        const issueId = response.data?.issue?.id;
        $bd36c8d3a13fb6b3$var$timeToFetchIssueGraphQlDataMetric.stop({
            customData: issueId ? {
                issueId: issueId
            } : null
        });
        return response;
    }).catch((error)=>{
        // Cancel the metric and re-throw the error
        $bd36c8d3a13fb6b3$var$timeToFetchIssueGraphQlDataMetric.cancel();
        throw error;
    });
    return issueGraphqlDataPromise;
};

});

parcelRegister("ilOZS", function(module, exports) {

$parcel$export(module.exports, "extractFromObject", () => $371b6da07ba8bb92$export$2b57c8930b67b22b);
$parcel$export(module.exports, "extractSubtasksOrPortfolioChildrenIssues", () => $371b6da07ba8bb92$export$c71895ba1b3f08cd);
$parcel$export(module.exports, "extractChildrenIssues", () => $371b6da07ba8bb92$export$d4199d8d54d21673);


var $fOGZN = parcelRequire("fOGZN");

var $5fc53 = parcelRequire("5fc53");

var $69oHP = parcelRequire("69oHP");
const $371b6da07ba8bb92$export$2b57c8930b67b22b = (fields)=>{
    const extractedFieldsData = {
        fieldValues: {},
        fieldConfigs: {}
    };
    Object.entries(fields).forEach(([key, field])=>{
        if (field?.schema?.custom === (0, $fOGZN.specialFields)()[0, $fOGZN.EPIC] || field?.schema?.custom === (0, $fOGZN.specialFields)()[0, $fOGZN.PARENT]) return;
        const isRichTextField = field.schema.type === (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE) && field.schema.renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c) || (0, $69oHP.getFieldType)(field) === (0, $5fc53.DESCRIPTION_TYPE);
        extractedFieldsData.fieldValues[key] = isRichTextField ? field.adfValue || field.value : field.value;
        extractedFieldsData.fieldConfigs[key] = {
            autoCompleteUrl: field.autoCompleteUrl,
            allowedValues: field.allowedValues,
            isEditable: field.editable,
            isRequired: field.required,
            schema: field.schema,
            title: field.title,
            configuration: field.configuration,
            description: field.description ?? undefined
        };
    });
    return extractedFieldsData;
};
const $371b6da07ba8bb92$export$f6ed1dae921a8132 = (fields)=>{
    const extractedFieldsData = {
        fieldValues: {},
        fieldConfigs: {}
    };
    fields.forEach((field)=>{
        extractedFieldsData.fieldValues[field.key] = field.value !== undefined ? field.value : null;
        extractedFieldsData.fieldConfigs[field.key] = {
            autoCompleteUrl: field.autoCompleteUrl,
            allowedValues: field.allowedValues,
            isEditable: field.editable,
            isRequired: field.required,
            schema: field.schema,
            title: field.title
        };
    });
    return extractedFieldsData;
};
const $371b6da07ba8bb92$export$c71895ba1b3f08cd = (childIssues)=>{
    const issuesFieldsValues = [];
    // @ts-expect-error - TS2345 - Argument of type '(childIssue: ChildIssue) => { id: string; key: string; }' is not assignable to parameter of type '(value: IssueFields, index: number, array: IssueFields[]) => { id: string; key: string; }'.
    const childrenKeyList = childIssues.map((childIssue)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const fieldValue = {};
        const { fields: fields = [], key: childIssueKey, id: childId } = childIssue;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.entries(fields).forEach(([key, value])=>{
            fieldValue[key] = value;
        });
        issuesFieldsValues.push({
            [childIssueKey]: fieldValue
        });
        return {
            id: childId,
            key: childIssueKey
        };
    });
    return {
        issuesFieldsValues: issuesFieldsValues,
        childrenKeyList: childrenKeyList
    };
};
const $371b6da07ba8bb92$export$d4199d8d54d21673 = (childrenIssues)=>{
    const issuesFieldsValues = [];
    const issueFieldsConfigurations = [];
    const childrenKeyList = childrenIssues.map((child)=>{
        const { fieldValues: values, fieldConfigs: configs } = $371b6da07ba8bb92$export$f6ed1dae921a8132(child.fields);
        issuesFieldsValues.push({
            [child.key]: values
        });
        issueFieldsConfigurations.push({
            [child.key]: configs
        });
        return {
            id: child.id,
            key: child.key
        };
    });
    return {
        issuesFieldsValues: issuesFieldsValues,
        issueFieldsConfigurations: issueFieldsConfigurations,
        childrenKeyList: childrenKeyList
    };
};

});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';


parcelRegister("NJMaZ", function(module, exports) {

$parcel$export(module.exports, "transformChild", () => $dc8801150aa9ea23$export$c66ac1a53266e423);
$parcel$export(module.exports, "transformChildrenNew", () => $dc8801150aa9ea23$export$f81c9d8b1547df05);

var $4Xk2W = parcelRequire("4Xk2W");

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $X0W3Y = parcelRequire("X0W3Y");

var $d4jBl = parcelRequire("d4jBl");
// we need to define a type here for default because of flow ambiguous error
// does not really matter because epicIssue type and nextgen issue type is same
const $dc8801150aa9ea23$var$defaultChildrenIssues = [];
const $dc8801150aa9ea23$var$getAssigneeFields = (assignee)=>{
    if (assignee != null) {
        const { avatarUrl: avatarUrl, displayName: displayName } = (0, $d4jBl.transformUser)(assignee);
        return {
            assigneeUrl: avatarUrl,
            assigneeDisplayName: displayName
        };
    }
    return {
        assigneeUrl: null,
        assigneeDisplayName: null
    };
};
const $dc8801150aa9ea23$export$c66ac1a53266e423 = (child, isSimplifiedProject = true)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const systemFields = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(child.fields, (field)=>field.schema.system);
    const issueType = systemFields[0, $5fc53.ISSUE_TYPE];
    const priority = systemFields[0, $5fc53.PRIORITY_TYPE];
    const summary = systemFields[0, $5fc53.SUMMARY_TYPE];
    const status = systemFields[0, $5fc53.STATUS_TYPE];
    const assignee = systemFields[0, $5fc53.ASSIGNEE_TYPE];
    const estimateField = child.fields.find((field)=>isSimplifiedProject ? field.schema.custom === (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE) : field.schema.custom === (0, $5fc53.STORY_POINTS_TYPE));
    const timeTrackingField = systemFields[0, $5fc53.TIME_TRACKING_TYPE];
    const created = systemFields[0, $5fc53.CREATED];
    const updated = systemFields[0, $5fc53.UPDATED];
    const resolution = systemFields[0, $5fc53.RESOLUTION_TYPE];
    const assigneeFields = assignee ? $dc8801150aa9ea23$var$getAssigneeFields(assignee.value) : {};
    return {
        id: child.id,
        issueLink: (0, $X0W3Y.getIssueHtmlUrl)((0, $g5X3G.toBaseUrl)(''), child.key),
        issueTypeIconUrl: issueType?.value.iconUrl,
        issueTypeName: issueType?.value.name,
        issuePriorityUrl: priority?.value?.iconUrl ?? undefined,
        issuePriorityName: priority?.value?.name ?? undefined,
        issueKey: child.key,
        issueSummary: summary?.value,
        statusCategory: status?.value && (0, $gULOk.statusCategoryForId)(status.value.statusCategory.id),
        statusCategoryId: status?.value?.statusCategory.id,
        statusName: status?.value?.name ?? undefined,
        statusId: status?.value?.id ?? undefined,
        estimateFieldId: estimateField?.key ?? undefined,
        estimateValue: estimateField?.value ?? undefined,
        // @ts-expect-error - TS2339 - Property 'assigneeDisplayName' does not exist on type '{}'.
        assigneeDisplayName: assigneeFields.assigneeDisplayName,
        // @ts-expect-error - TS2339 - Property 'assigneeUrl' does not exist on type '{}'.
        assigneeUrl: assigneeFields.assigneeUrl,
        isLoading: false,
        issueTimeTracking: timeTrackingField?.value ?? undefined,
        ...created?.value && {
            created: new Date(created.value)
        },
        ...updated?.value && {
            updated: new Date(updated.value)
        },
        isResolved: !!resolution?.value
    };
};
const $dc8801150aa9ea23$export$f81c9d8b1547df05 = (children = $dc8801150aa9ea23$var$defaultChildrenIssues, isSimplifiedProject)=>!children ? [] : children.map((child)=>$dc8801150aa9ea23$export$c66ac1a53266e423(child, isSimplifiedProject));

});

parcelRegister("Br4he", function(module, exports) {

$parcel$export(module.exports, "transformPermissions", () => $c853624ae4cf128d$export$7fe0bfa353103198);
$parcel$export(module.exports, "getGraphQlFields", () => $c853624ae4cf128d$export$7c5ecebab0b8a1c9);

var $4Xk2W = parcelRequire("4Xk2W");

var $gULOk = parcelRequire("gULOk");



var $fOGZN = parcelRequire("fOGZN");

var $fCo6Y = parcelRequire("fCo6Y");

var $g5X3G = parcelRequire("g5X3G");

var $NJMaZ = parcelRequire("NJMaZ");

var $f5Ld6 = parcelRequire("f5Ld6");

var $c1GJm = parcelRequire("c1GJm");

var $8dFFZ = parcelRequire("8dFFZ");
const $c853624ae4cf128d$var$transformParentIssue = (parentIssue)=>parentIssue ? {
        id: (0, $g5X3G.toIssueId)(parentIssue.id),
        key: (0, $g5X3G.toIssueKey)(parentIssue.key),
        summary: parentIssue.fields.summary,
        issueTypeName: parentIssue.fields.issuetype ? parentIssue.fields.issuetype.name : '',
        issueTypeIconUrl: parentIssue.fields.issuetype ? parentIssue.fields.issuetype.iconUrl : ''
    } : null;
const $c853624ae4cf128d$var$getProjectStatus = (project)=>{
    if (project.archived) return 0, $cd476f3ecebdab63$export$4ccc35479ba9ad1;
    if (project.deleted) return 0, $cd476f3ecebdab63$export$a95d71e582b8bc0;
    return 0, $cd476f3ecebdab63$export$62113557945f790a;
};
const $c853624ae4cf128d$export$2d1bde06ef9e2dcc = (graphQLResponse)=>{
    const { issue: issue, project: project } = graphQLResponse;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const issueFields = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(issue.fields, 'key');
    const subTasks = issueFields.subtasks?.content;
    const parentIssue = issueFields.parent?.content;
    const nextGenChildrenIssues = issueFields['children-issues']?.content;
    const classicEpicChildrenIssues = issueFields['epic-issues']?.content;
    const portfolioChildrenIssues = issueFields['portfolio-child-issues']?.content;
    const isSimplifiedProject = project.simplified;
    let childrenIssues = [];
    if (nextGenChildrenIssues) childrenIssues = (0, $NJMaZ.transformChildrenNew)(nextGenChildrenIssues, isSimplifiedProject);
    else if (classicEpicChildrenIssues) childrenIssues = (0, $NJMaZ.transformChildrenNew)(classicEpicChildrenIssues, isSimplifiedProject);
    else if (portfolioChildrenIssues) childrenIssues = (0, $f5Ld6.transformChildren)(portfolioChildrenIssues, (0, $g5X3G.toBaseUrl)(''));
    const avatarUrl = project.avatarUrls?.find(({ key: key })=>key === '32x32')?.value;
    return {
        // The `childIssuesLimit` field has been added to satisfy types.
        // This feature only works for the AGG migration phase 1 on case.
        // This value is not consumed.
        childIssuesLimit: undefined,
        project: {
            projectId: project.id,
            projectName: project.name,
            projectKey: project.key,
            projectType: project.projectTypeKey,
            isSimplified: isSimplifiedProject,
            avatarUrl: avatarUrl,
            projectStatus: $c853624ae4cf128d$var$getProjectStatus(project)
        },
        createdDate: issueFields.created?.content || null,
        updatedDate: issueFields.updated?.content || null,
        statuses: {
            [issueFields.status.content.id]: {
                id: issueFields.status.content.id,
                name: issueFields.status.content.name,
                statusCategory: (0, $gULOk.statusCategoryForId)(issueFields.status.content.statusCategory.id)
            }
        },
        issueLinks: issueFields.issuelinks && (0, $c1GJm.transformIssueLinks)((0, $g5X3G.toBaseUrl)(''), issueFields.issuelinks.content),
        subtasks: (0, $8dFFZ.transformSubtasks)(subTasks, (0, $g5X3G.toBaseUrl)('')),
        parentIssue: $c853624ae4cf128d$var$transformParentIssue(parentIssue),
        childrenIssues: childrenIssues
    };
};
const $c853624ae4cf128d$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER',
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'USER_PICKER',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CREATE_SUBTASK',
        'CLONE_ISSUE',
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
const $c853624ae4cf128d$export$7fe0bfa353103198 = (responseData)=>{
    const { permissions: { ADMINISTER_PROJECTS: ADMINISTER_PROJECTS, ASSIGN_ISSUES: ASSIGN_ISSUES, EDIT_ISSUES: EDIT_ISSUES, SCHEDULE_ISSUES: SCHEDULE_ISSUES, ADD_COMMENTS: ADD_COMMENTS, DELETE_ALL_COMMENTS: DELETE_ALL_COMMENTS, DELETE_OWN_COMMENTS: DELETE_OWN_COMMENTS, EDIT_ALL_COMMENTS: EDIT_ALL_COMMENTS, EDIT_OWN_COMMENTS: EDIT_OWN_COMMENTS, CREATE_ISSUES: CREATE_ISSUES, CLONE_ISSUE: CLONE_ISSUE, DELETE_ISSUES: DELETE_ISSUES, MOVE_ISSUES: MOVE_ISSUES, MODIFY_REPORTER: MODIFY_REPORTER, CREATE_ATTACHMENTS: CREATE_ATTACHMENTS, DELETE_ALL_ATTACHMENTS: DELETE_ALL_ATTACHMENTS, DELETE_OWN_ATTACHMENTS: DELETE_OWN_ATTACHMENTS, WORK_ON_ISSUES: WORK_ON_ISSUES, ASSIGNABLE_USER: ASSIGNABLE_USER, LINK_ISSUES: LINK_ISSUES, VIEW_VOTERS_AND_WATCHERS: VIEW_VOTERS_AND_WATCHERS, MANAGE_WATCHERS: MANAGE_WATCHERS, EDIT_ALL_WORKLOGS: EDIT_ALL_WORKLOGS, EDIT_OWN_WORKLOGS: EDIT_OWN_WORKLOGS, DELETE_ALL_WORKLOGS: DELETE_ALL_WORKLOGS, DELETE_OWN_WORKLOGS: DELETE_OWN_WORKLOGS, VIEW_DEV_TOOLS: VIEW_DEV_TOOLS, SERVICEDESK_AGENT: SERVICEDESK_AGENT, RESOLVE_ISSUES: RESOLVE_ISSUES, ARCHIVE_ISSUES: ARCHIVE_ISSUES, UNARCHIVE_ISSUES: UNARCHIVE_ISSUES } } = responseData;
    return {
        permissions: {
            canAddComments: ADD_COMMENTS.havePermission,
            canAdministerProject: ADMINISTER_PROJECTS.havePermission,
            canAssignIssues: ASSIGN_ISSUES.havePermission,
            canBeAssignedToIssues: ASSIGNABLE_USER.havePermission,
            canCloneIssue: CLONE_ISSUE.havePermission,
            canCreateAttachments: CREATE_ATTACHMENTS.havePermission,
            canCreateChildren: CREATE_ISSUES.havePermission,
            canCreateIssuesInClassicProjectEpic: CREATE_ISSUES.havePermission,
            canDeleteAllAttachments: DELETE_ALL_ATTACHMENTS.havePermission,
            canDeleteOwnAttachments: DELETE_OWN_ATTACHMENTS.havePermission,
            canDeleteAllComments: DELETE_ALL_COMMENTS.havePermission,
            canDeleteOwnComments: DELETE_OWN_COMMENTS.havePermission,
            canDeleteIssue: DELETE_ISSUES.havePermission,
            canEditAllComments: EDIT_ALL_COMMENTS.havePermission,
            canEditOwnComments: EDIT_OWN_COMMENTS.havePermission,
            canEditIssues: EDIT_ISSUES.havePermission,
            canLinkIssues: LINK_ISSUES.havePermission,
            canLogWork: WORK_ON_ISSUES.havePermission,
            canManageWatchers: MANAGE_WATCHERS.havePermission,
            canMoveIssue: MOVE_ISSUES.havePermission,
            canModifyReporter: MODIFY_REPORTER.havePermission,
            canScheduleIssues: SCHEDULE_ISSUES.havePermission,
            canViewWatchers: VIEW_VOTERS_AND_WATCHERS.havePermission,
            canViewVoters: VIEW_VOTERS_AND_WATCHERS.havePermission,
            canEditAllWorklogs: EDIT_ALL_WORKLOGS.havePermission,
            canEditOwnWorklogs: EDIT_OWN_WORKLOGS.havePermission,
            canDeleteAllWorklogs: DELETE_ALL_WORKLOGS.havePermission,
            canDeleteOwnWorklogs: DELETE_OWN_WORKLOGS.havePermission,
            canViewDevTools: !!(VIEW_DEV_TOOLS && VIEW_DEV_TOOLS.havePermission),
            canUseServiceDeskAgentFeatures: !!(SERVICEDESK_AGENT && SERVICEDESK_AGENT.havePermission),
            canResolveIssues: RESOLVE_ISSUES.havePermission,
            canArchiveIssue: ARCHIVE_ISSUES ? ARCHIVE_ISSUES.havePermission : false,
            canUnarchiveIssue: UNARCHIVE_ISSUES ? UNARCHIVE_ISSUES.havePermission : false
        }
    };
};
const $c853624ae4cf128d$export$7c1350f375476212 = (field)=>{
    const { content: content, renderedContent: renderedContent, configuration: configuration, ...rest } = field;
    const shouldHaveContentFields = content !== undefined || renderedContent !== undefined;
    // @ts-expect-error - TS2322 - Type '{ key: string; title: string; editable: boolean; required: boolean; autoCompleteUrl?: string | null | undefined; description?: string | null | undefined; allowedValues: any[]; schema: FieldSchema; ... 5 more ...; value?: any; }' is not assignable to type 'Field'.
    return {
        ...shouldHaveContentFields ? {
            value: content
        } : null,
        ...shouldHaveContentFields ? {
            renderedValue: renderedContent
        } : null,
        ...configuration && {
            configuration: configuration
        },
        ...rest
    };
};
const $c853624ae4cf128d$var$findGraphQlAdfField = (graphQlData, fieldId)=>{
    const systemField = graphQlData.issue.systemFields[`${fieldId}Adf`];
    const customTextareaField = graphQlData.issue.customFields.textareaAdf.find((multilineField)=>multilineField.key === fieldId);
    return systemField || customTextareaField || null;
};
const $c853624ae4cf128d$var$getAdfValue = (graphQlData, fieldId)=>{
    const graphQlAdfField = $c853624ae4cf128d$var$findGraphQlAdfField(graphQlData, fieldId);
    let adfField;
    if (graphQlAdfField && graphQlAdfField.value) adfField = {
        value: graphQlAdfField.value
    };
    else // A null ADF value and null WikiMarkup value means that the field has never had a value
    // set in it.
    adfField = {
        value: (0, $fCo6Y.emptyAdfObject)
    };
    // GraphQL is currently returning this as a JSON string, though ideally
    // we want it as JSON object
    // Can remove the check/JSON.parse when the below ticket is complete:
    //    https://product-fabric.atlassian.net/browse/EX-203
    const adfValue = typeof adfField.value === 'string' ? JSON.parse(adfField.value) : adfField.value;
    return (0, $fCo6Y.removeCollectionFromAdf)(adfValue);
};
const $c853624ae4cf128d$export$7c5ecebab0b8a1c9 = (graphQlData)=>{
    const fieldKeysWithRichRenderer = new Set(graphQlData.issue.fields.filter((field)=>field.schema.renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c)).map((field)=>field.key));
    const customMultilineFieldKeys = graphQlData.issue.customFields.textareaAdf.map((field)=>field.key);
    const customMultilineFieldKeysWithRichRenderer = customMultilineFieldKeys.filter((key)=>fieldKeysWithRichRenderer.has(key));
    const systemMultilineFieldsWithRichRenderer = [
        (0, $fOGZN.DESCRIPTION),
        (0, $fOGZN.ENVIRONMENT)
    ].filter((key)=>fieldKeysWithRichRenderer.has(key) || key === (0, $fOGZN.DESCRIPTION));
    const adfKeys = [
        ...systemMultilineFieldsWithRichRenderer,
        ...customMultilineFieldKeysWithRichRenderer
    ];
    const adfFields = adfKeys.map((field)=>({
            key: field,
            value: $c853624ae4cf128d$var$getAdfValue(graphQlData, field)
        }));
    return graphQlData.issue.fields.map((field)=>{
        const adfTransformationField = adfFields.find((adfField)=>adfField.key === field.key && adfField.value !== null);
        if (adfTransformationField) return {
            [adfTransformationField.key]: {
                ...$c853624ae4cf128d$export$7c1350f375476212(field),
                adfValue: adfTransformationField.value
            }
        };
        return {
            [field.key]: $c853624ae4cf128d$export$7c1350f375476212(field)
        };
    }).reduce((acc, currentValue)=>Object.assign(acc, currentValue));
};
const $c853624ae4cf128d$var$getTabs = (tabs)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    tabs?.reduce((acc, { id: id, name: name, items: items })=>{
        acc[id] = {
            id: id,
            name: name,
            items: items
        };
        return acc;
    }, {});
const $c853624ae4cf128d$export$aa5b1ce37de59943 = (graphQlData)=>{
    const oldTransformedFields = $c853624ae4cf128d$export$2d1bde06ef9e2dcc(graphQlData);
    const graphQlTransformedFields = {
        issue: {
            id: graphQlData.issue.id,
            agile: graphQlData.issue.agile,
            fields: $c853624ae4cf128d$export$7c5ecebab0b8a1c9(graphQlData),
            tabs: $c853624ae4cf128d$var$getTabs(graphQlData.issue.tabs),
            ...graphQlData.issue.viewScreenId ? {
                viewScreenId: graphQlData.issue.viewScreenId
            } : null
        }
    };
    return {
        ...graphQlTransformedFields,
        ...oldTransformedFields
    };
};

});
const $cd476f3ecebdab63$export$62113557945f790a = 'PROJECT_ACTIVE';
const $cd476f3ecebdab63$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $cd476f3ecebdab63$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';

parcelRegister("f5Ld6", function(module, exports) {

$parcel$export(module.exports, "transformChildren", () => $f371507c28e8e46a$export$6a0f063cd77f1995);

var $gULOk = parcelRequire("gULOk");

var $X0W3Y = parcelRequire("X0W3Y");

var $d4jBl = parcelRequire("d4jBl");
const $f371507c28e8e46a$var$getAssigneeFields = (assignee)=>{
    if (assignee != null) {
        const { avatarUrl: avatarUrl, displayName: displayName } = (0, $d4jBl.transformUser)(assignee);
        return {
            assigneeUrl: avatarUrl,
            assigneeDisplayName: displayName
        };
    }
    return {
        assigneeUrl: null,
        assigneeDisplayName: null
    };
};
const $f371507c28e8e46a$export$c66ac1a53266e423 = (child, baseUrl)=>{
    const { fields: fields } = child;
    return {
        id: child.id,
        issueLink: (0, $X0W3Y.getIssueHtmlUrl)(baseUrl, child.key),
        issueTypeIconUrl: fields.issuetype.iconUrl,
        issueTypeName: fields.issuetype.name,
        issuePriorityUrl: fields.priority && fields.priority.iconUrl || undefined,
        issuePriorityName: fields.priority && fields.priority.name || undefined,
        issueKey: child.key,
        issueSummary: fields.summary,
        statusCategory: (0, $gULOk.statusCategoryForId)(fields.status.statusCategory.id),
        statusCategoryId: fields.status.statusCategory.id,
        statusName: fields.status.name,
        statusId: fields.status.id,
        ...$f371507c28e8e46a$var$getAssigneeFields(fields.assignee),
        isLoading: false
    };
};
const $f371507c28e8e46a$export$6a0f063cd77f1995 = (children = [], baseUrl)=>!children ? [] : children.map((child)=>$f371507c28e8e46a$export$c66ac1a53266e423(child, baseUrl));

});

parcelRegister("8dFFZ", function(module, exports) {

$parcel$export(module.exports, "transformSubtasks", () => $6c4b6de6e138f69a$export$64c38caf710da25d);

var $gULOk = parcelRequire("gULOk");

var $X0W3Y = parcelRequire("X0W3Y");

var $d4jBl = parcelRequire("d4jBl");
const $6c4b6de6e138f69a$var$transformSubtask = (subtask, baseUrl)=>({
        id: subtask.id,
        issueLink: (0, $X0W3Y.getIssueHtmlUrl)(baseUrl, subtask.key),
        issueTypeIconUrl: subtask.fields.issuetype.iconUrl,
        issueTypeName: subtask.fields.issuetype.name,
        issuePriorityUrl: subtask.fields.priority && subtask.fields.priority.iconUrl || undefined,
        issuePriorityName: subtask.fields.priority && subtask.fields.priority.name || undefined,
        issueKey: subtask.key,
        issueSummary: subtask.fields.summary,
        statusCategory: (0, $gULOk.statusCategoryForId)(subtask.fields.status.statusCategory.id),
        statusCategoryId: subtask.fields.status.statusCategory.id,
        statusId: subtask.fields.status.id,
        statusName: subtask.fields.status.name,
        isLoading: false,
        hasError: false,
        assigneeUrl: subtask.fields.assignee ? (0, $d4jBl.transformUser)(subtask.fields.assignee).avatarUrl : null,
        assigneeDisplayName: subtask.fields.assignee ? (0, $d4jBl.transformUser)(subtask.fields.assignee).displayName : null,
        issueTimeTracking: subtask.fields.timetracking
    });
const $6c4b6de6e138f69a$export$64c38caf710da25d = (subtasks = [], baseUrl)=>subtasks === null ? [] : subtasks.map((subtask)=>$6c4b6de6e138f69a$var$transformSubtask(subtask, baseUrl));

});



parcelRegister("14sEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b2368e0518afe85$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $fwNZl = parcelRequire("fwNZl");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");

var $2iFnS = parcelRequire("2iFnS");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9b2368e0518afe85$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3XoQX.FETCH_DETAILS_FOR_ISSUES_REQUEST)).switchMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $58aTF.getBaseUrl)(state);
        const issues = (0, $2iFnS.getAllIssues)(state);
        const issueKeys = issues.map((issue)=>issue.issueKey).filter((issueKey)=>issueKey !== undefined);
        // @ts-expect-error - TS2345 - Argument of type '(string | undefined)[]' is not assignable to parameter of type 'string[]'.
        return (0, $kVLXA.Observable).from((0, $fwNZl.default)(baseUrl, issueKeys)).map((detailsForIssues)=>(0, $3XoQX.fetchDetailsForIssuesSuccess)(detailsForIssues)).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.fetch-details-for-issues', 'Failed to fetch details for issues', error);
            return (0, $kVLXA.Observable).empty();
        });
    });

});
parcelRegister("fwNZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fed79ce8374e5fe$export$2e2bcd8739ae039);

var $d4jBl = parcelRequire("d4jBl");

var $jIYAx = parcelRequire("jIYAx");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3fed79ce8374e5fe$export$2e2bcd8739ae039 = (baseUrl, issueKeys)=>(0, $jIYAx.default)(baseUrl, issueKeys).then((issues)=>issues.map(({ id: id, fields: fields })=>({
                id: id,
                assigneeUrl: fields && fields.assignee && (0, $d4jBl.transformUser)(fields.assignee).avatarUrl,
                assigneeDisplayName: fields && fields.assignee && (0, $d4jBl.transformUser)(fields.assignee).displayName
            })));

});
parcelRegister("jIYAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6ff1f023941056c$export$2e2bcd8739ae039);

var $iN8qj = parcelRequire("iN8qj");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e6ff1f023941056c$export$2e2bcd8739ae039 = (baseUrl, issueKeys)=>(0, $iN8qj.fetchBulkIssues)(baseUrl, issueKeys, [
        'assignee'
    ]).toPromise();

});
parcelRegister("iN8qj", function(module, exports) {

$parcel$export(module.exports, "fetchBulkIssues", () => $d3279b94cf6d565c$export$a2c6c774713b6c8);
parcelRequire("d6iim");
parcelRequire("kzFNe");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("64ZAE");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $487fd = parcelRequire("487fd");

var $X0W3Y = parcelRequire("X0W3Y");
const $d3279b94cf6d565c$var$JQL_PAGE_SIZE = 50;
/**
 * transform search result to issue array
 * @param issues
 */ // @ts-expect-error - TS2741 - Property 'issues' is missing in type '{}' but required in type 'SearchResults<T>'.
const $d3279b94cf6d565c$var$searchResultTransformer = ({ issues: issues = [] } = {})=>issues;
const $d3279b94cf6d565c$var$search = (baseUrl, jql, fields)=>{
    const searchUrl = (0, $X0W3Y.getSearchJqlUrl)(baseUrl);
    return (0, $487fd.default)(searchUrl, {
        method: 'POST',
        body: JSON.stringify({
            jql: jql,
            fields: fields
        })
    }).map($d3279b94cf6d565c$var$searchResultTransformer);
};
const $d3279b94cf6d565c$export$a2c6c774713b6c8 = (baseUrl, issueKeys, fields)=>// @ts-expect-error - TS2769 - No overload matches this call.
    (0, $kVLXA.Observable).from(issueKeys).bufferCount($d3279b94cf6d565c$var$JQL_PAGE_SIZE).flatMap((keys)=>$d3279b94cf6d565c$var$search(baseUrl, `key in (${keys.join(',')})`, fields)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce(// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
    (issues, currentBufferedIssues)=>[
            ...issues,
            ...currentBufferedIssues
        ], []);

});




parcelRegister("fcGCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dafc0ef6717e5e8$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $e1AU2 = parcelRequire("e1AU2");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $dX4sl = parcelRequire("dX4sl");

var $fOGZN = parcelRequire("fOGZN");

var $kF1SN = parcelRequire("kF1SN");

var $1C3pQ = parcelRequire("1C3pQ");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");

var $2iFnS = parcelRequire("2iFnS");
const $7dafc0ef6717e5e8$var$linkNextGenChildIssue = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
issueId, state, // eslint-disable-next-line @typescript-eslint/no-explicit-any
analyticsEvent, fieldsValuesActions, associatedIssuesContextActions)=>{
    const baseUrl = (0, $58aTF.getBaseUrl)(state);
    const parentIssueId = (0, $58aTF.getParentId)(state);
    // @ts-expect-error - TS2345 - Type 'ChildIssue | undefined' is not assignable to type 'ChildIssue'.
    const issue = (0, $2iFnS.getIssue)(issueId)(state);
    if (!parentIssueId) throw new Error('Attempted to link a next-gen issue to a parent without issue ID ');
    if (issue?.issueKey) {
        const parentIssueKey = (0, $58aTF.getParentKey)(state);
        fieldsValuesActions?.setIssue(issue.issueKey, {
            summary: issue.issueSummary,
            issueType: {
                iconUrl: issue.issueTypeIconUrl,
                name: 'issuetype'
            }
        });
        const currentChildren = parentIssueKey && fieldsValuesActions?.getFieldValue(parentIssueKey, (0, $fOGZN.CHILDREN_ISSUES)).filter((existingIssue)=>existingIssue.id !== issue.id) || [];
        parentIssueKey && fieldsValuesActions?.mergeIssue(parentIssueKey, {
            [(0, $fOGZN.CHILDREN_ISSUES)]: [
                ...currentChildren,
                {
                    id: issue.id,
                    key: issue.issueKey
                }
            ]
        });
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $kVLXA.Observable).from((0, $1C3pQ.nextGenLinkIssue)(baseUrl, parentIssueId, issueId)).map(()=>(0, $3XoQX.linkChildSuccess)(issueId, issue, analyticsEvent)).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.add-existing-issue', 'Failed to link a next-gen issue to a parent', error);
        if (issue.issueKey) associatedIssuesContextActions?.mergeSingleLocalAssociatedIssueContext(issue.issueKey, {
            hasError: true,
            errorType: (0, $dX4sl.associatedIssueErrorTypes).linkChild
        });
        return (0, $kVLXA.Observable).of((0, $3XoQX.linkingIssueRetryFailure)(issueId));
    });
};
const $7dafc0ef6717e5e8$var$addExistingChildEpic = (fieldsValuesActions, associatedIssuesContextActions)=>(action$, store)=>action$.ofType((0, $3XoQX.ADD_EXISTING_CHILD_ISSUE_REQUEST)).mergeMap(({ payload: { issueId: issueId }, meta: { analyticsEvent: analyticsEvent } })=>{
            const state = store.getState();
            const panelType = (0, $58aTF.getChildIssuesPanelType)(state);
            switch(panelType){
                case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL:
                    return $7dafc0ef6717e5e8$var$linkNextGenChildIssue(issueId, state, analyticsEvent, fieldsValuesActions, associatedIssuesContextActions);
                default:
                    return (0, $kVLXA.Observable).empty();
            }
        });
const $7dafc0ef6717e5e8$var$linkingIssueRetryEpic = (fieldsValuesActions, associatedIssuesContextActions)=>(action$, store)=>action$.ofType((0, $3XoQX.LINKING_ISSUE_RETRY)).mergeMap(({ payload: { issueId: issueId }, meta: { analyticsEvent: analyticsEvent } })=>{
            const state = store.getState();
            const panelType = (0, $58aTF.getChildIssuesPanelType)(state);
            switch(panelType){
                case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_PROJECT_EPIC_CHILDREN:
                    {
                        const baseUrl = (0, $58aTF.getBaseUrl)(state);
                        const parentIssueId = (0, $58aTF.getParentId)(state);
                        // @ts-expect-error - TS2345 - Type 'ChildIssue | undefined' is not assignable to type 'ChildIssue'.
                        const issue = (0, $2iFnS.getIssue)(issueId)(state);
                        if (!parentIssueId) throw new Error('Attempted to link a classic issue to an epic without a parent issue ID');
                        return (0, $kVLXA.Observable).from((0, $1C3pQ.classicEpicLinkIssue)(baseUrl, parentIssueId, issueId)).map(()=>(0, $3XoQX.linkChildSuccess)(issueId, issue, analyticsEvent)).catch((error)=>{
                            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.link-child-issue', 'Failed to link a classic issue to a parent', error);
                            return (0, $kVLXA.Observable).of((0, $3XoQX.linkingIssueRetryFailure)(issueId));
                        });
                    }
                case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL:
                    return $7dafc0ef6717e5e8$var$linkNextGenChildIssue(issueId, state, analyticsEvent, fieldsValuesActions, associatedIssuesContextActions);
                default:
                    return (0, $kVLXA.Observable).empty();
            }
        });
const $7dafc0ef6717e5e8$var$epics = (fieldsValuesActions, associatedIssuesContextActions)=>(0, $e1AU2.combineEpics)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $7dafc0ef6717e5e8$var$linkingIssueRetryEpic(fieldsValuesActions, associatedIssuesContextActions), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $7dafc0ef6717e5e8$var$addExistingChildEpic(fieldsValuesActions, associatedIssuesContextActions));
var $7dafc0ef6717e5e8$export$2e2bcd8739ae039 = $7dafc0ef6717e5e8$var$epics;

});
parcelRegister("dX4sl", function(module, exports) {

$parcel$export(module.exports, "associatedIssueErrorTypes", () => $72e9d9ef2599c4e6$export$e1cf8628ef0f1215);
const $72e9d9ef2599c4e6$export$e1cf8628ef0f1215 = {
    createChild: 'createChild',
    linkChild: 'linkChild'
};

});

parcelRegister("1C3pQ", function(module, exports) {

$parcel$export(module.exports, "classicEpicLinkIssue", () => $4f968d8bcec5a46e$export$e51e6895b9d58e3e);
$parcel$export(module.exports, "nextGenLinkIssue", () => $4f968d8bcec5a46e$export$3c035cbcbc89ca84);

var $eusud = parcelRequire("eusud");
const $4f968d8bcec5a46e$export$e51e6895b9d58e3e = (baseUrl, parentId, issueId)=>(0, $eusud.performPutRequest)(`${baseUrl}/rest/greenhopper/1.0/epics/${parentId}/add`, {
        body: JSON.stringify({
            ignoreEpics: true,
            issueKeys: [
                issueId
            ]
        })
    });
const $4f968d8bcec5a46e$export$3c035cbcbc89ca84 = (baseUrl, parentId, issueId)=>(0, $eusud.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueId}`, {
        body: JSON.stringify({
            fields: {
                parent: {
                    id: parentId
                }
            }
        })
    });

});


parcelRegister("cGWwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ab300a25782ef8$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("64ZAE");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $hhweD = parcelRequire("hhweD");

var $2YZCu = parcelRequire("2YZCu");

var $k3PbQ = parcelRequire("k3PbQ");

var $5v60M = parcelRequire("5v60M");

var $ilOZS = parcelRequire("ilOZS");

var $NJMaZ = parcelRequire("NJMaZ");

var $Br4he = parcelRequire("Br4he");

var $g5X3G = parcelRequire("g5X3G");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$86ab300a25782ef8$export$2e2bcd8739ae039 = (associatedIssuesContextActions, fieldsValuesActions, fieldConfigActions)=>(action$, store)=>action$.ofType((0, $3XoQX.LINK_CHILD_SUCCESS)).do(({ payload: { linkedChild: linkedChild }, meta: meta })=>{
            const state = store.getState();
            const panelType = (0, $58aTF.getChildIssuesPanelType)(state);
            const attributes = {
                action: 'linked',
                actionSubjectId: linkedChild.id,
                attributes: {
                    isInlineChildAdded: true,
                    panelType: panelType
                }
            };
            (0, $hhweD.fireTrackAnalytics)(meta.analyticsEvent, attributes);
        }).switchMap(({ payload: { linkedChild: linkedChild } })=>{
            const state = store.getState();
            const baseUrl = (0, $58aTF.getBaseUrl)(state);
            const issueKey = linkedChild.issueKey !== undefined && linkedChild.issueKey !== null ? (0, $g5X3G.toIssueKey)(linkedChild.issueKey) : undefined;
            const projectKey = issueKey !== undefined ? (0, $k3PbQ.extractProjectKey)(issueKey) : undefined;
            if (!issueKey || !projectKey) {
                const errorMessage = 'Issue or project key missing when handling link child success';
                (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.link-child-success.missing-key', errorMessage, new Error(errorMessage));
                return (0, $kVLXA.Observable).empty();
            }
            return (0, $kVLXA.Observable).from((0, $5v60M.fetchIssueGraphQlData)(baseUrl, issueKey, projectKey)).map(({ data: graphqlData })=>{
                const fieldsData = (0, $Br4he.getGraphQlFields)(graphqlData);
                const issue = {
                    id: graphqlData.issue.id,
                    key: issueKey,
                    self: '',
                    fields: Object.values(fieldsData),
                    // Added to satisfy Flow; `transformChild` will not use these fields
                    agile: {},
                    customFields: {
                        textareaAdf: []
                    },
                    systemFields: {}
                };
                const transformedData = (0, $NJMaZ.transformChild)(issue, (0, $58aTF.getIsSimplifiedProject)(state));
                associatedIssuesContextActions && associatedIssuesContextActions.mergeLocalAssociatedIssuesContext({
                    [issueKey]: {
                        estimateFieldId: transformedData.estimateFieldId,
                        isResolved: transformedData.isResolved ?? false
                    }
                });
                if (fieldsData && fieldsValuesActions && fieldConfigActions) {
                    const { fieldValues: fieldValues, fieldConfigs: fieldConfigs } = (0, $ilOZS.extractFromObject)(fieldsData);
                    fieldsValuesActions.setIssue(issueKey, fieldValues);
                    fieldConfigActions.setIssueConfig(issueKey, fieldConfigs);
                }
                return (0, $3XoQX.fetchSingleChildSuccess)(issue);
            }).catch((error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.link-child-success.fetch-single-issue', 'Failed to fetch single issue after a successful child issue linking', error);
                return (0, $kVLXA.Observable).empty();
            });
        });

});

parcelRegister("cFs5z", function(module, exports) {

$parcel$export(module.exports, "default", () => $82473d796e132a5a$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $kF1SN = parcelRequire("kF1SN");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");

var $dXRKV = parcelRequire("dXRKV");

var $b51Nm = parcelRequire("b51Nm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$82473d796e132a5a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3XoQX.REORDER_CHILDREN_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const panelType = (0, $58aTF.getChildIssuesPanelType)(state);
        switch(panelType){
            case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS:
                return (0, $b51Nm.default)(state, action.payload);
            case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL:
                return (0, $dXRKV.default)(state, action.payload, action.meta);
            default:
                return (0, $kVLXA.Observable).empty();
        }
    });

});
parcelRegister("dXRKV", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc82133b19718e9b$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $ajpes = parcelRequire("ajpes");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $2j7J7 = parcelRequire("2j7J7");

var $5sjbn = parcelRequire("5sjbn");

var $9mVXO = parcelRequire("9mVXO");

var $i7Tkw = parcelRequire("i7Tkw");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");
const $bc82133b19718e9b$var$onFailure = ({ error: error, currentOrder: currentOrder, optimisticOrder: optimisticOrder, currentIndex: currentIndex, newIndex: newIndex })=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.reorder-children', 'Failed to reorder children', error);
    return (0, $kVLXA.Observable).of((0, $3XoQX.reorderChildrenFailed)(currentOrder, optimisticOrder, currentIndex, newIndex));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bc82133b19718e9b$export$2e2bcd8739ae039 = (state, reorderActionPayload, reorderActionMeta)=>{
    const baseUrl = (0, $58aTF.getBaseUrl)(state);
    const parentId = (0, $58aTF.getParentId)(state);
    const customFieldId = (0, $58aTF.getCustomFieldIdRank)(state);
    const { currentOrder: currentOrder, newOrder: optimisticOrder, currentIndex: currentIndex, newIndex: newIndex } = reorderActionPayload;
    if (!parentId) return $bc82133b19718e9b$var$onFailure({
        error: new Error('Attempted to reorder children without parentId'),
        currentOrder: currentOrder,
        optimisticOrder: optimisticOrder,
        currentIndex: currentIndex,
        newIndex: newIndex
    });
    if (!customFieldId) return $bc82133b19718e9b$var$onFailure({
        error: new Error('Attempted to reorder children without customFieldId'),
        currentOrder: currentOrder,
        optimisticOrder: optimisticOrder,
        currentIndex: currentIndex,
        newIndex: newIndex
    });
    const { analyticsEvent: analyticsEvent } = reorderActionMeta;
    const { id: issueId } = currentOrder[currentIndex];
    const issueIds = issueId ? [
        +issueId
    ] : [];
    const isRankAfter = newIndex > currentIndex;
    const rankId = Number((optimisticOrder[isRankAfter ? newIndex - 1 : newIndex + 1] || {}).id);
    if (!rankId) return $bc82133b19718e9b$var$onFailure({
        error: new Error('Attempted to reorder children without rankId'),
        currentOrder: currentOrder,
        optimisticOrder: optimisticOrder,
        currentIndex: currentIndex,
        newIndex: newIndex
    });
    const reorderChildren$ = isRankAfter ? (0, $9mVXO.default)(baseUrl, customFieldId, issueIds, rankId) : (0, $i7Tkw.default)(baseUrl, customFieldId, issueIds, rankId);
    return reorderChildren$.switchMap(()=>(0, $5sjbn.default)(baseUrl, parentId)).flatMap((serverSubtasks = [])=>{
        const serverOrderIds = serverSubtasks.map(({ id: id })=>id);
        const optimisticOrderIds = optimisticOrder.map(({ id: id })=>id);
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueRank updated', {
            numIssues: 1,
            previousIssueIndex: currentIndex,
            currentIssueIndex: newIndex,
            isRankAfter: isRankAfter
        });
        // Server order matches what we are showing, return success action (but this will not change state)
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(serverOrderIds, optimisticOrderIds)) return (0, $kVLXA.Observable).of((0, $3XoQX.reorderChildrenSuccess)(optimisticOrder));
        // Issues are the same, just different order, update our order to match what is returned by the server
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))([
            ...serverOrderIds
        ].sort(), [
            ...optimisticOrderIds
        ].sort())) {
            // @ts-expect-error - TS2322 - Type '(ChildIssue | undefined)[]' is not assignable to type 'ChildIssue[]'.
            const differentOrder = serverOrderIds.map((id)=>optimisticOrder.find((issue)=>issue.id === id));
            return (0, $kVLXA.Observable).of((0, $3XoQX.reorderChildrenSuccess)(differentOrder));
        }
        // Server has a different set of issues, update what we have
        const newOrder = serverSubtasks.map((serverIssue)=>{
            const { id: id } = serverIssue;
            const existingIssue = optimisticOrder.find((issue)=>issue.id === id) || {};
            return {
                ...existingIssue,
                ...(0, $2j7J7.default)(serverIssue, baseUrl)
            };
        });
        return (0, $kVLXA.Observable).of((0, $3XoQX.reorderChildrenSuccess)(newOrder), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $3XoQX.fetchDetailsForIssuesRequest)());
    }).catch((error)=>$bc82133b19718e9b$var$onFailure({
            error: error,
            currentOrder: currentOrder,
            optimisticOrder: optimisticOrder,
            currentIndex: currentIndex,
            newIndex: newIndex
        }));
};

});
parcelRegister("2j7J7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a1d55476bc2ea76$export$2e2bcd8739ae039);

var $gULOk = parcelRequire("gULOk");

var $X0W3Y = parcelRequire("X0W3Y");

var $d4jBl = parcelRequire("d4jBl");

var $g5X3G = parcelRequire("g5X3G");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8a1d55476bc2ea76$export$2e2bcd8739ae039 = (childIssueFromServer, baseUrl)=>{
    const { id: id, key: key, fields: fields } = childIssueFromServer;
    return {
        id: id,
        issueKey: key,
        issueLink: (0, $X0W3Y.getIssueHtmlUrl)((0, $g5X3G.toBaseUrl)(baseUrl), (0, $g5X3G.toIssueKey)(key)),
        issueSummary: fields.summary,
        issueTypeIconUrl: fields.issuetype.iconUrl,
        issueTypeName: fields.issuetype.name,
        issuePriorityUrl: fields.priority && fields.priority.iconUrl || undefined,
        issuePriorityName: fields.priority && fields.priority.name || undefined,
        issuePrioritySequence: fields.priority && fields.priority.sequence || undefined,
        statusCategory: (0, $gULOk.statusCategoryForId)(fields.status.statusCategory.id),
        statusCategoryId: fields.status.statusCategory.id,
        statusName: fields.status.name,
        statusId: fields.status.id,
        assigneeUrl: fields.assignee && (0, $d4jBl.transformUser)(fields.assignee).avatarUrl,
        assigneeDisplayName: fields.assignee && (0, $d4jBl.transformUser)(fields.assignee).displayName,
        isLoading: false,
        errorType: undefined
    };
};

});

parcelRegister("5sjbn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b7d32b8a04b4191$export$2e2bcd8739ae039);
parcelRequire("d0pqD");

var $5fc53 = parcelRequire("5fc53");

var $amDOP = parcelRequire("amDOP");
const $5b7d32b8a04b4191$var$transformResponseToChildren = (response)=>{
    if (!response || !response.data || !response.data.issue) return [];
    const childrenIssues = response.data.issue.fields.find((field)=>field.key === (0, $5fc53.CHILDREN_ISSUES));
    if (childrenIssues && childrenIssues.value) return childrenIssues.value.map(// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'self' implicitly has an 'any' type. | TS7031 - Binding element 'assignee' implicitly has an 'any' type. | TS7031 - Binding element 'issuetype' implicitly has an 'any' type. | TS7031 - Binding element 'priority' implicitly has an 'any' type. | TS7031 - Binding element 'summary' implicitly has an 'any' type. | TS7031 - Binding element 'status' implicitly has an 'any' type.
    ({ id: id, key: key, self: self, fields: { assignee: assignee, issuetype: issuetype, priority: priority, summary: summary, status: status } })=>({
            id: id,
            key: key,
            self: self,
            fields: {
                issueType: issuetype,
                priority: priority,
                status: status,
                summary: summary,
                assignee: assignee
            }
        }));
    return [];
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5b7d32b8a04b4191$export$2e2bcd8739ae039 = (baseUrl, parentId)=>(0, $amDOP.fetchChildren)(baseUrl, parentId).map($5b7d32b8a04b4191$var$transformResponseToChildren);

});
parcelRegister("amDOP", function(module, exports) {

$parcel$export(module.exports, "fetchChildren", () => $d518cd1c56c7bca4$export$c4ff0a3824da3ed4);

var $ftbQH = parcelRequire("ftbQH");

var $487fd = parcelRequire("487fd");
const $d518cd1c56c7bca4$export$5647e6bbf2b3526f = (baseUrl)=>`${baseUrl}/rest/graphql/1/`;
const $d518cd1c56c7bca4$var$getChildrenGraphqlQuery = (parentId)=>(0, $ftbQH.gqlTagRest)`query childrenQuery {
      issue(issueIdOrKey: "${parentId}", latestVersion: true, screen:"view", fields:"subtasks") {
        fields {
          key
          value
        }
      }
    }`;
const $d518cd1c56c7bca4$export$c4ff0a3824da3ed4 = (baseUrl, parentId)=>(0, $487fd.default)($d518cd1c56c7bca4$export$5647e6bbf2b3526f(baseUrl), {
        method: 'POST',
        body: JSON.stringify({
            query: $d518cd1c56c7bca4$var$getChildrenGraphqlQuery(parentId)
        })
    });

});


parcelRegister("9mVXO", function(module, exports) {

$parcel$export(module.exports, "default", () => $522e898f51f6af16$export$2e2bcd8739ae039);

var $jy7EV = parcelRequire("jy7EV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$522e898f51f6af16$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueIds, rankAfterId)=>(0, $jy7EV.default)(baseUrl, customFieldId, issueIds, rankAfterId);

});
parcelRegister("jy7EV", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ce52048b4cb451$export$2e2bcd8739ae039);

var $7zmUm = parcelRequire("7zmUm");
const $19ce52048b4cb451$export$b33bd00367d146dc = (baseUrl)=>`${baseUrl}/rest/greenhopper/1.0/api/rank/after`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$19ce52048b4cb451$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueIds, rankAfterId)=>(0, $7zmUm.default)($19ce52048b4cb451$export$b33bd00367d146dc(baseUrl), {
        method: 'PUT',
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueIds: issueIds,
            rankAfterId: rankAfterId
        })
    });

});


parcelRegister("i7Tkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $dceb386f3882a86b$export$2e2bcd8739ae039);

var $hUp9e = parcelRequire("hUp9e");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dceb386f3882a86b$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueIds, rankBeforeId)=>(0, $hUp9e.default)(baseUrl, customFieldId, issueIds, rankBeforeId);

});
parcelRegister("hUp9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d0abeb4c6f2258$export$2e2bcd8739ae039);

var $7zmUm = parcelRequire("7zmUm");
const $18d0abeb4c6f2258$export$c3989986eef9bdd3 = (baseUrl)=>`${baseUrl}/rest/greenhopper/1.0/api/rank/before`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$18d0abeb4c6f2258$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueIds, rankBeforeId)=>(0, $7zmUm.default)($18d0abeb4c6f2258$export$c3989986eef9bdd3(baseUrl), {
        method: 'PUT',
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueIds: issueIds,
            rankBeforeId: rankBeforeId
        })
    });

});



parcelRegister("b51Nm", function(module, exports) {

$parcel$export(module.exports, "default", () => $38509844479f81e0$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $ajpes = parcelRequire("ajpes");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $2j7J7 = parcelRequire("2j7J7");

var $drGoL = parcelRequire("drGoL");

var $dsIlB = parcelRequire("dsIlB");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$38509844479f81e0$export$2e2bcd8739ae039 = (state, reorderActionPayload)=>{
    const baseUrl = (0, $58aTF.getBaseUrl)(state);
    const parentId = (0, $58aTF.getParentId)(state);
    if (!parentId) throw new Error('Attempted to reorder subtasks without parentId');
    const { currentOrder: currentOrder, newOrder: optimisticOrder, currentIndex: currentIndex, newIndex: newIndex } = reorderActionPayload;
    return (0, $kVLXA.Observable).from((0, $dsIlB.default)(baseUrl, parentId, currentIndex, newIndex)).switchMap(()=>(0, $drGoL.default)(baseUrl, parentId)).flatMap((serverSubtasks = [])=>{
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
        const serverOrderIds = serverSubtasks.map(({ id: id })=>id);
        const optimisticOrderIds = optimisticOrder.map(({ id: id })=>id);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(serverOrderIds, optimisticOrderIds)) // Server order matches what we are showing
        // Return success action (but this will not change state)
        return (0, $kVLXA.Observable).of((0, $3XoQX.reorderChildrenSuccess)(optimisticOrder));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(serverOrderIds.slice().sort(), optimisticOrderIds.slice().sort())) {
            // Issues are the same, just different order
            // Update our order to match what is returned by the server
            // @ts-expect-error - TS7006 - Parameter 'id' implicitly has an 'any' type.
            const differentOrder = serverOrderIds.map((id)=>optimisticOrder.find((issue)=>issue.id === id));
            return (0, $kVLXA.Observable).of((0, $3XoQX.reorderChildrenSuccess)(differentOrder));
        }
        // Server has a different set of issues, update what we have
        // @ts-expect-error - TS7006 - Parameter 'serverIssue' implicitly has an 'any' type.
        const newOrder = serverSubtasks.map((serverIssue)=>{
            const { id: id } = serverIssue;
            const existingIssue = optimisticOrder.find((issue)=>issue.id === id) || {};
            return {
                ...existingIssue,
                ...(0, $2j7J7.default)(serverIssue, baseUrl)
            };
        });
        return (0, $kVLXA.Observable).of((0, $3XoQX.reorderChildrenSuccess)(newOrder), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $3XoQX.fetchDetailsForIssuesRequest)());
    }).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.views.common.child-issues-panel.reorder-subtask', 'Failed to reorder subtasks', error);
        // Reordering failed, put order back to current order
        // Will also show error flag
        return (0, $kVLXA.Observable).of((0, $3XoQX.reorderChildrenFailed)(currentOrder, optimisticOrder, currentIndex, newIndex));
    });
};

});
parcelRegister("drGoL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2640d7d4061507a$export$2e2bcd8739ae039);

var $cd4JM = parcelRequire("cd4JM");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e2640d7d4061507a$export$2e2bcd8739ae039 = (baseUrl, parentId)=>(0, $cd4JM.default)(baseUrl, parentId).then((response)=>{
        const fields = response && response.fields;
        return fields && fields.subtasks || [];
    });

});
parcelRegister("cd4JM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b39c95e64a545c1$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2b39c95e64a545c1$export$2e2bcd8739ae039 = (baseUrl, parentId)=>(0, $eusud.performGetRequest)(`${baseUrl}/rest/api/2/issue/${parentId}?fields=subtasks`);

});


parcelRegister("dsIlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f37aaf4eac7a3c8$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");

var $4tcSU = parcelRequire("4tcSU");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5f37aaf4eac7a3c8$export$2e2bcd8739ae039 = (baseUrl, parentId, currentIndex, newIndex)=>{
    const url = `${baseUrl}/secure/MoveSubtask.jspa?id=${parentId}&currentSubTaskSequence=${currentIndex}&subTaskSequence=${newIndex}&atl_token=${(0, $4tcSU.default)() || ''}`;
    return fetch(url).then((response)=>{
        if (!response.ok) return response.text().then((str)=>{
            throw new (0, $jJZqs.default)(response.status, str);
        });
        // MoveIssueLink.jspa will return 200 and redirect to /browse/<issue-key> which will return raw HTML
        // So return 'null' instead as we don't care about the response
        return null;
    });
};

});



parcelRegister("5EIeG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b904b31d80c938e$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $bF6vO = parcelRequire("bF6vO");

var $58aTF = parcelRequire("58aTF");

var $cKgFM = parcelRequire("cKgFM");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6b904b31d80c938e$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $bF6vO.REQUIRES_FULL_CREATE_CHECK)).switchMap(()=>{
        const state = store.getState();
        const projectId = (0, $58aTF.getProjectId)(state);
        if (!projectId) return (0, $kVLXA.Observable).of((0, $bF6vO.requiresFullCreateCheckFailed)());
        return (0, $cKgFM.default)(projectId);
    });

});
parcelRegister("bF6vO", function(module, exports) {

$parcel$export(module.exports, "SET_CONTEXT", () => $68158c3ec41a0e77$export$4bc4e62e7d72b94b);
$parcel$export(module.exports, "setContext", () => $68158c3ec41a0e77$export$2f04de43fe27971a);
$parcel$export(module.exports, "SET_IS_ISSUE_VIEW_COMPLETE", () => $68158c3ec41a0e77$export$7906e119740223d7);
$parcel$export(module.exports, "REQUIRES_FULL_CREATE_CHECK", () => $68158c3ec41a0e77$export$11f9caff9aa53e6a);
$parcel$export(module.exports, "requiresFullCreateCheckRequest", () => $68158c3ec41a0e77$export$8ad448f541bd5099);
$parcel$export(module.exports, "REQUIRES_FULL_CREATE_CHECK_SUCCESS", () => $68158c3ec41a0e77$export$fe5c3e6a90862d04);
$parcel$export(module.exports, "requiresFullCreateCheckByIssueTypeSuccess", () => $68158c3ec41a0e77$export$be54c5b4f726a6c4);
$parcel$export(module.exports, "REQUIRES_FULL_CREATE_CHECK_FAILED", () => $68158c3ec41a0e77$export$4a904833093be872);
$parcel$export(module.exports, "requiresFullCreateCheckFailed", () => $68158c3ec41a0e77$export$ad6ee95a5a7f3bc6);
$parcel$export(module.exports, "SET_ONCHANGE", () => $68158c3ec41a0e77$export$72f058c6cfbb696e);
$parcel$export(module.exports, "setOnChange", () => $68158c3ec41a0e77$export$fb48ec7ce2339254);
const $68158c3ec41a0e77$export$4bc4e62e7d72b94b = 'state.context.SET_CONTEXT';
const $68158c3ec41a0e77$export$2f04de43fe27971a = (payload)=>({
        type: $68158c3ec41a0e77$export$4bc4e62e7d72b94b,
        payload: payload
    });
const $68158c3ec41a0e77$export$7906e119740223d7 = 'state.context.SET_IS_ISSUE_VIEW_COMPLETE';
const $68158c3ec41a0e77$export$ce1edafd23575c54 = (payload)=>({
        type: $68158c3ec41a0e77$export$7906e119740223d7,
        payload: payload
    });
const $68158c3ec41a0e77$export$11f9caff9aa53e6a = 'state.context.REQUIRES_FULL_CREATE_CHECK';
const $68158c3ec41a0e77$export$8ad448f541bd5099 = ()=>({
        type: $68158c3ec41a0e77$export$11f9caff9aa53e6a
    });
const $68158c3ec41a0e77$export$fe5c3e6a90862d04 = 'state.context.REQUIRES_FULL_CREATE_CHECK_SUCCESS';
const $68158c3ec41a0e77$export$be54c5b4f726a6c4 = (requiresFullCreateByIssueType)=>({
        type: $68158c3ec41a0e77$export$fe5c3e6a90862d04,
        payload: {
            requiresFullCreateByIssueType: requiresFullCreateByIssueType
        }
    });
const $68158c3ec41a0e77$export$4a904833093be872 = 'state.context.REQUIRES_FULL_CREATE_CHECK_FAILED';
const $68158c3ec41a0e77$export$ad6ee95a5a7f3bc6 = ()=>({
        type: $68158c3ec41a0e77$export$4a904833093be872
    });
const $68158c3ec41a0e77$export$72f058c6cfbb696e = 'state.context.SET_ONCHANGE';
const $68158c3ec41a0e77$export$fb48ec7ce2339254 = (payload)=>({
        type: $68158c3ec41a0e77$export$72f058c6cfbb696e,
        payload: payload
    });

});

parcelRegister("cKgFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0ff3aa73cb3c14b$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $6r7fT = parcelRequire("6r7fT");

var $bF6vO = parcelRequire("bF6vO");

var $01Me8 = parcelRequire("01Me8");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a0ff3aa73cb3c14b$export$2e2bcd8739ae039 = (projectId)=>(0, $kVLXA.Observable).from((0, $01Me8.default)(projectId)).map((result)=>(0, $bF6vO.requiresFullCreateCheckByIssueTypeSuccess)(result)).catch((error)=>{
        (0, $6r7fT.trackOrLogClientError)('issue.views.common.child-issues-panel.has-validators-on-issue-types', 'Failed to check if project has validators by issue type', error);
        return (0, $kVLXA.Observable).of((0, $bF6vO.requiresFullCreateCheckFailed)());
    });

});
parcelRegister("01Me8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf8363f9a711c408$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bf8363f9a711c408$export$2e2bcd8739ae039 = (projectId)=>(0, $eusud.performGetRequest)(`/rest/internal/2/project/${projectId}/hasValidatorsByIssueType`);
const $bf8363f9a711c408$export$419d6a5ca3b61473 = (projectId)=>(0, $eusud.performGetRequest)(`/rest/internal/2/project/${projectId}/hasValidatorsOnAnyIssueTypes`);
const $bf8363f9a711c408$export$3497258b64dc073f = (baseUrl, projectId)=>(0, $eusud.performGetRequest)(`${baseUrl}/rest/internal/2/project/${projectId}/hasValidatorsOnSubtasks`);

});




parcelRegister("byz9x", function(module, exports) {

$parcel$export(module.exports, "default", () => $92c03cefd5e3b039$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $fhr6M = parcelRequire("fhr6M");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$92c03cefd5e3b039$export$2e2bcd8739ae039 = (rootEpic, parentKey, panelType)=>(0, $F2Mxm.default)({
        appName: `${parentKey}-child-issues-panel-${panelType}`,
        rootReducer: $fhr6M.default,
        rootEpic: rootEpic
    });

});
parcelRegister("fhr6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a52699ecf7e577a$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $7Lqnb = parcelRequire("7Lqnb");

var $bGfQ4 = parcelRequire("bGfQ4");

var $2EtfV = parcelRequire("2EtfV");
var $2a52699ecf7e577a$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    context: $7Lqnb.default,
    ui: $2EtfV.default,
    entities: $bGfQ4.default
});

});
parcelRegister("7Lqnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $58a24434ea6724d7$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $lzeFL = parcelRequire("lzeFL");

var $g5X3G = parcelRequire("g5X3G");

var $bF6vO = parcelRequire("bF6vO");
const $58a24434ea6724d7$export$49d5fc8cba920a0 = {
    baseUrl: (0, $g5X3G.toBaseUrl)(''),
    locale: (0, $lzeFL.defaultLocale),
    user: null,
    childIssuesPanelType: null,
    supportsIssueCreation: false,
    requiresFullCreate: false,
    requiresFullCreateByIssueType: {},
    parentKey: null,
    customFieldIdRank: null,
    epicLinkFieldKey: null,
    parentId: null,
    projectId: null,
    parentIssueTypeId: null,
    messages: null,
    onNavigateToNewIssue: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isIssueViewComplete: false,
    projectType: null,
    application: null,
    edition: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onEditAssociatedIssue: ()=>{},
    isSimplifiedProject: false,
    filterSubtasks: null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$58a24434ea6724d7$export$2e2bcd8739ae039 = (state = $58a24434ea6724d7$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $bF6vO.SET_CONTEXT:
            return {
                ...state,
                ...action.payload
            };
        case 0, $bF6vO.SET_ONCHANGE:
            return {
                ...state,
                onChange: action.payload
            };
        case 0, $bF6vO.REQUIRES_FULL_CREATE_CHECK_SUCCESS:
            return {
                ...state,
                ...action.payload
            };
        case 0, $bF6vO.REQUIRES_FULL_CREATE_CHECK_FAILED:
            return {
                ...state,
                requiresFullCreate: true,
                requiresFullCreateByIssueType: {}
            };
        case 0, $bF6vO.SET_IS_ISSUE_VIEW_COMPLETE:
            return {
                ...state,
                isIssueViewComplete: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("bGfQ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e19ffc1384ce4c9b$export$2e2bcd8739ae039);

var $1sWm7 = parcelRequire("1sWm7");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $dX4sl = parcelRequire("dX4sl");

var $3XoQX = parcelRequire("3XoQX");
const $e19ffc1384ce4c9b$export$49d5fc8cba920a0 = {
    issues: [],
    issueTypes: [],
    issueHierarchyLevel: undefined,
    recentlyCreatedIssue: undefined,
    recentlyLinkedChildIssue: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e19ffc1384ce4c9b$export$2e2bcd8739ae039 = (state = $e19ffc1384ce4c9b$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $3XoQX.SET_ENTITIES:
            {
                const { issueTypes: issueTypes, issues: issues, issueHierarchyLevel: issueHierarchyLevel } = action.payload;
                return {
                    ...state,
                    issues: issues,
                    issueTypes: issueTypes,
                    issueHierarchyLevel: issueHierarchyLevel
                };
            }
        case 0, $3XoQX.UPDATE_ISSUE:
            return state;
        case 0, $3XoQX.CREATE_CHILD_REQUEST:
            {
                const optimisticChild = {
                    ...action.payload.optimisticUiChildIssue,
                    isLoading: true,
                    errorType: undefined
                };
                return {
                    ...state,
                    issues: state.issues.filter((issue)=>issue.id !== optimisticChild.id).concat(optimisticChild)
                };
            }
        case 0, $3XoQX.CREATE_CHILD_SUCCESS:
            {
                const { optimisticId: optimisticId, createdChild: createdChild, usedGlobalCreateDialog: usedGlobalCreateDialog } = action.payload;
                return (0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) ? {
                    ...state,
                    recentlyCreatedIssue: {
                        issueId: createdChild.id || createdChild.issueId || '',
                        issueKey: createdChild.issueKey || '',
                        usedGlobalCreateDialog: usedGlobalCreateDialog
                    },
                    issues: state.issues.filter((issue)=>issue.id !== optimisticId).concat(createdChild)
                } : {
                    ...state,
                    issues: state.issues.filter((issue)=>issue.id !== optimisticId).concat(createdChild)
                };
            }
        case 0, $3XoQX.FETCH_SINGLE_CHILD_SUCCESS:
            {
                const { childIssue: childIssue } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>issue.id === childIssue.id ? childIssue : issue)
                };
            }
        case 0, $3XoQX.FETCH_GRAPHQL_ISSUE_SUCCESS:
            {
                const { childIssue: childIssue } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>issue.id === childIssue.id ? childIssue : issue)
                };
            }
        case 0, $3XoQX.CREATE_CHILD_FAILURE:
            {
                const { optimisticId: optimisticId, error: error } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>{
                        if (issue.id === optimisticId) return {
                            ...issue,
                            error: error,
                            errorType: (0, $dX4sl.associatedIssueErrorTypes).createChild,
                            isLoading: false
                        };
                        return issue;
                    })
                };
            }
        case 0, $3XoQX.LINKING_ISSUE_FAILURE:
            {
                const { optimisticId: optimisticId, createdChild: createdChild } = action.payload;
                return {
                    ...state,
                    issues: state.issues.filter((issue)=>issue.id !== optimisticId).concat({
                        ...createdChild,
                        errorType: (0, $dX4sl.associatedIssueErrorTypes).linkChild,
                        isLoading: false
                    })
                };
            }
        case 0, $3XoQX.CREATE_CHILD_RETRY:
            {
                const { optimisticId: optimisticId } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>{
                        if (issue.id === optimisticId) return {
                            ...issue,
                            errorType: undefined,
                            isLoading: true
                        };
                        return issue;
                    })
                };
            }
        case 0, $3XoQX.LINKING_ISSUE_RETRY:
            {
                const { issueId: issueId } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>{
                        if (issue.id === issueId) return {
                            ...issue,
                            errorType: undefined,
                            isLoading: true
                        };
                        return issue;
                    })
                };
            }
        case 0, $3XoQX.LINKING_ISSUE_RETRY_FAILURE:
            {
                const { issueId: issueId } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>{
                        if (issue.id === issueId) return {
                            ...issue,
                            errorType: (0, $dX4sl.associatedIssueErrorTypes).linkChild,
                            isLoading: false
                        };
                        return issue;
                    })
                };
            }
        case 0, $3XoQX.LINK_CHILD_SUCCESS:
            {
                const { linkedChild: linkedChild } = action.payload;
                return {
                    ...state,
                    recentlyLinkedChildIssue: linkedChild
                };
            }
        // For LINK_PARENT_FAILURE: Can't easily offer retry to link,
        // so remove child row from issues list (will pop up a flag instead)
        case 0, $3XoQX.LINK_PARENT_FAILURE:
        case 0, $3XoQX.CANCEL_OPTIMISTIC_CHILD:
            {
                const { optimisticId: optimisticId } = action.payload;
                return {
                    ...state,
                    issues: state.issues.filter((issue)=>issue.id !== optimisticId)
                };
            }
        case 0, $3XoQX.FETCH_DETAILS_FOR_ISSUES_SUCCESS:
            {
                if ((0, $4R6GH.fg)('jira-issue-view-child-issues-panel-performance')) return state;
                const { issues: issues } = action.payload;
                return {
                    ...state,
                    issues: state.issues.map((issue)=>({
                            ...issue,
                            ...(0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(issues, (issueWithDetails)=>issueWithDetails.id === issue.id)
                        }))
                };
            }
        case 0, $3XoQX.REORDER_CHILDREN_REQUEST:
        case 0, $3XoQX.REORDER_CHILDREN_SUCCESS:
            {
                if ((0, $4R6GH.fg)('jira-issue-view-child-issues-panel-performance')) return state;
                const { newOrder: newOrder } = action.payload;
                return {
                    ...state,
                    issues: newOrder
                };
            }
        case 0, $3XoQX.REORDER_CHILDREN_FAILED:
            {
                if ((0, $4R6GH.fg)('jira-issue-view-child-issues-panel-performance')) return state;
                const { originalOrder: originalOrder } = action.payload;
                return {
                    ...state,
                    issues: originalOrder
                };
            }
        case 0, $3XoQX.ADD_EXISTING_CHILD_ISSUE_REQUEST:
            {
                const child = {
                    id: action.payload.issueId,
                    issueKey: action.payload.issueKey,
                    issueSummary: action.payload.issueSummary,
                    issueTypeIconUrl: action.payload.issueTypeIconUrl,
                    assigneeUrl: null,
                    assigneeDisplayName: null,
                    isLoading: true,
                    errorType: undefined
                };
                return {
                    ...state,
                    // The intention is to show the new added issue at the bottom of the list if it's already a child of the current issue.
                    issues: state.issues.filter((issue)=>issue.id !== child.id).concat(child)
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("2EtfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c81f3dc8fdc793$export$2e2bcd8739ae039);


var $6s1PB = parcelRequire("6s1PB");

var $dvqTC = parcelRequire("dvqTC");
const $b3c81f3dc8fdc793$export$49d5fc8cba920a0 = {
    addClickCount: 0,
    hideDone: false,
    selectedIssueType: null,
    childPanelView: (0, $dvqTC.CHILD_PANEL_VIEWS).InlineCreate,
    childCreateSummary: '',
    fetchIssueTypesStatus: (0, $d938a6f4f1d90c4d$export$e0428a74c92c3e81),
    triggeredViaHotKey: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3c81f3dc8fdc793$export$2e2bcd8739ae039 = (state = $b3c81f3dc8fdc793$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $dvqTC.SHOW_INLINE_CREATE:
            return {
                ...state,
                addClickCount: state.addClickCount + 1,
                ...(0, $6s1PB.expVal)('quick_actions_m3_experiment', 'hotKeysEnabled', false) ? {
                    // @ts-expect-error Property 'triggeredViaHotKey' does not exist on type 'FetchIssueTypesStatusState | { triggeredViaHotKey: boolean; }'.
                    triggeredViaHotKey: !!action.payload?.triggeredViaHotKey
                } : {}
            };
        case 0, $dvqTC.HIDE_ADD_CHILD_ISSUE:
            return {
                ...state,
                addClickCount: 0,
                childPanelView: (0, $dvqTC.CHILD_PANEL_VIEWS).InlineCreate,
                childCreateSummary: ''
            };
        case 0, $dvqTC.SET_CHILD_PANEL_VIEW:
            return {
                ...state,
                // @ts-expect-error - TS2339 - Property 'view' does not exist on type '{ type: "state.ui.SET_CHILD_PANEL_VIEW"; view: string; } | { type: string; payload: FetchIssueTypesStatusState; }'.
                childPanelView: action.view
            };
        case 0, $dvqTC.SET_CHILD_CREATE_SUMMARY:
            return {
                ...state,
                // @ts-expect-error - TS2339 - Property 'summary' does not exist on type '{ type: "state.ui.SET_CHILD_CREATE_SUMMARY"; summary: string; } | { type: string; payload: FetchIssueTypesStatusState; }'.
                childCreateSummary: action.summary
            };
        case 0, $dvqTC.TOGGLE_HIDE_DONE:
            return {
                ...state,
                hideDone: !state.hideDone
            };
        case 0, $dvqTC.SELECTED_ISSUE_TYPE_CHANGED:
            return {
                ...state,
                // @ts-expect-error - TS2322 - Type 'FetchIssueTypesStatusState | ChildIssueType' is not assignable to type 'ChildIssueType | null'.
                selectedIssueType: action.payload
            };
        case 0, $dvqTC.SET_FETCH_ISSUE_TYPES_STATUS:
            return {
                ...state,
                fetchIssueTypesStatus: action.payload
            };
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            action;
            return state;
    }
};

});
parcelRegister("dvqTC", function(module, exports) {

$parcel$export(module.exports, "SHOW_INLINE_CREATE", () => $6847f0f81cc7289a$export$aedc88716849b09d);
$parcel$export(module.exports, "showInlineCreate", () => $6847f0f81cc7289a$export$e21bcad34d98588b);
$parcel$export(module.exports, "HIDE_ADD_CHILD_ISSUE", () => $6847f0f81cc7289a$export$7e7e34d67d20f471);
$parcel$export(module.exports, "hideAddChildIssue", () => $6847f0f81cc7289a$export$e98004722e858eaf);
$parcel$export(module.exports, "SET_CHILD_PANEL_VIEW", () => $6847f0f81cc7289a$export$255c2674d2c029a8);
$parcel$export(module.exports, "CHILD_PANEL_VIEWS", () => $6847f0f81cc7289a$export$12c7b36016c70ee5);
$parcel$export(module.exports, "setChildPanelView", () => $6847f0f81cc7289a$export$2f50b33f6ec7d8cc);
$parcel$export(module.exports, "SET_CHILD_CREATE_SUMMARY", () => $6847f0f81cc7289a$export$dccc9c56d8960fce);
$parcel$export(module.exports, "setChildCreateSummary", () => $6847f0f81cc7289a$export$c2e49d97bf739a27);
$parcel$export(module.exports, "TOGGLE_HIDE_DONE", () => $6847f0f81cc7289a$export$4afca1f9886a5e5e);
$parcel$export(module.exports, "toggleHideDone", () => $6847f0f81cc7289a$export$6a5a86b429b01cee);
$parcel$export(module.exports, "SELECTED_ISSUE_TYPE_CHANGED", () => $6847f0f81cc7289a$export$64db7e478390882d);
$parcel$export(module.exports, "selectedIssueTypeChanged", () => $6847f0f81cc7289a$export$665d401a739df722);
$parcel$export(module.exports, "SET_FETCH_ISSUE_TYPES_STATUS", () => $6847f0f81cc7289a$export$fccdb586e917187a);
$parcel$export(module.exports, "setFetchIssueTypesStatus", () => $6847f0f81cc7289a$export$4e831a1392ac2182);

var $6s1PB = parcelRequire("6s1PB");
const $6847f0f81cc7289a$export$aedc88716849b09d = 'state.ui.SHOW_INLINE_CREATE';
const $6847f0f81cc7289a$export$e21bcad34d98588b = (payload)=>({
        type: $6847f0f81cc7289a$export$aedc88716849b09d,
        ...(0, $6s1PB.expVal)('quick_actions_m3_experiment', 'hotKeysEnabled', false) ? {
            payload: payload
        } : {}
    });
const $6847f0f81cc7289a$export$7e7e34d67d20f471 = 'state.ui.HIDE_ADD_CHILD_ISSUE';
const $6847f0f81cc7289a$export$e98004722e858eaf = ()=>({
        type: $6847f0f81cc7289a$export$7e7e34d67d20f471
    });
const $6847f0f81cc7289a$export$255c2674d2c029a8 = 'state.ui.SET_CHILD_PANEL_VIEW';
const $6847f0f81cc7289a$export$12c7b36016c70ee5 = Object.freeze({
    InlineCreate: 'InlineCreate',
    AddExistingIssue: 'AddExistingIssue'
});
const $6847f0f81cc7289a$export$2f50b33f6ec7d8cc = (view)=>({
        type: $6847f0f81cc7289a$export$255c2674d2c029a8,
        view: view
    });
const $6847f0f81cc7289a$export$dccc9c56d8960fce = 'state.ui.SET_CHILD_CREATE_SUMMARY';
const $6847f0f81cc7289a$export$c2e49d97bf739a27 = (summary)=>({
        type: $6847f0f81cc7289a$export$dccc9c56d8960fce,
        summary: summary
    });
const $6847f0f81cc7289a$export$4afca1f9886a5e5e = 'state.ui.TOGGLE_HIDE_DONE';
const $6847f0f81cc7289a$export$6a5a86b429b01cee = ()=>({
        type: $6847f0f81cc7289a$export$4afca1f9886a5e5e
    });
const $6847f0f81cc7289a$export$64db7e478390882d = 'state.ui.SELECTED_ISSUE_TYPE_CHANGED';
const $6847f0f81cc7289a$export$665d401a739df722 = (payload)=>({
        type: $6847f0f81cc7289a$export$64db7e478390882d,
        payload: payload
    });
const $6847f0f81cc7289a$export$fccdb586e917187a = 'state.ui.SET_FETCH_ISSUE_TYPES_STATUS';
const $6847f0f81cc7289a$export$4e831a1392ac2182 = (payload)=>({
        type: $6847f0f81cc7289a$export$fccdb586e917187a,
        payload: payload
    });

});




parcelRegister("5otrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c443ec7987755d8$export$2e2bcd8739ae039);

var $8oe80 = parcelRequire("8oe80");

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");

var $2iFnS = parcelRequire("2iFnS");

var $dvqTC = parcelRequire("dvqTC");

var $dtS0b = parcelRequire("dtS0b");

var $cadt1 = parcelRequire("cadt1");

var $lkZTd = parcelRequire("lkZTd");

var $eXTjX = parcelRequire("eXTjX");

var $eXYrX = parcelRequire("eXYrX");

var $6wTDL = parcelRequire("6wTDL");

var $duaxD = parcelRequire("duaxD");
const $2c443ec7987755d8$var$FlowWithSafeComponent = (0, $dRLCn.flowWithSafeComponent)(// @ts-expect-error - Argument of type '<T extends ComponentType<any>, Props = ComponentPropsWithRef<T>>(WrappedComponent: T) => FC<Omit<{ [K in keyof Props]: K extends "onFullDialogCreate" | "onSuggestedChildIssueCreateSuccess" ? (...args: [......]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>' is not assignable to parameter of type 'FlowStep<T, ComponentType<Matching<({ Heading: ConnectedComponent<typeof Heading, { childIssuesLimitStatus: ChildIssuesLimitStatus; sourceName?: string | undefined; onAddChildClick: AddChildEventHandler | undefined; issueHierarchyLevel: number | undefined; context?: Context<...> | undefined; store?: Store<...> | und...'.
(0, $8oe80.default)('childIssuePanelInlineCreate', {
    onFullDialogCreate: 'onFullDialogCreate',
    onSuggestedChildIssueCreateSuccess: 'onSuggestedChildIssueCreateSuccess'
}), (0, $hxqfC.connect)((state)=>{
    if (!state) // Monitoring has shown that state can be `undefined` but we have
    // not been able to replicate it.
    return {
        Heading: $lkZTd.default,
        InlineCreate: $eXTjX.default,
        Issues: $eXYrX.default,
        ProgressSummary: $6wTDL.default,
        AddExistingIssue: $cadt1.default,
        childPanelView: (0, $dvqTC.CHILD_PANEL_VIEWS).InlineCreate,
        allIssues: [],
        incompleteIssues: [],
        addClickCount: 0,
        noValueText: null,
        projectId: null,
        parentIssueTypeId: null
    };
    return {
        Heading: $lkZTd.default,
        InlineCreate: $eXTjX.default,
        Issues: $eXYrX.default,
        ProgressSummary: $6wTDL.default,
        AddExistingIssue: $cadt1.default,
        childPanelView: (0, $dtS0b.getChildPanelView)(state),
        allIssues: (0, $2iFnS.getAllIssues)(state),
        incompleteIssues: (0, $2iFnS.getIncompleteIssues)(state),
        addClickCount: (0, $dtS0b.getAddClickCount)(state),
        noValueText: (0, $58aTF.getNoValueText)(state),
        childIssuesPanelType: (0, $58aTF.getChildIssuesPanelType)(state),
        issueHierarchyLevel: (0, $2iFnS.getIssueHierarchyLevel)(state),
        epicLinkFieldKey: (0, $58aTF.getEpicLinkFieldKey)(state),
        parentIssueKey: (0, $58aTF.getParentKey)(state),
        baseUrl: (0, $58aTF.getBaseUrl)(state),
        // getIssueTypes only gets the issue types available for child issues
        childIssueTypes: (0, $2iFnS.getIssueTypes)(state),
        issueTypeWithWorkflowValidators: (0, $58aTF.getIssueTypeWFValidators)(state),
        projectId: (0, $58aTF.getProjectId)(state),
        parentIssueTypeId: (0, $58aTF.getParentIssueTypeId)(state),
        filterSubtasks: (0, $58aTF.getFilterSubtasks)(state)
    };
}, {
    onFullDialogCreate: (optimisticId, childIssue, additionalAttributes, analyticsEvent)=>(0, $3XoQX.childCreatedInFullDialog)(optimisticId, childIssue, analyticsEvent, additionalAttributes),
    onSuggestedChildIssueCreateSuccess: (createdChild, additionalAttributes, analyticsEvent)=>(0, $3XoQX.createChildSuccess)(createdChild.id, createdChild, analyticsEvent, false, additionalAttributes)
}))((0, $duaxD.ChildIssuesPanel));
var $2c443ec7987755d8$export$2e2bcd8739ae039 = $2c443ec7987755d8$var$FlowWithSafeComponent;

});
parcelRegister("cadt1", function(module, exports) {

$parcel$export(module.exports, "default", () => $27a778a7a294b7ad$export$2e2bcd8739ae039);

var $iQv12 = parcelRequire("iQv12");

var $8oe80 = parcelRequire("8oe80");

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");

var $2iFnS = parcelRequire("2iFnS");

var $dvqTC = parcelRequire("dvqTC");

var $dtS0b = parcelRequire("dtS0b");

var $luOW2 = parcelRequire("luOW2");
var $27a778a7a294b7ad$export$2e2bcd8739ae039 = (0, $dRLCn.flowWithSafeComponent)((0, $8oe80.default)('button', {
    onAdd: 'clicked',
    onCancel: 'clicked',
    onCreate: 'clicked'
}), (0, $iQv12.default)({
    onAdd: 'addExistingChildIssueRequest',
    onCancel: 'hideAddExistingChildIssue',
    onCreate: 'switchToCreateChildIssue'
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ addClickCount: number; initialValue: string; issueKey: string | null; jql: string; projectId: string | null; } & { onAdd: (issue: any, analyticsEvent: any) => { type: "state.entities.ADD_EXISTING_CHILD_ISSUE_REQUEST"; payload: { ...; }; meta: { ...; }; }; onCancel: () => { ...; ...' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof Props]: K extends "onAdd" | "onCancel" | "onCreate" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>, { ...; }>, ConnectedComponent<...>>'.
(0, $hxqfC.connect)((state)=>({
        addClickCount: (0, $dtS0b.getAddClickCount)(state),
        initialValue: (0, $dtS0b.getChildCreateSummary)(state),
        issueKey: (0, $58aTF.getParentKey)(state),
        jql: (0, $2iFnS.getNextGenChildrenIssueTypesJql)(state),
        projectId: (0, $58aTF.getProjectId)(state)
    }), (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
        onAdd: (issue, analyticsEvent)=>dispatch((0, $3XoQX.addExistingChildIssueRequest)(issue, analyticsEvent)),
        onCancel: ()=>dispatch((0, $dvqTC.hideAddChildIssue)()),
        onCreate: (inputValue)=>{
            dispatch((0, $dvqTC.setChildCreateSummary)(inputValue));
            dispatch((0, $dvqTC.setChildPanelView)((0, $dvqTC.CHILD_PANEL_VIEWS).InlineCreate));
        }
    })))((0, $luOW2.default));

});
parcelRegister("luOW2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1896764301a020c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fW62l = parcelRequire("fW62l");

var $fVnbM = parcelRequire("fVnbM");

var $i0vxP = parcelRequire("i0vxP");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $8FQuT = parcelRequire("8FQuT");

var $b8JO7 = parcelRequire("b8JO7");

var $1XJ20 = parcelRequire("1XJ20");

var $2NMNM = parcelRequire("2NMNM");

var $7my8Y = parcelRequire("7my8Y");
const $b1896764301a020c$export$bfa3a4c19902779f = ({ issueKey: issueKey, initialValue: initialValue = '', jql: jql, projectId: projectId, addClickCount: addClickCount, onAdd: onAdd, onCancel: onCancel, onCreate: onCreate })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const [selectedIssue, setSelectedIssue] = (0, $5uXOq.useState)();
    const [isDisabled, setIsDisabled] = (0, $5uXOq.useState)(true);
    const previousAddClickCount = (0, $1XJ20.usePrevious)(addClickCount);
    const childContainer = (0, $5uXOq.useRef)(null);
    const issuePicker = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2NMNM.useAnalyticsEvents)() : {
        createAnalyticsEvent: undefined
    };
    const focusPicker = (0, $5uXOq.useCallback)(()=>{
        issuePicker.current?.focus?.();
    }, []);
    const resetPicker = (0, $5uXOq.useCallback)(()=>{
        issuePicker.current?.reset();
    }, []);
    const onAddClicked = (0, $5uXOq.useCallback)(()=>{
        if (selectedIssue) {
            if (createAnalyticsEvent && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $8ikZj.ENTITY_FIELD_KEYS).PARENT, {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: 'parent',
                    updatedIssueId: selectedIssue.issueId
                }
            });
            onAdd(selectedIssue);
            resetPicker();
        }
    }, [
        createAnalyticsEvent,
        onAdd,
        resetPicker,
        selectedIssue
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)((issue)=>{
        setSelectedIssue(issue);
        setIsDisabled(false);
    }, []);
    const onClearClicked = (0, $5uXOq.useCallback)(()=>{
        setSelectedIssue(undefined);
        setIsDisabled(true);
    }, []);
    const onCancelClicked = (0, $5uXOq.useCallback)(()=>{
        onClearClicked();
        onCancel();
    }, [
        onCancel,
        onClearClicked
    ]); // AK Select Component's select on enter behaviour is broken if we use EnterEscapeHandler to handle enter key,
    // So we have to handle it separately here
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter')) {
            onAddClicked();
            event.stopPropagation();
        }
    }, [
        onAddClicked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $b8JO7.smoothScrollIntoCenterIfNeeded)(childContainer.current);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (addClickCount !== previousAddClickCount) {
            (0, $b8JO7.smoothScrollIntoCenterIfNeeded)(childContainer.current);
            focusPicker();
        }
    }, [
        addClickCount,
        focusPicker,
        previousAddClickCount
    ]); // TODO: remove create analtyics events from condition when cleaning up one_event_rules_them_all_fg
    if (createAnalyticsEvent && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $8ikZj.ENTITY_FIELD_KEYS).PARENT, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: 'parent'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    if (!issueKey || !projectId) return null;
    const ariaLabel = intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7my8Y.default).ariaLabelForAddExistingIssueIssueTermRefresh : (0, $7my8Y.default).ariaLabelForAddExistingIssue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEscape: onCancelClicked
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        onKeyDown: onKeyDown,
        ref: childContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8FQuT.default), {
        ref: issuePicker,
        initialValue: initialValue,
        issueKey: issueKey,
        projectId: projectId,
        jql: jql,
        onChange: handleOnChange,
        onClear: onClearClicked,
        intl: intl,
        onCreate: onCreate,
        label: ariaLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1896764301a020c$var$ButtonsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1896764301a020c$var$StyledButton, {
        appearance: "primary",
        onClick: onAddClicked,
        isDisabled: isDisabled
    }, intl.formatMessage((0, $7my8Y.default).childLinkButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1896764301a020c$var$StyledButton, {
        appearance: "subtle",
        onClick: onCancelClicked
    }, intl.formatMessage((0, $7my8Y.default).childCancelButton)))));
};
var $b1896764301a020c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $b1896764301a020c$export$bfa3a4c19902779f;
const $b1896764301a020c$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01a66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b1896764301a020c$var$ButtonsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8FQuT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26ddf6ddb258b30$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $iOwNT = parcelRequire("iOwNT");

var $eae50 = parcelRequire("eae50");

var $h18Ob = parcelRequire("h18Ob");

var $9OXo1 = parcelRequire("9OXo1");

var $2zUtc = parcelRequire("2zUtc");

var $5J4QV = parcelRequire("5J4QV");

var $gM6Zc = parcelRequire("gM6Zc");
class $c26ddf6ddb258b30$export$f351965c159f435d extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            initialValue: ''
        };
    }
    focus() {
        this.akSelect?.focus();
    }
    reset() {
        // Unfortunately, this is what we found in order to clear the select value.
        this.akSelect?.select?.clearValue();
        // The reason for doing a blur then focus is because AK button doesn't get the focus on clicking.
        this.akSelect?.blur();
        this.akSelect?.focus();
    }
    render() {
        const { initialValue: initialValue, issueKey: issueKey, projectId: projectId, jql: jql, intl: intl, label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: { baseUrl: baseUrl } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2zUtc.default), {
                labels: {
                    recentIssues: intl.formatMessage((0, $gM6Zc.default).defaultRecentIssues),
                    matchingIssues: intl.formatMessage((0, $gM6Zc.default).defaultMatchingIssues)
                },
                baseUrl: baseUrl,
                issueKey: issueKey,
                projectId: projectId,
                jql: jql,
                initialValue: initialValue
            }, ({ loadOptions: loadOptions, options: options, isLoading: isLoading, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iOwNT.default), {
                    ref: this.onSetSelectRef,
                    styles: (0, $h18Ob.defaultSelectStyles),
                    isLoading: isLoading,
                    formatOptionLabel: this.formatOptionLabel,
                    options: options,
                    defaultInputValue: initialValue,
                    autoFocus: true,
                    allowCreateWhileLoading: true,
                    defaultOptions: true,
                    onCreateOption: this.onCreate,
                    placeholder: intl.formatMessage((0, $gM6Zc.default).defaultPlaceholder),
                    components: {
                        SingleValue: $5J4QV.SingleValue
                    },
                    // @ts-expect-error - TS7006 - Parameter 'issueOption' implicitly has an 'any' type. | TS7006 - Parameter 'actionObject' implicitly has an 'any' type.
                    onChange: (issueOption, actionObject)=>this.onChange(issueOption, actionObject, loadOptions),
                    onInputChange: this.onInputChange(loadOptions),
                    onBlur: ()=>this.onBlur(loadOptions),
                    isClearable: true,
                    filterOption: this.filterOption,
                    noOptionsMessage: ()=>this.renderNoOptionsMessage(error),
                    openMenuOnFocus: true,
                    "aria-label": label
                })));
    }
    constructor(...args){
        super(...args), this.onBlur = (loadOptions)=>{
            loadOptions('');
        }, this.onChange = (issueOption, { action: action }, loadOptions)=>{
            switch(action){
                case 'select-option':
                    {
                        const { issueId: issueId, issueKey: issueKey, summary: summary, imageUrl: imageUrl } = issueOption;
                        this.props.onChange && this.props.onChange({
                            issueId: issueId,
                            issueKey: issueKey,
                            issueSummary: summary,
                            issueTypeIconUrl: imageUrl
                        });
                        loadOptions('');
                        break;
                    }
                case 'clear':
                    this.props.onClear && this.props.onClear();
                    break;
                default:
                    break;
            }
        }, this.onCreate = (inputValue)=>{
            this.props.onCreate && this.props.onCreate(inputValue);
        }, this.onInputChange = (loadOptions)=>(input, { action: action })=>{
                if (action === 'input-change') loadOptions(input);
            }, this.onSetSelectRef = (ref)=>{
            this.akSelect = ref;
        }, this.formatOptionLabel = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        option, { context: context })=>{
            const isNewOption = option.__isNew__;
            if (isNewOption) {
                const label = this.props.intl.formatMessage((0, $gM6Zc.default).createIssue, {
                    value: option.value
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5J4QV.CreateIssueOption), {
                    label: label
                });
            }
            if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5J4QV.IssueOption), {
                imageUrl: option.imageUrl,
                issueKey: option.issueKey,
                summary: option.summary
            });
            return option.label;
        }, this.filterOption = ()=>true, this.renderNoOptionsMessage = (error)=>{
            if (!error) return undefined;
            const { intl: intl } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
                description: intl.formatMessage((0, $gM6Zc.default).defaultFailedLoadingIssues),
                imageWidth: 56,
                isSubtle: true
            });
        };
    }
}
var $c26ddf6ddb258b30$export$2e2bcd8739ae039 = $c26ddf6ddb258b30$export$f351965c159f435d;

});
parcelRegister("eae50", function(module, exports) {

$parcel$export(module.exports, "default", () => $da809c0c454ce05f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $az4zD = parcelRequire("az4zD");

var $lB1Xg = parcelRequire("lB1Xg");

var $9Le4I = parcelRequire("9Le4I");

var $63TJV = parcelRequire("63TJV");
function $da809c0c454ce05f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($lB1Xg))) : (0, (/*@__PURE__*/$parcel$interopDefault($9Le4I)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$da809c0c454ce05f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $63TJV.default).retry
};
var $da809c0c454ce05f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($da809c0c454ce05f$export$edf27be85e5f6da0);

});
parcelRegister("lB1Xg", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("9Le4I", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("63TJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbeb04399739f055$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbeb04399739f055$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("2zUtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d00f57bae0d0107$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XS00 = parcelRequire("9XS00");

var $7f4tk = parcelRequire("7f4tk");

var $FtZX9 = parcelRequire("FtZX9");

var $6uHvi = parcelRequire("6uHvi");
class $6d00f57bae0d0107$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            initialValue: ''
        };
    }
    componentDidMount() {
        this.fetchData(this.props.initialValue);
    }
    render() {
        const { children: children } = this.props;
        const { options: options, isLoading: isLoading, error: error } = this.state;
        return children({
            options: options,
            isLoading: isLoading,
            error: error,
            loadOptions: this.debouncedFetchData
        });
    }
    constructor(...args){
        super(...args), this.state = {
            options: [],
            isLoading: false,
            error: null
        }, this.fetchData = (inputValue)=>{
            const { issueKey: issueKey, projectId: projectId, jql: jql, labels: labels } = this.props;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const matchingIssue = (0, $9XS00.default)(inputValue, window.location.host);
            const query = matchingIssue || inputValue;
            this.setState({
                isLoading: true,
                error: null
            });
            return (0, $7f4tk.default)(`/rest/api/3/issue/picker?currentIssueKey=${issueKey}&currentProjectId=${projectId}&showSubTasks=true&showSubTaskParent=true&currentJQL=${jql}&query=${query}`).then((results)=>{
                this.setState({
                    options: (0, $6uHvi.transformOptions)(results, labels),
                    isLoading: false
                });
                return results;
            }).catch((error)=>{
                this.setState({
                    isLoading: false,
                    options: [],
                    error: error
                });
                return [];
            });
        }, this.debouncedFetchData = (0, $FtZX9.default)(this.fetchData, 300);
    }
}

});
parcelRegister("9XS00", function(module, exports) {

$parcel$export(module.exports, "ISSUEKEY_REGEX", () => $76f8b51a225e9798$export$b52c9cee589449a8);
$parcel$export(module.exports, "default", () => $76f8b51a225e9798$export$2e2bcd8739ae039);

var $aZsz6 = parcelRequire("aZsz6");
const $76f8b51a225e9798$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
var /**
 * Returns the issue key if the URL is a valid full page Jira issue URL. It may also include a trailing
 * hash fragment. A matching URL must look like:
 * <host><baseurl>/browse/<issuekey><#hash?>
 * e.g. https://my-jira-instance.atlassian.net/browse/FOO-123#xyz
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$76f8b51a225e9798$export$2e2bcd8739ae039 = (url, host)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url, {});
    const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    const isMatchingHost = parsedUrl.host === host;
    const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$76f8b51a225e9798$export$b52c9cee589449a8}\\/?$`));
    const issueKey = matches && matches.length > 1 ? matches[1] : null;
    return isMatchingProtocol && isMatchingHost && issueKey || null;
};

});

parcelRegister("6uHvi", function(module, exports) {

$parcel$export(module.exports, "transformOptions", () => $31dc330a52fb0113$export$8f4ed8ef83bcbf04);

var $3JOCw = parcelRequire("3JOCw");

var $g5X3G = parcelRequire("g5X3G");
const $31dc330a52fb0113$export$8f4ed8ef83bcbf04 = ({ sections: sections }, labels)=>{
    const historySearch = sections[0];
    const currentSearch = sections[1];
    const historySearchIssues = historySearch.issues;
    const currentSearchissues = currentSearch ? currentSearch.issues : [];
    const issues = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
        ...historySearchIssues,
        ...currentSearchissues
    ], 'key');
    return [
        {
            label: currentSearch ? labels.matchingIssues : labels.recentIssues,
            options: issues.map((issue)=>({
                    issueId: (0, $g5X3G.toIssueId)(String(issue.id)),
                    value: issue.key,
                    issueKey: issue.key,
                    summary: issue.summaryText,
                    imageUrl: issue.img
                }))
        }
    ];
};

});


parcelRegister("5J4QV", function(module, exports) {

$parcel$export(module.exports, "CreateIssueOption", () => $4bc22e6adb18d1f3$export$39c2758d2fa09a8f);
$parcel$export(module.exports, "IssueOption", () => $4bc22e6adb18d1f3$export$e3339d36fc322bcf);
$parcel$export(module.exports, "SingleValue", () => $4bc22e6adb18d1f3$export$1949dac661ba6e3a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $99M5v = parcelRequire("99M5v");

var $bChGW = parcelRequire("bChGW");
const $4bc22e6adb18d1f3$var$IssueCard = ({ imageUrl: imageUrl, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bc22e6adb18d1f3$var$IssueCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bc22e6adb18d1f3$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bc22e6adb18d1f3$var$Img, {
        src: imageUrl,
        alt: ""
    })), children);
const $4bc22e6adb18d1f3$export$39c2758d2fa09a8f = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bc22e6adb18d1f3$var$IssueCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-brand, #0C66E4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        isSelected: false,
        interactionName: "auto-generated.jira-issue-picker.ui.issue-cards.button"
    }, label));
const $4bc22e6adb18d1f3$export$e3339d36fc322bcf = ({ imageUrl: imageUrl, issueKey: issueKey, summary: summary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bc22e6adb18d1f3$var$IssueCard, {
        imageUrl: imageUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bc22e6adb18d1f3$var$IssueDescription, null, issueKey, " ", summary));
const $4bc22e6adb18d1f3$var$SelectedValue = ({ imageUrl: imageUrl, issueKey: issueKey, summary: summary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bc22e6adb18d1f3$var$IssueCard, {
        imageUrl: imageUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bc22e6adb18d1f3$var$IssueDescription, null, `${issueKey} ${summary}`));
const $4bc22e6adb18d1f3$export$1949dac661ba6e3a = ({ children: children, ...props })=>// @ts-expect-error - TS2740 - Type '{ children: Element; data: PlainIssueOptionType; }' is missing the following properties from type 'CommonProps<PlainIssueOptionType, false, GroupTypeBase<PlainIssueOptionType>>': clearValue, cx, getStyles, getValue, and 8 more.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bc22e6adb18d1f3$var$SelectedValue, {
        imageUrl: props.data.imageUrl,
        issueKey: props.data.issueKey,
        summary: props.data.summary
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4bc22e6adb18d1f3$var$IssueCardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4bc22e6adb18d1f3$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});
const $4bc22e6adb18d1f3$var$Img = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $4bc22e6adb18d1f3$var$IssueDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dl1osq _1bto1l2s _o5721q9c _1ul9idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gM6Zc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4b39e559ef55a5f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d4b39e559ef55a5f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultPlaceholder: {
        "id": "issue-picker.default-placeholder",
        "defaultMessage": "Search by issue key or summary"
    },
    defaultRecentIssues: {
        "id": "issue-picker.default-recent-issues",
        "defaultMessage": "Recent Issues"
    },
    defaultMatchingIssues: {
        "id": "issue-picker.default-matching-issues",
        "defaultMessage": "Matching Issues"
    },
    defaultFailedLoadingIssues: {
        "id": "issue-picker.default-failed-loading-issues",
        "defaultMessage": "Failed to load issues"
    },
    createIssue: {
        "id": "issue-picker.create-issue",
        "defaultMessage": "Create an issue for {value}"
    }
});

});


parcelRegister("7my8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a904967130dd4c$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $89a904967130dd4c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    childLinkButton: {
        "id": "issue.views.common.child-issues-panel.add-existing-issue.child-link-button",
        "defaultMessage": "Add"
    },
    childCancelButton: {
        "id": "issue.views.common.child-issues-panel.add-existing-issue.child-cancel-button",
        "defaultMessage": "Cancel"
    },
    ariaLabelForAddExistingIssue: {
        "id": "issue.views.common.child-issues-panel.add-existing-issue.aria-label",
        "defaultMessage": "add existing issue"
    },
    ariaLabelForAddExistingIssueIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.add-existing-issue.aria-label-issue-term-refresh",
        "defaultMessage": "add existing work item"
    }
});

});



parcelRegister("lkZTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f7ab8c93113b369$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $58aTF = parcelRequire("58aTF");

var $2iFnS = parcelRequire("2iFnS");

var $4ckjx = parcelRequire("4ckjx");

var $3UZ3l = parcelRequire("3UZ3l");

var $fAMRX = parcelRequire("fAMRX");

var $ai9zi = parcelRequire("ai9zi");

var $gRIlG = parcelRequire("gRIlG");
var $1f7ab8c93113b369$export$2e2bcd8739ae039 = (0, $dRLCn.flowWithSafeComponent)((0, $hxqfC.connect)((state)=>({
        Title: $ai9zi.default,
        Meatballs: $3UZ3l.default,
        AddChild: $4ckjx.default,
        SortByMenu: $fAMRX.default,
        allIssues: (0, $2iFnS.getAllIssues)(state),
        supportsIssueCreation: (0, $58aTF.getSupportsIssueCreation)(state),
        isSortingAvailable: !(0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) && (0, $58aTF.isCompatibleSortingPanel)(state)
    }), {}))((0, $gRIlG.default));

});
parcelRegister("4ckjx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1635c026e9086b75$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $iQv12 = parcelRequire("iQv12");

var $8oe80 = parcelRequire("8oe80");

var $hxqfC = parcelRequire("hxqfC");

var $4R6GH = parcelRequire("4R6GH");

var $58aTF = parcelRequire("58aTF");

var $dvqTC = parcelRequire("dvqTC");

var $47uR0 = parcelRequire("47uR0");
var $1635c026e9086b75$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8oe80.default)('button', {
    onClick: 'clicked'
}), (0, $iQv12.default)({
    onClick: (...args)=>{
        const [, , issueCreateSessionId, hasDescription, descriptionLength] = args;
        // If add_description_range_to_add_child_click is false & new_attributes_for_child_issue_create_click is true then send hasDescription
        // If both add_description_range_to_add_child_click & new_attributes_for_child_issue_create_click are true then send hasDescription & descriptionLength
        // If new_attributes_for_child_issue_create_click is false dont send any description attributes
        return {
            name: 'showChildIssuesInlineCreate',
            sessionId: issueCreateSessionId,
            ...!(0, $4R6GH.fg)('add_description_range_to_add_child_click') ? {
                hasDescription: hasDescription
            } : {},
            ...(0, $4R6GH.fg)('add_description_range_to_add_child_click') ? {
                hasDescription: hasDescription,
                descriptionLength: descriptionLength
            } : {}
        };
    }
}), (0, $hxqfC.connect)((state)=>({
        isClassicSubtaskPanel: (0, $58aTF.getIsClassicSubtaskPanel)(state)
    }), (dispatch, props)=>({
        onClick: (...args)=>{
            dispatch((0, $dvqTC.showInlineCreate)());
            props.onClick(...args);
        }
    })))((0, $47uR0.AddChild));

});
parcelRegister("47uR0", function(module, exports) {

$parcel$export(module.exports, "AddChild", () => $1e751a2027b8b9b8$export$5fd93af9704b3891);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kz2lw = parcelRequire("kz2lw");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $ecB7Y = parcelRequire("ecB7Y");

var $ifmGP = parcelRequire("ifmGP");

var $2gCtH = parcelRequire("2gCtH");

var $3pfyj = parcelRequire("3pfyj");

var $4R6GH = parcelRequire("4R6GH");

var $hchBL = parcelRequire("hchBL");

var $8WpNU = parcelRequire("8WpNU");

var $dk9hZ = parcelRequire("dk9hZ");
const $1e751a2027b8b9b8$var$AddChildNew = ({ isClassicSubtaskPanel: isClassicSubtaskPanel = false, onClick: onClick })=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const [{ value: value }] = (0, $ifmGP.useDescriptionField)({
        issueKey: issueKey
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const label = isClassicSubtaskPanel ? (0, $dk9hZ.default).createSubtaskLabel : (0, $dk9hZ.default).createChildLabel;
    const [, { setIssueCreateSessionId: setIssueCreateSessionId }] = (0, $ecB7Y.useTriggerIssueViewModal)();
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const addChildRef = (0, $5uXOq.useRef)(null);
    const handleOnClick = (e, analyticsEvent)=>{
        const sessionId = (0, $7Jxgt.v4)();
        setIssueCreateSessionId(sessionId);
        const hasDescription = value != null && JSON.stringify(value) !== JSON.stringify((0, $kz2lw.getEmptyADF)());
        register('quick-add-items.add-child-subtask', addChildRef.current);
        if ((0, $4R6GH.fg)('add_description_range_to_add_child_click')) {
            const descriptionLength = value ? (0, $3pfyj.getADFCharacterCount)(value) : 0;
            onClick(e, analyticsEvent, sessionId, hasDescription, descriptionLength);
            return;
        }
        onClick(e, analyticsEvent, sessionId, hasDescription);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        prefixOverride: "issue",
        id: "Safe(AddChild)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1e751a2027b8b9b8$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WpNU.default), {
        onClick: handleOnClick,
        label: formatMessage(label),
        ref: addChildRef
    })));
};
const $1e751a2027b8b9b8$export$5fd93af9704b3891 = $1e751a2027b8b9b8$var$AddChildNew;
const $1e751a2027b8b9b8$var$buttonWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.075'
});

});
parcelRegister("dk9hZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6351f389d8dd3100$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $6351f389d8dd3100$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createChildLabel: {
        "id": "issue.views.common.child-issues-panel.heading.add-child.create-child-label",
        "defaultMessage": "Create child"
    },
    createSubtaskLabel: {
        "id": "issue.views.common.child-issues-panel.heading.add-child.create-subtask-label",
        "defaultMessage": "Create subtask"
    }
});

});



parcelRegister("3UZ3l", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb78bf8b1b381b00$export$2e2bcd8739ae039);

var $iQv12 = parcelRequire("iQv12");

var $8oe80 = parcelRequire("8oe80");

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $58aTF = parcelRequire("58aTF");

var $2iFnS = parcelRequire("2iFnS");

var $dvqTC = parcelRequire("dvqTC");

var $dtS0b = parcelRequire("dtS0b");

var $wTIvR = parcelRequire("wTIvR");
var // FIXME: JIV-17455 should be fully typed
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$cb78bf8b1b381b00$export$2e2bcd8739ae039 = (0, $dRLCn.flowWithSafeComponent)((0, $8oe80.default)('item', {
    onBulkEditClicked: 'clicked',
    onViewInSearchClicked: 'clicked',
    onHideDoneClicked: 'clicked'
}), (0, $iQv12.default)({
    // @ts-expect-error - TS7006 - Parameter 'issueCount' implicitly has an 'any' type.
    onBulkEditClicked: (issueCount)=>({
            name: 'bulkEdit',
            issueCount: issueCount
        }),
    // @ts-expect-error - TS7006 - Parameter 'issueCount' implicitly has an 'any' type.
    onViewInSearchClicked: (issueCount)=>({
            name: 'viewInSearch',
            issueCount: issueCount
        }),
    // @ts-expect-error - TS7006 - Parameter 'totalIssues' implicitly has an 'any' type. | TS7006 - Parameter 'incompleteIssues' implicitly has an 'any' type. | TS7006 - Parameter 'hideDone' implicitly has an 'any' type.
    onHideDoneClicked: (totalIssues, incompleteIssues, hideDone)=>({
            name: 'toggleHideDone',
            totalIssues: totalIssues,
            incompleteIssues: incompleteIssues,
            hideDone: hideDone
        })
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ baseUrl: string; childIssuesPanelType: ChildIssuesPanelType | null; parentKey: string | null; hideDone: boolean; allIssues: ChildIssue[]; incompleteIssues: ChildIssue[]; } & { ...; }, {}>' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof Props]: K extends "onBulkEditClicked" | "onViewInSearchClicked" | "onHideDoneClicked" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>, { ...; }>, ConnectedComponent<...>>'.
(0, $hxqfC.connect)((state)=>({
        baseUrl: (0, $58aTF.getBaseUrl)(state),
        childIssuesPanelType: (0, $58aTF.getChildIssuesPanelType)(state),
        parentKey: (0, $58aTF.getParentKey)(state),
        hideDone: (0, $dtS0b.getHideDone)(state),
        allIssues: (0, $2iFnS.getAllIssues)(state),
        incompleteIssues: (0, $2iFnS.getIncompleteIssues)(state)
    }), {
    onHideDoneClicked: (0, $dvqTC.toggleHideDone)
}))((0, $wTIvR.Meatballs));

});
parcelRegister("wTIvR", function(module, exports) {

$parcel$export(module.exports, "Meatballs", () => $475760658c9af901$export$8e357490a4a1908a);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $jFrow = parcelRequire("jFrow");
var $2RlqF = parcelRequire("2RlqF");
var $aRoVz = parcelRequire("aRoVz");

var $aoKYM = parcelRequire("aoKYM");

var $kqDoy = parcelRequire("kqDoy");

var $bJeNF = parcelRequire("bJeNF");

var $3bDjY = parcelRequire("3bDjY");

var $2YZCu = parcelRequire("2YZCu");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");


var $eNNkf = parcelRequire("eNNkf");

var $kuVxL = parcelRequire("kuVxL");

var $2NMNM = parcelRequire("2NMNM");

var $93Yeu = parcelRequire("93Yeu");

var $lVJAU = parcelRequire("lVJAU");

var $fg6rA = parcelRequire("fg6rA");

var $dG70I = parcelRequire("dG70I");

var $fvYyN = parcelRequire("fvYyN");

var $LTrSl = parcelRequire("LTrSl");

var $ecQay = parcelRequire("ecQay");

var $gsyyb = parcelRequire("gsyyb");

var $6M7wj = parcelRequire("6M7wj");

var $3BUiW = parcelRequire("3BUiW");

var $7pYDr = parcelRequire("7pYDr");

var $5uJfx = parcelRequire("5uJfx");

var $i4t8K = parcelRequire("i4t8K");
const $475760658c9af901$export$8e357490a4a1908a = ({ childIssuesLimitStatus: childIssuesLimitStatus, childIssuesPanelType: childIssuesPanelType, parentKey: parentKey, hideDone: hideDone = false, allIssues: allIssues, incompleteIssues: incompleteIssues, isSortingAvailable: isSortingAvailable, onHideDoneClicked: onHideDoneClicked, onBulkEditClicked: onBulkEditClicked, onViewInSearchClicked: onViewInSearchClicked, rootRelayFragment: rootRelayFragment, isHideDoneFilterEnabled: isHideDoneFilterEnabled, isRankingEnabled: isRankingEnabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [sortByValue] = (0, $LTrSl.useChildIssuesSortBy)();
    // TODO: When cleaning up fg('key-chin-hide-done-relay-migration') remove the redux usages for hideDonePreference
    const [hideDonePreference, { setValue: setHideDonePreference }] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$4c9f7f9f8a4000e1));
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const isSimplifiedProject = (0, $93Yeu.useIsSimplifiedProject)(projectKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const toggleIssueHideDone = (0, $i4t8K.useUpdateHideDoneStateMutation)();
    const onBulkEditClickedAnalytics = (0, $5uXOq.useCallback)((issueCount)=>(analyticsEvent)=>{
            onBulkEditClicked(issueCount, analyticsEvent);
        }, [
        onBulkEditClicked
    ]);
    const onViewInSearchClickedAnalytics = (0, $5uXOq.useCallback)((issueCount)=>(analyticsEvent)=>{
            onViewInSearchClicked(issueCount, analyticsEvent);
        }, [
        onViewInSearchClicked
    ]);
    const onHideDoneClickedWithMyPreferences = (0, $5uXOq.useCallback)(()=>{
        // myPreferences can only be set as a string, not as a boolean
        const hasHideDonePreference = (0, $4R6GH.fg)('key-chin-hide-done-relay-migration') ? isHideDoneFilterEnabled === true : hideDonePreference === 'true';
        if ((0, $4R6GH.fg)('key-chin-hide-done-relay-migration')) toggleIssueHideDone({
            isHideDoneEnabled: !hasHideDonePreference,
            rootRelayFragment: rootRelayFragment
        });
        else setHideDonePreference(String(!hasHideDonePreference));
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'item',
            attributes: {
                childIssuesPanelType: childIssuesPanelType,
                totalIssues: allIssues.length,
                incompleteIssues: incompleteIssues.length,
                hideDone: !hasHideDonePreference
            }
        });
        onHideDoneClicked(allIssues.length, incompleteIssues.length, !hasHideDonePreference, analyticsEvent);
    }, [
        isHideDoneFilterEnabled,
        hideDonePreference,
        createAnalyticsEvent,
        childIssuesPanelType,
        allIssues.length,
        incompleteIssues.length,
        onHideDoneClicked,
        toggleIssueHideDone,
        rootRelayFragment,
        setHideDonePreference
    ]);
    const isWithinLimitOnInitialLoad = (0, $5uXOq.useMemo)(()=>!(0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus), [
        childIssuesLimitStatus
    ]);
    const isHideDoneCheckboxVisible = (0, $5uXOq.useMemo)(()=>(0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) ? isWithinLimitOnInitialLoad : !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(incompleteIssues) && incompleteIssues.length !== allIssues.length && isWithinLimitOnInitialLoad, [
        allIssues.length,
        isWithinLimitOnInitialLoad,
        incompleteIssues
    ]);
    const viewInSearchLink = (0, $5uXOq.useMemo)(()=>{
        // These values will never be missing when the FF is enabled, this check is to satisfy TS
        if (projectType === undefined || isSimplifiedProject === undefined) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.child-issues-panel', 'Missing project, type, or isSimplified when generating search link');
            return '';
        }
        return (0, $dG70I.generateViewInSearchLink)(projectKey, projectType, isSimplifiedProject, parentKey, childIssuesPanelType, (0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus), sortByValue);
    }, [
        childIssuesLimitStatus,
        childIssuesPanelType,
        isSimplifiedProject,
        parentKey,
        projectKey,
        projectType,
        sortByValue
    ]);
    const onViewInSearchClickedCallback = (0, $5uXOq.useCallback)((visibleIssuesCount)=>(event, analyticsEvent)=>{
            onViewInSearchClickedAnalytics(visibleIssuesCount)(analyticsEvent);
            // Ignore cmd or ctrl clicks - allow user to open in new tab
            if (!event.metaKey && !event.ctrlKey) {
                event.preventDefault();
                push(viewInSearchLink);
            }
        }, [
        push,
        onViewInSearchClickedAnalytics,
        viewInSearchLink
    ]);
    // TODO: To be removed on clean-up of ('jira-issue-view-chin-ga')
    const renderFilters = (0, $5uXOq.useCallback)(()=>{
        const hasExceededLimitAfterLoad = (0, $fvYyN.hasExceededIssuesLimitAfterLoad)(childIssuesLimitStatus);
        const renderFiltersDropdownGroup = isHideDoneCheckboxVisible;
        const hideDoneToolTip = hasExceededLimitAfterLoad ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7pYDr.default).disabledHideDoneIssueTermRefresh : (0, $7pYDr.default).disabledHideDone) : formatMessage((0, $7pYDr.default).hideDoneTooltip);
        return renderFiltersDropdownGroup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
            title: formatMessage((0, $7pYDr.default).filter),
            id: "child-issues-panel-filter-group"
        }, isHideDoneCheckboxVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2RlqF.default), {
            id: "child-issues-panel-checkbox-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: hideDoneToolTip,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jFrow.default), {
            id: "hideDone",
            key: "hideDone",
            onClick: onHideDoneClickedWithMyPreferences,
            isSelected: (0, $4R6GH.fg)('key-chin-hide-done-relay-migration') ? isHideDoneFilterEnabled === true : hideDonePreference === 'true',
            isDisabled: hasExceededLimitAfterLoad
        }, formatMessage((0, $7pYDr.default).hideDone))))) : null;
    }, [
        childIssuesLimitStatus,
        formatMessage,
        hideDonePreference,
        isHideDoneFilterEnabled,
        isHideDoneCheckboxVisible,
        onHideDoneClickedWithMyPreferences
    ]);
    const renderHideDoneFilter = (0, $5uXOq.useCallback)(()=>{
        const hasExceededLimitAfterLoad = (0, $fvYyN.hasExceededIssuesLimitAfterLoad)(childIssuesLimitStatus);
        const renderFiltersDropdownGroup = isHideDoneCheckboxVisible;
        const hideDoneToolTip = hasExceededLimitAfterLoad ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7pYDr.default).disabledHideDoneIssueTermRefresh : (0, $7pYDr.default).disabledHideDone) : formatMessage((0, $7pYDr.default).hideDoneTooltip);
        return renderFiltersDropdownGroup && isHideDoneCheckboxVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: hideDoneToolTip,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            isSelected: (0, $4R6GH.fg)('key-chin-hide-done-relay-migration') ? isHideDoneFilterEnabled === true : hideDonePreference === 'true',
            onClick: onHideDoneClickedWithMyPreferences,
            elemBefore: ((0, $4R6GH.fg)('key-chin-hide-done-relay-migration') ? isHideDoneFilterEnabled === true : hideDonePreference === 'true') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aoKYM))), {
                color: "currentColor",
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kqDoy))), {
                color: "currentColor",
                label: ""
            }),
            /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "issue.views.common.child-issues-panel.heading.meatballs.hide-done-dropdown-item",
            isDisabled: hasExceededLimitAfterLoad
        }, formatMessage((0, $7pYDr.default).hideDone))) : null;
    }, [
        childIssuesLimitStatus,
        formatMessage,
        hideDonePreference,
        isHideDoneFilterEnabled,
        isHideDoneCheckboxVisible,
        onHideDoneClickedWithMyPreferences
    ]);
    const childIssuesLimit = (0, $2gCtH.useChildIssuesLimit)();
    const childIssuesLimitExceededAnalyticsCount = (0, $kuVxL.getChildIssuesLimitExceededAnalyticsCount)(childIssuesLimit);
    const renderedActions = (0, $5uXOq.useMemo)(()=>{
        const visibleIssues = hideDone ? incompleteIssues : allIssues;
        const visibleIssuesCount = (0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus) ? childIssuesLimitExceededAnalyticsCount : visibleIssues.length;
        const bulkEditLink = (0, $5uJfx.generateBulkEditLink)(parentKey, childIssuesPanelType, (0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus), sortByValue || undefined);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            // @ts-expect-error Type '(analyticsEvent: AnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>) => void'.
            onClick: onBulkEditClickedAnalytics(visibleIssuesCount),
            href: bulkEditLink,
            /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.common.child-issues-panel.heading.meatballs.bulk-edit-dropdown-item",
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, $7pYDr.default).bulkEdit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            // @ts-expect-error - TS2769 - No overload matches this call.
            onClick: onViewInSearchClickedCallback(visibleIssuesCount),
            href: viewInSearchLink,
            /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.common.child-issues-panel.heading.meatballs.view-in-search-dropdown-item",
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, $7pYDr.default).search)));
    }, [
        hideDone,
        incompleteIssues,
        allIssues,
        childIssuesLimitStatus,
        childIssuesLimitExceededAnalyticsCount,
        parentKey,
        childIssuesPanelType,
        sortByValue,
        formatMessage,
        onBulkEditClickedAnalytics,
        onViewInSearchClickedCallback,
        viewInSearchLink
    ]);
    const renderDropdownTriggerButton = (0, $5uXOq.useCallback)(({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "compact",
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    color: "currentColor",
                    ...iconProps,
                    LEGACY_size: "small"
                }),
            label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7pYDr.default).tooltipIssueTermRefresh : (0, $7pYDr.default).tooltip),
            ref: triggerRef,
            interactionName: "auto-generated.jira-issue-view-common-views.child-issues-panel.view.heading.meatballs.button"
        }), [
        formatMessage
    ]);
    const actionsTitle = isHideDoneCheckboxVisible ? formatMessage((0, $7pYDr.default).actions) : undefined;
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('chin-refactor-and-prune-jiv-child-issues-sorting') && (0, $4R6GH.fg)('hide-rank-option-when-unavailable') && (0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fg6rA.ButtonWrapper), {
        "data-testid": (0, $5uJfx.triggerButtonTestId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        trigger: renderDropdownTriggerButton
    }, renderHideDoneFilter(), isSortingAvailable && isRankingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6M7wj.default), {
        childIssuesLimitStatus: childIssuesLimitStatus
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, renderedActions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, (0, $4R6GH.fg)('jiv-chin-spotlight-tour') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3BUiW.default), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gsyyb.default), null))));
    return (0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fg6rA.ButtonWrapper), {
        "data-testid": (0, $5uJfx.triggerButtonTestId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        trigger: renderDropdownTriggerButton
    }, renderHideDoneFilter(), isSortingAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ecQay.default), {
        childIssuesLimitStatus: childIssuesLimitStatus,
        isRankingEnabled: (0, $4R6GH.fg)('hide-rank-option-when-unavailable') ? isRankingEnabled : undefined
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, renderedActions, (0, $4R6GH.fg)('jiv-chin-spotlight-tour') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gsyyb.default), null)), (0, $4R6GH.fg)('jiv-chin-spotlight-tour') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3BUiW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gsyyb.default), null)) : null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fg6rA.ButtonWrapper), {
        "data-testid": (0, $5uJfx.triggerButtonTestId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        trigger: renderDropdownTriggerButton
    }, renderFilters(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        testId: "issue-view-common-views.child-issues-panel.heading.meatballs.dropdown-item-group",
        title: actionsTitle
    }, renderedActions)));
};
var $475760658c9af901$export$2e2bcd8739ae039 = $475760658c9af901$export$8e357490a4a1908a;

});
parcelRegister("kqDoy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3d7f6e098f10fcfa391b7a545c3a4282>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edf4cb651ed8a915$var$_react = $edf4cb651ed8a915$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $edf4cb651ed8a915$var$_baseNew = $edf4cb651ed8a915$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $edf4cb651ed8a915$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxUnchecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edf4cb651ed8a915$var$CheckboxUncheckedIcon = (props)=>/*#__PURE__*/ $edf4cb651ed8a915$var$_react.default.createElement($edf4cb651ed8a915$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$edf4cb651ed8a915$var$CheckboxUncheckedIcon.displayName = 'CheckboxUncheckedIcon';
var $edf4cb651ed8a915$var$_default = module.exports.default = $edf4cb651ed8a915$var$CheckboxUncheckedIcon;

});

const $31848aa9a0db89de$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $31848aa9a0db89de$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $31848aa9a0db89de$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $31848aa9a0db89de$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $31848aa9a0db89de$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $31848aa9a0db89de$export$2cf981c493d79a21 = 'jira.user.issue.details.activity-layout-setting';

parcelRegister("dG70I", function(module, exports) {

$parcel$export(module.exports, "generateViewInSearchLink", () => $6e09580af9a4f78e$export$d93c4c90817c96e8);

var $h6hhX = parcelRequire("h6hhX");

var $i9dBM = parcelRequire("i9dBM");
const $6e09580af9a4f78e$export$d93c4c90817c96e8 = (projectKey, projectType, isSimplifiedProject, parentKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad, sortByValue = null)=>`${(0, $i9dBM.generateNinBasePath)()}?${(0, $h6hhX.generateChildIssuesJQL)(parentKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad, sortByValue || undefined)}`;

});
parcelRegister("h6hhX", function(module, exports) {

$parcel$export(module.exports, "generateChildIssuesJQL", () => $93efa98a3a7eb94e$export$1d901f8ae5a6a569);

var $kF1SN = parcelRequire("kF1SN");
const $93efa98a3a7eb94e$export$75859f394155a563 = (sortByValue)=>{
    if (!sortByValue) return encodeURIComponent(' ORDER BY rank');
    switch(sortByValue){
        case (0, $kF1SN.SORT_OPTION).STATUS:
            return encodeURIComponent(' ORDER BY statusCategory, status asc, rank');
        case (0, $kF1SN.SORT_OPTION).PRIORITY:
        case (0, $kF1SN.SORT_OPTION).KEY:
        case (0, $kF1SN.SORT_OPTION).ASSIGNEE:
        case (0, $kF1SN.SORT_OPTION).CREATED:
            return encodeURIComponent(` ORDER BY ${sortByValue}, rank`);
        case (0, $kF1SN.SORT_OPTION).RANKING:
        default:
            return encodeURIComponent(' ORDER BY rank');
    }
};
// different between parent and parent link jql is that parent refers to subtasks/next gen child issues
// parent link refers to portfolio children issues
const $93efa98a3a7eb94e$var$generateParentJQL = (parentKey)=>`${encodeURIComponent(`parent=${parentKey}`)}`;
const $93efa98a3a7eb94e$var$generateParentLinkJQL = (parentKey)=>`${encodeURIComponent(`"Parent Link"=${parentKey}`)}`;
const $93efa98a3a7eb94e$var$generateEpicLinkJQL = (parentKey)=>`${encodeURIComponent(`"Epic Link"=${parentKey}`)}`;
const $93efa98a3a7eb94e$var$generateOverLimitJQL = (parentKey, sortByValue)=>`jql=${$93efa98a3a7eb94e$var$generateParentJQL(parentKey)}${$93efa98a3a7eb94e$export$75859f394155a563(sortByValue)}`;
// Non-system epics do not support Epic Link: https://hello.atlassian.net/wiki/spaces/~888416081/pages/2366083841/System+and+Non-system+epic+issue+types
// To search for their children, we have to additionally use Parent Link
// Once https://team.atlassian.com/project/ATLAS-15331 is complete, both should be replaced with the Parent JQL
// The work to replace it is tracked at https://hello.atlassian.net/browse/JPO-23454
const $93efa98a3a7eb94e$var$generateJQLForCMPParentAtHierarchyLevelOne = (parentKey, sortByValue)=>`jql=${$93efa98a3a7eb94e$var$generateEpicLinkJQL(parentKey)} OR ${$93efa98a3a7eb94e$var$generateParentLinkJQL(parentKey)}${$93efa98a3a7eb94e$export$75859f394155a563(sortByValue)}`;
const $93efa98a3a7eb94e$export$1d901f8ae5a6a569 = (parentKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad, sortByValue)=>{
    if (hasExceededIssuesLimitInitialLoad && childIssuesPanelType !== (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL) return $93efa98a3a7eb94e$var$generateOverLimitJQL(parentKey, sortByValue);
    switch(childIssuesPanelType){
        case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_PORTFOLIO_CHILDREN:
            return `jql=${$93efa98a3a7eb94e$var$generateParentLinkJQL(parentKey)}${$93efa98a3a7eb94e$export$75859f394155a563(sortByValue)}`;
        case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_PROJECT_EPIC_CHILDREN:
            return $93efa98a3a7eb94e$var$generateJQLForCMPParentAtHierarchyLevelOne(parentKey, sortByValue);
        case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS:
        case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL:
        default:
            return `jql=${$93efa98a3a7eb94e$var$generateParentJQL(parentKey)}${$93efa98a3a7eb94e$export$75859f394155a563(sortByValue)}`;
    }
};

});

parcelRegister("i9dBM", function(module, exports) {

$parcel$export(module.exports, "generateNinBasePath", () => $7b59a817453d6917$export$47d9a807c1277671);
const $7b59a817453d6917$export$ddaf187654250a8d = '/issues/';
const $7b59a817453d6917$export$47d9a807c1277671 = ()=>$7b59a817453d6917$export$ddaf187654250a8d;

});


parcelRegister("fvYyN", function(module, exports) {

$parcel$export(module.exports, "hasExceededIssuesLimitAfterLoad", () => $286193d468eae14d$export$29bd5f79d7a90777);
$parcel$export(module.exports, "hasExceededIssuesLimitInitialLoad", () => $286193d468eae14d$export$730caf8c50e5c851);

var $38bVB = parcelRequire("38bVB");
const $286193d468eae14d$export$29bd5f79d7a90777 = (childIssueLimitStatus)=>childIssueLimitStatus === (0, $38bVB.EXCEEDED_LIMIT_AFTER_LOAD);
const $286193d468eae14d$export$730caf8c50e5c851 = (childIssueLimitStatus)=>childIssueLimitStatus === (0, $38bVB.EXCEEDED_LIMIT_INITIAL_LOAD);

});

parcelRegister("ecQay", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d0bba980d761a2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGvGJ = parcelRequire("dGvGJ");

var $4R6GH = parcelRequire("4R6GH");

var $hxqfC = parcelRequire("hxqfC");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $LTrSl = parcelRequire("LTrSl");

var $2iFnS = parcelRequire("2iFnS");

var $ethS3 = parcelRequire("ethS3");
const $69d0bba980d761a2$export$413b1c23ad987cd8 = ({ allIssueIds: allIssueIds, childIssuesLimitStatus: childIssuesLimitStatus, isRankingEnabled: isRankingEnabled })=>{
    const [sortByValue, { setSortBy: setSortBy }] = (0, $LTrSl.useChildIssuesSortBy)();
    const [, { setSortableIssueIds: setSortableIssueIds }] = (0, $LTrSl.useSortableIssueIds)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onSelect = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
    (value)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        }), 'childIssuesSortBy', {
            selection: value
        });
        setSortableIssueIds(allIssueIds);
        setSortBy(value);
    }, [
        allIssueIds,
        createAnalyticsEvent,
        setSortBy,
        setSortableIssueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ethS3.ActionsSortByMenu), {
        sortedBy: sortByValue,
        // @ts-expect-error - TS2322 - Type '(value: any) => void' is not assignable to type '(selection: SortingOption, event: UIAnalyticsEventInterface) => Promise<undefined> | undefined'.
        onSelect: onSelect,
        childIssuesLimitStatus: childIssuesLimitStatus,
        isRankingEnabled: (0, $4R6GH.fg)('hide-rank-option-when-unavailable') ? isRankingEnabled : true
    });
};
const $69d0bba980d761a2$var$toIssueIds = (0, $dGvGJ.createSelector)((0, $2iFnS.getAllIssues), (issues)=>issues.map((issue)=>(0, $g5X3G.toIssueId)(issue.id)));
const $69d0bba980d761a2$var$ReduxConnectedComponent = (0, $hxqfC.connect)((state)=>({
        allIssueIds: $69d0bba980d761a2$var$toIssueIds(state)
    }), {})($69d0bba980d761a2$export$413b1c23ad987cd8);
var $69d0bba980d761a2$export$2e2bcd8739ae039 = $69d0bba980d761a2$var$ReduxConnectedComponent;

});
parcelRegister("ethS3", function(module, exports) {

$parcel$export(module.exports, "ActionsSortByMenu", () => $00faffb48b420251$export$207e5d7d28d0516d);

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $jpYlM = parcelRequire("jpYlM");

var $hWZau = parcelRequire("hWZau");

var $cgL5K = parcelRequire("cgL5K");

var $3bDjY = parcelRequire("3bDjY");

var $jQtKF = parcelRequire("jQtKF");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $54wEF = parcelRequire("54wEF");

var $fOGZN = parcelRequire("fOGZN");

var $2OMDV = parcelRequire("2OMDV");

var $kF1SN = parcelRequire("kF1SN");

var $fvYyN = parcelRequire("fvYyN");

var $brpbf = parcelRequire("brpbf");
const $00faffb48b420251$export$c0117b1abc6c64e3 = (0, $2OMDV.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
const $00faffb48b420251$export$207e5d7d28d0516d = (props)=>{
    const { onSelect: onSelect, childIssuesLimitStatus: childIssuesLimitStatus, isRankingEnabled: isRankingEnabled } = props;
    const options = (0, $kF1SN.SORT_OPTIONS);
    let availableSortingOptions = options;
    const issueKey = (0, $2gCtH.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    // we only want to allow filter by priority if we have `allowedValues` in context
    const [{ value: priorityField }] = (0, $54wEF.useFieldConfig)(issueKey, (0, $fOGZN.PRIORITY));
    if (!priorityField || !priorityField.allowedValues || priorityField.allowedValues.length <= 1) availableSortingOptions = options.filter((option)=>option !== (0, $kF1SN.SORT_OPTION).PRIORITY);
    if (!isRankingEnabled && (0, $4R6GH.fg)('hide-rank-option-when-unavailable')) availableSortingOptions = availableSortingOptions.filter((option)=>option !== (0, $kF1SN.SORT_OPTION).RANKING);
    const optionLabels = (0, $5uXOq.useMemo)(()=>{
        const labelsMap = new Map();
        availableSortingOptions.forEach((sortOption)=>{
            labelsMap.set(sortOption, formatMessage((0, $brpbf.default)[sortOption]));
        });
        return labelsMap;
    }, [
        availableSortingOptions,
        formatMessage
    ]);
    const hasExceededLimitAfterLoad = (0, $fvYyN.hasExceededIssuesLimitAfterLoad)(childIssuesLimitStatus);
    const button = (0, $5uXOq.useCallback)(// @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    ({ triggerRef: triggerRef, ...triggerProps } = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            ...triggerProps,
            isSelected: isOpen,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpYlM))), {
                color: "var(--ds-icon, #44546F)",
                label: ""
            }),
            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
                spacing: "spacious",
                label: ""
            }),
            testId: "issue-view-common-views.child-issues-panel.heading.actions-sort-by-menu.trigger-button",
            isDisabled: hasExceededLimitAfterLoad,
            ref: triggerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $brpbf.default).sortByLabel))), [
        formatMessage,
        hasExceededLimitAfterLoad,
        isOpen
    ]);
    if ((0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus)) return null;
    if (hasExceededLimitAfterLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $brpbf.default).exceededChildIssuesLimitIssueTermRefresh : (0, $brpbf.default).exceededChildIssuesLimit),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jQtKF.default), {
        isDisabled: hasExceededLimitAfterLoad
    }, button()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "right-start",
        trigger: button,
        isOpen: isOpen,
        onOpenChange: ()=>{
            setIsOpen(!isOpen);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, availableSortingOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($00faffb48b420251$export$c0117b1abc6c64e3, {
            key: option,
            "data-testId": `issue.views.common.child-issues-panel.heading.sort-by-menu.option-${option}`,
            // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
            onClick: (event, analyticsEvent)=>onSelect(option, analyticsEvent)
        }, optionLabels.get(option)))));
};

});
parcelRegister("jQtKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dbfcf6b8255255f$export$2e2bcd8739ae039);

var $47bDC = parcelRequire("47bDC");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dbfcf6b8255255f$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $47bDC.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$4dbfcf6b8255255f$export$2e2bcd8739ae039 = $4dbfcf6b8255255f$var$DisabledButtonWithTooltip;

});

parcelRegister("brpbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c37a74242776a295$export$2e2bcd8739ae039);
// FIXME: JIV-19267 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $c37a74242776a295$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sortByLabel: {
        "id": "issue.views.common.child-issues-panel.heading.sort-by.title",
        "defaultMessage": "Sort"
    },
    created: {
        "id": "issue.views.common.child-issues-panel.heading.created.label",
        "defaultMessage": "Created"
    },
    key: {
        "id": "issue.views.common.child-issues-panel.heading.key.label",
        "defaultMessage": "Key"
    },
    priority: {
        "id": "issue.views.common.child-issues-panel.heading.priority.label",
        "defaultMessage": "Priority"
    },
    status: {
        "id": "issue.views.common.child-issues-panel.heading.status.label",
        "defaultMessage": "Status"
    },
    assignee: {
        "id": "issue.views.common.child-issues-panel.heading.assignee.label",
        "defaultMessage": "Assignee"
    },
    ranking: {
        "id": "issue.views.common.child-issues-panel.heading.ranking.label",
        "defaultMessage": "Rank"
    },
    exceededChildIssuesLimit: {
        "id": "issue.views.common.child-issues-panel.heading.sort-by.exceeded-child-issues-limit",
        "defaultMessage": "To order more than 500 child issues, select \xB7\xB7\xB7 > View in search."
    },
    exceededChildIssuesLimitIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.heading.sort-by.exceeded-child-issues-limit-issue-term-refresh",
        "defaultMessage": "To order more than 500 child work items, select \xB7\xB7\xB7 > View in search."
    }
});

});



parcelRegister("gsyyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a690f8ae7cc9900$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $6jY6G = parcelRequire("6jY6G");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $93Yeu = parcelRequire("93Yeu");

var $k9JTq = parcelRequire("k9JTq");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $ljNLo = parcelRequire("ljNLo");
const $5a690f8ae7cc9900$var$FEEDBACK_GROUP_ID = 'sow-nike-issue-view-configurable-child-issues';
const $5a690f8ae7cc9900$var$CollectFeedbackActionItem = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const [isFeedbackDisabled, setIsFeedbackDisabled] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const issueId = (0, $2gCtH.useIssueId)();
    const handleFeedbackSent = (0, $5uXOq.useCallback)((wasSent)=>{
        setIsFeedbackDisabled(wasSent);
    }, []);
    const feedbackCollectorContext = [
        {
            id: (0, $7iULw.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
            value: $5a690f8ae7cc9900$var$FEEDBACK_GROUP_ID
        },
        {
            id: (0, $7iULw.EntryKeys).ROUTE_NAME,
            value: route.name ?? 'unknown'
        },
        {
            id: (0, $7iULw.EntryKeys).ROUTE_GROUP,
            value: route.group ?? 'unknown'
        },
        {
            id: (0, $7iULw.EntryKeys).IS_ADMIN,
            value: isAdmin ?? 'unknown'
        },
        {
            id: (0, $7iULw.EntryKeys).IS_SITE_ADMIN,
            value: isSiteAdmin ?? 'unknown'
        },
        {
            id: (0, $7iULw.EntryKeys).EDITION,
            value: appEditions?.software ?? 'unknown'
        },
        {
            id: 'product',
            value: projectType ?? 'unknown'
        },
        {
            id: 'issueId',
            value: issueId ?? 'unknown'
        }
    ];
    const handleOnGiveFeedbackClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'childIssuePanelFeedback clicked');
        if (!isFeedbackDisabled) {
            setIsFeedbackDisabled(true);
            openFeedbackCollector({
                entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
                feedbackGroupId: $5a690f8ae7cc9900$var$FEEDBACK_GROUP_ID,
                feedbackContext: feedbackCollectorContext,
                onSubmit () {
                    handleFeedbackSent(true);
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'childIssuePanelFeedback submitted');
                },
                onClose () {
                    handleFeedbackSent(false);
                }
            });
        }
    // This function does not need to be triggered with the variables in the feedbackContext
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        handleFeedbackSent,
        isFeedbackDisabled,
        openFeedbackCollector
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>handleOnGiveFeedbackClick(),
        isDisabled: isFeedbackDisabled,
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ "data-testid": "issue.views.common.child-issues-panel.heading.meatballs.give-feedback"
    }, formatMessage((0, $ljNLo.default).giveFeedback));
};
var $5a690f8ae7cc9900$export$2e2bcd8739ae039 = $5a690f8ae7cc9900$var$CollectFeedbackActionItem;

});
parcelRegister("ljNLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $588f8c6d0e2f6798$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $588f8c6d0e2f6798$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    giveFeedback: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.give-feedback",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("6M7wj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f222bd64347c39f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGvGJ = parcelRequire("dGvGJ");

var $6B7KL = parcelRequire("6B7KL");

var $jpYlM = parcelRequire("jpYlM");

var $cgL5K = parcelRequire("cgL5K");

var $3bDjY = parcelRequire("3bDjY");

var $jQtKF = parcelRequire("jQtKF");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hxqfC = parcelRequire("hxqfC");

var $g5X3G = parcelRequire("g5X3G");

var $fvYyN = parcelRequire("fvYyN");

var $LTrSl = parcelRequire("LTrSl");

var $2iFnS = parcelRequire("2iFnS");

var $LVgB4 = parcelRequire("LVgB4");
const $f222bd64347c39f5$export$c0117b1abc6c64e3 = (0, $2OMDV.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
const $f222bd64347c39f5$export$413b1c23ad987cd8 = ({ allIssueIds: allIssueIds, childIssuesLimitStatus: childIssuesLimitStatus })=>{
    const [sortByValue, { setSortBy: setSortBy }] = (0, $LTrSl.useChildIssuesSortBy)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { setSortableIssueIds: setSortableIssueIds }] = (0, $LTrSl.useSortableIssueIds)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onSelect = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
    (value)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        }), 'childIssuesSortBy', {
            selection: value
        });
        setSortableIssueIds(allIssueIds);
        setSortBy(value);
    }, [
        allIssueIds,
        createAnalyticsEvent,
        setSortBy,
        setSortableIssueIds
    ]);
    const hasExceededLimitAfterLoad = (0, $fvYyN.hasExceededIssuesLimitAfterLoad)(childIssuesLimitStatus);
    const button = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpYlM))), {
                color: "var(--ds-icon, #44546F)",
                label: ""
            }),
            testId: "issue-view-common-views.child-issues-panel.heading.sort-by-rank-button.trigger-button",
            isDisabled: hasExceededLimitAfterLoad,
            // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
            onClick: (event, analyticsEvent)=>onSelect(sortByValue, analyticsEvent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $LVgB4.default).sortByRanking))), [
        formatMessage,
        hasExceededLimitAfterLoad,
        onSelect,
        sortByValue
    ]);
    if ((0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus)) return null;
    if (hasExceededLimitAfterLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $LVgB4.default).exceededChildIssuesLimitIssueTermRefresh : (0, $LVgB4.default).exceededChildIssuesLimit),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jQtKF.default), {
        isDisabled: hasExceededLimitAfterLoad
    }, button()));
    return button();
};
const $f222bd64347c39f5$var$toIssueIds = (0, $dGvGJ.createSelector)((0, $2iFnS.getAllIssues), (issues)=>issues.map((issue)=>(0, $g5X3G.toIssueId)(issue.id)));
const $f222bd64347c39f5$var$ReduxConnectedComponent = (0, $hxqfC.connect)((state)=>({
        allIssueIds: $f222bd64347c39f5$var$toIssueIds(state)
    }), {})($f222bd64347c39f5$export$413b1c23ad987cd8);
var $f222bd64347c39f5$export$2e2bcd8739ae039 = $f222bd64347c39f5$var$ReduxConnectedComponent;

});
parcelRegister("LVgB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d5a5a00322bd11$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $37d5a5a00322bd11$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sortByRanking: {
        "id": "issue.views.common.child-issues-panel.heading.ranking.label",
        "defaultMessage": "Sort by rank"
    },
    exceededChildIssuesLimit: {
        "id": "issue.views.common.child-issues-panel.heading.sort-by.exceeded-child-issues-limit",
        "defaultMessage": "To order more than 500 child issues, select \xB7\xB7\xB7 > View in search."
    },
    exceededChildIssuesLimitIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.heading.sort-by.exceeded-child-issues-limit-issue-term-refresh",
        "defaultMessage": "To order more than 500 child work items, select \xB7\xB7\xB7 > View in search."
    }
});

});


parcelRegister("3BUiW", function(module, exports) {

$parcel$export(module.exports, "default", () => $eab1b67b29757845$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $koVbs = parcelRequire("koVbs");

var $cHvzH = parcelRequire("cHvzH");
const $eab1b67b29757845$var$WhatsNewSpotlightButton = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        // onClick={}
        "data-testid": "issue-view-common-views.child-issues-panel.heading.whats-new-spotlight-button"
    }, formatMessage((0, $cHvzH.default).spotlightButtonLabel));
};
var $eab1b67b29757845$export$2e2bcd8739ae039 = $eab1b67b29757845$var$WhatsNewSpotlightButton;

});
parcelRegister("cHvzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $166dadff3bb08104$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $166dadff3bb08104$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    spotlightButtonLabel: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.whats-new",
        "defaultMessage": "What's new?"
    }
});

});


parcelRegister("7pYDr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb4b390ccacfa4b9$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $bb4b390ccacfa4b9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    actions: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.actions",
        "defaultMessage": "Actions"
    },
    filter: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.filter",
        "defaultMessage": "Filter"
    },
    summaryDisplay: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.summary-display",
        "defaultMessage": "Summary display"
    },
    bulkEdit: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.bulk-edit",
        "defaultMessage": "Bulk edit"
    },
    giveFeedback: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.give-feedback",
        "defaultMessage": "Give feedback"
    },
    hideDone: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.hide-done",
        "defaultMessage": "Hide done"
    },
    search: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.search",
        "defaultMessage": "View in search"
    },
    showStoryPoints: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.show-story-points",
        "defaultMessage": "Show total story points"
    },
    tooltip: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.tooltip",
        "defaultMessage": "Issue actions"
    },
    hideDoneTooltip: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.hide-done-tooltip",
        "defaultMessage": "Hide done"
    },
    disabledHideDone: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.disabled-hide-done",
        "defaultMessage": "To filter more than 100 child issues, select ... -> View in Search"
    },
    disabledShowStoryPoints: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.disabled-show-story-points",
        "defaultMessage": "Add some story point values to your children issues to view story point progress"
    },
    tooltipIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.tooltip-issue-term-refresh",
        "defaultMessage": "Work item actions"
    },
    disabledHideDoneIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.disabled-hide-done-issue-term-refresh",
        "defaultMessage": "To filter more than 100 child work items, select ... -> View in Search"
    },
    disabledShowStoryPointsIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.heading.meatballs.disabled-show-story-points-issue-term-refresh",
        "defaultMessage": "Add some story point values to your child work items to view story point progress"
    }
});

});

parcelRegister("5uJfx", function(module, exports) {

$parcel$export(module.exports, "triggerButtonTestId", () => $44e34e7f11b44d9a$export$4f95ce1bdc02472f);
$parcel$export(module.exports, "generateBulkEditLink", () => $44e34e7f11b44d9a$export$d9a3bf30975d0075);

var $h6hhX = parcelRequire("h6hhX");
const $44e34e7f11b44d9a$export$4f95ce1bdc02472f = 'issue.views.common.child-issues-panel.heading.meatballs.dropdown.trigger-button';
const $44e34e7f11b44d9a$var$BULK_EDIT_URL = '/secure/views/bulkedit/BulkEdit1!default.jspa?reset=true&new=true';
const $44e34e7f11b44d9a$export$d9a3bf30975d0075 = (parentKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad, sortByValue)=>`${$44e34e7f11b44d9a$var$BULK_EDIT_URL}&${(0, $h6hhX.generateChildIssuesJQL)(parentKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad, sortByValue)}`;

});

parcelRegister("i4t8K", function(module, exports) {

$parcel$export(module.exports, "useUpdateHideDoneStateMutation", () => $767a0708eda59ac5$export$e49c4d453f227f8a);

var $3NkhO = parcelRequire("3NkhO");

var $4US5k = parcelRequire("4US5k");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koeKL = parcelRequire("koeKL");


var $6FvcE = parcelRequire("6FvcE");
const $767a0708eda59ac5$export$e49c4d453f227f8a = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $4US5k.default));
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hideDonePreferenceUpdater = (0, $5uXOq.useCallback)((store, hasHideDonePreference, rootRelayFragment)=>{
        // eslint-disable-next-line @atlassian/relay/must-use-inline
        const UpdateHideDoneStateFragment = ()=>(0, $3NkhO.default);
        if (rootRelayFragment?.jira.userPreferences) {
            const { updatableData: updatableData } = store.readUpdatableFragment(UpdateHideDoneStateFragment(), {
                ...rootRelayFragment.jira.userPreferences,
                $updatableFragmentSpreads: {
                    updateHideDoneState: true
                }
            });
            if (updatableData) updatableData.isIssueViewHideDoneChildIssuesFilterEnabled = hasHideDonePreference;
        }
    }, []);
    const updateHideDone = (0, $5uXOq.useCallback)(({ isHideDoneEnabled: isHideDoneEnabled, rootRelayFragment: rootRelayFragment })=>{
        commitMutation({
            variables: {
                cloudId: cloudId,
                isHideDoneEnabled: isHideDoneEnabled
            },
            updater (store) {
                hideDonePreferenceUpdater(store, isHideDoneEnabled, rootRelayFragment);
            },
            optimisticUpdater (store) {
                hideDonePreferenceUpdater(store, isHideDoneEnabled, rootRelayFragment);
            },
            onError: (error)=>{
                (0, $jcw0u.default)({
                    meta: {
                        id: 'jiv-child-issue-table-hide-done-toggle',
                        packageName: (0, $53c3423eb9321582$export$b8b9d90f9e5bd72b),
                        teamName: (0, $53c3423eb9321582$export$d57b6b390e78d90f)
                    },
                    error: error
                });
                showFlag({
                    messageId: 'issue-view-common-views.child-issues-panel.heading.meatballs.services.update-hide-done-state.show-flag.error.update-hide-done-toggle.show-flag.error',
                    messageType: 'transactional',
                    id: 'hideDoneToggleError',
                    title: formatMessage((0, $6FvcE.default).hideDoneErrorFlagTitle),
                    description: formatMessage((0, $6FvcE.default).hideDoneErrorFlagDescription),
                    isAutoDismiss: true,
                    type: 'error'
                });
            }
        });
    }, [
        commitMutation,
        formatMessage,
        hideDonePreferenceUpdater,
        cloudId,
        showFlag
    ]);
    return updateHideDone;
};

});
parcelRegister("3NkhO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b213de6f6f618065$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98ff9e60ca984f7a2a48babeef509f66>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b213de6f6f618065$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "updateHideDoneState",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isIssueViewHideDoneChildIssuesFilterEnabled"
        }
    ],
    "type": "JiraUserPreferences"
};
$b213de6f6f618065$var$node.hash = "4d9e8be4e7a4ce0964105fa782efcef1";
var $b213de6f6f618065$export$2e2bcd8739ae039 = $b213de6f6f618065$var$node;

});

parcelRegister("4US5k", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bdee0562f5824e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0a3c91ed79c0b02bb0407c60b6ee9489>>
 * @relayHash c55e645a74170fdd11476ed02122d5a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 21039befd11257c3478ba08dae0d42694cdb2a2c8599a5dc12d807a6a3610bc7
const $4bdee0562f5824e8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isHideDoneEnabled"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isHideDoneEnabled",
                                    "variableName": "isHideDoneEnabled"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "setIsIssueViewHideDoneChildIssuesFilterEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "updateHideDoneStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "updateHideDoneStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "21039befd11257c3478ba08dae0d42694cdb2a2c8599a5dc12d807a6a3610bc7",
            "metadata": {},
            "name": "updateHideDoneStateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$4bdee0562f5824e8$var$node.hash = "6babc4ed1c077329c89c7abdb79da681";
var $4bdee0562f5824e8$export$2e2bcd8739ae039 = $4bdee0562f5824e8$var$node;

});

const $53c3423eb9321582$export$b8b9d90f9e5bd72b = 'jivChildIssueTableHideDoneToggle';
const $53c3423eb9321582$export$d57b6b390e78d90f = 'keystone';

parcelRegister("6FvcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4dfb56286e48937$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b4dfb56286e48937$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hideDoneErrorFlagTitle: {
        "id": "jiv-child-issue-table-hide-done-error-flag-title",
        "defaultMessage": "Hide done preference could not be updated."
    },
    hideDoneErrorFlagDescription: {
        "id": "jiv-child-issue-table-hide-done-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});




parcelRegister("fAMRX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb60f3103c32af2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGvGJ = parcelRequire("dGvGJ");

var $hxqfC = parcelRequire("hxqfC");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $LTrSl = parcelRequire("LTrSl");

var $2iFnS = parcelRequire("2iFnS");

var $4X3Cg = parcelRequire("4X3Cg");
const $ffb60f3103c32af2$export$413b1c23ad987cd8 = ({ allIssueIds: allIssueIds, childIssuesLimitStatus: childIssuesLimitStatus })=>{
    const [sortByValue, { setSortBy: setSortBy }] = (0, $LTrSl.useChildIssuesSortBy)();
    const [, { setSortableIssueIds: setSortableIssueIds }] = (0, $LTrSl.useSortableIssueIds)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onSelect = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
    (value)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        }), 'childIssuesSortBy', {
            selection: value
        });
        setSortableIssueIds(allIssueIds);
        setSortBy(value);
    }, [
        allIssueIds,
        createAnalyticsEvent,
        setSortBy,
        setSortableIssueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4X3Cg.SortByMenu), {
        sortedBy: sortByValue,
        // @ts-expect-error - TS2322 - Type '(value: any) => void' is not assignable to type '(selection: SortingOption, event: UIAnalyticsEventInterface) => Promise<undefined> | undefined'.
        onSelect: onSelect,
        childIssuesLimitStatus: childIssuesLimitStatus
    });
};
const $ffb60f3103c32af2$var$toIssueIds = (0, $dGvGJ.createSelector)((0, $2iFnS.getAllIssues), (issues)=>issues.map((issue)=>(0, $g5X3G.toIssueId)(issue.id)));
const $ffb60f3103c32af2$var$ReduxConnectedComponent = (0, $hxqfC.connect)((state)=>({
        allIssueIds: $ffb60f3103c32af2$var$toIssueIds(state)
    }), {})($ffb60f3103c32af2$export$413b1c23ad987cd8);
var $ffb60f3103c32af2$export$2e2bcd8739ae039 = $ffb60f3103c32af2$var$ReduxConnectedComponent;

});
parcelRegister("4X3Cg", function(module, exports) {

$parcel$export(module.exports, "SortByMenu", () => $82fa61f5930c65f9$export$9c87b266b3462029);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $c8Oei = parcelRequire("c8Oei");

var $3bDjY = parcelRequire("3bDjY");

var $jQtKF = parcelRequire("jQtKF");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $54wEF = parcelRequire("54wEF");

var $fOGZN = parcelRequire("fOGZN");

var $2OMDV = parcelRequire("2OMDV");

var $kF1SN = parcelRequire("kF1SN");

var $fvYyN = parcelRequire("fvYyN");

var $d748V = parcelRequire("d748V");
const $82fa61f5930c65f9$export$c0117b1abc6c64e3 = (0, $2OMDV.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
const $82fa61f5930c65f9$var$optionsWithoutDefault = (0, $kF1SN.SORT_OPTIONS).filter((sortingOption)=>sortingOption !== (0, $kF1SN.DEFAULT_SORTING_OPTION));
const $82fa61f5930c65f9$var$DEFAULT_OPTION_LABEL = 'defaultOptionLabel';
const $82fa61f5930c65f9$export$9c87b266b3462029 = (props)=>{
    const { sortedBy: sortedBy, onSelect: onSelect, childIssuesLimitStatus: childIssuesLimitStatus } = props;
    const options = $82fa61f5930c65f9$var$optionsWithoutDefault;
    const defaultOption = (0, $kF1SN.DEFAULT_SORTING_OPTION);
    let availableSortingOptions = options;
    const issueKey = (0, $2gCtH.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false); // we only want to allow filter by priority if we have `allowedValues` in context
    const [{ value: priorityField }] = (0, $54wEF.useFieldConfig)(issueKey, (0, $fOGZN.PRIORITY));
    if (!priorityField || !priorityField.allowedValues || priorityField.allowedValues.length <= 1) availableSortingOptions = options.filter((option)=>option !== (0, $kF1SN.SORT_OPTION).PRIORITY);
    const optionLabels = (0, $5uXOq.useMemo)(()=>{
        const labelsMap = new Map();
        const defaultOptionName = formatMessage((0, $d748V.default)[0, $kF1SN.DEFAULT_SORTING_OPTION]);
        const defaultOptionLabel = formatMessage((0, $d748V.default).defaultOptionLabel, {
            option: defaultOptionName
        });
        labelsMap.set((0, $kF1SN.DEFAULT_SORTING_OPTION), defaultOptionName);
        labelsMap.set($82fa61f5930c65f9$var$DEFAULT_OPTION_LABEL, defaultOptionLabel);
        availableSortingOptions.forEach((sortOption)=>{
            labelsMap.set(sortOption, formatMessage((0, $d748V.default)[sortOption]));
        });
        return labelsMap;
    }, [
        availableSortingOptions,
        formatMessage
    ]);
    const otherOptions = (0, $5uXOq.useMemo)(()=>availableSortingOptions.filter((option)=>option !== sortedBy), [
        availableSortingOptions,
        sortedBy
    ]);
    const hasExceededLimitAfterLoad = (0, $fvYyN.hasExceededIssuesLimitAfterLoad)(childIssuesLimitStatus);
    const button = (0, $5uXOq.useCallback)(// @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    ({ triggerRef: triggerRef, ...triggerProps } = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82fa61f5930c65f9$var$StyledButton, {
            ...triggerProps,
            appearance: "subtle",
            isSelected: isOpen,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                color: "currentColor",
                label: ""
            }),
            testId: "issue.views.common.child-issues-panel.heading.sort-by-menu.trigger-button",
            isDisabled: hasExceededLimitAfterLoad,
            ref: triggerRef,
            interactionName: "auto-generated.issue.views.common.child-issues-panel.heading.sort-by-menu.trigger-button.button",
            spacing: "compact"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82fa61f5930c65f9$var$LabelWrapper, null, formatMessage((0, $d748V.default).sortByLabel, {
            // label should read just "sort by" whenever the default option is to be used
            option: sortedBy !== null && sortedBy !== defaultOption ? optionLabels.get(sortedBy)?.toLowerCase() : ''
        }))), [
        defaultOption,
        formatMessage,
        hasExceededLimitAfterLoad,
        isOpen,
        optionLabels,
        sortedBy
    ]);
    if ((0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus)) return null;
    if (hasExceededLimitAfterLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $d748V.default).exceededChildIssuesLimitIssueTermRefresh : (0, $d748V.default).exceededChildIssuesLimit),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jQtKF.default), {
        isDisabled: hasExceededLimitAfterLoad
    }, button()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: button,
        isOpen: isOpen,
        onOpenChange: ()=>{
            setIsOpen(!isOpen);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82fa61f5930c65f9$var$DropdownGroupWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, otherOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82fa61f5930c65f9$export$c0117b1abc6c64e3, {
            key: option,
            "data-testId": `issue.views.common.child-issues-panel.heading.sort-by-menu.option-${option}`,
            onClick: (event, analyticsEvent)=>onSelect(option, analyticsEvent)
        }, optionLabels.get(option))), sortedBy && sortedBy !== defaultOption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82fa61f5930c65f9$var$DefaultOptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82fa61f5930c65f9$export$c0117b1abc6c64e3, {
        key: defaultOption,
        "data-testId": "issue.views.common.child-issues-panel.heading.sort-by-menu.default-option" // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
        ,
        onClick: (event, analyticsEvent)=>onSelect(defaultOption, analyticsEvent)
    }, optionLabels.get($82fa61f5930c65f9$var$DEFAULT_OPTION_LABEL))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82fa61f5930c65f9$var$DropdownGroupWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul91lit",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $82fa61f5930c65f9$var$DefaultOptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf _1tjq14q2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $82fa61f5930c65f9$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $82fa61f5930c65f9$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f312x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d748V", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e3b6d85f1281399$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $3e3b6d85f1281399$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sortByLabel: {
        "id": "issue.views.common.child-issues-panel.heading.sort-by.label",
        "defaultMessage": "Order by {option}"
    },
    created: {
        "id": "issue.views.common.child-issues-panel.heading.created.label",
        "defaultMessage": "Created"
    },
    key: {
        "id": "issue.views.common.child-issues-panel.heading.key.label",
        "defaultMessage": "Key"
    },
    priority: {
        "id": "issue.views.common.child-issues-panel.heading.priority.label",
        "defaultMessage": "Priority"
    },
    status: {
        "id": "issue.views.common.child-issues-panel.heading.status.label",
        "defaultMessage": "Status"
    },
    assignee: {
        "id": "issue.views.common.child-issues-panel.heading.assignee.label",
        "defaultMessage": "Assignee"
    },
    ranking: {
        "id": "issue.views.common.child-issues-panel.heading.ranking.label",
        "defaultMessage": "Rank"
    },
    defaultOptionLabel: {
        "id": "issue.views.common.child-issues-panel.heading.default-option.label",
        "defaultMessage": "{option} (default)"
    },
    exceededChildIssuesLimit: {
        "id": "issue.views.common.child-issues-panel.heading.sort-by.exceeded-child-issues-limit",
        "defaultMessage": "To order more than 100 child issues, select \xB7\xB7\xB7 > View in search."
    },
    exceededChildIssuesLimitIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.heading.sort-by.exceeded-child-issues-limit-issue-term-refresh",
        "defaultMessage": "To order more than 100 child work items, select \xB7\xB7\xB7 > View in search."
    }
});

});



parcelRegister("ai9zi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7a89b028f6aa29f$export$2e2bcd8739ae039);

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $58aTF = parcelRequire("58aTF");

var $cfyZw = parcelRequire("cfyZw");
var $e7a89b028f6aa29f$export$2e2bcd8739ae039 = (0, $dRLCn.flowWithSafeComponent)((0, $hxqfC.connect)((state)=>({
        title: (0, $58aTF.getTitle)(state),
        titleChildIssues: (0, $58aTF.getChildTitle)(state)
    }), {}))((0, $cfyZw.Title));

});
parcelRegister("cfyZw", function(module, exports) {

$parcel$export(module.exports, "Title", () => $1dd0f2438b238834$export$f99233281efd08a0);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $koiRX = parcelRequire("koiRX");

var $f7CQF = parcelRequire("f7CQF");

var $93Yeu = parcelRequire("93Yeu");

var $4R6GH = parcelRequire("4R6GH");

var $3xJAU = parcelRequire("3xJAU");

var $fvYyN = parcelRequire("fvYyN");

var $hTdwI = parcelRequire("hTdwI");
const $1dd0f2438b238834$var$testId = 'issue.views.common.child-issues-panel.heading.title';
const $1dd0f2438b238834$var$getDefaultTitle = ()=>{
    if ((0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $hTdwI.default).titleIssueTerminologyRefreshM4;
    return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hTdwI.default).titleIssueTermRefresh : (0, $hTdwI.default).title;
};
const $1dd0f2438b238834$export$f99233281efd08a0 = ({ title: title = $1dd0f2438b238834$var$getDefaultTitle(), titleChildIssues: titleChildIssues, hasMultipleChildPanels: hasMultipleChildPanels = false, childIssuesLimitStatus: childIssuesLimitStatus })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const isSimplified = (0, $93Yeu.useIsSimplifiedProject)(projectKey);
    const [issueHierarchyLevel] = (0, $koiRX.useIssueHierarchyLevel)();
    const isIssueBaseLevel = issueHierarchyLevel !== undefined && issueHierarchyLevel === 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7CQF.SectionHeadingTitle), {
        "data-testid": $1dd0f2438b238834$var$testId
    }, projectType === 'software' && !isSimplified && titleChildIssues ? formatMessage(titleChildIssues) : formatMessage(title, {
        issueLevel: isIssueBaseLevel ? 'subtask' : 'work'
    })), !(0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus) && hasMultipleChildPanels && (0, $4R6GH.fg)('jira-issue-view-child-issues-panel-merge-subtasks') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3xJAU.default), null) : null);
};

});
parcelRegister("3xJAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $53e3ebb19c37c106$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $6yUsV = parcelRequire("6yUsV");

var $e4yMr = parcelRequire("e4yMr");

var $koVbs = parcelRequire("koVbs");

var $beY15 = parcelRequire("beY15");

const $53e3ebb19c37c106$var$COMMUNITY_POST_LINK = 'https://community.atlassian.com/forums/Jira-articles/Creating-subtasks-within-epics-in-the-work-item-panel/ba-p/2982758';
const $53e3ebb19c37c106$var$InlineHeaderMessageInfoPanel = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6yUsV.default), {
        appearance: "info",
        testId: (0, $03706683a047c033$export$acf5a2b0dfb6b4c9),
        iconLabel: formatMessage((0, $beY15.default).inlineMessageIconLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong"
    }, formatMessage((0, $beY15.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $beY15.default).coreMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $beY15.default).createActionMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: $53e3ebb19c37c106$var$COMMUNITY_POST_LINK
    }, formatMessage((0, $beY15.default).communityPostLink)))));
};
var $53e3ebb19c37c106$export$2e2bcd8739ae039 = $53e3ebb19c37c106$var$InlineHeaderMessageInfoPanel;

});
parcelRegister("beY15", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e9b84d2308b42d1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9e9b84d2308b42d1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue.views.common.child-issues-panel.heading.inline-header-message-info-panel.title",
        "defaultMessage": "You can no longer create subtasks within epics"
    },
    coreMessage: {
        "id": "issue.views.common.child-issues-panel.heading.inline-header-message-info-panel.core-message",
        "defaultMessage": "Existing subtasks will be merged into the work item panel."
    },
    createActionMessage: {
        "id": "issue.views.common.child-issues-panel.heading.inline-header-message-info-panel.create-action-message",
        "defaultMessage": "You can still create work items by selecting + Add under the summary, or the + on the right of the child work items panel header."
    },
    communityPostLink: {
        "id": "issue.views.common.child-issues-panel.heading.inline-header-message-info-panel.community-post-link",
        "defaultMessage": "Read our Community post"
    },
    inlineMessageIconLabel: {
        "id": "issue.views.common.child-issues-panel.heading.inline-header-message-info-panel.label",
        "defaultMessage": "Help information for the merging of child types"
    }
});

});

const $03706683a047c033$export$acf5a2b0dfb6b4c9 = 'issue.views.common.child-issues-panel.heading.title.information-panel';
const $03706683a047c033$export$a7340217f6bc555d = `${$03706683a047c033$export$acf5a2b0dfb6b4c9}--inline-dialog`;


parcelRegister("hTdwI", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cfd6f30ff5b31eb$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $2cfd6f30ff5b31eb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue.views.common.child-issues-panel.heading.title.title",
        "defaultMessage": "Child issues"
    },
    titleIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.heading.title.title-issue-term-refresh",
        "defaultMessage": "Child work items"
    },
    titleIssueTerminologyRefreshM4: {
        "id": "issue.views.common.child-issues-panel.heading.title.title-issue-terminology-refresh-m4",
        "defaultMessage": "{issueLevel, select, subtask{Subtasks} other{Child work items}}"
    }
});

});



parcelRegister("gRIlG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3428b0f5513bc5f0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $ckKDf = parcelRequire("ckKDf");

var $6s1PB = parcelRequire("6s1PB");

var $2gCtH = parcelRequire("2gCtH");

var $6IWM9 = parcelRequire("6IWM9");

var $f7CQF = parcelRequire("f7CQF");

var $cZpsT = parcelRequire("cZpsT");

var $4R6GH = parcelRequire("4R6GH");

var $fvYyN = parcelRequire("fvYyN");

var $8ZsUM = parcelRequire("8ZsUM");

var $9C5ME = parcelRequire("9C5ME");
// This number was calculated by hand to see when buttons started to overflow
const $3428b0f5513bc5f0$var$SINGLE_COLUMN_MAX_WIDTH = 440;
function $3428b0f5513bc5f0$var$Heading(props) {
    const { Title: Title, Meatballs: Meatballs, AddChild: AddChild, SortByMenu: SortByMenu, supportsIssueCreation: supportsIssueCreation, allIssues: allIssues, onAddChildClick: onAddChildClick, sourceName: sourceName, isSortingAvailable: isSortingAvailable, childIssuesLimitStatus: childIssuesLimitStatus, issueHierarchyLevel: issueHierarchyLevel, containerWidth: containerWidth, rootRelayFragment: rootRelayFragment, isHideDoneFilterEnabled: isHideDoneFilterEnabled, isRankingEnabled: isRankingEnabled, columnPickerRef: columnPickerRef, hasMultipleChildPanels: hasMultipleChildPanels } = props;
    const isMeatballMenuEnabled = (0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus) || allIssues.length > 0;
    const isAiEnabled = (0, $8ZsUM.useIsAiEnabled)();
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isAnonymousUser = (0, $cZpsT.useIsAnonymous)();
    const renderIssueBreakdownButton = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: "suggestIssuesSpotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckKDf.IssueBreakdownButton), {
            issueHierarchyLevel: issueHierarchyLevel,
            isCompact: !!containerWidth && containerWidth <= $3428b0f5513bc5f0$var$SINGLE_COLUMN_MAX_WIDTH || (0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
            engagementId: "suggestIssuesSpotlight"
        }));
    }, [
        containerWidth,
        issueHierarchyLevel
    ]);
    const oldSectionHeadingIcons = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7CQF.SectionHeadingIcons), null, isSortingAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SortByMenu, {
            childIssuesLimitStatus: childIssuesLimitStatus
        }), isMeatballMenuEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Meatballs, {
            childIssuesLimitStatus: childIssuesLimitStatus
        }) : null, supportsIssueCreation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AddChild, {
            onClick: onAddChildClick
        }) : null, !isAnonymousUser && supportsIssueCreation && isAiEnabled && isAiOptInEnabled && !(0, $6s1PB.expVal)('proactive_aiwb_2', 'enabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $3428b0f5513bc5f0$var$oldIssueBreakdownButtonStyles
        }, renderIssueBreakdownButton) : null);
    };
    const ConfigurableChildIssueHeading = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: (0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false) ? [
                $3428b0f5513bc5f0$var$marginBottomStyles,
                $3428b0f5513bc5f0$var$minHeightStyles
            ] : $3428b0f5513bc5f0$var$marginBottomStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7CQF.SectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
            htmlFor: sourceName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Title, {
            hasMultipleChildPanels: hasMultipleChildPanels,
            childIssuesLimitStatus: childIssuesLimitStatus
        })), (0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus) && (0, $4R6GH.fg)('jiv-chin-child-issue-limit-panel-header-enablement') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9C5ME.default), {
            columnPickerRef: columnPickerRef,
            onAddChildClick: onAddChildClick,
            childIssuesLimitStatus: childIssuesLimitStatus,
            issueHierarchyLevel: issueHierarchyLevel,
            isRankingEnabled: (0, $4R6GH.fg)('hide-rank-option-when-unavailable') ? isRankingEnabled : undefined,
            rootRelayFragment: rootRelayFragment,
            isHideDoneFilterEnabled: isHideDoneFilterEnabled
        })));
    };
    const OldChildIssueHeading = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7CQF.SectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
            htmlFor: sourceName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Title, {
            hasMultipleChildPanels: hasMultipleChildPanels,
            childIssuesLimitStatus: childIssuesLimitStatus
        })), oldSectionHeadingIcons());
    };
    return (0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) ? ConfigurableChildIssueHeading() : OldChildIssueHeading();
}
var $3428b0f5513bc5f0$export$2e2bcd8739ae039 = (0, $6IWM9.default)($3428b0f5513bc5f0$var$Heading);
const $3428b0f5513bc5f0$var$oldIssueBreakdownButtonStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.075'
});
const $3428b0f5513bc5f0$var$marginBottomStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});
// This minHeight is used to ensure that the heading does not jump when the meatball menu appears
const $3428b0f5513bc5f0$var$minHeightStyles = (0, $8CUq3.xcss)({
    minHeight: '24px'
});
$3428b0f5513bc5f0$var$Heading.defaultProps = {
    isSortingAvailable: false,
    supportsIssueCreation: false,
    allIssues: []
};

});
parcelRegister("ckKDf", function(module, exports) {

$parcel$export(module.exports, "IssueBreakdownButton", () => $c87a018d6dbe6fe1$export$c8fabf04379fa2f7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $3bDjY = parcelRequire("3bDjY");

var $jps85 = parcelRequire("jps85");

var $47gW9 = parcelRequire("47gW9");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $jyNU3 = parcelRequire("jyNU3");

var $lqdvb = parcelRequire("lqdvb");

var $euAs1 = parcelRequire("euAs1");

var $1fz0b = parcelRequire("1fz0b");

var $4FsGL = parcelRequire("4FsGL");
const $c87a018d6dbe6fe1$export$2c5c38d2211a0152 = ()=>(0, $5uXOq.useContext)((0, $euAs1.AiIssueBreakdownEntryPointContext)).entryPointActions;
const $c87a018d6dbe6fe1$export$c8fabf04379fa2f7 = ({ issueHierarchyLevel: issueHierarchyLevel, isCompact: isCompact })=>{
    const [{ currentStep: currentStep, channelId: channelId }, { setIssueBreakdownStep: setIssueBreakdownStep, updateStreamingStatus: updateStreamingStatus, setStartTime: setStartTime, setIsProactivelySuggestingIssues: setIsProactivelySuggestingIssues }] = (0, $1fz0b.useIssueBreakdown)();
    const entryPointActions = $c87a018d6dbe6fe1$export$2c5c38d2211a0152();
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, true);
    const { fireTrack: fireTrack } = (0, $jyNU3.useAiWorkBreakDownAnalytics)({
        channelId: channelId,
        consumer: (0, $lqdvb.ISSUE_VIEW_CONSUMER)
    });
    const isSelected = currentStep !== (0, $1fz0b.steps).defaultStep;
    /**
   * We manually load the AI Work Breakdown (AIWB) component if it looks like it was already open (i.e. isSelected)
   * This is to ensure that the AIWB component is rendered when the issue view is resized
   * since this results in a complete re-render of the issue view & unmounting of the AIWB component.
   */ // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isSelected) entryPointActions.load();
    }, [
        isSelected,
        entryPointActions
    ]);
    // Toggle to open/close issue breakdown
    const onFullViewClick = (0, $5uXOq.useCallback)(()=>{
        if (!isSelected) {
            if ((0, $4R6GH.fg)('proactive_aiwb_2_targeting_gate')) setIsProactivelySuggestingIssues(false);
            setStartTime();
            setIssueBreakdownStep((0, $1fz0b.steps).draftListStep);
            updateStreamingStatus(true);
            fireTrack('aiInteraction initiated', 'issueBreakdownButtonClicked', {
                invokedFrom: (0, $jyNU3.ISSUE_BREAKDOWN_BUTTON_ID)
            });
        }
    }, [
        isSelected,
        setStartTime,
        setIssueBreakdownStep,
        updateStreamingStatus,
        fireTrack,
        setIsProactivelySuggestingIssues
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueNameForFormatting = {
        issueType: issueHierarchyLevel && issueHierarchyLevel > 0 ? 'issues' : 'tasks'
    };
    const buttonLabel = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4FsGL.default).buttonLabelIssueTermRefresh : (0, $4FsGL.default).buttonLabel, issueNameForFormatting);
    const buttonDefaultTooltip = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4FsGL.default).buttonDefaultTooltipContentIssueTermRefresh : (0, $4FsGL.default).buttonDefaultTooltipContent, issueNameForFormatting);
    const interactionName = 'ai-work-breakdown.ui.issue-breakdown-button';
    const commonProps = {
        ref: triggerRef,
        spacing: 'compact',
        interactionName: interactionName,
        testId: 'ai-work-breakdown.ui.issue-breakdown-button.button',
        'aria-label': buttonLabel
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: buttonDefaultTooltip,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...commonProps,
        isSelected: isSelected,
        onClick: onFullViewClick,
        iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
                color: "currentColor",
                label: ""
            })
    }, !(0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false) && !isCompact && buttonLabel));
};

});
parcelRegister("4FsGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f5d89f4c7a236e0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9f5d89f4c7a236e0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        "id": "ai-work-breakdown.button-label",
        "defaultMessage": "Suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}}"
    },
    buttonDefaultTooltipContent: {
        "id": "ai-work-breakdown.button-default-tooltip-content",
        "defaultMessage": "Ask Atlassian Intelligence to suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}} for you."
    },
    buttonModalViewTooltipContent: {
        "id": "ai-work-breakdown.button-modal-view-tooltip-content",
        "defaultMessage": "Ask Atlassian Intelligence to suggest {issueType, select, tasks {subtasks} issues {child issues} other {child issues}} for you. This will open in a full page view."
    },
    placeholderTextNonFinal: {
        "id": "ai-work-breakdown.placeholder-text-non-final",
        "defaultMessage": "Tell us how you want your issues generated, or hit Enter."
    },
    footerTextPromptNonFinal: {
        "id": "ai-work-breakdown.footer-text-prompt-non-final",
        "defaultMessage": "Powered by Atlassian Intelligence"
    },
    labelCancel: {
        "id": "ai-work-breakdown.label-cancel",
        "defaultMessage": "Cancel"
    },
    acceptAll: {
        "id": "ai-work-breakdown.accept-all",
        "defaultMessage": "Accept all"
    },
    createAll: {
        "id": "ai-work-breakdown.create-all",
        "defaultMessage": "Create all"
    },
    successFlagTitle: {
        "id": "ai-work-breakdown.success-flag-title",
        "defaultMessage": "Issues successfully created"
    },
    successFlagDescription: {
        "id": "ai-work-breakdown.success-flag-description",
        "defaultMessage": "Your issues have been successfully created"
    },
    errorFlagTitleOnItemNonFinal: {
        "id": "ai-work-breakdown.error-flag-title-on-item-non-final",
        "defaultMessage": "Project or issue ID was not provided."
    },
    errorFlagDescriptionNonFinal: {
        "id": "ai-work-breakdown.error-flag-description-non-final",
        "defaultMessage": "Please try again later."
    },
    statusRetrievingSourceContext: {
        "id": "ai-work-breakdown.status-retrieving-source-context",
        "defaultMessage": "Atlassian Intelligence is reading the parent issue..."
    },
    statusRefiningSuggestedIssues: {
        "id": "ai-work-breakdown.status-refining-suggested-issues",
        "defaultMessage": "Atlassian Intelligence is refining suggestions..."
    },
    statusSuggestingInitialIssues: {
        "id": "ai-work-breakdown.status-suggesting-initial-issues",
        "defaultMessage": "Atlassian Intelligence is generating suggestions..."
    },
    statusRemovingDuplicateIssues: {
        "id": "ai-work-breakdown.status-removing-duplicate-issues",
        "defaultMessage": "Atlassian Intelligence is removing duplicates..."
    },
    statusReformatingIssues: {
        "id": "ai-work-breakdown.status-reformating-issues",
        "defaultMessage": "Atlassian Intelligence is writing descriptions..."
    },
    statusGeneratingDefaultMessage: {
        "id": "ai-work-breakdown.status-generating-default-message",
        "defaultMessage": "Generating issue suggestions"
    },
    createErrorFlagTitle: {
        "id": "ai-work-breakdown.create-error-flag-title",
        "defaultMessage": "Couldn't create the issue"
    },
    createErrorFlagDescription: {
        "id": "ai-work-breakdown.create-error-flag-description",
        "defaultMessage": "We're having some trouble creating the issue. Refresh the page and try again."
    },
    suggestErrorMessageTitle: {
        "id": "ai-work-breakdown.suggest-error-message-title",
        "defaultMessage": "These suggestions have required fields"
    },
    suggestErrorMessageBody: {
        "id": "ai-work-breakdown.suggest-error-message-body",
        "defaultMessage": "Edit each suggestion and complete the required fields to create the issue"
    },
    bottomInputPrompt: {
        "id": "ai-work-breakdown.bottom-input-prompt",
        "defaultMessage": "What should I do next?"
    },
    buttonLabelIssueTermRefresh: {
        "id": "ai-work-breakdown.button-label-issue-term-refresh",
        "defaultMessage": "Suggest {issueType, select, tasks {subtasks} issues {child work items} other {child work items}}"
    },
    buttonDefaultTooltipContentIssueTermRefresh: {
        "id": "ai-work-breakdown.button-default-tooltip-content-issue-term-refresh",
        "defaultMessage": "Ask Atlassian Intelligence to suggest {issueType, select, tasks {subtasks} issues {child work items} other {child work items}} for you."
    },
    buttonModalViewTooltipContentIssueTermRefresh: {
        "id": "ai-work-breakdown.button-modal-view-tooltip-content-issue-term-refresh",
        "defaultMessage": "Ask Atlassian Intelligence to suggest {issueType, select, tasks {subtasks} issues {child work items} other {child work items}} for you. This will open in a full page view."
    },
    placeholderTextNonFinalIssueTermRefresh: {
        "id": "ai-work-breakdown.placeholder-text-non-final-issue-term-refresh",
        "defaultMessage": "Tell us how you want your work items generated, or hit Enter."
    },
    successFlagTitleIssueTermRefresh: {
        "id": "ai-work-breakdown.success-flag-title-issue-term-refresh",
        "defaultMessage": "Work items successfully created"
    },
    successFlagDescriptionIssueTermRefresh: {
        "id": "ai-work-breakdown.success-flag-description-issue-term-refresh",
        "defaultMessage": "Your work items have been successfully created"
    },
    errorFlagTitleOnItemNonFinalIssueTermRefresh: {
        "id": "ai-work-breakdown.error-flag-title-on-item-non-final-issue-term-refresh",
        "defaultMessage": "Project or work item ID was not provided."
    },
    statusRetrievingSourceContextNonFinalIssueTermRefresh: {
        "id": "ai-work-breakdown.status-retrieving-source-context-non-final-issue-term-refresh",
        "defaultMessage": "Atlassian Intelligence is reading the parent work item..."
    },
    statusGeneratingDefaultMessageNonFinalIssueTermRefresh: {
        "id": "ai-work-breakdown.status-generating-default-message-non-final-issue-term-refresh",
        "defaultMessage": "Generating suggestions"
    },
    createErrorFlagTitleIssueTermRefresh: {
        "id": "ai-work-breakdown.create-error-flag-title-issue-term-refresh",
        "defaultMessage": "Couldn't create the work item"
    },
    createErrorFlagDescriptionIssueTermRefresh: {
        "id": "ai-work-breakdown.create-error-flag-description-issue-term-refresh",
        "defaultMessage": "We're having some trouble creating the work item. Refresh the page and try again."
    },
    suggestErrorMessageBodyIssueTermRefresh: {
        "id": "ai-work-breakdown.suggest-error-message-body-issue-term-refresh",
        "defaultMessage": "Edit each suggestion and complete the required fields to create the work item"
    },
    showAllSuggestionsButton: {
        "id": "ai-work-breakdown.ui.issue-breakdown-draft-list.show-all-suggestions-button",
        "defaultMessage": "Show all suggestions"
    },
    generateSuggests: {
        "id": "ai-work-breakdown.issue-breakdown-draft-list.generate-suggest",
        "defaultMessage": "Generate suggestions"
    },
    showXSuggestions: {
        "id": "ai-work-breakdown.issue-breakdown-draft-list.show-x-suggestions",
        "defaultMessage": "Show {itemCount} suggestions"
    },
    collapsedDraftListLabel: {
        "id": "ai-work-breakdown.issue-breakdown-draft-list.collapsed-draft-list-label",
        "defaultMessage": "Collapse suggestions"
    },
    noSuggestions: {
        "id": "ai-work-breakdown.issue-breakdown-draft-list.no-suggestions",
        "defaultMessage": "No suggestions"
    }
});

});


parcelRegister("8ZsUM", function(module, exports) {

$parcel$export(module.exports, "useHideDoneChildIssues", () => $c103ea9219eb9d67$export$25b90030957fcfd3);
$parcel$export(module.exports, "getIsSubtaskCreateEnabled", () => $c103ea9219eb9d67$export$fe88f9a1f24669a4);
$parcel$export(module.exports, "useIsAiEnabled", () => $c103ea9219eb9d67$export$742ce7b41314d513);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $2gCtH = parcelRequire("2gCtH");


var $eNNkf = parcelRequire("eNNkf");

var $93Yeu = parcelRequire("93Yeu");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $kF1SN = parcelRequire("kF1SN");
const $c103ea9219eb9d67$export$25b90030957fcfd3 = (allIssues, incompleteIssues)=>{
    const [hideDonePreference] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$4c9f7f9f8a4000e1));
    const completedIssuesCount = (0, $5uXOq.useMemo)(()=>allIssues.length - incompleteIssues.length, [
        allIssues.length,
        incompleteIssues.length
    ]);
    const shouldShowHideDoneInfoIcon = (0, $5uXOq.useMemo)(()=>{
        if ((0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false)) return hideDonePreference === 'true';
        const hasIncompleteIssues = !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(incompleteIssues);
        return completedIssuesCount > 0 && hasIncompleteIssues && hideDonePreference === 'true';
    }, [
        hideDonePreference,
        completedIssuesCount,
        incompleteIssues
    ]);
    return {
        shouldShowHideDoneInfoIcon: shouldShowHideDoneInfoIcon,
        completedIssuesCount: completedIssuesCount
    };
};
const $c103ea9219eb9d67$var$getIsNextgenSubtask = (childIssuesPanelType, issueHierarchyLevel)=>childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL ? !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueHierarchyLevel) && issueHierarchyLevel === 0 : false;
const $c103ea9219eb9d67$export$fe88f9a1f24669a4 = (childIssuesPanelType, issueHierarchyLevel)=>$c103ea9219eb9d67$var$getIsNextgenSubtask(childIssuesPanelType, issueHierarchyLevel) || childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS || childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_PORTFOLIO_CHILDREN;
const $c103ea9219eb9d67$export$742ce7b41314d513 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    if (!appEditions) return false;
    // currently admin hub AI BE endpoint for JWM already defaults to JSW value
    // so we reflect same logic for JWM here
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return appEditions.software === (0, $ldyPw.PREMIUM_EDITION);
        default:
            return false;
    }
};

});

parcelRegister("9C5ME", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3eb09c2d32ad1e2$export$2e2bcd8739ae039);

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $58aTF = parcelRequire("58aTF");

var $2iFnS = parcelRequire("2iFnS");

var $4ckjx = parcelRequire("4ckjx");

var $3UZ3l = parcelRequire("3UZ3l");

var $8R7ny = parcelRequire("8R7ny");
var $a3eb09c2d32ad1e2$export$2e2bcd8739ae039 = (0, $dRLCn.flowWithSafeComponent)((0, $hxqfC.connect)((state)=>{
    return {
        Meatballs: $3UZ3l.default,
        AddChild: $4ckjx.default,
        allIssues: (0, $2iFnS.getAllIssues)(state),
        supportsIssueCreation: (0, $58aTF.getSupportsIssueCreation)(state),
        isSortingAvailable: false
    };
}, {}))((0, $8R7ny.default));

});
parcelRegister("8R7ny", function(module, exports) {

$parcel$export(module.exports, "default", () => $67403d6f83bc62ce$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $ckKDf = parcelRequire("ckKDf");

var $2gCtH = parcelRequire("2gCtH");

var $f7CQF = parcelRequire("f7CQF");

var $cZpsT = parcelRequire("cZpsT");

var $6s1PB = parcelRequire("6s1PB");

var $fvYyN = parcelRequire("fvYyN");

var $8ZsUM = parcelRequire("8ZsUM");
function $67403d6f83bc62ce$var$HeaderSectionHeadingIcons({ Meatballs: Meatballs, AddChild: AddChild, supportsIssueCreation: supportsIssueCreation, allIssues: allIssues, onAddChildClick: onAddChildClick, childIssuesLimitStatus: childIssuesLimitStatus, issueHierarchyLevel: issueHierarchyLevel, rootRelayFragment: rootRelayFragment, isHideDoneFilterEnabled: isHideDoneFilterEnabled, isRankingEnabled: isRankingEnabled, columnPickerRef: columnPickerRef }) {
    const isMeatballMenuEnabled = (0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus) || allIssues.length > 0;
    const isAiEnabled = (0, $8ZsUM.useIsAiEnabled)();
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isAnonymousUser = (0, $cZpsT.useIsAnonymous)();
    const renderIssueBreakdownButton = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: "suggestIssuesSpotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckKDf.IssueBreakdownButton), {
            issueHierarchyLevel: issueHierarchyLevel,
            isCompact: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
            engagementId: "suggestIssuesSpotlight"
        }));
    }, [
        issueHierarchyLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7CQF.SectionHeadingIcons), null, !isAnonymousUser && supportsIssueCreation && isAiEnabled && isAiOptInEnabled && !(0, $6s1PB.expVal)('proactive_aiwb_2', 'enabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $67403d6f83bc62ce$var$issueBreakdownButtonStyles
    }, renderIssueBreakdownButton) : null, isMeatballMenuEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Meatballs, {
        childIssuesLimitStatus: childIssuesLimitStatus,
        isSortingAvailable: true,
        rootRelayFragment: rootRelayFragment,
        isHideDoneFilterEnabled: isHideDoneFilterEnabled,
        isRankingEnabled: (0, $4R6GH.fg)('hide-rank-option-when-unavailable') ? isRankingEnabled : undefined
    }) : null, // The hasExceededIssuesLimitInitialLoad precondition can be removed when jiv-chin-child-issue-limit-panel-header-enablemen is cleaned up
    !(0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus) && (0, $4R6GH.fg)('jira-nike-chin-config-button-in-header') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: columnPickerRef
    }) : null, supportsIssueCreation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AddChild, {
        onClick: onAddChildClick
    }) : null);
}
var $67403d6f83bc62ce$export$2e2bcd8739ae039 = $67403d6f83bc62ce$var$HeaderSectionHeadingIcons;
const $67403d6f83bc62ce$var$issueBreakdownButtonStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.075'
});

});




parcelRegister("eXTjX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c73931ba3ca8764$export$2e2bcd8739ae039);

var $iQv12 = parcelRequire("iQv12");

var $8oe80 = parcelRequire("8oe80");

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");

var $2iFnS = parcelRequire("2iFnS");

var $dvqTC = parcelRequire("dvqTC");

var $dtS0b = parcelRequire("dtS0b");

var $nvySy = parcelRequire("nvySy");

var $8GpfS = parcelRequire("8GpfS");
var $1c73931ba3ca8764$export$2e2bcd8739ae039 = (0, $dRLCn.flowWithSafeComponent)((0, $8oe80.default)('button', {
    onSubmitClickAnalytics: 'clicked',
    onCancelClickAnalytics: 'clicked',
    onAddExistingClickAnalytics: 'clicked'
}), (0, $8oe80.default)('keyboardShortcut', {
    onEnterKeyPressedAnalytics: 'pressed',
    onEscapeKeyPressedAnalytics: 'pressed'
}), (0, $8oe80.default)('childIssuePanelInlineCreate', {
    onSubmit: 'onSubmit',
    onFullDialogCreate: 'onFullDialogCreate'
}), (0, $iQv12.default)({
    onSubmitClickAnalytics: ({ triggeredViaHotKey: triggeredViaHotKey })=>({
            name: 'createChildIssue',
            triggeredViaHotKey: !!triggeredViaHotKey
        }),
    onCancelClickAnalytics: 'hideChildIssueInlineCreate',
    onEnterKeyPressedAnalytics: 'confirmChildIssueCreate',
    onEscapeKeyPressedAnalytics: 'cancelChildIssueCreate',
    onAddExistingClickAnalytics: 'addExistingChildClick'
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ ChildTypesSelect: ConnectedComponent<ComponentType<WithIntlProps<Pick<{ issueTypes: ChildIssueType[]; isDisabled?: boolean | undefined; } & Intl & { selectedIssueType: ChildIssueType; onChange: (arg1: ChildIssueType) => void; defaultMenuIsOpen?: boolean | undefined; }, "intl" | ...' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof PropsWithRef<Omit<{ [K in keyof PropsWithRef<Omit<{ [K in keyof Props]: K extends "onSubmitClickAnalytics" | "onCancelClickAnalytics" | "onAddExistingClickAnalytics" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<...> : Props[K]...'.
(0, $hxqfC.connect)((state)=>({
        ChildTypesSelect: $nvySy.default,
        baseUrl: (0, $58aTF.getBaseUrl)(state),
        issues: (0, $2iFnS.getAllIssues)(state),
        addClickCount: (0, $dtS0b.getAddClickCount)(state),
        triggeredViaHotKey: (0, $dtS0b.getTriggeredViaHotKey)(state),
        issueTypes: (0, $2iFnS.getIssueTypes)(state),
        selectedIssueType: (0, $dtS0b.getSelectedIssueType)(state),
        projectId: (0, $58aTF.getProjectId)(state),
        parentIssueId: (0, $58aTF.getParentId)(state),
        parentIssueKey: (0, $58aTF.getParentKey)(state),
        epicLinkFieldKey: (0, $58aTF.getEpicLinkFieldKey)(state),
        childIssuesPanelType: (0, $58aTF.getChildIssuesPanelType)(state),
        requiresFullCreate: (0, $58aTF.getRequiresFullCreateByIssueType)(state),
        summary: (0, $dtS0b.getChildCreateSummary)(state),
        issueHierarchyLevel: (0, $2iFnS.getIssueHierarchyLevel)(state)
    }), {
    onCancel: (0, $dvqTC.hideAddChildIssue),
    onAddExistingIssue: ()=>(0, $dvqTC.setChildPanelView)((0, $dvqTC.CHILD_PANEL_VIEWS).AddExistingIssue),
    onChangeSummary: (summary)=>(0, $dvqTC.setChildCreateSummary)(summary),
    onSubmit: (optimisticUiChildIssue, additionalAttributes, analyticsEvent)=>(0, $3XoQX.createChildRequest)(optimisticUiChildIssue, analyticsEvent, additionalAttributes),
    onFullDialogCreate: (optimisticId, childIssue, additionalAttributes, analyticsEvent)=>(0, $3XoQX.childCreatedInFullDialog)(optimisticId, childIssue, analyticsEvent, additionalAttributes)
}))((0, $8GpfS.default));

});
parcelRegister("nvySy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3ea946913ed2477$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $2iFnS = parcelRequire("2iFnS");

var $dvqTC = parcelRequire("dvqTC");

var $dtS0b = parcelRequire("dtS0b");

var $ltvZM = parcelRequire("ltvZM");
var $f3ea946913ed2477$export$2e2bcd8739ae039 = (0, $dRLCn.flowWithSafeComponent)((0, $hxqfC.connect)((state)=>({
        selectedIssueType: (0, $dtS0b.getSelectedIssueType)(state),
        issueTypes: (0, $2iFnS.getIssueTypes)(state)
    }), {
    onChange: (0, $dvqTC.selectedIssueTypeChanged)
}))((0, $az4zD.injectIntlV2)((0, $ltvZM.default)));

});
parcelRegister("ltvZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fcd985a4678d75a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7K5PP = parcelRequire("7K5PP");

var $jjlQu = parcelRequire("jjlQu");

var $4R6GH = parcelRequire("4R6GH");

var $gT4Fa = parcelRequire("gT4Fa");

var $h18Ob = parcelRequire("h18Ob");

var $4Xid9 = parcelRequire("4Xid9");

var $4a0Ad = parcelRequire("4a0Ad");
const $4fcd985a4678d75a$var$selectStyles = {
    singleValue: (baseStyles)=>({
            ...baseStyles,
            // item is already vertically aligned because of `align-items: center` in parent. With `position: absolute` select does not have width == content width
            position: 'static',
            transform: 'none'
        })
};
const $4fcd985a4678d75a$var$getOptionLabel = (option)=>option.name;
const $4fcd985a4678d75a$var$getOptionValue = (option)=>option.id;
const $4fcd985a4678d75a$var$formatOptionLabel = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4fcd985a4678d75a$var$OptionLabelAndIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
        url: option.iconUrl,
        title: option.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4fcd985a4678d75a$var$OptionLabelContainer, null, option.name));
class $4fcd985a4678d75a$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            issueTypes: []
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage }, issueTypes: issueTypes, selectedIssueType: selectedIssueType, isDisabled: isDisabled = false, defaultMenuIsOpen: defaultMenuIsOpen } = this.props;
        return(// @ts-expect-error  Type '{ styles: AkSelectStyles; options: ChildIssueType[]; value: ChildIssueType; getOptionLabel: (option: Option) => string; getOptionValue: (option: Option) => string; ... 5 more ...; filterOption: (option: OptionToFilter, inputValue: string) => boolean; }' is not assignable to type 'IntrinsicAttributes & (IntrinsicClassAttributes<{ components: Partial<SelectComponents<ChildIssueType, false, GroupBase<ChildIssueType>>>; ... 23 more ...; UNSAFE_componentWillUpdate?(nextProps: Readonly<...>, nextState: Readonly<...>, nextContext: any): void; }> & (Readonly<...> & Readonly<...>))
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            ...(0, $gT4Fa.defaultSelectProps),
            isDisabled: isDisabled,
            styles: (0, $4Xid9.mergeReactSelectStyles)((0, $h18Ob.defaultSelectStyles), $4fcd985a4678d75a$var$selectStyles),
            options: issueTypes,
            value: selectedIssueType,
            getOptionLabel: $4fcd985a4678d75a$var$getOptionLabel,
            getOptionValue: $4fcd985a4678d75a$var$getOptionValue,
            formatOptionLabel: $4fcd985a4678d75a$var$formatOptionLabel,
            onChange: this.onChange,
            placeholder: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4a0Ad.default).typesPlaceholderIssueTermRefresh : (0, $4a0Ad.default).typesPlaceholder),
            defaultMenuIsOpen: defaultMenuIsOpen,
            "aria-label": formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4a0Ad.default).issueTypeSelectorLabelIssueTermRefresh : (0, $4a0Ad.default).issueTypeSelectorLabel)
        }));
    }
    constructor(...args){
        super(...args), this.onChange = (selectedOption, actionMeta)=>{
            if (actionMeta.action === 'select-option' && selectedOption != null) this.props.onChange(selectedOption);
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4fcd985a4678d75a$var$OptionLabelAndIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4fcd985a4678d75a$var$OptionLabelContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _19bvu2gc _1e0c1o8l _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4a0Ad", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7610bd9391fc27$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $ac7610bd9391fc27$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    typesPlaceholder: {
        "id": "issue.views.common.child-issues-panel.inline-create.child-types-select.types-placeholder",
        "defaultMessage": "Issue type"
    },
    issueTypeSelectorLabel: {
        "id": "issue.views.common.child-issues-panel.inline-create.child-types-select.issue-type-selector-label",
        "defaultMessage": "Select issue type"
    },
    typesPlaceholderIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.inline-create.child-types-select.types-placeholder-issue-term-refresh",
        "defaultMessage": "Work type"
    },
    issueTypeSelectorLabelIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.inline-create.child-types-select.issue-type-selector-label-issue-term-refresh",
        "defaultMessage": "Select work type"
    }
});

});



parcelRegister("8GpfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6abc109dfd6e835f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $2nvJN = parcelRequire("2nvJN");

var $fVnbM = parcelRequire("fVnbM");

var $bU3PY = parcelRequire("bU3PY");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $chqpx = parcelRequire("chqpx");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $eHJxW = parcelRequire("eHJxW");

var $jzjy1 = parcelRequire("jzjy1");

var $6BZYo = parcelRequire("6BZYo");

var $i0vxP = parcelRequire("i0vxP");

var $bUPgZ = parcelRequire("bUPgZ");

var $bwLf9 = parcelRequire("bwLf9");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $38bVB = parcelRequire("38bVB");

var $b8JO7 = parcelRequire("b8JO7");

var $4HdDJ = parcelRequire("4HdDJ");

var $ecB7Y = parcelRequire("ecB7Y");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $1XJ20 = parcelRequire("1XJ20");

var $hchBL = parcelRequire("hchBL");

var $5knXz = parcelRequire("5knXz");

var $dCm1o = parcelRequire("dCm1o");

var $92wsG = parcelRequire("92wsG");

var $1fz0b = parcelRequire("1fz0b");

var $kF1SN = parcelRequire("kF1SN");

var $2j7J7 = parcelRequire("2j7J7");

var $8KYZt = parcelRequire("8KYZt");

var $gpjoS = parcelRequire("gpjoS");
const $6abc109dfd6e835f$var$MAX_SUMMARY_LENGTH = 255;
const $6abc109dfd6e835f$var$isSummaryTooLong = (summary)=>{
    const trimmedSummary = (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(summary);
    return trimmedSummary.length > $6abc109dfd6e835f$var$MAX_SUMMARY_LENGTH;
};
const $6abc109dfd6e835f$var$isCreatingChildIssueAllowed = (selectedIssueType)=>{
    // Currently, in an Epic only project selectedIssueType is coming as undefined
    if (!selectedIssueType) return false;
    return true;
};
const $6abc109dfd6e835f$var$isPrimaryButtonDisabled = (summary, selectedIssueType)=>{
    if (!$6abc109dfd6e835f$var$isCreatingChildIssueAllowed(selectedIssueType)) return true;
    const trimmedSummary = (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(summary);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(trimmedSummary) || $6abc109dfd6e835f$var$isSummaryTooLong(summary);
};
const $6abc109dfd6e835f$var$isTextFieldInvalid = (summary, selectedIssueType)=>{
    if (!$6abc109dfd6e835f$var$isCreatingChildIssueAllowed(selectedIssueType)) return true;
    return $6abc109dfd6e835f$var$isSummaryTooLong(summary);
};
const $6abc109dfd6e835f$var$testId = 'issue.views.common.child-issues-panel.inline-create.add-child-trigger-button';
const $6abc109dfd6e835f$export$bff74f82b631e3d3 = ({ addClickCount: addClickCount = 0, requiresFullCreate: requiresFullCreate = false, parentIssueKey: parentIssueKey, epicLinkFieldKey: epicLinkFieldKey = null, issueTypes: issueTypes = [], ChildTypesSelect: ChildTypesSelect, childIssuesPanelType: childIssuesPanelType, baseUrl: baseUrl, projectId: projectId, parentIssueId: parentIssueId, selectedIssueType: selectedIssueType, summary: summary, inputId: inputId, openIssueCreateModal: openIssueCreateModal, onSubmit: onSubmit, onCancel: onCancel, onFullDialogCreate: onFullDialogCreate, onChangeSummary: onChangeSummary, onAddExistingIssue: onAddExistingIssue, onSubmitClickAnalytics: onSubmitClickAnalytics, onCancelClickAnalytics: onCancelClickAnalytics, onEnterKeyPressedAnalytics: onEnterKeyPressedAnalytics, onEscapeKeyPressedAnalytics: onEscapeKeyPressedAnalytics, onAddExistingClickAnalytics: onAddExistingClickAnalytics, issueHierarchyLevel: issueHierarchyLevel, triggeredViaHotKey: triggeredViaHotKey })=>{
    const childContainer = (0, $5uXOq.useRef)(null);
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const createSubtaskButtonRef = (0, $hchBL.useGlobalRef)('quick-add-items.create-subtask')[0];
    const createSubtaskAddButton = (0, $hchBL.useGlobalRef)((0, $92wsG.QUICK_ADD_ITEMS_ADD_BUTTON_REF_KEY))[0];
    const addChildSubtaskRef = (0, $hchBL.useGlobalRef)('quick-add-items.add-child-subtask')[0];
    const fieldContainer = (0, $chqpx.default)('child-issue-inline-create-type-tracing');
    const createIssueFormFactory = (0, $5uXOq.useRef)(null);
    const { showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull } = (0, $5knXz.useStorageEnforcement)();
    const [{ issueCreateSessionId: issueCreateSessionId }] = (0, $ecB7Y.useTriggerIssueViewModal)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { resetIssueBreakdownState: resetIssueBreakdownState }] = (0, $1fz0b.useIssueBreakdown)();
    const reset = (0, $5uXOq.useCallback)(()=>{
        onChangeSummary('');
    }, [
        onChangeSummary
    ]);
    const closeAndReset = (0, $5uXOq.useCallback)(()=>{
        reset();
        onCancel();
    }, [
        onCancel,
        reset
    ]);
    const resetAndFocus = (0, $5uXOq.useCallback)(()=>{
        reset();
        fieldContainer.current?.focus();
    }, [
        reset,
        fieldContainer
    ]);
    const isNextgenSubtask = (0, $5uXOq.useCallback)(()=>childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL ? !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueHierarchyLevel) && issueHierarchyLevel === 0 : false, [
        childIssuesPanelType,
        issueHierarchyLevel
    ]);
    const subtaskCreateEnabled = (0, $5uXOq.useCallback)(()=>isNextgenSubtask() || childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS || childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_PORTFOLIO_CHILDREN, [
        isNextgenSubtask,
        childIssuesPanelType
    ]);
    const enableVisualRefreshChanges = (0, $dCm1o.isVisualRefreshEnabled)();
    const [childIssuesPanelTypeInState] = (0, $5uXOq.useState)(()=>childIssuesPanelType);
    (0, $5uXOq.useEffect)(()=>{
        const legacyResource = childIssuesPanelTypeInState === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS ? 'quick-edit/form/factory/create-subtask' : 'quick-edit/form/factory/create-issue'; // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $6BZYo.loadBridge)({
            name: legacyResource,
            wrmKeys: (0, $bUPgZ.QUICK_EDIT_PLUGIN_WRM_KEY)
        }).then((bridgeValue)=>{
            createIssueFormFactory.current = bridgeValue;
        });
    }, [
        childIssuesPanelTypeInState
    ]);
    const createChild = (0, $5uXOq.useCallback)(()=>{
        const optimisticId = `OPTIMISTIC_CHILD_${Date.now()}`; // If full create is required, we check if modern GIC is enabled and window.IssueCreate is defined
        // If full create is not required, we don't need to check for GIC or windows.issueCreate and the child issue will simply be submitted
        const isWRMRemovalConditionMet = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.IssueCreate && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.IssueCreate.Visibility.isEnabled && (0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience') || !selectedIssueType?.hasRequiredField && !requiresFullCreate;
        const isWRMRemoved = isWRMRemovalConditionMet ? true : typeof createIssueFormFactory.current === 'function';
        const canCreateChild = !$6abc109dfd6e835f$var$isPrimaryButtonDisabled(summary, selectedIssueType) && isWRMRemoved;
        if (canCreateChild && selectedIssueType) {
            const optimisticChild = {
                id: optimisticId,
                issueSummary: summary,
                issueTypeId: `${selectedIssueType.id}`,
                issueTypeIconUrl: `${selectedIssueType.iconUrl}`,
                issueTypeName: `${selectedIssueType.name}`,
                assigneeUrl: null,
                assigneeDisplayName: null
            };
            if (selectedIssueType.hasRequiredField || requiresFullCreate) {
                const creatingIssueInClassicProjectEpic = childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_PROJECT_EPIC_CHILDREN;
                const payload = {
                    pid: projectId,
                    issueType: selectedIssueType && selectedIssueType.id,
                    fields: {
                        issuetype: selectedIssueType.id,
                        summary: summary || '',
                        ...creatingIssueInClassicProjectEpic && epicLinkFieldKey ? {
                            [epicLinkFieldKey]: parentIssueKey
                        } : {}
                    },
                    customFieldsToPreserveOnFormRecreation: [
                        ...creatingIssueInClassicProjectEpic && epicLinkFieldKey ? [
                            epicLinkFieldKey
                        ] : []
                    ],
                    ...childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS || isNextgenSubtask() ? {
                        parentIssueId: parentIssueId
                    } : {}
                };
                if (// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.IssueCreate && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.IssueCreate.Visibility.isEnabled && (0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience')) {
                    const { pid: pid, issueType: issueType, fields: payloadFields } = payload;
                    const epicField = creatingIssueInClassicProjectEpic && epicLinkFieldKey && parentIssueKey ? {
                        epic: {
                            fieldId: epicLinkFieldKey,
                            fieldValue: parentIssueKey
                        }
                    } : null;
                    const newPayload = (0, $4HdDJ.transformGICPayload)({
                        prefilledFields: {
                            pid: pid,
                            parentId: parentIssueId,
                            issuetype: issueType,
                            summary: payloadFields.summary,
                            ...epicField
                        }
                    });
                    const triggerSource = creatingIssueInClassicProjectEpic ? (0, $hULKg.JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC) : (0, $hULKg.JSW_ISSUE_VIEW_CREATE_SUBTASK);
                    openIssueCreateModal?.({
                        payload: newPayload,
                        fieldsToAddInPublishedData: [
                            epicLinkFieldKey
                        ],
                        isSubTaskCreationOpen: subtaskCreateEnabled(),
                        triggerPointKey: triggerSource,
                        sessionId: issueCreateSessionId,
                        triggeredViaHotKey: triggeredViaHotKey,
                        callbackPayload: {
                            id: (0, $38bVB.GIC_CALLBACK_PAYLOAD_INLINE_CREATE_ID),
                            data: {
                                optimisticId: optimisticId,
                                parentIssueKey: parentIssueKey,
                                childIssuesPanelType: childIssuesPanelType
                            }
                        }
                    });
                } else {
                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    const createIssueForm = createIssueFormFactory.current?.(payload); // This overrides the monolith frontend's JQuery event watcher that sends GASv3 events.
                    // So we manually send the Create Issue SLA event in the create-child-success epic.
                    createIssueForm?.bind('issueCreated', (e, data)=>{
                        if (!creatingIssueInClassicProjectEpic || // @ts-expect-error - TS2538 - Type 'null' cannot be used as an index type.
                        data.createdIssueDetails.fields[epicLinkFieldKey] === parentIssueKey) onFullDialogCreate(optimisticId, (0, $2j7J7.default)(data.createdIssueDetails, baseUrl), {
                            sessionId: issueCreateSessionId
                        });
                        resetAndFocus();
                    });
                    createIssueForm?.asDialog({
                        id: childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS ? 'create-subtask-dialog' : 'create-issue-dialog'
                    }).show();
                }
            } else {
                onSubmit(optimisticChild, {
                    sessionId: issueCreateSessionId,
                    ...(0, $6s1PB.expVal)('quick_actions_m3_experiment', 'hotKeysEnabled', false) ? {
                        triggeredViaHotKey: triggeredViaHotKey
                    } : {}
                });
                resetAndFocus();
                showEnforcementIfStorageIsFull({
                    touchpoint: 'child-issues-panel'
                });
            }
        }
    }, [
        selectedIssueType,
        requiresFullCreate,
        summary,
        childIssuesPanelType,
        projectId,
        epicLinkFieldKey,
        parentIssueKey,
        isNextgenSubtask,
        parentIssueId,
        openIssueCreateModal,
        subtaskCreateEnabled,
        issueCreateSessionId,
        triggeredViaHotKey,
        resetAndFocus,
        onFullDialogCreate,
        baseUrl,
        onSubmit,
        showEnforcementIfStorageIsFull
    ]);
    const onSubmitClicked = (0, $5uXOq.useCallback)(()=>{
        createChild();
        onSubmitClickAnalytics({
            triggeredViaHotKey: triggeredViaHotKey
        });
    }, [
        createChild,
        onSubmitClickAnalytics,
        triggeredViaHotKey
    ]);
    const onCancelClicked = (0, $5uXOq.useCallback)(()=>{
        closeAndReset();
        (0, $4R6GH.fg)('proactive_aiwb_2_targeting_gate') && resetIssueBreakdownState();
        onCancelClickAnalytics();
        if (addChildSubtaskRef) addChildSubtaskRef?.focus();
        else createSubtaskAddButton?.focus();
        register('quick-add-items.add-child-subtask', null);
    }, [
        closeAndReset,
        onCancelClickAnalytics,
        createSubtaskAddButton,
        addChildSubtaskRef,
        register,
        resetIssueBreakdownState
    ]);
    const onCancelKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') createSubtaskButtonRef?.focus();
    }, [
        createSubtaskButtonRef
    ]);
    const onEnterPressed = (0, $5uXOq.useCallback)(()=>{
        createChild();
        onEnterKeyPressedAnalytics();
    }, [
        createChild,
        onEnterKeyPressedAnalytics
    ]);
    const onEscPressed = (0, $5uXOq.useCallback)(()=>{
        closeAndReset();
        onEscapeKeyPressedAnalytics();
    }, [
        closeAndReset,
        onEscapeKeyPressedAnalytics
    ]);
    const onUpdateChildSummary = (0, $5uXOq.useCallback)((e)=>{
        onChangeSummary(e.target.value);
    }, [
        onChangeSummary
    ]);
    const onAddExisting = (0, $5uXOq.useCallback)(()=>{
        onAddExistingIssue();
        onAddExistingClickAnalytics();
    }, [
        onAddExistingClickAnalytics,
        onAddExistingIssue
    ]);
    const previousAddClickCount = (0, $1XJ20.usePrevious)(addClickCount);
    const scrollPanelIntoView = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('quick_actions_menu_ga')) setTimeout(()=>{
            (0, $b8JO7.smoothScrollIntoCenterIfNeeded)(childContainer.current);
            fieldContainer.current?.focus({
                preventScroll: true
            });
        }, 0);
        else {
            (0, $b8JO7.smoothScrollIntoCenterIfNeeded)(childContainer.current);
            fieldContainer.current?.focus({
                preventScroll: true
            });
        }
    }, [
        childContainer,
        fieldContainer
    ]);
    (0, $5uXOq.useEffect)(()=>{
        scrollPanelIntoView();
    }, [
        childIssuesPanelTypeInState,
        scrollPanelIntoView,
        fieldContainer
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (previousAddClickCount !== undefined && addClickCount !== previousAddClickCount) scrollPanelIntoView();
    }, [
        addClickCount,
        previousAddClickCount,
        fieldContainer,
        scrollPanelIntoView
    ]);
    const summaryTooLongMessage = $6abc109dfd6e835f$var$isSummaryTooLong(summary) ? formatMessage((0, $gpjoS.default).summaryTooLong) : '';
    const cannotCreateChildIssueMessage = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $gpjoS.default).cannotCreateChildIssueIssueTermRefresh : (0, $gpjoS.default).cannotCreateChildIssue);
    const getInlineDialogContent = ()=>{
        if (!$6abc109dfd6e835f$var$isCreatingChildIssueAllowed(selectedIssueType)) return cannotCreateChildIssueMessage;
        return summaryTooLongMessage;
    };
    const addExistingIssueButton = (0, $5uXOq.useMemo)(()=>{
        switch(childIssuesPanelType){
            case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gpjoS.default).addExistingIssuePlaceholderIssueTermRefresh : (0, $gpjoS.default).addExistingIssuePlaceholder)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8KYZt.AddExistingIssueButton), {
                    onClick: onAddExisting
                }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gpjoS.default).addExistingIssuePlaceholderIssueTermRefresh : (0, $gpjoS.default).addExistingIssuePlaceholder)));
            case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_PORTFOLIO_CHILDREN:
            case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_PROJECT_EPIC_CHILDREN:
            case (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS:
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null);
        }
    }, [
        childIssuesPanelType,
        formatMessage,
        onAddExisting
    ]);
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    (0, $5uXOq.useEffect)(()=>subscribe?.((0, $5eGnF.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, async (payload)=>{
            if (payload.callbackPayload?.id !== (0, $38bVB.GIC_CALLBACK_PAYLOAD_INLINE_CREATE_ID)) return;
            const callbackData = payload.callbackPayload?.data;
            let isEpicEqualToParent = (epicLinkFieldKey && payload.createdIssueData.createdIssueDetails.fields[epicLinkFieldKey]) === parentIssueKey;
            if (callbackData.parentIssueKey !== parentIssueKey || callbackData.childIssuesPanelType !== childIssuesPanelType) return;
            if ((0, $4R6GH.fg)('iv_fix_summary_clear_after_inline_child_creation')) isEpicEqualToParent = (epicLinkFieldKey && payload.createdIssueData.createdIssueDetails.fields[epicLinkFieldKey]) === parentIssueKey || callbackData?.parentIssueKey === parentIssueKey;
            if (subtaskCreateEnabled() || isEpicEqualToParent) resetAndFocus();
        }), [
        subscribe,
        resetAndFocus,
        subtaskCreateEnabled,
        epicLinkFieldKey,
        parentIssueKey,
        childIssuesPanelType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (issueTypes.length < 1) (0, $jcw0u.default)({
            error: new Error('issue types array is empty'),
            meta: {
                id: 'ChildIssuePanelNoIssueType',
                packageName: 'jiraIssueViewCommonViews',
                teamName: 'bento'
            },
            skipSentry: true
        });
    }, [
        issueTypes.length
    ]);
    const childTypeSelect = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChildTypesSelect, {
            isDisabled: issueTypes.length <= 1
        }), [
        ChildTypesSelect,
        issueTypes.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: childContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6abc109dfd6e835f$var$WrapperDiv, {
        isVisualRefreshEnabled: enableVisualRefreshChanges
    }, enableVisualRefreshChanges ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6abc109dfd6e835f$var$childTypesSelectStyles
    }, childTypeSelect) : childTypeSelect, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6abc109dfd6e835f$var$FieldTextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEnter: onEnterPressed,
        onEscape: onEscPressed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        messageId: "issue-view-common-views.child-issues-panel.inline-create.inline-dialog",
        messageType: "transactional",
        content: getInlineDialogContent(),
        isOpen: $6abc109dfd6e835f$var$isTextFieldInvalid(summary, selectedIssueType),
        placement: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        id: inputId,
        value: summary,
        placeholder: formatMessage((0, $gpjoS.default).summaryPlaceholder),
        onChange: onUpdateChildSummary,
        isInvalid: $6abc109dfd6e835f$var$isTextFieldInvalid(summary, selectedIssueType),
        shouldFitContainer: true,
        "aria-label": formatMessage((0, $gpjoS.default).summaryTextFieldLabel),
        ref: fieldContainer,
        elemAfterInput: $6abc109dfd6e835f$var$isTextFieldInvalid(summary, selectedIssueType) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $6abc109dfd6e835f$var$warningWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            color: "var(--ds-icon-warning, #E56910)",
            spacing: "spacious",
            label: "",
            testId: "issue-view-common-views.child-issues-panel.inline-create.invalid-textfield-warning-icon"
        })) : null,
        isDisabled: !$6abc109dfd6e835f$var$isCreatingChildIssueAllowed(selectedIssueType)
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6abc109dfd6e835f$var$ButtonsContainer, null, addExistingIssueButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6abc109dfd6e835f$var$ButtonsRightSide, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6abc109dfd6e835f$var$StyledButton, {
        appearance: "primary",
        onClick: onSubmitClicked,
        isDisabled: $6abc109dfd6e835f$var$isPrimaryButtonDisabled(summary, selectedIssueType),
        "data-testId": $6abc109dfd6e835f$var$testId
    }, formatMessage((0, $gpjoS.default).childCreateButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6abc109dfd6e835f$var$StyledButton, {
        appearance: "subtle",
        onClick: onCancelClicked,
        onKeyPress: onCancelKeyPress,
        testId: "issue.views.common.child-issues-panel.inline-create.styled-button"
    }, formatMessage((0, $gpjoS.default).childCancelButton)))));
};
var $6abc109dfd6e835f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $bwLf9.default)(()=>(0, $4R6GH.fg)('render_modern_global_issue_create_modal_experience'), // @ts-expect-error - TS2345 - Argument of type 'ComponentType<Record<any, any>>' is not assignable to parameter of type 'AbstractComponent<Props, any>'. | TS2345 - Argument of type '(props: Props & DefaultProps) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to parameter of type 'ComponentType<Record<any, any>>'.
(0, $jzjy1.AnalyticsSubject)('issue')((0, $5rzqz.withNewGICProvider)($6abc109dfd6e835f$export$bff74f82b631e3d3)), (0, $jzjy1.AnalyticsSubject)('issue')($6abc109dfd6e835f$export$bff74f82b631e3d3));
const $6abc109dfd6e835f$var$WrapperDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefreshEnabled: isVisualRefreshEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpv77o _1e0c1txw _4cvr1h6o _1bsb1osq",
            !__cmplp.isVisualRefreshEnabled && "_bfhkm7j4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6abc109dfd6e835f$var$FieldTextWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6abc109dfd6e835f$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01a66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6abc109dfd6e835f$var$ButtonsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6abc109dfd6e835f$var$ButtonsRightSide = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bahesu3 _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6abc109dfd6e835f$var$warningWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.050',
    marginRight: 'space.050'
});
const $6abc109dfd6e835f$var$childTypesSelectStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral',
    marginRight: 'space.050'
});

});
parcelRegister("bUPgZ", function(module, exports) {

$parcel$export(module.exports, "QUICK_EDIT_PLUGIN_WRM_KEY", () => $3814a584fa2035df$export$d3ca508c5f4ac1ef);
const $3814a584fa2035df$export$d3ca508c5f4ac1ef = 'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-form';
const $3814a584fa2035df$var$CONNECT_PLUGIN_WRM_KEY = 'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5';
const $3814a584fa2035df$var$SIDEBAR_PLUGIN_WRM_KEY = 'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar';
const $3814a584fa2035df$export$6e48ebf5f0972073 = [
    $3814a584fa2035df$export$d3ca508c5f4ac1ef,
    $3814a584fa2035df$var$CONNECT_PLUGIN_WRM_KEY,
    $3814a584fa2035df$var$SIDEBAR_PLUGIN_WRM_KEY
];

});

parcelRegister("4HdDJ", function(module, exports) {

$parcel$export(module.exports, "generateDefaultValues", () => $0dff8558153b0cdd$export$300f392f5922240);
$parcel$export(module.exports, "extractEventAttributes", () => $0dff8558153b0cdd$export$1e69307ca1d0a0a);
$parcel$export(module.exports, "filterCustomFields", () => $0dff8558153b0cdd$export$3d0318b836ef9005);
$parcel$export(module.exports, "mergeDefaultValues", () => $0dff8558153b0cdd$export$2b461e4b4c8d36cf);
$parcel$export(module.exports, "transformGICPayload", () => $0dff8558153b0cdd$export$db3a4d24608ba186);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $gccSB = parcelRequire("gccSB");

var $aZsz6 = parcelRequire("aZsz6");

var $fafYK = parcelRequire("fafYK");

var $6mTQO = parcelRequire("6mTQO");
const $0dff8558153b0cdd$var$CUSTOM_FIELD_PREFIX = 'customfield';
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $0dff8558153b0cdd$var$mergePrefilled = (oldPayload, newPayload)=>{
    if (newPayload !== null && newPayload !== undefined) // @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
    return {
        ...oldPayload,
        ...newPayload
    };
    return oldPayload;
};
const $0dff8558153b0cdd$var$returnActualValue = (value)=>{
    if (Array.isArray(value)) return value[0].toString();
    return value.toString();
};
// @ts-expect-error - TS7023 - 'mergeFormat' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions. | TS7006 - Parameter 'format' implicitly has an 'any' type.
const $0dff8558153b0cdd$var$mergeFormat = (format, finalKey, finalValue)=>{
    // Ideally format can be object or string
    // Format will only contain 1 object having single key/value where value can be null or an object
    // go inside and wherever we find first null, replace the same with the value.
    // some of the mutation use fieldId whereas other uses like priorityId
    // so whichever key has value === ID will replace the same with the proper mutationKey
    if (typeof format === 'string') {
        if (format === 'ID') return finalKey;
        return format;
    }
    // recursively goes inside to find the null and key param and replace with the corresponding values
    // Also checks for array like labels
    return Object.keys(format).reduce((accumulator, currentKey)=>{
        const currentValue = format[currentKey];
        if (Array.isArray(currentValue)) {
            const mappedValue = Array.isArray(finalValue) ? finalValue : [
                finalValue
            ];
            return {
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...accumulator,
                [currentKey]: mappedValue.map((val)=>$0dff8558153b0cdd$var$mergeFormat(currentValue[0], finalKey, val))
            };
        }
        return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...accumulator,
            [currentKey]: currentValue === null ? $0dff8558153b0cdd$var$returnActualValue(finalValue) : $0dff8558153b0cdd$var$mergeFormat(format[currentKey], finalKey, finalValue)
        };
    }, {});
};
const $0dff8558153b0cdd$var$generateDefaultValuesForEcosystemAPI = (otherFields)=>{
    const defaultValues = {};
    const fieldIds = [];
    Object.keys(otherFields).forEach((mutationKey)=>{
        const mutationValue = otherFields[mutationKey];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
        if ((0, $6mTQO.ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP)[mutationKey]) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const mutationGroup = (0, $6mTQO.ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP)[mutationKey];
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const formattedValue = (0, $6mTQO.ECOSYSTEM_API_FIELD_FORMATTER)[mutationGroup](mutationKey, mutationValue);
            if (formattedValue) {
                const { value: value, type: type } = formattedValue;
                fieldIds.push(mutationKey);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(value)) {
                    if (type === 'array') (defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(value);
                    else if (type === 'object') defaultValues[mutationGroup] = value;
                }
            }
        }
    });
    return {
        defaultValues: defaultValues,
        fieldIds: fieldIds
    };
};
const $0dff8558153b0cdd$var$generateDefaultValuesLegacy = (otherFields)=>{
    const defaultValues = {};
    const fieldIds = [];
    Object.keys(otherFields).forEach((mutationKey)=>{
        const mutationValue = otherFields[mutationKey];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
        if ((0, $fafYK.FIELD_MAPPER_MUTATION_GROUP)[mutationKey]) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const mutationGroup = (0, $fafYK.FIELD_MAPPER_MUTATION_GROUP)[mutationKey];
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly singleLineTextFields: { readonly value: { readonly fieldId: "ID"; readonly text: null; }; readonly type: "array"; }; readonly epicLinkField: { readonly value: { readonly fieldId: "ID"; readonly epicLink: { readonly issueKey: null; }; }; readonly type: "object"; }; ... 7 more ...; readonly components: { .....'.
            const { type: type = null, value: depth = null } = (0, $fafYK.FORMATTER)[mutationGroup];
            let pattern = null;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(mutationValue) && depth && type) {
                if (!Array.isArray(mutationValue) && typeof mutationValue === 'object') {
                    const { fieldId: fieldId, fieldValue: fieldValue } = mutationValue;
                    // If fieldValue is different from the key like custom fields
                    pattern = $0dff8558153b0cdd$var$mergeFormat(depth, fieldId || mutationKey, fieldValue);
                    fieldIds.push(fieldId || mutationKey);
                } else {
                    // same as key like summary etc.
                    pattern = $0dff8558153b0cdd$var$mergeFormat(depth, mutationKey, mutationValue);
                    fieldIds.push(mutationKey);
                }
            }
            // merge mutations based on type as some mutations are object whereas others are arrays
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(pattern)) {
                if (type === 'array') (defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(pattern);
                else if (type === 'object') defaultValues[mutationGroup] = pattern;
            }
        }
    });
    return {
        defaultValues: defaultValues,
        fieldIds: fieldIds
    };
};
const $0dff8558153b0cdd$export$300f392f5922240 = (otherFields, isEcosystemAPI = false)=>{
    if (isEcosystemAPI) return $0dff8558153b0cdd$var$generateDefaultValuesForEcosystemAPI(otherFields);
    return $0dff8558153b0cdd$var$generateDefaultValuesLegacy(otherFields);
};
const $0dff8558153b0cdd$export$1e69307ca1d0a0a = (trigger)=>{
    const anchor = trigger.nodeName === 'A' ? trigger : trigger.querySelector('a');
    if (anchor) {
        const href = anchor.getAttribute('href');
        // @ts-expect-error - TS2769 - No overload matches this call. | TS7006 - Parameter 'qs' implicitly has an 'any' type.
        const { query: query } = (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(href, (qs)=>new URLSearchParams(qs));
        const returnData = {
            prefilledFields: {}
        };
        // If data attributes exist, we will prefer those over the query params.
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const pid = anchor.getAttribute('data-pid') || query.get('pid');
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const issuetype = anchor.getAttribute('data-issue-type') || query.get('issuetype');
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const requestype = anchor.getAttribute('data-itsm-category') || query.get('itsmCategory');
        if (pid) // @ts-expect-error - TS2339 - Property 'pid' does not exist on type '{}'.
        returnData.prefilledFields.pid = pid;
        if (issuetype) // @ts-expect-error - TS2339 - Property 'issuetype' does not exist on type '{}'.
        returnData.prefilledFields.issuetype = issuetype;
        if (requestype) // @ts-expect-error - TS2339 - Property 'requestype' does not exist on type '{}'.
        returnData.prefilledFields.requestype = requestype;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(returnData.prefilledFields)) return returnData;
        return {};
    }
    return {};
};
const $0dff8558153b0cdd$export$70cb7a42e309786 = (payload = {}, isEcosystemAPI = false)=>{
    const { prefilledFields: gicPreFilledFields, target: target = null } = payload;
    let prefilledFields = gicPreFilledFields;
    if (target) {
        const newPayload = $0dff8558153b0cdd$export$1e69307ca1d0a0a(target);
        prefilledFields = $0dff8558153b0cdd$var$mergePrefilled(gicPreFilledFields, newPayload.prefilledFields);
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(prefilledFields)) {
        const { fieldsToRetain: fieldsToRetain = [], pid: pid, issuetype: issuetype, requestype: requestype, additionalContext: additionalContext, statusId: statusId, ...otherFields } = prefilledFields;
        const outputPayload = {};
        if ((!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(pid) || typeof pid === 'number') && pid !== 'undefined') outputPayload.project = {
            projectId: $0dff8558153b0cdd$var$returnActualValue(pid)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issuetype) || typeof issuetype === 'number') outputPayload.issueType = {
            issueTypeId: $0dff8558153b0cdd$var$returnActualValue(issuetype)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(requestype)) outputPayload.requestType = {
            key: $0dff8558153b0cdd$var$returnActualValue(requestype)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(otherFields.parentId)) outputPayload.parentId = {
            parentId: $0dff8558153b0cdd$var$returnActualValue(otherFields.parentId)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(statusId)) outputPayload.status = {
            statusId: statusId
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(additionalContext)) outputPayload.additionalContext = additionalContext;
        // for other fields
        if (Object.keys(otherFields).length > 0) {
            const { parentId: parentId, ...otherFieldsWithoutParent } = otherFields;
            const { defaultValues: defaultValues, fieldIds: fieldIds } = $0dff8558153b0cdd$export$300f392f5922240(parentId !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(parentId) ? {
                parent: parentId,
                ...otherFieldsWithoutParent
            } : otherFieldsWithoutParent, isEcosystemAPI);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(defaultValues)) outputPayload.defaultValues = defaultValues;
            outputPayload.customFieldsToPreserveOnFormRecreation = [
                ...fieldsToRetain,
                ...fieldIds
            ];
        }
        return outputPayload;
    }
    return null;
};
const $0dff8558153b0cdd$export$3d0318b836ef9005 = (payload = {})=>{
    // customField's id's start with the name customfield https://confluence.atlassian.com/adminjiraserver/advanced-use-of-the-jira-issue-collector-938847349.html
    const fieldsToPrefill = payload?.prefilledFields;
    if (!fieldsToPrefill) return {};
    const prefilledCustomFields = {};
    const systemFieldsToBeIncluded = [
        'worklog_timeLogged',
        'worklog_startDate',
        'worklog_comment',
        'timetracking_remainingestimate',
        'description',
        'paragraph',
        'environment'
    ];
    Object.keys(fieldsToPrefill).forEach((key)=>{
        if (key.startsWith($0dff8558153b0cdd$var$CUSTOM_FIELD_PREFIX) || systemFieldsToBeIncluded.includes(key)) prefilledCustomFields[key] = fieldsToPrefill[key];
    });
    return prefilledCustomFields;
};
const $0dff8558153b0cdd$export$2b461e4b4c8d36cf = (defaultValuesFromAPI = {}, defaultValuesFromFE = {})=>{
    const mergedDefaultValues = JSON.parse(JSON.stringify(defaultValuesFromAPI));
    if (!defaultValuesFromFE) return mergedDefaultValues;
    Object.keys(defaultValuesFromFE).forEach((key)=>{
        if (mergedDefaultValues?.key) mergedDefaultValues[key] = {
            ...mergedDefaultValues[key],
            ...defaultValuesFromFE[key]
        };
        else mergedDefaultValues[key] = defaultValuesFromFE[key];
    });
    return mergedDefaultValues;
};
const $0dff8558153b0cdd$export$db3a4d24608ba186 = $0dff8558153b0cdd$export$70cb7a42e309786;

});
parcelRegister("fafYK", function(module, exports) {

$parcel$export(module.exports, "FORMATTER", () => $044a5aa973e46e78$export$92cfe806f4f0ae2f);
$parcel$export(module.exports, "FIELD_MAPPER_MUTATION_GROUP", () => $044a5aa973e46e78$export$6669905e89f27d17);
const $044a5aa973e46e78$export$92cfe806f4f0ae2f = {
    singleLineTextFields: {
        value: {
            fieldId: 'ID',
            text: null
        },
        type: 'array'
    },
    epicLinkField: {
        value: {
            fieldId: 'ID',
            epicLink: {
                issueKey: null
            }
        },
        type: 'object'
    },
    sprintsField: {
        value: {
            fieldId: 'ID',
            sprints: [
                {
                    sprintId: null
                }
            ]
        },
        type: 'object'
    },
    priority: {
        value: {
            priorityId: 'ID'
        },
        type: 'object'
    },
    datePickerFields: {
        value: {
            fieldId: 'ID',
            date: {
                formattedDate: null
            }
        },
        type: 'array'
    },
    dateTimePickerFields: {
        value: {
            fieldId: 'ID',
            dateTime: {
                formattedDateTime: null
            }
        },
        type: 'array'
    },
    labelsFields: {
        value: {
            fieldId: 'ID',
            labels: [
                {
                    name: null
                }
            ]
        },
        type: 'array'
    },
    singleSelectUserPickerFields: {
        value: {
            fieldId: 'ID',
            user: {
                accountId: null
            }
        },
        type: 'array'
    },
    multipleVersionPickerFields: {
        value: {
            fieldId: 'ID',
            versions: [
                {
                    versionId: null
                }
            ]
        },
        type: 'array'
    },
    components: {
        value: {
            componentId: null
        },
        type: 'array'
    },
    parentField: {
        value: {
            issueId: null
        },
        type: 'object'
    }
};
const $044a5aa973e46e78$export$6669905e89f27d17 = {
    summary: 'singleLineTextFields',
    epic: 'epicLinkField',
    epicName: 'singleLineTextFields',
    duedate: 'datePickerFields',
    startdate: 'datePickerFields',
    plannedStartDate: 'dateTimePickerFields',
    plannedEndDate: 'dateTimePickerFields',
    labels: 'labelsFields',
    sprint: 'sprintsField',
    assignee: 'singleSelectUserPickerFields',
    reporter: 'singleSelectUserPickerFields',
    fixVersions: 'multipleVersionPickerFields',
    components: 'components',
    parent: 'parentField'
};

});

parcelRegister("6mTQO", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_API_FIELD_FORMATTER", () => $b6c3b74824a18d57$export$8ef3266ee07318b4);
$parcel$export(module.exports, "ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP", () => $b6c3b74824a18d57$export$343b44fa14f045e3);

var $h5wrT = parcelRequire("h5wrT");
const $b6c3b74824a18d57$export$8ef3266ee07318b4 = {
    security: (id, input)=>{
        if ((0, $h5wrT.checkIfValidId)(input)) return {
            value: {
                securityLevelId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $h5wrT.checkIfValidId)(input[0])) return {
            value: {
                securityLevelId: Number(input[0])
            },
            type: 'object'
        };
    },
    singleLineTextFields: (id, input)=>{
        if (typeof input === 'string' || typeof input === 'number') return {
            value: {
                fieldId: id,
                text: input.toString()
            },
            type: 'array'
        };
        if (Array.isArray(input) && input.length > 0) return {
            value: {
                fieldId: id,
                text: input[0].toString()
            },
            type: 'array'
        };
    },
    timeTrackingField: (id, input)=>{
        if (typeof input === 'string') return {
            value: {
                originalEstimate: input
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') return {
            value: {
                originalEstimate: input[0]
            },
            type: 'object'
        };
    },
    priority: (id, input)=>{
        if ((0, $h5wrT.checkIfValidId)(input)) return {
            value: {
                priorityId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $h5wrT.checkIfValidId)(input[0])) return {
            value: {
                priorityId: Number(input[0])
            },
            type: 'object'
        };
    },
    resolution: (id, input)=>{
        if ((0, $h5wrT.checkIfValidId)(input)) return {
            value: {
                resolutionId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $h5wrT.checkIfValidId)(input[0])) return {
            value: {
                resolutionId: Number(input[0])
            },
            type: 'object'
        };
        return {
            value: {
                resolutionId: 10000
            },
            type: 'object'
        };
    },
    datePickerFields: (id, input)=>{
        if (typeof input === 'string') {
            const dateInISO = (0, $h5wrT.findADate)(input);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    date: {
                        formattedDate: dateInISO
                    }
                },
                type: 'array'
            };
        }
        if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') {
            const dateInISO = (0, $h5wrT.findADate)(input[0]);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    date: {
                        formattedDate: dateInISO
                    }
                },
                type: 'array'
            };
        }
    },
    dateTimePickerFields: (id, input)=>{
        if (typeof input === 'string') {
            const dateInISO = (0, $h5wrT.findADate)(input);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    dateTime: {
                        formattedDateTime: dateInISO
                    }
                },
                type: 'array'
            };
        }
        if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') {
            const dateInISO = (0, $h5wrT.findADate)(input[0]);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    dateTime: {
                        formattedDateTime: dateInISO
                    }
                },
                type: 'array'
            };
        }
    },
    labelsFields: (id, input)=>{
        let transformedValue = [];
        if (Array.isArray(input) && input.length > 0) {
            for (const label of input)if (typeof label === 'string' || typeof label === 'number') transformedValue.push({
                name: label.toString()
            });
        } else if (typeof input === 'string' || typeof input === 'number') transformedValue = [
            {
                name: input.toString()
            }
        ];
        return {
            value: {
                fieldId: id,
                labels: transformedValue
            },
            type: 'array'
        };
    },
    multipleVersionPickerFields: (id, input)=>{
        let transformedValue = [];
        if (Array.isArray(input) && input.length > 0) {
            for (const version of input)if ((0, $h5wrT.checkIfValidId)(version)) transformedValue.push({
                versionId: Number(version)
            });
        } else if ((0, $h5wrT.checkIfValidId)(input)) transformedValue = [
            {
                versionId: Number(input)
            }
        ];
        return {
            value: {
                fieldId: id,
                versions: transformedValue
            },
            type: 'array'
        };
    },
    components: (id, input)=>{
        let transformedValue = [];
        if (Array.isArray(input) && input.length > 0) {
            for (const component of input)if ((0, $h5wrT.checkIfValidId)(component)) transformedValue.push({
                componentId: Number(component)
            });
        } else if ((0, $h5wrT.checkIfValidId)(input)) transformedValue = [
            {
                componentId: Number(input)
            }
        ];
        return {
            value: transformedValue,
            type: 'object'
        };
    },
    parentField: (id, input)=>{
        if ((0, $h5wrT.checkIfValidId)(input)) return {
            value: {
                issueId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $h5wrT.checkIfValidId)(input[0])) return {
            value: {
                issueId: Number(input[0])
            },
            type: 'object'
        };
    }
};
const $b6c3b74824a18d57$export$343b44fa14f045e3 = {
    security: 'security',
    resolution: 'resolution',
    summary: 'singleLineTextFields',
    epicName: 'singleLineTextFields',
    duedate: 'datePickerFields',
    startdate: 'datePickerFields',
    labels: 'labelsFields',
    fixVersions: 'multipleVersionPickerFields',
    versions: 'multipleVersionPickerFields',
    components: 'components',
    parent: 'parentField',
    priority: 'priority',
    timetracking_originalestimate: 'timeTrackingField'
};

});
parcelRegister("h5wrT", function(module, exports) {

$parcel$export(module.exports, "findADate", () => $fc8e7b5490fd5042$export$3ce9cccf56f196eb);
$parcel$export(module.exports, "checkIfValidId", () => $fc8e7b5490fd5042$export$d65005e77da517bc);
const $fc8e7b5490fd5042$var$monthMap = {
    Jan: '01',
    January: '01',
    Feb: '02',
    February: '02',
    Mar: '03',
    March: '03',
    Apr: '04',
    April: '04',
    May: '05',
    Jun: '06',
    June: '06',
    Jul: '07',
    July: '07',
    Aug: '08',
    August: '08',
    Sep: '09',
    September: '09',
    Oct: '10',
    October: '10',
    Nov: '11',
    November: '11',
    Dec: '12',
    December: '12'
};
const $fc8e7b5490fd5042$var$formatDay = (day)=>{
    if (day.length === 1) return `0${day}`;
    return day;
};
const $fc8e7b5490fd5042$var$formatMonth = (month)=>{
    if ($fc8e7b5490fd5042$var$monthMap[month]) return $fc8e7b5490fd5042$var$monthMap[month];
    if (month.length === 1) return `0${month}`;
    return month;
};
const $fc8e7b5490fd5042$var$formatYear = (year)=>{
    const yearAsNumber = Number(year);
    if (yearAsNumber < 100) return yearAsNumber + 2000;
    return yearAsNumber;
};
const $fc8e7b5490fd5042$var$constructISOTime = (time)=>{
    const timeStr = time.trim();
    const time24HourPattern = /^T(\d{1,2}):(\d{2}):?(\d{2})?$/;
    const time12HourPattern = /^@?\s*(\d{1,2}):(\d{2})\s*(am|pm)?$/i;
    const match24Hour = timeStr.match(time24HourPattern);
    if (match24Hour) {
        // eslint-disable-next-line prefer-const
        let [, hours, minutes, seconds] = match24Hour;
        seconds = seconds || '00';
        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
    }
    const match12Hour = timeStr.match(time12HourPattern);
    if (match12Hour) {
        let hours;
        let minutes;
        let ampm;
        [, hours, minutes, ampm] = match12Hour;
        hours = parseInt(hours, 10);
        minutes = parseInt(minutes, 10);
        if (ampm) {
            ampm = ampm.toLowerCase();
            if (ampm === 'pm' && hours !== 12) hours += 12;
            else if (ampm === 'am' && hours === 12) hours = 0;
        }
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    }
    return '00:00:00';
};
const $fc8e7b5490fd5042$var$constructISODateTime = (date)=>{
    const regexForDay = /^(\d{1,2})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{2,4})(.*)/;
    const regexForDateWithYYYYFirst = /^(\d{2,4})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{1,2})(.*)/;
    const matchForDay = date.match(regexForDay);
    const matchForDayWithYYYYFirst = date.match(regexForDateWithYYYYFirst);
    if (matchForDay) {
        const [, day, month, year, time] = matchForDay;
        let formattedDay = $fc8e7b5490fd5042$var$formatDay(day);
        let formattedMonth = $fc8e7b5490fd5042$var$formatMonth(month);
        const formattedYear = $fc8e7b5490fd5042$var$formatYear(year);
        let skipMatchingDay = false;
        if (Number(day) < 13 && Number(month)) [formattedDay, formattedMonth] = [
            formattedMonth,
            formattedDay
        ];
        else if (Number(formattedMonth) > 12) {
            if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else skipMatchingDay = true;
        }
        if (!skipMatchingDay) {
            const isoTime = $fc8e7b5490fd5042$var$constructISOTime(time);
            return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
        }
    }
    if (matchForDayWithYYYYFirst) {
        const [, year, month, day, time] = matchForDayWithYYYYFirst;
        let formattedDay = $fc8e7b5490fd5042$var$formatDay(day);
        let formattedMonth = $fc8e7b5490fd5042$var$formatMonth(month);
        const formattedYear = $fc8e7b5490fd5042$var$formatYear(year);
        if (Number(formattedMonth) > 12) {
            if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else return null;
        }
        const isoTime = $fc8e7b5490fd5042$var$constructISOTime(time);
        return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
    }
    return null;
};
function $fc8e7b5490fd5042$var$convertUnixToISO(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);
    if (!date.getTime()) return null;
    return date.toISOString().slice(0, 19);
}
const $fc8e7b5490fd5042$export$3ce9cccf56f196eb = (defaultValue)=>{
    if (typeof defaultValue === 'number') return $fc8e7b5490fd5042$var$convertUnixToISO(defaultValue);
    if (typeof defaultValue === 'string') {
        if (Number(defaultValue)) return $fc8e7b5490fd5042$var$convertUnixToISO(Number(defaultValue));
        return $fc8e7b5490fd5042$var$constructISODateTime(defaultValue);
    }
    return null;
};
const $fc8e7b5490fd5042$export$d65005e77da517bc = (input)=>{
    if ((typeof input === 'string' || typeof input === 'number') && Number(input)) return true;
    return false;
};

});



parcelRegister("5knXz", function(module, exports) {

$parcel$export(module.exports, "useStorageEnforcement", () => $a61178001d7e3bbc$export$fa2c25e1ed13a1a8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $dAfqg = parcelRequire("dAfqg");


var $RnWyv = parcelRequire("RnWyv");

var $l2AwX = parcelRequire("l2AwX");
const $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS = 86400000; // 1 day in ms
const $a61178001d7e3bbc$export$fa2c25e1ed13a1a8 = ()=>{
    const [currentState, { setIsOpen: setEnforceStorageModalIsOpen }] = (0, $l2AwX.useEnforceStorageModal)();
    const issueViewMode = (0, $2gCtH.useViewMode)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isInJSWProject = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const openModalIfNotOnCooldown = (0, $5uXOq.useCallback)((touchpoint)=>{
        const isOnCooldown = Date.now() - ((0, $RnWyv.localStorage).get((0, $3f79643dcab1adf8$export$ed785d2382d0101d)) || 0) < $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS;
        if (isOnCooldown) {
            if (currentState.isOpen === 'pending') // Reset pending state if modal is on cooldown when it should be shown
            setEnforceStorageModalIsOpen({
                isOpen: 'closed',
                touchpoint: undefined
            });
        } else setEnforceStorageModalIsOpen({
            isOpen: 'open',
            touchpoint: touchpoint
        });
    }, [
        setEnforceStorageModalIsOpen,
        currentState.isOpen
    ]);
    const showEnforcementIfStorageIsFull = (0, $5uXOq.useCallback)(({ delayShow: delayShow = false, shouldOnlyShowInJSWContext: shouldOnlyShowInJSWContext = true, touchpoint: touchpoint })=>{
        if (shouldOnlyShowInJSWContext && !isInJSWProject) return;
        // Issue view use case is checked internally here rather than passed in, to avoid polluting consumer code
        if (delayShow || issueViewMode === 'MODAL') setEnforceStorageModalIsOpen({
            isOpen: 'pending',
            touchpoint: touchpoint
        });
        else openModalIfNotOnCooldown(touchpoint);
    }, [
        isInJSWProject,
        issueViewMode,
        setEnforceStorageModalIsOpen,
        openModalIfNotOnCooldown
    ]);
    // Used to show enforcement modal after modals are dismissed, to avoid modal on modal UX
    const showEnforcementIfPendingToShow = (0, $5uXOq.useCallback)(()=>{
        if (currentState.isOpen === 'pending') // Use the trigger from created the JSW issue
        openModalIfNotOnCooldown(currentState.touchpoint);
    }, [
        currentState.isOpen,
        openModalIfNotOnCooldown,
        currentState.touchpoint
    ]);
    return {
        showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull,
        showEnforcementIfPendingToShow: showEnforcementIfPendingToShow
    };
};

});
const $3f79643dcab1adf8$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $3f79643dcab1adf8$export$ed785d2382d0101d = 'lastStorageEnforcement';

parcelRegister("RnWyv", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $5fd7f3930a81124f$export$c2ed3351cac403d1);

var $bSSG7 = parcelRequire("bSSG7");
const $5fd7f3930a81124f$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('enforce-storage-limits');

});

parcelRegister("l2AwX", function(module, exports) {

$parcel$export(module.exports, "useEnforceStorageModal", () => $377250c350eb1ea3$export$56beb4c2629d6615);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $7FEwN = parcelRequire("7FEwN");
const $377250c350eb1ea3$var$initialState = {
    isOpen: 'closed',
    touchpoint: undefined
};
const $377250c350eb1ea3$var$store = (0, $iXqE5.createStore)({
    name: 'jsw-enforce-storage-limit-modal',
    initialState: $377250c350eb1ea3$var$initialState,
    actions: $7FEwN.actions
});
const $377250c350eb1ea3$export$56beb4c2629d6615 = (0, $3sQ5x.createHook)($377250c350eb1ea3$var$store);

});
parcelRegister("7FEwN", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a1630f6ff8f7879d$export$e324594224ef24da);

var $aBMM9 = parcelRequire("aBMM9");
const $a1630f6ff8f7879d$export$e324594224ef24da = {
    setIsOpen: $aBMM9.setIsOpen
};

});
parcelRegister("aBMM9", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $bd4df525f1eeff62$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $bd4df525f1eeff62$export$dcf23146e0a40195 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };

});




parcelRegister("8KYZt", function(module, exports) {

$parcel$export(module.exports, "AddExistingIssueButton", () => $fd9f77a81f5a8592$export$9474a3654cef375);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $26g7Y = parcelRequire("26g7Y");
const $fd9f77a81f5a8592$export$9474a3654cef375 = (props)=>{
    const { children: children, onClick: onClick } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
            color: "currentColor",
            label: ""
        }),
        isSelected: false,
        onClick: onClick,
        testId: "issue-view-common-views.child-issues-panel.inline-create.add-existing-issue-button",
        interactionName: "auto-generated.jira-issue-view-common-views.child-issues-panel.view.inline-create.add-existing-issue-button.button"
    }, children);
};
$fd9f77a81f5a8592$export$9474a3654cef375.displayName = 'AddExistingIssueButton';

});

parcelRegister("gpjoS", function(module, exports) {

$parcel$export(module.exports, "default", () => $14e8c0564382a024$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $14e8c0564382a024$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    summaryLabel: {
        "id": "issue.views.common.child-issues-panel.inline-create.summary-label",
        "defaultMessage": "Child summary"
    },
    summaryPlaceholder: {
        "id": "issue.views.common.child-issues-panel.inline-create.summary-placeholder",
        "defaultMessage": "What needs to be done?"
    },
    summaryTextFieldLabel: {
        "id": "issue.views.common.child-issues-panel.inline-create.summary-text-field-label",
        "defaultMessage": "What needs to be done?"
    },
    summaryTooLong: {
        "id": "issue.views.common.child-issues-panel.inline-create.summary-too-long",
        "defaultMessage": "Summary must be less than 255 characters."
    },
    childCreateButton: {
        "id": "issue.views.common.child-issues-panel.inline-create.child-create-button",
        "defaultMessage": "Create"
    },
    childCancelButton: {
        "id": "issue.views.common.child-issues-panel.inline-create.child-cancel-button",
        "defaultMessage": "Cancel"
    },
    addExistingIssuePlaceholder: {
        "id": "issue.views.common.child-issues-panel.inline-create.add-existing-issue-placeholder",
        "defaultMessage": "Choose an existing issue"
    },
    cannotCreateChildIssue: {
        "id": "issue.views.common.child-issues-panel.inline-create.cannot-create-child-issue",
        "defaultMessage": "We can't create child issues. This project only allows you to create epics."
    },
    addExistingIssuePlaceholderIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.inline-create.add-existing-issue-placeholder-issue-term-refresh",
        "defaultMessage": "Choose existing"
    },
    cannotCreateChildIssueIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.inline-create.cannot-create-child-issue-issue-term-refresh",
        "defaultMessage": "We can't create child work items. This project only allows you to create epics."
    }
});

});



parcelRegister("eXYrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3785599c729ae811$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $iQv12 = parcelRequire("iQv12");

var $8oe80 = parcelRequire("8oe80");

var $aWse0 = parcelRequire("aWse0");

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $g5X3G = parcelRequire("g5X3G");

var $8p5e0 = parcelRequire("8p5e0");

var $LTrSl = parcelRequire("LTrSl");

var $58aTF = parcelRequire("58aTF");

var $3XoQX = parcelRequire("3XoQX");

var $2iFnS = parcelRequire("2iFnS");

var $dtS0b = parcelRequire("dtS0b");

var $jkdmh = parcelRequire("jkdmh");
const $3785599c729ae811$export$f36edb964ab3dd49 = (props)=>{
    const { allIssues: allIssues, onReorderChildren: onReorderChildren } = props;
    const [, { setSortableIssueIds: setSortableIssueIds }] = (0, $8p5e0.useSortableIssuesActions)();
    const enhancedOnReorderChildren = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    (...args)=>{
        setSortableIssueIds(allIssues.map((issue)=>(0, $g5X3G.toIssueId)(issue.id)));
        // @ts-expect-error - TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
        onReorderChildren(...args);
    }, [
        allIssues,
        onReorderChildren,
        setSortableIssueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jkdmh.IssuesList), {
        ...props,
        onReorderChildren: enhancedOnReorderChildren
    });
};
const $3785599c729ae811$var$ConnectedIssuesList = (props)=>{
    const intl = (0, $aWse0.useIntlV2)();
    const [sortByValue] = (0, $LTrSl.useChildIssuesSortBy)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3785599c729ae811$export$f36edb964ab3dd49, {
        ...props,
        sortBy: sortByValue,
        intl: intl
    });
};
const $3785599c729ae811$var$mapStateToProps = (state)=>({
        allIssues: (0, $2iFnS.getAllIssues)(state),
        incompleteIssues: (0, $2iFnS.getIncompleteIssues)(state),
        hideDone: (0, $dtS0b.getHideDone)(state),
        parentKey: (0, $58aTF.getParentKey)(state),
        projectType: (0, $58aTF.getChildIssuesPanelProjectType)(state),
        isSimplifiedProject: (0, $58aTF.getIsSimplifiedProject)(state),
        isClassicSubtaskPanel: (0, $58aTF.getIsClassicSubtaskPanel)(state),
        isChildrenIssuesPanel: (0, $58aTF.getIsChildrenIssuesPanel)(state),
        onNavigateToNewIssue: (0, $58aTF.getOnNavigateToNewIssue)(state),
        shouldDisplayWorklogGraph: (0, $58aTF.getIsClassicSubtaskPanel)(state) || (0, $58aTF.getIsChildrenIssuesPanel)(state) && (0, $2iFnS.getIssueHierarchyLevel)(state) === 0,
        onEditAssociatedIssue: (0, $58aTF.getOnEditAssociatedIssue)(state)
    });
const $3785599c729ae811$var$mapDispatchToProps = {
    onInlineErrorCancel: (0, $3XoQX.cancelOptimisticChild),
    onInlineErrorCreateRetry: (0, $3XoQX.createChildRetry),
    onInlineErrorLinkingRetry: (0, $3XoQX.linkingIssueRetry),
    onReorderChildren: (0, $3XoQX.reorderChildrenRequest),
    onEditIssue: (0, $3XoQX.updateIssue)
};
const $3785599c729ae811$var$onEditIssueFactory = (0, $8QpSo.default)((onEditIssue, onEditAssociatedIssue)=>(payload)=>{
        onEditIssue(payload);
        onEditAssociatedIssue?.(payload.issueKey);
    });
const $3785599c729ae811$var$mergeProps = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        onEditIssue: $3785599c729ae811$var$onEditIssueFactory(dispatchProps.onEditIssue, stateProps.onEditAssociatedIssue)
    });
const $3785599c729ae811$var$ReduxConnectedView = (0, $dRLCn.flowWithSafeComponent)((0, $8oe80.default)('button', {
    onInlineErrorCancel: 'clicked',
    onInlineErrorCreateRetry: 'clicked'
}), (0, $8oe80.default)('inlineIssue', {
    onNavigateToNewIssue: 'clicked',
    onReorderChildren: 'dragged'
}), (0, $iQv12.default)({
    onInlineErrorCancel: 'cancelInlineErrorCreate',
    onInlineErrorCreateRetry: 'retryInlineErrorCreate',
    onNavigateToNewIssue: 'navigateToNewIssue',
    onReorderChildren: 'reorderChildren'
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ onEditIssue: (payload: ChildIssue) => void; onInlineErrorCancel: (optimisticId: string) => { type: "state.entities.CANCEL_OPTIMISTIC_CHILD"; payload: { optimisticId: string; }; }; ... 16 more ...; sortBy: SortingOption | null; }, Props>' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof PropsWithRef<Omit<{ [K in keyof Props]: K extends "onInlineErrorCreateRetry" | "onInlineErrorCancel" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>]: K extends "onNavigateToNe...'.
(0, $hxqfC.connect)($3785599c729ae811$var$mapStateToProps, $3785599c729ae811$var$mapDispatchToProps, $3785599c729ae811$var$mergeProps))($3785599c729ae811$var$ConnectedIssuesList);
var $3785599c729ae811$export$2e2bcd8739ae039 = $3785599c729ae811$var$ReduxConnectedView;

});
parcelRegister("jkdmh", function(module, exports) {

$parcel$export(module.exports, "IssuesList", () => $6f9b646f9bc2a3f3$export$f0e0d2b9b78901da);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $8Rkzz = parcelRequire("8Rkzz");

var $ifg6x = parcelRequire("ifg6x");

var $jzjy1 = parcelRequire("jzjy1");


var $eNNkf = parcelRequire("eNNkf");

var $kF1SN = parcelRequire("kF1SN");

var $LTrSl = parcelRequire("LTrSl");

var $9maSU = parcelRequire("9maSU");

var $1xPmj = parcelRequire("1xPmj");
const $6f9b646f9bc2a3f3$export$e9e38206b130e511 = ({ allIssues: allIssues, incompleteIssues: incompleteIssues, sortBy: sortBy, hasExceededChildIssuesLimitOnLoadOrAfter: hasExceededChildIssuesLimitOnLoadOrAfter, isSimplifiedProject: isSimplifiedProject, isClassicSubtaskPanel: isClassicSubtaskPanel, ...props })=>{
    const [hideDonePreference] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$4c9f7f9f8a4000e1));
    const [sortableIssueIds] = (0, $LTrSl.useSortableIssueIds)();
    const [oldIssuesFromAll, newIssuesFromAll] = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))(allIssues, (issue)=>sortableIssueIds.includes(issue.id)), [
        allIssues,
        sortableIssueIds
    ]);
    const [oldIssuesFromIncomplete, newIssuesFromIncomplete] = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))(incompleteIssues, (issue)=>sortableIssueIds.includes(issue.id)), [
        incompleteIssues,
        sortableIssueIds
    ]);
    const sortingFn = (0, $5uXOq.useMemo)(()=>{
        switch(sortBy){
            case (0, $kF1SN.SORT_OPTION).CREATED:
                return 0, $1xPmj.sortIssuesByCreated;
            case (0, $kF1SN.SORT_OPTION).KEY:
                return 0, $1xPmj.sortIssuesByKey;
            case (0, $kF1SN.SORT_OPTION).STATUS:
                return 0, $1xPmj.sortIssuesByStatus;
            case (0, $kF1SN.SORT_OPTION).ASSIGNEE:
                return 0, $1xPmj.sortIssuesByAssignee;
            case (0, $kF1SN.SORT_OPTION).PRIORITY:
                return 0, $1xPmj.sortIssuesByPriority;
            case (0, $kF1SN.SORT_OPTION).RANKING:
            default:
                return (issues)=>issues;
        }
    }, [
        sortBy
    ]);
    const sortedAllIssues = (0, $5uXOq.useMemo)(()=>sortingFn(oldIssuesFromAll), [
        oldIssuesFromAll,
        sortingFn
    ]);
    const sortedIncompleteIssues = (0, $5uXOq.useMemo)(()=>sortingFn(oldIssuesFromIncomplete), [
        oldIssuesFromIncomplete,
        sortingFn
    ]);
    // Company Managed Projects do not currently support reranking as
    // the rank custom field is specially always loaded for TMP but not for CMP.
    // Without the rank custom field id we cannot rerank CMP issues
    const restrictReordering = !isSimplifiedProject && !isClassicSubtaskPanel || hasExceededChildIssuesLimitOnLoadOrAfter || sortBy !== null && sortBy !== (0, $kF1SN.SORT_OPTION).RANKING;
    //  show hidden done issues if all child issues/subtasks are done
    //  otherwise we'll have an empty child issues panel
    const hasIncompleteIssues = !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(incompleteIssues);
    const shouldHideDone = hasIncompleteIssues && hideDonePreference === 'true';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9maSU.Issues), {
        ...props,
        isSimplifiedProject: isSimplifiedProject,
        isClassicSubtaskPanel: isClassicSubtaskPanel,
        allIssues: [
            ...sortedAllIssues,
            ...newIssuesFromAll
        ],
        incompleteIssues: [
            ...sortedIncompleteIssues,
            ...newIssuesFromIncomplete
        ],
        restrictReordering: restrictReordering,
        hasExceededChildIssuesLimitOnLoadOrAfter: hasExceededChildIssuesLimitOnLoadOrAfter,
        hideDone: shouldHideDone
    });
};
$6f9b646f9bc2a3f3$export$e9e38206b130e511.defaultProps = {
    isClassicSubtaskPanel: false,
    isChildrenIssuesPanel: false,
    shouldDisplayWorklogGraph: false,
    allIssues: [],
    incompleteIssues: [],
    projectType: null,
    onReorderChildren: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onEditIssue: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    hasExceededChildIssuesLimitOnLoadOrAfter: false
};
const $6f9b646f9bc2a3f3$export$f0e0d2b9b78901da = (0, $jzjy1.AnalyticsSubject)('issue')($6f9b646f9bc2a3f3$export$e9e38206b130e511);

});
parcelRegister("9maSU", function(module, exports) {

$parcel$export(module.exports, "Issues", () => $da3d8a9864985ee2$export$1cb51167b20548a0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $cVsSS = parcelRequire("cVsSS");

var $ivrNr = parcelRequire("ivrNr");

var $dX4sl = parcelRequire("dX4sl");

var $38bVB = parcelRequire("38bVB");

var $cWUH6 = parcelRequire("cWUH6");

var $fOGZN = parcelRequire("fOGZN");

var $bay8L = parcelRequire("bay8L");

var $g5X3G = parcelRequire("g5X3G");

var $kfztd = parcelRequire("kfztd");

var $dCm1o = parcelRequire("dCm1o");

var $bD3dP = parcelRequire("bD3dP");

var $b6FPk = parcelRequire("b6FPk");

var $8CwTD = parcelRequire("8CwTD");

var $1xPmj = parcelRequire("1xPmj");

var $46T6W = parcelRequire("46T6W");

var $eqq2o = parcelRequire("eqq2o");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $da3d8a9864985ee2$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _otyru2gc _u5f3v77o",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $da3d8a9864985ee2$var$IssuesInternal extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isClassicSubtaskPanel: false,
            isChildrenIssuesPanel: false,
            shouldDisplayWorklogGraph: false,
            allIssues: [],
            incompleteIssues: [],
            projectType: null,
            restrictReordering: false,
            onReorderChildren: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onEditIssue: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    inlineErrorMessage(id, errorType, error) {
        const { intl: intl, onInlineErrorCreateRetry: onInlineErrorCreateRetry, onInlineErrorLinkingRetry: onInlineErrorLinkingRetry, onInlineErrorCancel: onInlineErrorCancel, isClassicSubtaskPanel: isClassicSubtaskPanel } = this.props;
        const createChildErrorTitleMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8CwTD.default).createChildErrorTitleIssueTermRefresh : (0, $8CwTD.default).createChildErrorTitle;
        switch(errorType){
            case (0, $dX4sl.associatedIssueErrorTypes).linkChild:
                return (0, $b6FPk.renderInlineMessage)(intl, intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8CwTD.default).linkIssueErrorTitleIssueTermRefresh : (0, $8CwTD.default).linkIssueErrorTitle), intl.formatMessage((0, $8CwTD.default).linkIssueErrorBody), (e, analyticsEvent)=>onInlineErrorLinkingRetry(id, analyticsEvent), ()=>onInlineErrorCancel(id));
            case (0, $dX4sl.associatedIssueErrorTypes).createChild:
            default:
                {
                    const errorTitle = isClassicSubtaskPanel ? (0, $8CwTD.default).createSubtaskErrorTitle : createChildErrorTitleMessage;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(error)) {
                        const errorMessages = error.message ? error.message.split('; ') : [];
                        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2339 - Property 'errors' does not exist on type 'Error | ValidationError'.
                        const fieldErrorMessages = error.errors?.length ? // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2339 - Property 'errors' does not exist on type 'Error | ValidationError'. | TS7031 - Binding element 'field' implicitly has an 'any' type. | TS7031 - Binding element 'errorMessage' implicitly has an 'any' type.
                        error.errors.map(({ field: field, error: errorMessage })=>field === (0, $fOGZN.ASSIGNEE) && errorMessage === (0, $38bVB.DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE) ? (0, $38bVB.DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE_FE) : errorMessage) : [];
                        const allErrors = [
                            ...errorMessages,
                            ...fieldErrorMessages
                        ];
                        if (allErrors.length) {
                            const limitToTwoErrorMessages = allErrors.slice(0, 2);
                            return (0, $b6FPk.renderInlineMessage)(intl, intl.formatMessage(errorTitle), limitToTwoErrorMessages, (e, analyticsEvent)=>onInlineErrorCreateRetry(id, analyticsEvent), ()=>onInlineErrorCancel(id));
                        }
                    }
                    return (0, $b6FPk.renderInlineMessage)(intl, intl.formatMessage(errorTitle), intl.formatMessage((0, $8CwTD.default).createErrorBody), (e, analyticsEvent)=>onInlineErrorCreateRetry(id, analyticsEvent), ()=>onInlineErrorCancel(id));
                }
        }
    }
    renderIssueLineCardGroup({ groupId: groupId, issues: issues, projectType: projectType, isReorderEnabled: isReorderEnabled, isInteractive: isInteractive, onEditIssue: onEditIssue, shouldDisplayWorklogGraph: shouldDisplayWorklogGraph, restrictedReorderingMessage: restrictedReorderingMessage }) {
        const isAnyPrioritySetForAnyChildIssue = (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('redesign-linked-issues-issue-view') ? (0, $1xPmj.getIsAnyPrioritySetInAnyChildIssue)(issues) : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivrNr.ItemLineCardGroup), {
            items: issues,
            onOrderChange: this.onOrderChange,
            groupId: groupId,
            isReorderEnabled: isReorderEnabled,
            isInteractive: isInteractive,
            onClick: this.onChildIssueClick
        }, ({ isHovering: isHovering, isActive: isActive, isFocused: isFocused, isDragging: isDragging, item: issue, isReorderMenuOpen: isReorderMenuOpen, reorderMenu: reorderMenu })=>{
            const handleEdit = (updatedFields)=>onEditIssue && onEditIssue({
                    ...issue,
                    ...updatedFields
                });
            const handleClick = (event)=>this.onChildIssueClick({
                    ...issue
                }, event);
            const { id: id, issueKey: issueKey, issueLink: issueLink, issueTypeIconUrl: issueTypeIconUrl, issueTypeName: issueTypeName, issuePriorityUrl: issuePriorityUrl, issuePriorityName: issuePriorityName, issueSummary: issueSummary, statusCategory: statusCategory, statusCategoryId: statusCategoryId, statusId: statusId, statusName: statusName, assigneeUrl: assigneeUrl, assigneeDisplayName: assigneeDisplayName, isLoading: isLoading, errorInlineMessage: errorInlineMessage, hasError: hasError, estimateFieldId: estimateFieldId, issueTimeTracking: issueTimeTracking, isResolved: isResolved } = issue;
            const additionalItems = [];
            if (shouldDisplayWorklogGraph && issueTimeTracking?.timeSpentSeconds !== undefined && issueTimeTracking.timeSpentSeconds > 0) additionalItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eqq2o.default), {
                issueTimeTracking: issueTimeTracking,
                statusCategory: issue.statusCategory
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bD3dP.default), {
                id: (0, $g5X3G.toIssueId)(id),
                issueKey: (0, $g5X3G.toIssueKey)(issueKey ?? ''),
                issueLink: issueLink,
                issueTypeIconUrl: issueTypeIconUrl,
                issueTypeName: issueTypeName,
                issuePriorityUrl: issuePriorityUrl,
                issuePriorityName: issuePriorityName,
                issueSummary: issueSummary,
                statusCategory: statusCategory,
                statusCategoryId: statusCategoryId,
                shouldSetWidthForPriorityField: isAnyPrioritySetForAnyChildIssue,
                statusId: statusId,
                statusName: statusName,
                assigneeUrl: assigneeUrl,
                assigneeDisplayName: assigneeDisplayName,
                isLoading: isLoading,
                errorInlineMessage: errorInlineMessage,
                hasError: hasError,
                estimateFieldId: estimateFieldId,
                isHovering: isHovering,
                isActive: isActive,
                /**
         * Ensures the reorder menu stays visible while it is open.
         */ isFocused: isFocused || isReorderMenuOpen,
                isDraggable: isReorderEnabled,
                isDragging: isDragging,
                isInteractive: isInteractive,
                projectType: projectType,
                onEdit: handleEdit,
                onClick: handleClick,
                restrictedReorderingMessage: restrictedReorderingMessage,
                additionalItems: additionalItems,
                shouldDisplayDevOpsData: true,
                isInlineEditEnabled: true,
                isResolved: isResolved,
                reorderMenu: reorderMenu,
                isVisuallyRefreshedIssueKey: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_5')
            });
        });
    }
    render() {
        const { allIssues: allIssues, incompleteIssues: incompleteIssues, hideDone: hideDone, isClassicSubtaskPanel: isClassicSubtaskPanel, isChildrenIssuesPanel: isChildrenIssuesPanel, isSimplifiedProject: isSimplifiedProject, projectType: projectType, onEditIssue: onEditIssue, shouldDisplayWorklogGraph: shouldDisplayWorklogGraph, intl: { formatMessage: formatMessage }, restrictReordering: restrictReordering = false, hasExceededChildIssuesLimitOnLoadOrAfter: hasExceededChildIssuesLimitOnLoadOrAfter } = this.props;
        const hasMultipleIssues = allIssues.length > 1;
        const hasLoadingIssues = allIssues.filter((issue)=>issue.isLoading).length > 0;
        const canReorderIssues = (isChildrenIssuesPanel || isClassicSubtaskPanel) && !hideDone && hasMultipleIssues && !hasLoadingIssues && !restrictReordering;
        const issuesToRender = hideDone ? incompleteIssues : allIssues;
        const issues = issuesToRender.map((issue)=>{
            const dragPreview = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $46T6W.DragPreview), {
                iconUrl: issue.issueTypeIconUrl,
                issueKey: issue.issueKey
            });
            const name = issue.issueSummary ?? '';
            const type = issue.issueTypeName ?? '';
            return issue.errorType ? {
                ...issue,
                errorInlineMessage: this.inlineErrorMessage(issue.id, issue.errorType, issue.error),
                dragPreview: dragPreview,
                name: name,
                type: type
            } : {
                ...issue,
                dragPreview: dragPreview,
                name: name,
                type: type
            };
        });
        const containerProps = {
            'data-testid': 'issue.issue-view.views.common.child-issues-panel.issues-container'
        };
        const reorderingMessageProps = (isChildrenIssuesPanel || isClassicSubtaskPanel) && hasMultipleIssues && restrictReordering && !(!isSimplifiedProject && isChildrenIssuesPanel) && {
            restrictedReorderingMessage: hasExceededChildIssuesLimitOnLoadOrAfter ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8CwTD.default).restrictedReorderingExceededLimitMessageIssueTermRefresh : (0, $8CwTD.default).restrictedReorderingExceededLimitMessage) : formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8CwTD.default).restrictedReorderingMessageIssueTermRefresh : (0, $8CwTD.default).restrictedReorderingMessage)
        };
        const issueIds = issues.map((issue)=>issue.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bay8L.SmartCardProviderMigration), null, (0, $kfztd.isDevopsFeatureDisabledInFedRamp)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da3d8a9864985ee2$var$Container, containerProps, this.renderIssueLineCardGroup({
            groupId: 'child-issues-panel',
            issues: issues,
            projectType: projectType,
            isReorderEnabled: canReorderIssues,
            onEditIssue: onEditIssue,
            shouldDisplayWorklogGraph: shouldDisplayWorklogGraph,
            ...reorderingMessageProps
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cVsSS.DevOpsSummaryContainer), {
            issueIds: issueIds,
            location: "issue_view_child_issues_list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da3d8a9864985ee2$var$Container, containerProps, this.renderIssueLineCardGroup({
            groupId: 'child-issues-panel',
            issues: issues,
            projectType: projectType,
            isReorderEnabled: canReorderIssues,
            onEditIssue: onEditIssue,
            shouldDisplayWorklogGraph: shouldDisplayWorklogGraph,
            ...reorderingMessageProps
        }))));
    }
    constructor(...args){
        super(...args), this.onChildIssueClick = (issue, event)=>{
            if ((0, $cWUH6.isMiddleClick)(event)) return;
            const nextIssueKey = issue.issueKey;
            if (typeof nextIssueKey === 'string' && (0, $cWUH6.isLeftClickOnly)(event)) this.props.onNavigateToNewIssue({
                fromIssueKey: this.props.parentKey,
                toIssueKey: nextIssueKey
            });
            else if (typeof nextIssueKey === 'string' && (0, $cWUH6.isCmdOrCtrlClick)(event)) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(issue.issueLink, '_blank');
        }, this.onOrderChange = (optimisticNewOrder, reorderedIssue, currentIssueIndex, newIssueIndex, analyticsEvent)=>{
            this.props.onReorderChildren(this.props.allIssues, optimisticNewOrder, currentIssueIndex, newIssueIndex, analyticsEvent);
        };
    }
}
const $da3d8a9864985ee2$export$1cb51167b20548a0 = /*#__PURE__*/ (0, $5uXOq.memo)($da3d8a9864985ee2$var$IssuesInternal, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));
$da3d8a9864985ee2$export$1cb51167b20548a0.displayName = 'Issues';

});
parcelRegister("8CwTD", function(module, exports) {

$parcel$export(module.exports, "default", () => $1efc334d9f0ed146$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $1efc334d9f0ed146$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createChildErrorTitle: {
        "id": "issue.views.common.child-issues-panel.issues.create-child-error-title",
        "defaultMessage": "We couldn't create the child issue"
    },
    createSubtaskErrorTitle: {
        "id": "issue.views.common.child-issues-panel.issues.create-subtask-error-title",
        "defaultMessage": "We couldn't create the subtask"
    },
    createErrorBody: {
        "id": "issue.views.common.child-issues-panel.issues.create-error-body",
        "defaultMessage": "Check your connection, then give it another try"
    },
    linkIssueErrorTitle: {
        "id": "issue.views.common.child-issues-panel.issues.link-issue-error-title",
        "defaultMessage": "We couldn't link the child issue"
    },
    linkIssueErrorBody: {
        "id": "issue.views.common.child-issues-panel.issues.link-issue-error-body",
        "defaultMessage": "Check your connection, then give it another try"
    },
    restrictedReorderingMessage: {
        "id": "issue.views.common.child-issues-panel.issues.restricted-reordering-message",
        "defaultMessage": "To order these issues manually, choose 'Order by rank'"
    },
    restrictedReorderingExceededLimitMessage: {
        "id": "issue.views.common.child-issues-panel.issues.restricted-reordering-exceeded-limit-message",
        "defaultMessage": "To order more than 100 child issues, select ... -> View in search"
    },
    createChildErrorTitleIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.issues.create-child-error-title-issue-term-refresh",
        "defaultMessage": "We couldn't create the child work items"
    },
    linkIssueErrorTitleIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.issues.link-issue-error-title-issue-term-refresh",
        "defaultMessage": "We couldn't link the child work item"
    },
    restrictedReorderingMessageIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.issues.restricted-reordering-message-issue-term-refresh",
        "defaultMessage": "To order these work items manually, choose 'Order by rank'"
    },
    restrictedReorderingExceededLimitMessageIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.issues.restricted-reordering-exceeded-limit-message-issue-term-refresh",
        "defaultMessage": "To order more than 100 child work items, select ... -> View in search"
    }
});

});

parcelRegister("1xPmj", function(module, exports) {

$parcel$export(module.exports, "getIsAnyPrioritySetInAnyChildIssue", () => $5d810796eb525c87$export$a97531b7b331332d);
$parcel$export(module.exports, "sortIssuesByCreated", () => $5d810796eb525c87$export$f98c246157e8809c);
$parcel$export(module.exports, "sortIssuesByKey", () => $5d810796eb525c87$export$75bc2191a1c5e544);
$parcel$export(module.exports, "sortIssuesByStatus", () => $5d810796eb525c87$export$b12b96dc5456b2e);
$parcel$export(module.exports, "sortIssuesByAssignee", () => $5d810796eb525c87$export$653d72ce77c114f5);
$parcel$export(module.exports, "sortIssuesByPriority", () => $5d810796eb525c87$export$200919e667fbb916);

var $gULOk = parcelRequire("gULOk");
const $5d810796eb525c87$export$a97531b7b331332d = (childIssues)=>{
    if (!childIssues) return false;
    return Boolean(childIssues.find((childIssue)=>Boolean(childIssue.issuePriorityUrl)));
};
const $5d810796eb525c87$export$f98c246157e8809c = (issues)=>[
        ...issues
    ].sort((a, b)=>{
        if (a.created === undefined) return 1;
        if (b.created === undefined) return -1;
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        return b.created - a.created;
    });
const $5d810796eb525c87$export$75bc2191a1c5e544 = (issues)=>[
        ...issues
    ].sort((a, b)=>{
        const [aKey = '', aIndex = 0] = (a.issueKey || '').split('-');
        const [bKey = '', bIndex = 0] = (b.issueKey || '').split('-');
        // @ts-expect-error - TS2345 - Argument of type 'string | 0' is not assignable to parameter of type 'string'. | TS2345 - Argument of type 'string | 0' is not assignable to parameter of type 'string'.
        return aKey.localeCompare(bKey) || parseInt(aIndex, 10) - parseInt(bIndex, 10);
    });
const $5d810796eb525c87$var$STATUS_SORT_ORDER = {
    [(0, $gULOk.UNDEFINED)]: 0,
    [(0, $gULOk.TODO)]: 1,
    [(0, $gULOk.IN_PROGRESS)]: 2,
    [(0, $gULOk.DONE)]: 3
};
const $5d810796eb525c87$var$getStatusSortOrder = (statusCategory)=>{
    const categoryName = statusCategory == null ? (0, $gULOk.UNDEFINED) : statusCategory;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly UNDEFINED: 0; readonly TODO: 1; readonly IN_PROGRESS: 2; readonly DONE: 3; }'.
    return $5d810796eb525c87$var$STATUS_SORT_ORDER[categoryName] || 0;
};
const $5d810796eb525c87$export$b12b96dc5456b2e = (issues)=>[
        ...issues
    ].sort((a, b)=>$5d810796eb525c87$var$getStatusSortOrder(a.statusCategory) - $5d810796eb525c87$var$getStatusSortOrder(b.statusCategory) || (a.statusName || '').localeCompare(b.statusName || ''));
const $5d810796eb525c87$export$653d72ce77c114f5 = (issues)=>[
        ...issues
    ].sort((a, b)=>{
        if (a.assigneeDisplayName === '' || a.assigneeDisplayName == null) return 1;
        if (b.assigneeDisplayName === '' || b.assigneeDisplayName == null) return -1;
        return a.assigneeDisplayName.localeCompare(b.assigneeDisplayName);
    });
// this is to ensure issues where priority is empty are placed last
const $5d810796eb525c87$var$getPriorityValue = (priorityOrder, priorityName)=>{
    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
    const index = priorityOrder.indexOf(priorityName);
    return index >= 0 ? index : Number.MAX_SAFE_INTEGER;
};
const $5d810796eb525c87$export$1828c302333b42d8 = (issues, priorityOrder)=>[
        ...issues
    ].sort((a, b)=>$5d810796eb525c87$var$getPriorityValue(priorityOrder, a.issuePriorityName) - $5d810796eb525c87$var$getPriorityValue(priorityOrder, b.issuePriorityName));
const $5d810796eb525c87$export$200919e667fbb916 = (issues)=>[
        ...issues
    ].sort((a, b)=>(a.issuePrioritySequence || Number.MAX_SAFE_INTEGER) - (b.issuePrioritySequence || Number.MAX_SAFE_INTEGER));

});

parcelRegister("46T6W", function(module, exports) {

$parcel$export(module.exports, "DragPreview", () => $86d34785e85a1acc$export$905ab40ac2179daa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
function $86d34785e85a1acc$export$905ab40ac2179daa({ iconUrl: iconUrl, issueKey: issueKey }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86d34785e85a1acc$var$Container, null, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: iconUrl,
        /**
     * This preview won't be read by assistive technology,
     * so can be treated as purely decorative.
     */ alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($86d34785e85a1acc$var$Key, null, issueKey));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86d34785e85a1acc$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoglpi _zulpu2gc _bfhk1bhr _1e0c1txw _4cvr1h6o _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $86d34785e85a1acc$var$Key = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81vhk _syaz14q2 _k48p1wq8 _o5721q9c",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eqq2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c11d039e39a578$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gULOk = parcelRequire("gULOk");

var $aY4x8 = parcelRequire("aY4x8");

var $34rRp = parcelRequire("34rRp");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$60c11d039e39a578$export$2e2bcd8739ae039 = ({ issueTimeTracking: issueTimeTracking, statusCategory: statusCategory })=>{
    const [config] = (0, $34rRp.useTimeTrackingConfiguration)();
    const { remainingEstimateSeconds: remainingEstimateSeconds, originalEstimateSeconds: originalEstimateSeconds, timeSpentSeconds: timeSpentSeconds } = issueTimeTracking;
    const value = {
        loggedTime: timeSpentSeconds,
        remainingTime: remainingEstimateSeconds
    };
    const estimatedTime = originalEstimateSeconds;
    const isDone = statusCategory === (0, $gULOk).DONE;
    return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60c11d039e39a578$export$b1569cb93f9fcc1f, {
        "data-testid": "issue.views.common.issue-line-card.issue-line-card.mini-time-log-graph"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aY4x8.ProgressTracker), {
        value: value,
        estimatedTime: estimatedTime,
        config: config,
        isDone: isDone,
        isCompact: true,
        shouldHighlightOnHover: true
    })));
};
const $60c11d039e39a578$export$b1569cb93f9fcc1f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1ylp _kqswh2mm",
            __cmplp.className
        ])
    });
});

});




parcelRegister("6wTDL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4383c12a2bb6883$export$2e2bcd8739ae039);

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $58aTF = parcelRequire("58aTF");

var $2iFnS = parcelRequire("2iFnS");

var $irR9p = parcelRequire("irR9p");
var $f4383c12a2bb6883$export$2e2bcd8739ae039 = (0, $dRLCn.flowWithSafeComponent)((0, $hxqfC.connect)((state)=>{
    const totalIssues = (0, $2iFnS.getAllIssues)(state);
    const inProgressIssues = (0, $2iFnS.getInProgressIssues)(state);
    const completedIssues = (0, $2iFnS.getCompletedIssues)(state);
    return {
        isClassicSubtaskPanel: (0, $58aTF.getIsClassicSubtaskPanel)(state),
        totalIssueCount: totalIssues.length,
        inProgressIssueCount: inProgressIssues.length,
        completedIssueCount: completedIssues.length
    };
}, {}))((0, $irR9p.ProgressSummaryView));

});
parcelRegister("irR9p", function(module, exports) {

$parcel$export(module.exports, "ProgressSummaryView", () => $aba41d2f8411fcfa$export$d71da7c107cf4a34);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6xUNT = parcelRequire("6xUNT");

var $7IWsp = parcelRequire("7IWsp");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $aWse0 = parcelRequire("aWse0");

var $dv3Qk = parcelRequire("dv3Qk");

var $j4eQY = parcelRequire("j4eQY");

const $aba41d2f8411fcfa$export$d71da7c107cf4a34 = (props)=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { isClassicSubtaskPanel: isClassicSubtaskPanel, totalIssueCount: totalIssueCount, inProgressIssueCount: inProgressIssueCount, completedIssueCount: completedIssueCount } = props; // Note: on rare occasions, it is possible for todoIssueCount to include issues with UNDEFINED status category.
    const todoIssueCount = totalIssueCount - inProgressIssueCount - completedIssueCount; // Ensuring the total count is not 0, to avoid division by 0.
    const correctedTotalIssueCount = totalIssueCount === 0 ? 1 : totalIssueCount;
    const finalTotalIssueCount = (0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false) ? correctedTotalIssueCount : totalIssueCount; // Math.floor instead of Math.round so we don't incorrectly show 100% Done when we're only at 99.5%.
    const completionPercentage = Math.floor(completedIssueCount / finalTotalIssueCount * 100);
    const CHILD_ISSUE_PANEL_TOOLTIP_MESSAGE = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dv3Qk.CHILD_ISSUE_PANEL_TOOLTIP_ISSUE_TERM_REFRESH) : (0, $dv3Qk.CHILD_ISSUE_PANEL_TOOLTIP);
    const { remainingTooltip: remainingTooltip, completedTooltip: completedTooltip, inProgressTooltip: inProgressTooltip } = isClassicSubtaskPanel ? (0, $dv3Qk.CLASSIC_SUBTASK_PANEL_TOOLTIP) : CHILD_ISSUE_PANEL_TOOLTIP_MESSAGE;
    const progressElementCompleted = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7IWsp.default), {
        value: completedIssueCount,
        color: (0, $21380742b5054e2d$export$53b2ee28ea173ab6),
        tooltipContent: formatMessage(completedTooltip, {
            completedIssueCount: completedIssueCount,
            totalIssueCount: totalIssueCount
        })
    });
    const progressElementInProgress = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7IWsp.default), {
        value: inProgressIssueCount,
        color: (0, $21380742b5054e2d$export$14dbcc9140a368ac),
        tooltipContent: formatMessage(inProgressTooltip, {
            inProgressIssueCount: inProgressIssueCount,
            totalIssueCount: totalIssueCount
        })
    });
    const childWorkProgressSummaryLabel = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $j4eQY.default).childWorkProgressSummaryLabelRefresh : (0, $j4eQY.default).childWorkProgressSummaryLabel; // Extra the common content from newProgressBarContainer and oldProgressBarContainer
    const progressBarContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6xUNT.default), {
        sum: finalTotalIssueCount,
        backgroundColor: (0, $21380742b5054e2d$export$ffab47bcf4a11d42),
        remainingTooltipContent: formatMessage(remainingTooltip, {
            todoIssueCount: todoIssueCount,
            totalIssueCount: totalIssueCount
        }),
        height: 8,
        "aria-label": formatMessage(childWorkProgressSummaryLabel)
    }, progressElementCompleted, progressElementInProgress);
    if ((0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aba41d2f8411fcfa$var$ProgressSummaryContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aba41d2f8411fcfa$var$ProgressBarContainer, null, progressBarContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aba41d2f8411fcfa$var$CompletionPercentageContainer, {
        ...(0, $4R6GH.fg)('jfp_a11y_fix_announce_updated_progress') ? {
            'aria-live': 'polite',
            'aria-atomic': 'true'
        } : {
            'aria-hidden': 'true'
        },
        "data-testid": "issue-view-common-views.child-issues-panel.progress-summary.progress-percentage-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $j4eQY.default).completionPercentageText,
        values: {
            completionPercentage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aba41d2f8411fcfa$var$PercentageValueContainer, null, completionPercentage)
        }
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aba41d2f8411fcfa$var$OldProgressSummaryContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aba41d2f8411fcfa$var$OldProgressBarContainer, null, progressBarContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aba41d2f8411fcfa$var$OldCompletionPercentageContainer, {
        ...(0, $4R6GH.fg)('jfp_a11y_fix_announce_updated_progress') ? {
            'aria-live': 'polite',
            'aria-atomic': 'true'
        } : {
            'aria-hidden': 'true'
        },
        "data-testid": "issue-view-common-views.child-issues-panel.progress-summary.progress-percentage-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $j4eQY.default).completionPercentageText,
        values: {
            completionPercentage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aba41d2f8411fcfa$var$OldPercentageValueContainer, null, completionPercentage)
        }
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aba41d2f8411fcfa$var$OldProgressSummaryContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _16jlcs5v",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aba41d2f8411fcfa$var$ProgressSummaryContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1wpz1h6o _16jlcs5v",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aba41d2f8411fcfa$var$OldProgressBarContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _19pku2gc _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aba41d2f8411fcfa$var$ProgressBarContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aba41d2f8411fcfa$var$OldCompletionPercentageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0pxbi _2hwxv77o _1o9zidpf _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aba41d2f8411fcfa$var$CompletionPercentageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0pxbi _2hwxpxbi _1o9zidpf _syaz131l",
            __cmplp.className
        ])
    });
}); // Fixed width span is used to contain the actual completion percentage value. This will ensure the progress bar width
const $aba41d2f8411fcfa$var$OldPercentageValueContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _1bsb1tcg _y3gnusic",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aba41d2f8411fcfa$var$PercentageValueContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6xUNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d12efc7cca969bbb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");


var $az4zD = parcelRequire("az4zD");

var $7IWsp = parcelRequire("7IWsp");

var $jR3Es = parcelRequire("jR3Es");
// eslint-disable-next-line jira/react/no-class-components
class $d12efc7cca969bbb$var$ProgressBar extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            children: null,
            sum: 0,
            remainingTooltipContent: '',
            // TODO: Use tokens for colors
            backgroundColor: (0, $829f609a65d26a98$exports).N30,
            height: 10
        };
    }
    validateElementsAndCalculateElementsWidth() {
        const { children: children } = this.props;
        let sumOfElementsValues = 0;
        const validatedElements = [];
        (0, $5uXOq.Children).map(children, (child)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const childEl = child;
            if (childEl.props.value && childEl.props.value > 0) {
                sumOfElementsValues += childEl.props.value;
                validatedElements.push(childEl);
            }
        });
        return {
            validatedElements: validatedElements,
            elementsSum: sumOfElementsValues
        };
    }
    render() {
        const { children: children, remainingTooltipContent: remainingTooltipContent, sum: sum = 0, backgroundColor: backgroundColor, height: height, borderRadius: borderRadius, tooltipHoverPadding: tooltipHoverPadding, intl: { formatMessage: formatMessage } } = this.props;
        if (!children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d12efc7cca969bbb$var$ProgressWrapper, {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "common.components.progress-bar.progress-wrapper",
            backgroundColor: backgroundColor,
            elementsGrow: 0,
            elementsHeight: height,
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            borderRadius: borderRadius
        });
        const { validatedElements: validatedElements, elementsSum: elementsSum } = this.validateElementsAndCalculateElementsWidth();
        const correctedSum = Number.isNaN(sum) ? 0 : sum;
        const remaining = correctedSum - elementsSum;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d12efc7cca969bbb$var$ProgressWrapper, {
            ...this.props,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "common.components.progress-bar.progress-wrapper",
            backgroundColor: remaining > 0 ? backgroundColor : 'transparent',
            elementsHeight: height,
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            borderRadius: borderRadius,
            tooltipHoverPadding: tooltipHoverPadding,
            ariaLive: "polite",
            role: "progressbar",
            "aria-valuemax": correctedSum,
            "aria-valuenow": elementsSum,
            "aria-label": this.props['aria-label'] || formatMessage((0, $jR3Es.default).progressBarAriaLabel)
        }, validatedElements, remaining > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7IWsp.default), {
            value: remaining,
            tooltipContent: remainingTooltipContent,
            color: backgroundColor,
            tooltipHoverPadding: tooltipHoverPadding
        }));
    }
}
var $d12efc7cca969bbb$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($d12efc7cca969bbb$var$ProgressBar);
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d12efc7cca969bbb$var$ProgressWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1750df9-0"
})`width:100%;height:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.elementsHeight}px;display:flex;${({ borderRadius: borderRadius, elementsHeight: elementsHeight, tooltipHoverPadding: tooltipHoverPadding })=>!tooltipHoverPadding && `border-radius: ${borderRadius || elementsHeight / 2}px;
        overflow: hidden;
    `} & > div{${({ borderRadius: borderRadius, elementsHeight: elementsHeight })=>{
    const radius = `${borderRadius || elementsHeight / 2}px`;
    return `
                &:first-child {
                    border-top-left-radius: ${radius};
                    border-bottom-left-radius: ${radius};
                }
                &:last-child {
                    border-top-right-radius: ${radius};
                    border-bottom-right-radius: ${radius};
                }
                &:not(:last-child) {
                    margin-right: 2px;
                }
                &:last-child {
                    margin-right: 0;
                }
            `;
}}}`;
$d12efc7cca969bbb$var$ProgressWrapper.displayName = 'ProgressWrapper';

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("7IWsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $719ee7d438676972$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $3bDjY = parcelRequire("3bDjY");
const $719ee7d438676972$var$SingleElementWithTooltip = (props)=>{
    const { value: value, tooltipContent: tooltipContent, color: color, position: position, tooltipHoverPadding: tooltipHoverPadding } = props;
    const TooltipTag = (0, $5uXOq.useMemo)(()=>{
        const singleElementProps = {
            alt: tooltipContent
        };
        // FIXME: Fix that by extracting the forwarded component
        return /*#__PURE__*/ (0, $5uXOq.forwardRef)((tagProps, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElement, {
                elementGrow: value,
                color: color,
                // @ts-expect-error - TS2322 - Type '((instance: unknown) => void) | MutableRefObject<unknown> | null' is not assignable to type '((instance: any) => void) | RefObject<HTMLElement | SVGElement | Component<{}, {}, any>> | undefined'.
                innerRef: ref,
                tooltipHoverPadding: tooltipHoverPadding,
                ...tagProps,
                ...typeof tooltipContent === 'string' ? singleElementProps : {}
            }));
    }, [
        value,
        color,
        tooltipHoverPadding,
        tooltipContent
    ]);
    return(// @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'keyof IntrinsicElements | ComponentType<AllHTMLAttributes<HTMLElement> & { ref: Ref<HTMLElement>; }> | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        position: position,
        tag: TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null)));
};
class $719ee7d438676972$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            value: 0,
            tooltipContent: ''
        };
    }
    render() {
        const { value: value, tooltipContent: tooltipContent, color: color } = this.props;
        const hasTooltipContent = Boolean(tooltipContent);
        if (hasTooltipContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElementWithTooltip, {
            ...this.props,
            tooltipContent: tooltipContent
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElement, {
            elementGrow: value,
            color: color,
            alt: tooltipContent
        });
    }
}
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $719ee7d438676972$var$SingleElement = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-234u1k-0"
})`flex-grow:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.elementGrow};height:100%;min-width:5px;background-color:${// eslint-disable-next-line @typescript-eslint/no-explicit-any
(props)=>props.color};div{height:100%;width:100%;${({ tooltipHoverPadding: tooltipHoverPadding })=>tooltipHoverPadding && `padding-block: ${tooltipHoverPadding}px;
            margin-top: -${tooltipHoverPadding}px;`}}`;
$719ee7d438676972$var$SingleElement.displayName = 'SingleElement';

});

parcelRegister("jR3Es", function(module, exports) {

$parcel$export(module.exports, "default", () => $0110d4743e8f1dbb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0110d4743e8f1dbb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    progressBarAriaLabel: {
        "id": "common.components.progress-bar.aria-label",
        "defaultMessage": "Progress Bar"
    }
});

});


parcelRegister("dv3Qk", function(module, exports) {

$parcel$export(module.exports, "CLASSIC_SUBTASK_PANEL_TOOLTIP", () => $2002f4ad2939c474$export$a1ed91a324eaae09);
$parcel$export(module.exports, "CHILD_ISSUE_PANEL_TOOLTIP_ISSUE_TERM_REFRESH", () => $2002f4ad2939c474$export$8cd9378007b1d093);
$parcel$export(module.exports, "CHILD_ISSUE_PANEL_TOOLTIP", () => $2002f4ad2939c474$export$e20610670e0b0141);
$parcel$export(module.exports, "ProgressSummary", () => $2002f4ad2939c474$export$62a9419a7178a940);

var $9nt3o = parcelRequire("9nt3o");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $6xUNT = parcelRequire("6xUNT");

var $7IWsp = parcelRequire("7IWsp");

var $gULOk = parcelRequire("gULOk");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $j4eQY = parcelRequire("j4eQY");
const $2002f4ad2939c474$export$a1ed91a324eaae09 = {
    remainingTooltip: (0, $j4eQY.default).todoSubtasksSegmentTooltipText,
    completedTooltip: (0, $j4eQY.default).completedSubtasksSegmentTooltipText,
    inProgressTooltip: (0, $j4eQY.default).inProgressSubtasksSegmentTooltipText
};
const $2002f4ad2939c474$export$8cd9378007b1d093 = {
    remainingTooltip: (0, $j4eQY.default).todoIssuesSegmentTooltipTextIssueTermRefresh,
    completedTooltip: (0, $j4eQY.default).completedIssuesSegmentTooltipTextIssueTermRefresh,
    inProgressTooltip: (0, $j4eQY.default).inProgressIssuesSegmentTooltipTextIssueTermRefresh
};
const $2002f4ad2939c474$export$e20610670e0b0141 = {
    remainingTooltip: (0, $j4eQY.default).todoIssuesSegmentTooltipText,
    completedTooltip: (0, $j4eQY.default).completedIssuesSegmentTooltipText,
    inProgressTooltip: (0, $j4eQY.default).inProgressIssuesSegmentTooltipText
};
const $2002f4ad2939c474$export$62a9419a7178a940 = ({ issues: issues, isClassicSubtaskPanel: isClassicSubtaskPanel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const CHILD_ISSUE_PANEL_TOOLTIP_MESSAGE = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? $2002f4ad2939c474$export$8cd9378007b1d093 : $2002f4ad2939c474$export$e20610670e0b0141;
    const { remainingTooltip: remainingTooltip, completedTooltip: completedTooltip, inProgressTooltip: inProgressTooltip } = isClassicSubtaskPanel ? $2002f4ad2939c474$export$a1ed91a324eaae09 : CHILD_ISSUE_PANEL_TOOLTIP_MESSAGE;
    const childWorkProgressSummaryLabel = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $j4eQY.default).childWorkProgressSummaryLabelRefresh : (0, $j4eQY.default).childWorkProgressSummaryLabel;
    const data = (0, $8Uumt.useFragment)((0, $9nt3o.default), issues);
    const edges = data?.edges || [];
    const totalIssueCount = edges.length;
    const completedIssueCount = edges.filter((e)=>(0, $gULOk.statusCategoryForId)(e?.node?.statusField?.status?.statusCategory.statusCategoryId) === (0, $gULOk.DONE)).length;
    const inProgressIssueCount = edges.filter((e)=>(0, $gULOk.statusCategoryForId)(e?.node?.statusField?.status?.statusCategory.statusCategoryId) === (0, $gULOk.IN_PROGRESS)).length;
    // Note: on rare occasions, it is possible for todoIssueCount to include issues with UNDEFINED status category.
    const todoIssueCount = totalIssueCount - inProgressIssueCount - completedIssueCount;
    // Math.floor instead of Math.round so we don't incorrectly show 100% Done when we're only at 99.5%.
    const completionPercentage = Math.floor(completedIssueCount / totalIssueCount * 100);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        alignInline: "center",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2002f4ad2939c474$var$progressBarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6xUNT.default), {
        sum: totalIssueCount,
        backgroundColor: "var(--ds-chart-neutral, #8590A2)",
        remainingTooltipContent: formatMessage(remainingTooltip, {
            todoIssueCount: todoIssueCount,
            totalIssueCount: totalIssueCount
        }),
        height: 8,
        "aria-label": formatMessage(childWorkProgressSummaryLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7IWsp.default), {
        value: completedIssueCount,
        color: "var(--ds-border-success, #22A06B)",
        tooltipContent: formatMessage(completedTooltip, {
            completedIssueCount: completedIssueCount,
            totalIssueCount: totalIssueCount
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7IWsp.default), {
        value: inProgressIssueCount,
        color: "var(--ds-border-information, #1D7AFC)",
        tooltipContent: formatMessage(inProgressTooltip, {
            inProgressIssueCount: inProgressIssueCount,
            totalIssueCount: totalIssueCount
        })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ...(0, $4R6GH.fg)('jfp_a11y_fix_announce_updated_progress') ? {
            'aria-live': 'polite',
            'aria-atomic': 'true'
        } : {
            'aria-hidden': 'true'
        },
        testId: "issue-view-child-issues-panel.ui.progress-summary.progress-percentage-container",
        xcss: $2002f4ad2939c474$var$completionPercentageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $j4eQY.default).completionPercentageText,
        values: {
            completionPercentage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                as: "span",
                xcss: $2002f4ad2939c474$var$percentageValueContainer
            }, completionPercentage)
        }
    })));
};
const $2002f4ad2939c474$var$completionPercentageContainerStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    flexShrink: 0,
    marginLeft: 'space.200',
    marginRight: 'space.200'
});
const $2002f4ad2939c474$var$percentageValueContainer = (0, $8CUq3.xcss)({
    display: 'inline-block'
});
const $2002f4ad2939c474$var$progressBarContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1
});

});
parcelRegister("9nt3o", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba8b3ca855c02fdd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c08d9dcda3dd64bbf367388bf948be9a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ba8b3ca855c02fdd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "progressSummary_issueViewChildIssuesPanel",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraStatusField",
                            "kind": "LinkedField",
                            "name": "statusField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "statusCategoryId"
                                                    }
                                                ]
                                            },
                                            "action": "LOG",
                                            "path": "edges.node.statusField.status.statusCategory"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$ba8b3ca855c02fdd$var$node.hash = "6031fdf648d4e180026ffea9139024f1";
var $ba8b3ca855c02fdd$export$2e2bcd8739ae039 = $ba8b3ca855c02fdd$var$node;

});

parcelRegister("j4eQY", function(module, exports) {

$parcel$export(module.exports, "default", () => $456d3dcf9d121891$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $456d3dcf9d121891$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    childWorkProgressSummaryLabel: {
        "id": "issue-view-child-issues-panel.ui.progress-summary.child-work-progress-summary-label",
        "defaultMessage": "Child issue progress"
    },
    childWorkProgressSummaryLabelRefresh: {
        "id": "issue-view-child-issues-panel.ui.progress-summary.child-work-progress-summary-label-refresh",
        "defaultMessage": "Child work progress"
    },
    completionPercentageText: {
        "id": "issue-view-child-issues-panel.ui.progress-summary.completion-percentage-text",
        "defaultMessage": "{completionPercentage}% Done"
    },
    completedIssuesSegmentTooltipText: {
        "id": "issue-view-child-issues-panel.ui.progress-summary.completed-issues-segment-tooltip-text",
        "defaultMessage": "Done: {completedIssueCount} of {totalIssueCount} issues"
    },
    completedIssuesSegmentTooltipTextIssueTermRefresh: {
        "id": "issue-view-child-issues-panel.ui.progress-summary.completed-issues-segment-tooltip-text-issue-term-refresh",
        "defaultMessage": "Done: {completedIssueCount} of {totalIssueCount} work items"
    },
    completedSubtasksSegmentTooltipText: {
        "id": "issue-view-child-issues-panel.ui.progress-summary.completed-subtasks-segment-tooltip-text",
        "defaultMessage": "Done: {completedIssueCount} of {totalIssueCount} subtasks"
    },
    inProgressIssuesSegmentTooltipText: {
        "id": "issue-view-child-issues-panel.ui.progress-summary.in-progress-issues-segment-tooltip-text",
        "defaultMessage": "In Progress: {inProgressIssueCount} of {totalIssueCount} issues"
    },
    inProgressSubtasksSegmentTooltipText: {
        "id": "issue-view-child-issues-panel.ui.progress-summary.in-progress-subtasks-segment-tooltip-text",
        "defaultMessage": "In Progress: {inProgressIssueCount} of {totalIssueCount} subtasks"
    },
    inProgressIssuesSegmentTooltipTextIssueTermRefresh: {
        "id": "issue-view-child-issues-panel.ui.progress-summary.in-progress-issues-segment-tooltip-text-issue-term-refresh",
        "defaultMessage": "In Progress: {inProgressIssueCount} of {totalIssueCount} work items"
    },
    todoIssuesSegmentTooltipText: {
        "id": "issue-view-child-issues-panel.ui.progress-summary.todo-issues-segment-tooltip-text",
        "defaultMessage": "To Do: {todoIssueCount} of {totalIssueCount} issues"
    },
    todoSubtasksSegmentTooltipText: {
        "id": "issue-view-child-issues-panel.ui.progress-summary.todo-subtasks-segment-tooltip-text",
        "defaultMessage": "To Do: {todoIssueCount} of {totalIssueCount} subtasks"
    },
    todoIssuesSegmentTooltipTextIssueTermRefresh: {
        "id": "issue-view-child-issues-panel.ui.progress-summary.todo-issues-segment-tooltip-text-issue-term-refresh",
        "defaultMessage": "To Do: {todoIssueCount} of {totalIssueCount} work items"
    }
});

});


const $21380742b5054e2d$export$ffab47bcf4a11d42 = "var(--ds-chart-neutral, #8590A2)";
const $21380742b5054e2d$export$14dbcc9140a368ac = "var(--ds-border-information, #1D7AFC)";
const $21380742b5054e2d$export$53b2ee28ea173ab6 = "var(--ds-border-success, #22A06B)";



parcelRegister("duaxD", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesPanel", () => $be550185ca0355ef$export$402e0e6a7dd45ba5);

var $eQmO7 = parcelRequire("eQmO7");

var $aMON3 = parcelRequire("aMON3");

var $WIzu1 = parcelRequire("WIzu1");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $1fz0b = parcelRequire("1fz0b");

var $lqdvb = parcelRequire("lqdvb");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $2gCtH = parcelRequire("2gCtH");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $dv3Qk = parcelRequire("dv3Qk");

var $38bVB = parcelRequire("38bVB");

var $kuVxL = parcelRequire("kuVxL");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $ecB7Y = parcelRequire("ecB7Y");

var $5fc53 = parcelRequire("5fc53");

var $93Yeu = parcelRequire("93Yeu");

var $l8ruj = parcelRequire("l8ruj");

var $cSD7y = parcelRequire("cSD7y");

var $7XYc4 = parcelRequire("7XYc4");

var $jyNU3 = parcelRequire("jyNU3");

var $cee7x = parcelRequire("cee7x");

var $38bVB = parcelRequire("38bVB");

var $euAs1 = parcelRequire("euAs1");

var $kF1SN = parcelRequire("kF1SN");

var $fvYyN = parcelRequire("fvYyN");

var $2j7J7 = parcelRequire("2j7J7");

var $gCV2C = parcelRequire("gCV2C");

var $3N1Ka = parcelRequire("3N1Ka");

var $LTrSl = parcelRequire("LTrSl");

var $dvqTC = parcelRequire("dvqTC");

var $fWnZD = parcelRequire("fWnZD");

var $clEve = parcelRequire("clEve");

var $1iZLN = parcelRequire("1iZLN");

var $1eLpT = parcelRequire("1eLpT");

var $GgZWv = parcelRequire("GgZWv");

var $8ZsUM = parcelRequire("8ZsUM");
const $be550185ca0355ef$var$PROGRESS_SUMMARY_MIN_ISSUE_COUNT = 2;
const $be550185ca0355ef$export$2c5c38d2211a0152 = ()=>(0, $5uXOq.useContext)((0, $euAs1.AiIssueBreakdownEntryPointContext)).entryPointActions;
const $be550185ca0355ef$var$ChildIssuesPanelBase = ({ hasExceededIssuesLimitAfterLoad: hasExceededIssuesLimitAfterLoad, totalChildIssueCount: totalChildIssueCount, addClickCount: addClickCount = 0, Heading: Heading, Issues: Issues, InlineCreate: InlineCreate, ProgressSummary: ProgressSummary, AddExistingIssue: AddExistingIssue, allIssues: allIssues, childPanelView: childPanelView, sourceName: sourceName, childIssuesLimitUrl: childIssuesLimitUrl, onAddChildClick: onAddChildClick, onIssueBreakdownClick: onIssueBreakdownClick, childIssuesPanelType: childIssuesPanelType, issueHierarchyLevel: issueHierarchyLevel, epicLinkFieldKey: epicLinkFieldKey, parentIssueKey: parentIssueKey, parentIssueTypeId: parentIssueTypeId, projectId: projectId, baseUrl: baseUrl, childIssueTypes: childIssueTypes, issueTypeWithWorkflowValidators: issueTypeWithWorkflowValidators, onFullDialogCreate: onFullDialogCreate, onSuggestedChildIssueCreateSuccess: onSuggestedChildIssueCreateSuccess, incompleteIssues: incompleteIssues, filterSubtasks: filterSubtasks, rootRelayFragment: rootRelayFragment, shouldProactivelySuggestIssues: shouldProactivelySuggestIssues = false, isRankingEnabled: isRankingEnabled, isHideDoneFilterEnabled: isHideDoneFilterEnabled, hasMultipleChildPanels: hasMultipleChildPanels, issueSearchTotalCount: issueSearchTotalCount = 0 })=>{
    const [{ issueCreateSessionId: issueCreateSessionId }] = (0, $ecB7Y.useTriggerIssueViewModal)();
    const initialTotalChildIssueCount = (0, $5uXOq.useRef)(totalChildIssueCount);
    const columnPickerRef = (0, $5uXOq.useRef)(null);
    const childIssuesLimitStatus = (0, $5uXOq.useMemo)(()=>{
        if (childIssuesLimitUrl) return 0, $38bVB.EXCEEDED_LIMIT_INITIAL_LOAD;
        if (hasExceededIssuesLimitAfterLoad) return 0, $38bVB.EXCEEDED_LIMIT_AFTER_LOAD;
        return 0, $38bVB.WITHIN_LIMIT;
    }, [
        childIssuesLimitUrl,
        hasExceededIssuesLimitAfterLoad
    ]);
    const shouldTriggerAiSuggestedIssues = (0, $LTrSl.useShouldTriggerAiSuggestedIssues)();
    const entryPointActions = $be550185ca0355ef$export$2c5c38d2211a0152();
    const issueId = (0, $2gCtH.useIssueId)();
    const projectKey = (0, $93Yeu.useProjectKey)(parentIssueKey || '');
    const [{ whichChildPanelRenderTriggered: whichChildPanelRenderTriggered }, { resetWhichChildPanelRenderTriggered: resetWhichChildPanelRenderTriggered }] = (0, $gCV2C.useChildPanelRenderTrigger)();
    const hasExceededChildIssuesLimitInitialLoad = (0, $5uXOq.useMemo)(()=>(0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus), [
        childIssuesLimitStatus
    ]);
    const hasExceededChildIssuesLimitAfterLoad = (0, $5uXOq.useMemo)(()=>(0, $fvYyN.hasExceededIssuesLimitAfterLoad)(childIssuesLimitStatus), [
        childIssuesLimitStatus
    ]);
    const hasContent = hasExceededChildIssuesLimitInitialLoad || allIssues.length > 0 || addClickCount > 0 || shouldTriggerAiSuggestedIssues || whichChildPanelRenderTriggered || issueSearchTotalCount > 0;
    const loadingAllIssues = allIssues.length === 0 && issueSearchTotalCount > 0;
    const willHaveAnyIssues = allIssues.length > 0 || issueSearchTotalCount > 0;
    const childIssuesLimit = (0, $2gCtH.useChildIssuesLimit)();
    const approachingLimitCutOff = childIssuesLimit - 1;
    const startedBelowTheCutoff = !hasExceededChildIssuesLimitInitialLoad && initialTotalChildIssueCount.current < approachingLimitCutOff;
    const isNowAtTheCutoff = totalChildIssueCount === approachingLimitCutOff;
    const isApproachingLimit = startedBelowTheCutoff && isNowAtTheCutoff;
    const { shouldShowHideDoneInfoIcon: shouldShowHideDoneInfoIcon, completedIssuesCount: completedIssuesCount } = (0, $8ZsUM.useHideDoneChildIssues)(allIssues, incompleteIssues);
    const [{ currentStep: currentStep, channelId: channelId }, { resetIssueBreakdownState: resetIssueBreakdownState, isIssueBreakdownOpen: isIssueBreakdownOpen, setIssueBreakdownStep: setIssueBreakdownStep, setIsProactivelySuggestingIssues: setIsProactivelySuggestingIssues }] = (0, $1fz0b.useIssueBreakdown)();
    const isAIWBPanelLoaded = (0, $5uXOq.useRef)(false); // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        /*
    AIWB panel is async loaded
    - on hover of suggest subtasks option in suggest issues DD
    - on hover of suggest subtasks button in child issue panel
          - in AIWB button component (similar to below, manually triggering when AIWB step changes)
    proactive_aiwb_2 is redesigning the UI & AIWB button is removed from child panel, hence loading entrypoints here when a flow needs AIWB panel
    */ if (!isAIWBPanelLoaded.current && currentStep !== (0, $1fz0b.steps).defaultStep && (0, $6s1PB.expVal)('proactive_aiwb_2', 'enabled', false)) {
            entryPointActions.load();
            isAIWBPanelLoaded.current = true;
        }
    }, [
        entryPointActions,
        currentStep
    ]);
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const { fireTrack: fireTrack } = (0, $jyNU3.useAiWorkBreakDownAnalytics)({
        channelId: channelId,
        consumer: (0, $lqdvb.ISSUE_VIEW_CONSUMER)
    });
    const onAddChildClickWithAiBreakdownEnabled = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        if (isAiOptInEnabled) {
            if ((0, $6s1PB.expVal)('proactive_aiwb_2', 'enabled', false)) {
                setIsProactivelySuggestingIssues(shouldProactivelySuggestIssues);
                if (!isIssueBreakdownOpen()) {
                    setIssueBreakdownStep((0, $1fz0b.steps).draftListStep);
                    shouldProactivelySuggestIssues && fireTrack('aiInteraction initiated', 'proactiveFromQuickAddClick', {
                        invokedFrom: (0, $jyNU3.ISSUE_BREAKDOWN_PROACTIVE_CHILD_PANEL_ADD_ID),
                        proactiveAIGenerated: 1
                    });
                }
            } else resetIssueBreakdownState();
        }
        onAddChildClick && onAddChildClick(e, analyticsEvent);
    }, [
        fireTrack,
        isAiOptInEnabled,
        isIssueBreakdownOpen,
        onAddChildClick,
        resetIssueBreakdownState,
        setIsProactivelySuggestingIssues,
        setIssueBreakdownStep,
        shouldProactivelySuggestIssues
    ]);
    const ProgressSummaryWithHideDoneIconContainer = (0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) ? $be550185ca0355ef$var$ProgressSummaryWithHideDoneIconContainerCHIN : $be550185ca0355ef$var$ProgressSummaryWithHideDoneIconContainerOld;
    const renderIssues = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('improve_rendering_child_issues_summary_bar')) return null;
        const progressSummary = !hasExceededChildIssuesLimitInitialLoad && ((0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) ? true : allIssues.length >= $be550185ca0355ef$var$PROGRESS_SUMMARY_MIN_ISSUE_COUNT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProgressSummary, null) : null;
        const newChildIssues = ()=>loadingAllIssues && (0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cee7x.ChildIssuesPanelSkeletonNew), {
                rows: totalChildIssueCount,
                maxRows: (0, $38bVB.getChildIssuesLimit)()
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "issue-child-issues-table"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eLpT.AsyncConfigurableChildIssuesPanel), {
                columnPickerRef: columnPickerRef,
                parentIssueTypeId: parentIssueTypeId,
                projectId: projectId,
                filterSubtasks: filterSubtasks,
                rootRelayFragment: rootRelayFragment,
                totalChildIssueCount: totalChildIssueCount,
                isHideDoneFilterEnabled: isHideDoneFilterEnabled,
                sourceName: sourceName
            }));
        const childIssues = ()=>(0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) ? newChildIssues() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "issue-child-issues-list"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Issues, {
                hasExceededChildIssuesLimitOnLoadOrAfter: hasExceededChildIssuesLimitAfterLoad || hasExceededChildIssuesLimitInitialLoad
            }));
        return willHaveAnyIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProgressSummaryWithHideDoneIconContainer, null, progressSummary, shouldShowHideDoneInfoIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $GgZWv.HideDoneIconWithToolTip), {
            completedChildIssuesCount: completedIssuesCount
        })), childIssues()) : null; // Excluded ProgressSummary, projectKey, Issues, issueId as the component and analytic variable are not needed in the dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldShowHideDoneInfoIcon,
        completedIssuesCount,
        allIssues.length,
        projectId,
        parentIssueTypeId,
        incompleteIssues.length,
        hasExceededChildIssuesLimitInitialLoad,
        hasExceededChildIssuesLimitAfterLoad,
        filterSubtasks
    ]);
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    const isSubtaskCreateEnabled = (0, $8ZsUM.getIsSubtaskCreateEnabled)(childIssuesPanelType, issueHierarchyLevel);
    (0, $5uXOq.useEffect)(()=>subscribe?.((0, $5eGnF.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, async (payload)=>{
            if (payload.callbackPayload?.id !== (0, $38bVB.GIC_CALLBACK_PAYLOAD_INLINE_CREATE_ID)) return;
            const { createdIssueDetails: createdIssueDetails } = payload.createdIssueData;
            const callbackData = payload.callbackPayload?.data;
            if (callbackData.parentIssueKey !== parentIssueKey || callbackData.childIssuesPanelType !== childIssuesPanelType) return;
            if (isSubtaskCreateEnabled || (epicLinkFieldKey && createdIssueDetails.fields[epicLinkFieldKey]) === parentIssueKey || callbackData?.parentIssueKey === parentIssueKey) onFullDialogCreate(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            callbackData.optimisticId, (0, $2j7J7.default)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            createdIssueDetails, baseUrl), {
                sessionId: issueCreateSessionId
            });
        }), [
        subscribe,
        baseUrl,
        epicLinkFieldKey,
        onFullDialogCreate,
        parentIssueKey,
        childIssuesPanelType,
        isSubtaskCreateEnabled,
        issueCreateSessionId
    ]);
    const renderCreate = (0, $5uXOq.useMemo)(()=>{
        const isAiEnabledAndOpen = isAiOptInEnabled && isIssueBreakdownOpen(); // Create panel should not render if AI issue breakdown is open when proactive suggestions experiment is disabled
        // when enabled should render both inline create & AI issue breakdown
        if (isAiEnabledAndOpen && !(0, $6s1PB.expVal)('proactive_aiwb_2', 'enabled', false)) return;
        if (addClickCount > 0) switch(childPanelView){
            case (0, $dvqTC.CHILD_PANEL_VIEWS).InlineCreate:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InlineCreate, {
                    inputId: sourceName
                });
            case (0, $dvqTC.CHILD_PANEL_VIEWS).AddExistingIssue:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AddExistingIssue, null);
            default:
                return null;
        }
        return null; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        addClickCount,
        childPanelView,
        sourceName,
        currentStep,
        isIssueBreakdownOpen,
        shouldProactivelySuggestIssues
    ]);
    const childIssuesLimitExceededAnalyticsCount = (0, $kuVxL.getChildIssuesLimitExceededAnalyticsCount)(childIssuesLimit);
    const renderAIWorkBreakdown = (0, $5uXOq.useMemo)(()=>{
        if (childIssueTypes.length === 0) return null;
        const childIssueTypeWithWFValidator = childIssueTypes.map((issueType)=>({
                ...issueType,
                hasWorkflowValidators: issueTypeWithWorkflowValidators && issueTypeWithWorkflowValidators[issueType.id] || false
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fWnZD.AiIssueBreakdownEntryPointContainer), {
            onInit: onIssueBreakdownClick,
            onCreate: onSuggestedChildIssueCreateSuccess,
            childIssueTypes: childIssueTypeWithWFValidator,
            isSubTaskCreationOpen: isSubtaskCreateEnabled,
            issueHierarchyLevel: issueHierarchyLevel,
            onDiscard: resetWhichChildPanelRenderTriggered,
            projectId: projectId,
            issueKey: parentIssueKey || '',
            issueId: issueId,
            projectKey: projectKey,
            consumer: (0, $lqdvb.ISSUE_VIEW_CONSUMER)
        });
    }, [
        childIssueTypes,
        onIssueBreakdownClick,
        onSuggestedChildIssueCreateSuccess,
        isSubtaskCreateEnabled,
        issueHierarchyLevel,
        resetWhichChildPanelRenderTriggered,
        projectId,
        parentIssueKey,
        issueId,
        projectKey,
        issueTypeWithWorkflowValidators
    ]);
    if (!hasContent) return null;
    const shouldDisplayProgressSummary = !hasExceededChildIssuesLimitInitialLoad && ((0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) || allIssues.length >= $be550185ca0355ef$var$PROGRESS_SUMMARY_MIN_ISSUE_COUNT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            childCount: hasExceededChildIssuesLimitInitialLoad ? childIssuesLimitExceededAnalyticsCount : allIssues.length,
            isChildIssuesLimitPanelDisplayed: hasExceededChildIssuesLimitInitialLoad
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        actionSubjectId: sourceName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Heading, {
        columnPickerRef: columnPickerRef,
        onAddChildClick: onAddChildClickWithAiBreakdownEnabled,
        sourceName: sourceName,
        childIssuesLimitStatus: childIssuesLimitStatus,
        issueHierarchyLevel: issueHierarchyLevel,
        rootRelayFragment: rootRelayFragment,
        isHideDoneFilterEnabled: // Precondition needed as hide-rank-option-when-unavailable has the root relay fragment where we grab the value from
        // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $4R6GH.fg)('hide-rank-option-when-unavailable') && (0, $4R6GH.fg)('key-chin-hide-done-relay-migration') ? isHideDoneFilterEnabled : undefined,
        isRankingEnabled: (0, $4R6GH.fg)('hide-rank-option-when-unavailable') ? isRankingEnabled : undefined,
        hasMultipleChildPanels: hasMultipleChildPanels
    }), hasExceededChildIssuesLimitInitialLoad && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1iZLN.ChildIssuesLimitPanel), {
        hasExceededIssuesLimitInitialLoad: hasExceededChildIssuesLimitInitialLoad
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clEve.ChildIssuesLimitFlag), {
        isApproachingLimit: isApproachingLimit,
        childIssuesLimitStatus: childIssuesLimitStatus
    }), (0, $6s1PB.expVal)('proactive_aiwb_2', 'enabled', false) && renderAIWorkBreakdown, willHaveAnyIssues && (0, $4R6GH.fg)('improve_rendering_child_issues_summary_bar') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProgressSummaryWithHideDoneIconContainer, null, shouldDisplayProgressSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProgressSummary, null), shouldShowHideDoneInfoIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $GgZWv.HideDoneIconWithToolTip), {
        completedChildIssuesCount: completedIssuesCount
    })), (0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "issue-child-issues-table"
    }, loadingAllIssues && (0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cee7x.ChildIssuesPanelSkeletonNew), {
        rows: totalChildIssueCount,
        maxRows: (0, $38bVB.getChildIssuesLimit)()
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eLpT.AsyncConfigurableChildIssuesPanel), {
        columnPickerRef: columnPickerRef,
        parentIssueTypeId: parentIssueTypeId,
        projectId: projectId,
        filterSubtasks: filterSubtasks,
        rootRelayFragment: rootRelayFragment,
        totalChildIssueCount: totalChildIssueCount,
        isHideDoneFilterEnabled: isHideDoneFilterEnabled,
        sourceName: sourceName
    })), !(0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "issue-child-issues-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Issues, {
        hasExceededChildIssuesLimitOnLoadOrAfter: hasExceededChildIssuesLimitAfterLoad || hasExceededChildIssuesLimitInitialLoad
    }))), renderIssues, renderCreate && (0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $be550185ca0355ef$var$createChildIssueContainerStyles
    }, renderCreate) : renderCreate, !(0, $6s1PB.expVal)('proactive_aiwb_2', 'enabled', false) && renderAIWorkBreakdown);
};
const $be550185ca0355ef$var$ChildIssuesPanelBaseWithRanking = (props)=>{
    const { allIssues: allIssues, childIssuesPanelType: childIssuesPanelType, rootRelayFragment: rootRelayFragment } = props; // eslint-disable-next-line @atlassian/relay/query-restriction
    const data = (0, $8Uumt.useFragment)((0, $WIzu1.default), rootRelayFragment?.jira ?? null);
    const isTeamManagedProject = data?.issueByKey?.projectField?.project?.projectStyle === (0, $2vSU6.TEAM_MANAGED_PROJECT);
    const isHideDoneFilterEnabled = data?.userPreferences?.isIssueViewHideDoneChildIssuesFilterEnabled === true;
    const isRankingEnabled = // Issue ranking is only supported in CMP Subtasks and TMP Child Issues
    (childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS || isTeamManagedProject && childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CHILDREN_ISSUES_PANEL) && // Should have at least 2 issues
    allIssues.length > 1 && // All issues should be visible
    !isHideDoneFilterEnabled && // Rank field should be available
    data?.rankField?.jqlTerm != null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($be550185ca0355ef$var$ChildIssuesPanelBase, {
        ...props,
        isRankingEnabled: isRankingEnabled,
        isHideDoneFilterEnabled: isHideDoneFilterEnabled
    });
};
const $be550185ca0355ef$var$MaybeChildIssuesPanelBaseWithRanking = (0, $cSD7y.componentWithFG)('hide-rank-option-when-unavailable', $be550185ca0355ef$var$ChildIssuesPanelBaseWithRanking, $be550185ca0355ef$var$ChildIssuesPanelBase);
const $be550185ca0355ef$var$ChildIssuesPanelBaseWithFragment = (props)=>{
    // This will be addressed once we move this into its own package
    // eslint-disable-next-line @atlassian/relay/query-restriction
    const data = (0, $8Uumt.useFragment)((0, $aMON3.default), props.rootRelayFragment?.jira ?? null);
    const issues = data?.issueByKey?.childIssues?.__typename === (0, $5fc53.CHILDREN_WITHIN_LIMIT_GQL_FIELD) ? data.issueByKey.childIssues.issues : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($be550185ca0355ef$var$MaybeChildIssuesPanelBaseWithRanking, {
        ...props,
        ProgressSummary: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dv3Qk.ProgressSummary), {
                issues: issues ?? null,
                isClassicSubtaskPanel: props.childIssuesPanelType === (0, $kF1SN.CHILD_ISSUES_PANEL_TYPE).CLASSIC_SUBTASKS
            })
    });
};
const $be550185ca0355ef$var$MaybeChildIssuesPanelBaseWithFragment = (0, $cSD7y.componentWithFG)('issue-jiv-20335-relay-progress-summary', $be550185ca0355ef$var$ChildIssuesPanelBaseWithFragment, $be550185ca0355ef$var$MaybeChildIssuesPanelBaseWithRanking);
const $be550185ca0355ef$var$ChildIssuePanelWithProactiveParam = (props)=>{
    const shouldProactivelySuggestIssues = (0, $3N1Ka.useShouldProactivelySuggestIssues)(props.totalChildIssueCount);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($be550185ca0355ef$var$MaybeChildIssuesPanelBaseWithFragment, {
        ...props,
        shouldProactivelySuggestIssues: shouldProactivelySuggestIssues
    });
};
const $be550185ca0355ef$export$a5fa84d53408cd6b = (0, $cSD7y.componentWithFG)('proactive_aiwb_2_targeting_gate', $be550185ca0355ef$var$ChildIssuePanelWithProactiveParam, $be550185ca0355ef$var$MaybeChildIssuesPanelBaseWithFragment);
const $be550185ca0355ef$var$ChildIssuePanelBaseWithIssueSearchTotalCount = (props)=>{
    const data = // eslint-disable-next-line @atlassian/relay/query-restriction
    (0, $8Uumt.useFragment)((0, $eQmO7.default), props.rootRelayFragment?.jira ?? null);
    const issueSearchTotalCount = data?.issueSearch?.totalCount ?? 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($be550185ca0355ef$export$a5fa84d53408cd6b, {
        ...props,
        issueSearchTotalCount: issueSearchTotalCount
    });
};
const $be550185ca0355ef$export$402e0e6a7dd45ba5 = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false), $be550185ca0355ef$var$ChildIssuePanelBaseWithIssueSearchTotalCount, $be550185ca0355ef$export$a5fa84d53408cd6b); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $be550185ca0355ef$var$ProgressSummaryWithHideDoneIconContainerOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $be550185ca0355ef$var$ProgressSummaryWithHideDoneIconContainerCHIN = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _otyru2gc",
            __cmplp.className
        ])
    });
});
const $be550185ca0355ef$var$createChildIssueContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("eQmO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e76acbe1042b29c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<48f33c3add3d339e4155edd1f28928a7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e76acbe1042b29c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewssrperfm2isenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsInput"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        }
    ],
    "kind": "Fragment",
    "name": "view_issueViewCommonViews_ChildIssuePanelBaseWithIssueSearchTotalCount",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewssrperfm2isenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "fieldSetsInput",
                            "variableName": "fieldSetsInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        }
                    ],
                    "concreteType": "JiraIssueConnection",
                    "kind": "LinkedField",
                    "name": "issueSearch",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$3e76acbe1042b29c$var$node.hash = "92ce31907d90c1e455c66f400e4c574c";
var $3e76acbe1042b29c$export$2e2bcd8739ae039 = $3e76acbe1042b29c$var$node;

});

parcelRegister("aMON3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f643d38b47a254b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<85d6ee10ccc882fe19f04ceff57a316e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f643d38b47a254b6$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "issueKey"
        }
    ],
    "kind": "Fragment",
    "name": "view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "issueKey"
                }
            ],
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "childIssues",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "activeIssuesOnly",
                                            "value": true
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "activeProjectsOnly",
                                            "value": true
                                        }
                                    ],
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "progressSummary_issueViewChildIssuesPanel"
                                        }
                                    ],
                                    "storageKey": "issues(activeIssuesOnly:true,activeProjectsOnly:true)"
                                }
                            ],
                            "type": "JiraChildIssuesWithinLimit"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$f643d38b47a254b6$var$node.hash = "a2ad230914026793a63baafd396b249e";
var $f643d38b47a254b6$export$2e2bcd8739ae039 = $f643d38b47a254b6$var$node;

});

parcelRegister("WIzu1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f011f8501bd93891$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d3a5fe6c93b70a1210535f542d603176>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f011f8501bd93891$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = [
        v0 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "issueKey"
            }
        ],
        "kind": "Fragment",
        "name": "view_issueViewCommonViews_ChildIssuesPanelBaseWithRanking",
        "selections": [
            {
                "args": v1 /*: any*/ ,
                "concreteType": "JiraJqlFieldWithAliases",
                "kind": "LinkedField",
                "name": "rankField",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    }
                ]
            },
            {
                "args": v1 /*: any*/ ,
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isIssueViewHideDoneChildIssuesFilterEnabled"
                    }
                ]
            },
            {
                "args": [
                    v0 /*: any*/ ,
                    {
                        "kind": "Variable",
                        "name": "key",
                        "variableName": "issueKey"
                    }
                ],
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraProjectField",
                        "kind": "LinkedField",
                        "name": "projectField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "projectStyle"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$f011f8501bd93891$var$node.hash = "caed8b79fdc58a1873dc2f66e30b7335";
var $f011f8501bd93891$export$2e2bcd8739ae039 = $f011f8501bd93891$var$node;

});

parcelRegister("cee7x", function(module, exports) {

$parcel$export(module.exports, "MAX_ROWS", () => $20bdb40ed51435a4$export$29aaa579571d742c);
$parcel$export(module.exports, "ChildIssuesPanelSkeleton", () => $20bdb40ed51435a4$export$dec176b7f32dbec8);
$parcel$export(module.exports, "ChildIssuesPanelSkeletonNew", () => $20bdb40ed51435a4$export$a6b4ff5dc0f2a708);
/* ChildIssuesPanelSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $gPB4Q = parcelRequire("gPB4Q");

var $hL2Si = parcelRequire("hL2Si");
const $20bdb40ed51435a4$var$customCssStyles = null;
const $20bdb40ed51435a4$export$29aaa579571d742c = 10;
const $20bdb40ed51435a4$var$ROW_HEIGHT_EM = 2.86;
const $20bdb40ed51435a4$var$containerStyles = {
    height: '448px'
};
const $20bdb40ed51435a4$export$dec176b7f32dbec8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gPB4Q))),
        containerStyles: $20bdb40ed51435a4$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });
const $20bdb40ed51435a4$export$a6b4ff5dc0f2a708 = ({ rows: rows = $20bdb40ed51435a4$export$29aaa579571d742c, maxRows: maxRows = $20bdb40ed51435a4$export$29aaa579571d742c })=>{
    const height = $20bdb40ed51435a4$var$ROW_HEIGHT_EM + $20bdb40ed51435a4$var$ROW_HEIGHT_EM * Math.min(rows, maxRows); // Header plus max number of rows
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hL2Si))),
        containerStyles: {
            height: `${height}em`
        },
        testId: "skeletons.ui.child-issues-panel.components.child-issues-panel-skeleton",
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });
};

});
parcelRegister("gPB4Q", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.f74ea9a0.svg", import.meta.url).toString();

});

parcelRegister("hL2Si", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton-new.tpl.2bc4520f.svg", import.meta.url).toString();

});


parcelRegister("fWnZD", function(module, exports) {

$parcel$export(module.exports, "AiIssueBreakdownEntryPointContainer", () => $99e7c8aeb1e22f16$export$191ce15e25539c05);

var $5uXOq = parcelRequire("5uXOq");

var $euAs1 = parcelRequire("euAs1");

var $7XluA = parcelRequire("7XluA");
const $99e7c8aeb1e22f16$export$191ce15e25539c05 = ({ onInit: onInit, onCreate: onCreate, childIssueTypes: childIssueTypes, isSubTaskCreationOpen: isSubTaskCreationOpen, issueHierarchyLevel: issueHierarchyLevel, onDiscard: onDiscard, issueId: issueId, projectId: projectId, issueKey: issueKey, projectKey: projectKey, consumer: consumer })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $5uXOq.useContext)((0, $euAs1.AiIssueBreakdownEntryPointContext));
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onInit: onInit,
            onCreate: onCreate,
            childIssueTypes: childIssueTypes,
            isSubTaskCreationOpen: isSubTaskCreationOpen,
            issueHierarchyLevel: issueHierarchyLevel,
            onDiscard: onDiscard,
            issueId: issueId,
            issueKey: issueKey,
            projectId: projectId,
            projectKey: projectKey,
            consumer: consumer
        }), [
        onInit,
        onCreate,
        childIssueTypes,
        isSubTaskCreationOpen,
        issueHierarchyLevel,
        onDiscard,
        issueId,
        issueKey,
        projectId,
        projectKey,
        consumer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jiraAIWorkBreakdownEntryPointContainer",
        packageName: "jiraAIWorkBreakdown",
        teamName: "crocs",
        fallback: null,
        runtimeProps: runtimeProps
    });
};

});

parcelRegister("clEve", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesLimitFlag", () => $8ca59edfaa1bdf56$export$4fdf3bfcb198a412);

var $5uXOq = parcelRequire("5uXOq");

var $bU3PY = parcelRequire("bU3PY");

var $4R6GH = parcelRequire("4R6GH");

var $gOHSJ = parcelRequire("gOHSJ");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $eDXka = parcelRequire("eDXka");

var $54wEF = parcelRequire("54wEF");

var $eNNkf = parcelRequire("eNNkf");

var $38bVB = parcelRequire("38bVB");

var $fOGZN = parcelRequire("fOGZN");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $fvYyN = parcelRequire("fvYyN");

var $kpGtZ = parcelRequire("kpGtZ");

var $i57Qs = parcelRequire("i57Qs");

var $drsbe = parcelRequire("drsbe");
const $8ca59edfaa1bdf56$export$a7bb072605d6094c = 'issue.views.common.child-issues-panel.child-issues-limit-flag';
const $8ca59edfaa1bdf56$var$LEARN_MORE_LINK_TEST_ID = `${$8ca59edfaa1bdf56$export$a7bb072605d6094c}.learn-more-link`;
const $8ca59edfaa1bdf56$export$45f30691d690262e = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// @ts-expect-error - TS2322 - Type '((instance: ButtonLinkWithShortcutIconProps | null) => void) | MutableRefObject<ButtonLinkWithShortcutIconProps | null> | null' is not assignable to type '{ current: HTMLElement | null; } | ((arg1: HTMLElement | null) => unknown) | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i57Qs.ButtonLinkWithShortcutIcon), {
        ...props,
        innerRef: ref,
        testId: $8ca59edfaa1bdf56$var$LEARN_MORE_LINK_TEST_ID
    }));
const $8ca59edfaa1bdf56$export$5881677fb314e6d9 = (0, $7HGHK.toFlagId)('child-issues-limit-flag');
const $8ca59edfaa1bdf56$var$ANALYTICS_SOURCE_NAME = 'childIssuesLimitFlag';
const $8ca59edfaa1bdf56$export$4fdf3bfcb198a412 = ({ isApproachingLimit: isApproachingLimit = false, childIssuesLimitStatus: childIssuesLimitStatus })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const childIssuesLimitHelp = (0, $kpGtZ.useChildIssuesLimitHelp)();
    const { showFlag: showFlag, dismissFlag: dismissFlag, hasFlag: hasFlag } = (0, $pa9q9.useFlagsService)();
    const onLearnMoreLinkClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'learnMore');
        if (childIssuesLimitHelp.type === (0, $38bVB.IN_PRODUCT_HELP)) childIssuesLimitHelp.openInProductHelp();
    }, [
        childIssuesLimitHelp
    ]);
    // Ensure the flag is no longer displayed after the user dismisses it the first time
    const [isDismissed, { setValue: setValue }] = (0, $eNNkf.useUserPreferencesValue)((0, $eDXka.CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED));
    const onDismissed = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'close');
        setValue((0, $38bVB.DISMISSED));
        dismissFlag($8ca59edfaa1bdf56$export$5881677fb314e6d9);
    }, [
        dismissFlag,
        setValue
    ]);
    const issueKey = (0, $2gCtH.useIssueKey)();
    const [{ value: fieldConfig, loading: loading }] = (0, $54wEF.useFieldConfig)(issueKey, (0, $fOGZN.TIME_TRACKING));
    const hasTimetracking = Boolean(fieldConfig);
    const childIssuesLimit = (0, $2gCtH.useChildIssuesLimit)();
    const withTimeTrackingDescription = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $drsbe.default).withTimetrackingDescriptionIssueTermRefresh : (0, $drsbe.default).withTimetrackingDescription, {
        limit: childIssuesLimit
    });
    const withoutTimeTrackingDescription = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $drsbe.default).withoutTimetrackingDescriptionIssueTermRefresh : (0, $drsbe.default).withoutTimetrackingDescription, {
        limit: childIssuesLimit
    });
    const title = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $drsbe.default).titleIssueTermRefresh : (0, $drsbe.default).title, {
        limit: childIssuesLimit
    });
    const description = hasTimetracking ? withTimeTrackingDescription : withoutTimeTrackingDescription;
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && // isDismissed is null when users have not dismissed the onboarding
        // it will be set to `dismissed` when the user dismisses via the X button.
        isDismissed !== (0, $38bVB.DISMISSED) && !hasFlag?.($8ca59edfaa1bdf56$export$5881677fb314e6d9) && (isApproachingLimit || (0, $fvYyN.hasExceededIssuesLimitInitialLoad)(childIssuesLimitStatus))) showFlag({
            id: $8ca59edfaa1bdf56$export$5881677fb314e6d9,
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                    sourceName: $8ca59edfaa1bdf56$var$ANALYTICS_SOURCE_NAME,
                    sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
                    actionSubjectId: $8ca59edfaa1bdf56$var$ANALYTICS_SOURCE_NAME
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gOHSJ.JiraCommonFlag), {
                    messageId: "issue-view-common-views.child-issues-panel.child-issues-limit-flag.flag",
                    messageType: "transactional",
                    id: (0, $7HGHK.fromFlagId)($8ca59edfaa1bdf56$export$5881677fb314e6d9),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
                        color: "var(--ds-icon-warning, #E56910)",
                        LEGACY_primaryColor: "var(--ds-icon-warning, #E56910)",
                        label: ""
                    }),
                    title: title,
                    description: description,
                    onDismissed: (_, analyticsEvent)=>{
                        onDismissed(analyticsEvent);
                    },
                    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<HTMLElement & RefAttributes<ButtonLinkWithShortcutIconProps>>' is not assignable to type 'ComponentType<CustomThemeButtonProps> | undefined'.
                    linkComponent: $8ca59edfaa1bdf56$export$45f30691d690262e,
                    actions: [
                        {
                            content: formatMessage((0, $drsbe.default).learnMoreLink),
                            ...childIssuesLimitHelp.type === (0, $38bVB.HREF) ? {
                                href: childIssuesLimitHelp.href,
                                onClick: onLearnMoreLinkClick,
                                target: '_blank'
                            } : {
                                onClick: onLearnMoreLinkClick
                            }
                        }
                    ],
                    testId: $8ca59edfaa1bdf56$export$a7bb072605d6094c
                }))
        });
    }, [
        childIssuesLimitHelp.href,
        childIssuesLimitHelp.type,
        childIssuesLimitStatus,
        description,
        formatMessage,
        hasFlag,
        isApproachingLimit,
        isDismissed,
        loading,
        onDismissed,
        onLearnMoreLinkClick,
        showFlag,
        title
    ]);
    return null;
};
$8ca59edfaa1bdf56$export$4fdf3bfcb198a412.displayName = 'ChildIssuesLimitFlag';

});
parcelRegister("gOHSJ", function(module, exports) {

$parcel$export(module.exports, "JiraCommonFlag", () => $8f9a85e85178b852$export$1d9a3324fc0eb52);

var $5uXOq = parcelRequire("5uXOq");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $59YvY = parcelRequire("59YvY");

var $6TwEp = parcelRequire("6TwEp");
const $8f9a85e85178b852$export$1d9a3324fc0eb52 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $59YvY.ChoreographerCommonFlag), props);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6TwEp.default), rest);
};

});
parcelRegister("59YvY", function(module, exports) {

$parcel$export(module.exports, "ChoreographerCommonFlag", () => $3f981fa4d7c05e5a$export$ef12cdd486f28a7a);

var $cSWNW = parcelRequire("cSWNW");

var $6TwEp = parcelRequire("6TwEp");
const $3f981fa4d7c05e5a$export$ef12cdd486f28a7a = (0, $cSWNW.withChoreographedRender)((0, $6TwEp.default));

});
parcelRegister("6TwEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb99bb14be92466$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fWXJB = parcelRequire("fWXJB");
var $epfFv = parcelRequire("epfFv");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $6pLjz = parcelRequire("6pLjz");

var $7fDjk = parcelRequire("7fDjk");
const $ffb99bb14be92466$export$b020578ce674a70f = 'platform.ui.flags.common.ui.common-flag-v2';
// standard delay time in ms, added for SR users to announce the status flag
const $ffb99bb14be92466$var$ANNOUNCEMENT_DELAY = 2500;
/**
 * Renders a flag component with dynamic behavior, automatically choosing between auto-dismissing
 * and standard modes based on properties. It dynamically selects an appropriate icon and supports
 * internationalization and accessibility, making it versatile for various use cases.
 */ const $ffb99bb14be92466$var$CommonFlag = (props)=>{
    const { flagType: flagType, icon: icon, delayAnnouncement: delayAnnouncement = $ffb99bb14be92466$var$ANNOUNCEMENT_DELAY, isAutoDismiss: isAutoDismiss, ...flagProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const StyledIcon = flagProps.appearance ? (0, $6pLjz.boldIconMap)[flagType] : (0, $6pLjz.iconMap)[flagType];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ffb99bb14be92466$var$containerStyles,
        ...flagProps.testId && {
            'data-test-id': flagProps.testId
        }
    }, isAutoDismiss ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fWXJB.default), {
        testId: `${$ffb99bb14be92466$export$b020578ce674a70f}-auto-dismiss`,
        ...flagProps,
        delayAnnouncement: delayAnnouncement,
        icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledIcon, {
            label: formatMessage((0, $7fDjk.messages)[flagType])
        }) ?? null
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epfFv.default), {
        testId: $ffb99bb14be92466$export$b020578ce674a70f,
        ...flagProps,
        delayAnnouncement: delayAnnouncement,
        icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledIcon, {
            label: formatMessage((0, $7fDjk.messages)[flagType])
        }) ?? null
    }));
};
var $ffb99bb14be92466$export$2e2bcd8739ae039 = $ffb99bb14be92466$var$CommonFlag;
const $ffb99bb14be92466$var$containerStyles = (0, $8CUq3.xcss)({
    wordWrap: 'break-word'
});

});
parcelRegister("6pLjz", function(module, exports) {

$parcel$export(module.exports, "iconMap", () => $38acb16b2f8a5dd3$export$6d49a893c897b0cc);
$parcel$export(module.exports, "boldIconMap", () => $38acb16b2f8a5dd3$export$6c71c95b1e390472);

var $jEF9d = parcelRequire("jEF9d");
const $38acb16b2f8a5dd3$export$6d49a893c897b0cc = {
    error: (0, $jEF9d.IconError),
    success: (0, $jEF9d.IconSuccess),
    info: (0, $jEF9d.IconInfo),
    warning: (0, $jEF9d.IconWarning)
};
const $38acb16b2f8a5dd3$export$6c71c95b1e390472 = {
    error: (0, $jEF9d.BoldIconError),
    success: (0, $jEF9d.BoldIconSuccess),
    info: (0, $jEF9d.BoldIconInfo),
    warning: (0, $jEF9d.BoldIconWarning)
};

});
parcelRegister("jEF9d", function(module, exports) {

$parcel$export(module.exports, "IconError", () => $29d87fe42743cbe5$export$66493327321323ad);
$parcel$export(module.exports, "IconSuccess", () => $29d87fe42743cbe5$export$9cae035d1b6ae1dc);
$parcel$export(module.exports, "IconInfo", () => $29d87fe42743cbe5$export$340bfce9b4df026b);
$parcel$export(module.exports, "IconWarning", () => $29d87fe42743cbe5$export$5be70e40251e6f9b);
$parcel$export(module.exports, "BoldIconError", () => $29d87fe42743cbe5$export$4d6c0ef1e9e095ae);
$parcel$export(module.exports, "BoldIconSuccess", () => $29d87fe42743cbe5$export$23fdc8fccd51d997);
$parcel$export(module.exports, "BoldIconInfo", () => $29d87fe42743cbe5$export$4c05116eb19cc3aa);
$parcel$export(module.exports, "BoldIconWarning", () => $29d87fe42743cbe5$export$522238647b7d04fc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $c2i4s = parcelRequire("c2i4s");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $bU3PY = parcelRequire("bU3PY");
const $29d87fe42743cbe5$export$66493327321323ad = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-danger, #C9372C)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$9cae035d1b6ae1dc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-success, #22A06B)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$340bfce9b4df026b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-discovery, #8270DB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$5be70e40251e6f9b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($29d87fe42743cbe5$export$8f314e512d92575f, {
        iconColor: "var(--ds-icon-warning, #E56910)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        label: label
    }));
const $29d87fe42743cbe5$export$4d6c0ef1e9e095ae = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-danger, #C9372C)"
    });
const $29d87fe42743cbe5$export$23fdc8fccd51d997 = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-success, #22A06B)"
    });
const $29d87fe42743cbe5$export$4c05116eb19cc3aa = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-discovery, #8270DB)"
    });
const $29d87fe42743cbe5$export$522238647b7d04fc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        label: label,
        LEGACY_secondaryColor: "var(--ds-icon-warning, #E56910)"
    });
const $29d87fe42743cbe5$export$8f314e512d92575f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconColor: iconColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1weumv": (0, $lD23V.default)(__cmplp.iconColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1kah",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7fDjk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $de522aa55d5b135d$export$defe85febe8b728c);
// Should not remove this disabled-line and don't run eslint --fix for this file

var $7VHMR = parcelRequire("7VHMR");
const $de522aa55d5b135d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    error: {
        "id": "platform.flags.common.components.common-flag.error",
        "defaultMessage": "Error"
    },
    success: {
        "id": "platform.flags.common.components.common-flag.success",
        "defaultMessage": "Success"
    },
    info: {
        "id": "platform.flags.common.components.common-flag.info",
        "defaultMessage": "Information"
    },
    warning: {
        "id": "platform.flags.common.components.common-flag.warning",
        "defaultMessage": "Warning"
    }
});

});




parcelRegister("kpGtZ", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimitHelp", () => $0310a3a69d692067$export$78fc5e43e3c95b5);

var $5uXOq = parcelRequire("5uXOq");

var $5Zxxp = parcelRequire("5Zxxp");

var $2gCtH = parcelRequire("2gCtH");

var $38bVB = parcelRequire("38bVB");

var $93Yeu = parcelRequire("93Yeu");
const $0310a3a69d692067$export$78fc5e43e3c95b5 = ()=>{
    // What's going on here?
    // The `useHelpPanelLink` returns a function that is not currently wrapped in
    // a `useCallback` this causes unnecessary re-renders.
    // I have notified the team that owns it and have put this `useRef` workaround
    // in place for the time being.
    const openInProductHelp = (0, $5uXOq.useRef)((0, $5Zxxp.useHelpPanelLink)());
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const isModal = (0, $2gCtH.useIsModal)();
    const openInProductHelpCb = (0, $5uXOq.useCallback)(()=>{
        if (projectType !== undefined) openInProductHelp.current?.((0, $38bVB.IN_PRODUCT_HELP_ARTICLE_IDS)[projectType] || '');
    }, [
        openInProductHelp,
        projectType
    ]);
    const isInProductHelp = Boolean(projectType !== undefined && (0, $38bVB.IN_PRODUCT_HELP_ARTICLE_IDS)[projectType] && !isModal);
    if (!isInProductHelp) return {
        type: (0, $38bVB.HREF),
        href: (0, $38bVB.WHAT_ARE_ISSUE_TYPES_URL)
    };
    const articleId = projectType !== undefined && (0, $38bVB.IN_PRODUCT_HELP_ARTICLE_IDS)[projectType] ? (0, $38bVB.IN_PRODUCT_HELP_ARTICLE_IDS)[projectType] : '';
    return {
        type: (0, $38bVB.IN_PRODUCT_HELP),
        articleId: articleId,
        href: (0, $38bVB.WHAT_ARE_ISSUE_TYPES_URL),
        openInProductHelp: openInProductHelpCb
    };
};

});

parcelRegister("i57Qs", function(module, exports) {

$parcel$export(module.exports, "ButtonLinkWithShortcutIcon", () => $01dad238f1c60a44$export$f92a39b994ea74fd);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $7paD5 = parcelRequire("7paD5");
const $01dad238f1c60a44$export$f92a39b994ea74fd = ({ href: href, innerRef: innerRef, testId: testId, target: target, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        appearance: "link",
        href: href,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
        iconAfter: target === '_blank' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
            color: "currentColor",
            LEGACY_size: "small",
            label: "",
            testId: "issue-view-common-views.child-issues-panel.button-link-with-shortcut-icon"
        }) : null,
        target: target,
        testId: testId,
        interactionName: "auto-generated.jira-issue-view-common-views.child-issues-panel.view.button-link-with-shortcut-icon.button"
    });

});

parcelRegister("drsbe", function(module, exports) {

$parcel$export(module.exports, "default", () => $57e7e882662a921b$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $57e7e882662a921b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    titleOld: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.title",
        "defaultMessage": "Best practice: Limit child issues to 100"
    },
    withoutTimetrackingDescriptionOld: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.without-timetracking-description",
        "defaultMessage": "The issue view can only display up to 100 child issues. If you add more, you'll have to view them in search."
    },
    withTimetrackingDescriptionOld: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.with-timetracking-description",
        "defaultMessage": "The issue view can only display up to 100 child issues. If you add more, you'll have to view them in search and won't be able to include them in time tracking."
    },
    title: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.title-with-limit",
        "defaultMessage": "Best practice: Limit child issues to {limit}"
    },
    withoutTimetrackingDescription: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.without-timetracking-description-with-limit",
        "defaultMessage": "The issue view can only display up to {limit} child issues. If you add more, you'll have to view them in search."
    },
    withTimetrackingDescription: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.with-timetracking-description-with-limit",
        "defaultMessage": "The issue view can only display up to {limit} child issues. If you add more, you'll have to view them in search and won't be able to include them in time tracking."
    },
    learnMoreLink: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.learn-more-link",
        "defaultMessage": "Learn more"
    },
    titleOldIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.title-issue-term-refresh",
        "defaultMessage": "Best practice: Limit child work items to 100"
    },
    withoutTimetrackingDescriptionOldIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.without-timetracking-description-issue-term-refresh",
        "defaultMessage": "The work item can only display up to 100 child issues. If you add more, you'll have to view them in search."
    },
    withTimetrackingDescriptionOldIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.with-timetracking-description-issue-term-refresh",
        "defaultMessage": "The work item can only display up to 100 child issues. If you add more, you'll have to view them in search and won't be able to include them in time tracking."
    },
    titleIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.title-with-limit-issue-term-refresh",
        "defaultMessage": "Best practice: Limit child work items to {limit}"
    },
    withoutTimetrackingDescriptionIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.without-timetracking-description-with-limit-issue-term-refresh",
        "defaultMessage": "The work item can only display up to {limit} child work items. If you add more, you'll have to view them in search."
    },
    withTimetrackingDescriptionIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-flag.with-timetracking-description-with-limit-issue-term-refresh",
        "defaultMessage": "The work item can only display up to {limit} child work items. If you add more, you'll have to view them in search and won't be able to include them in time tracking."
    }
});

});


parcelRegister("1iZLN", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesLimitPanel", () => $5c6cd7f4e8531171$export$6bf3a50103fe3fac);

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $iQv12 = parcelRequire("iQv12");

var $8oe80 = parcelRequire("8oe80");

var $58aTF = parcelRequire("58aTF");

var $cLV3m = parcelRequire("cLV3m");
const $5c6cd7f4e8531171$export$6bf3a50103fe3fac = (0, $dRLCn.flowWithSafeComponent)((0, $8oe80.default)('item', {
    onBulkEditClicked: 'clicked'
}), (0, $iQv12.default)({
    // @ts-expect-error - TS7006 - Parameter 'issueCount' implicitly has an 'any' type.
    onBulkEditClicked: (issueCount)=>({
            name: 'bulkEdit',
            issueCount: issueCount
        })
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ baseUrl: string; childIssuesPanelType: ChildIssuesPanelType | null; parentKey: string | null; hideDone: boolean; allIssues: ChildIssue[]; incompleteIssues: ChildIssue[]; } & { ...; }, {}>' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof Props]: K extends "onBulkEditClicked" | "onViewInSearchClicked" | "onHideDoneClicked" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>, { ...; }>, ConnectedComponent<...>>'.
(0, $hxqfC.connect)((state, props)=>{
    // FIXME: JIV-17455 can be null
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const childIssuesPanelType = (0, $58aTF.getChildIssuesPanelType)(state);
    return {
        childIssuesPanelType: childIssuesPanelType,
        hasExceededIssuesLimitInitialLoad: props.hasExceededIssuesLimitInitialLoad,
        parentKey: (0, $58aTF.getParentKey)(state)
    };
}, {}))((0, $cLV3m.ChildIssuesLimitPanel));

});
parcelRegister("cLV3m", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesLimitPanel", () => $c3c7dc89c662ff68$export$6bf3a50103fe3fac);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $7zeVL = parcelRequire("7zeVL");

var $ousew = parcelRequire("ousew");

var $aWse0 = parcelRequire("aWse0");

var $2gCtH = parcelRequire("2gCtH");

var $54wEF = parcelRequire("54wEF");

var $38bVB = parcelRequire("38bVB");

var $kuVxL = parcelRequire("kuVxL");

var $fOGZN = parcelRequire("fOGZN");

var $8zOmE = parcelRequire("8zOmE");

var $93Yeu = parcelRequire("93Yeu");

var $lVJAU = parcelRequire("lVJAU");

var $dG70I = parcelRequire("dG70I");

var $kpGtZ = parcelRequire("kpGtZ");

var $i57Qs = parcelRequire("i57Qs");

var $LTrSl = parcelRequire("LTrSl");

var $5uJfx = parcelRequire("5uJfx");

var $7AQbf = parcelRequire("7AQbf");
const $c3c7dc89c662ff68$var$TEST_ID = 'issue.views.common.child-issues-panel.child-issues-limit-panel';
const $c3c7dc89c662ff68$var$LEARN_MORE_LINK_TEST_ID = `${$c3c7dc89c662ff68$var$TEST_ID}.learn-more-link`;
const $c3c7dc89c662ff68$export$a57d58e1d3aa81a7 = `${$c3c7dc89c662ff68$var$TEST_ID}.view-in-search-button`;
const $c3c7dc89c662ff68$export$c22142c0de832b0e = `${$c3c7dc89c662ff68$var$TEST_ID}.bulk-edit-button`;
const $c3c7dc89c662ff68$export$6bf3a50103fe3fac = ({ hasExceededIssuesLimitInitialLoad: hasExceededIssuesLimitInitialLoad, childIssuesPanelType: childIssuesPanelType, parentKey: parentKey, onBulkEditClicked: onBulkEditClicked })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const isModal = (0, $2gCtH.useIsModal)();
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, (0, $fOGZN.TIME_TRACKING));
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const isSimplifiedProject = (0, $93Yeu.useIsSimplifiedProject)(projectKey);
    const hasTimetracking = Boolean(fieldConfig);
    const childIssuesLimit = (0, $2gCtH.useChildIssuesLimit)();
    const visibleIssuesCount = (0, $kuVxL.getChildIssuesLimitExceededAnalyticsCount)(childIssuesLimit);
    const onInProductHelpLinkClicked = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'learnMoreAboutChildIssues', {
            issueCount: visibleIssuesCount
        });
    }, [
        visibleIssuesCount
    ]);
    const childIssuesLimitHelp = (0, $kpGtZ.useChildIssuesLimitHelp)();
    const [sortByValue] = (0, $LTrSl.useChildIssuesSortBy)();
    const bulkEditLink = (0, $5uJfx.generateBulkEditLink)(parentKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad, sortByValue || undefined);
    const onBulkEditClickedAnalytics = (0, $5uXOq.useCallback)((issueCount)=>(analyticsEvent)=>{
            onBulkEditClicked(issueCount, analyticsEvent);
        }, [
        onBulkEditClicked
    ]);
    const viewInSearchLink = (0, $5uXOq.useMemo)(()=>{
        // These values will never be missing when the FF is enabled, this check is to satisfy flow
        if (projectKey === undefined || projectType === undefined || isSimplifiedProject === undefined) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.child-issues-panel.child-issues-limit-panel', 'Missing project key, type, or isSimplified when generating search link');
            return '';
        }
        return (0, $dG70I.generateViewInSearchLink)(projectKey, projectType, isSimplifiedProject, issueKey, childIssuesPanelType, hasExceededIssuesLimitInitialLoad);
    }, [
        childIssuesPanelType,
        hasExceededIssuesLimitInitialLoad,
        isSimplifiedProject,
        issueKey,
        projectKey,
        projectType
    ]);
    const onViewInSearchClicked = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'viewInSearch', {
            issueCount: (0, $kuVxL.getChildIssuesLimitExceededAnalyticsCount)(childIssuesLimit)
        }); // Ignore cmd or ctrl clicks - allow user to open in new tab
        if (!event.metaKey && !event.ctrlKey) {
            event.preventDefault();
            push(viewInSearchLink);
        }
    }, [
        childIssuesLimit,
        push,
        viewInSearchLink
    ]);
    const oldFallbackComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i57Qs.ButtonLinkWithShortcutIcon), {
        href: childIssuesLimitHelp.href,
        onClick: onInProductHelpLinkClicked,
        target: "_blank",
        testId: $c3c7dc89c662ff68$var$LEARN_MORE_LINK_TEST_ID
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7AQbf.default).oldLearnMoreAboutChildIssuesLinkIssueTermRefresh : (0, $7AQbf.default).oldLearnMoreAboutChildIssuesLink));
    const newFallbackComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i57Qs.ButtonLinkWithShortcutIcon), {
        href: childIssuesLimitHelp.href,
        onClick: onInProductHelpLinkClicked,
        target: "_blank",
        testId: $c3c7dc89c662ff68$var$LEARN_MORE_LINK_TEST_ID
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7AQbf.default).learnMoreAboutChildIssuesLinkIssueTermRefresh : (0, $7AQbf.default).learnMoreAboutChildIssuesLink));
    const fallbackComponent = (0, $4R6GH.fg)('jiv-chin-child-issue-limit-panel-header-enablement') ? newFallbackComponent : oldFallbackComponent; // Child Issue Limit Panel Title
    const childIssuesLimitTitle = (0, $4R6GH.fg)('jiv-chin-child-issue-limit-panel-header-enablement') ? (0, $7AQbf.default).childIssuesLimitTitle : (0, $7AQbf.default).oldChildIssuesLimitTitle;
    const childIssuesLimitTitleRefresh = (0, $4R6GH.fg)('jiv-chin-child-issue-limit-panel-header-enablement') ? (0, $7AQbf.default).childIssuesLimitTitleIssueTermRefresh : (0, $7AQbf.default).oldChildIssuesLimitTitleIssueTermRefresh; // Old  Description with Time Tracking
    const oldWithTimetrackingChildIssuesLimitDescriptionMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7AQbf.default).oldWithTimetrackingChildIssuesLimitDescriptionIssueTermRefresh : (0, $7AQbf.default).oldWithTimetrackingChildIssuesLimitDescription; // Description with Time Tracking
    const withTimetrackingChildIssuesLimitDescriptionMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7AQbf.default).withTimetrackingChildIssuesLimitDescriptionIssueTermRefresh : (0, $7AQbf.default).withTimetrackingChildIssuesLimitDescription; // Old Description without Time Tracking
    const oldWithoutTimetrackingChildIssuesLimitDescriptionMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7AQbf.default).oldWithoutTimetrackingChildIssuesLimitDescriptionIssueTermRefresh : (0, $7AQbf.default).oldWithoutTimetrackingChildIssuesLimitDescription; // Description without Time Tracking
    const withoutTimetrackingChildIssuesLimitDescriptionMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7AQbf.default).withoutTimetrackingChildIssuesLimitDescriptionIssueTermRefresh : (0, $7AQbf.default).withoutTimetrackingChildIssuesLimitDescription; // Learn more about child issues link
    let oldLearnMoreAboutChildIssuesLinkMessage = (0, $7AQbf.default).oldLearnMoreAboutChildIssuesLink;
    let learnMoreAboutChildIssuesLinkMessage = (0, $7AQbf.default).learnMoreAboutChildIssuesLink;
    if ((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3')) {
        oldLearnMoreAboutChildIssuesLinkMessage = (0, $7AQbf.default).oldLearnMoreAboutChildIssuesLinkIssueTermRefresh;
        learnMoreAboutChildIssuesLinkMessage = (0, $7AQbf.default).learnMoreAboutChildIssuesLinkIssueTermRefresh;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3c7dc89c662ff68$var$ChildrenLimitPanelContainer, {
        "data-testid": $c3c7dc89c662ff68$var$TEST_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3c7dc89c662ff68$var$ImgContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c3c7dc89c662ff68$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7zeVL.default), {
        alt: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3c7dc89c662ff68$var$DescriptionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? childIssuesLimitTitleRefresh : childIssuesLimitTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3c7dc89c662ff68$var$LimitDescription, null, (0, $4R6GH.fg)('jiv-chin-child-issue-limit-panel-header-enablement') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...hasTimetracking ? withTimetrackingChildIssuesLimitDescriptionMessage : withoutTimetrackingChildIssuesLimitDescriptionMessage,
        values: {
            learnMoreLink: childIssuesLimitHelp.type === (0, $38bVB.IN_PRODUCT_HELP) && !isModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
                appearance: "link",
                spacing: "none",
                articleId: childIssuesLimitHelp.articleId,
                fallbackComponent: fallbackComponent,
                onClick: onInProductHelpLinkClicked,
                testId: $c3c7dc89c662ff68$var$LEARN_MORE_LINK_TEST_ID
            }, formatMessage(learnMoreAboutChildIssuesLinkMessage)) : fallbackComponent,
            limit: childIssuesLimit
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...hasTimetracking ? oldWithTimetrackingChildIssuesLimitDescriptionMessage : oldWithoutTimetrackingChildIssuesLimitDescriptionMessage,
        values: {
            learnMoreLink: childIssuesLimitHelp.type === (0, $38bVB.IN_PRODUCT_HELP) && !isModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
                appearance: "link",
                spacing: "none",
                articleId: childIssuesLimitHelp.articleId,
                fallbackComponent: fallbackComponent,
                onClick: onInProductHelpLinkClicked,
                testId: $c3c7dc89c662ff68$var$LEARN_MORE_LINK_TEST_ID
            }, formatMessage(oldLearnMoreAboutChildIssuesLinkMessage)) : fallbackComponent,
            limit: childIssuesLimit
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "default",
        href: viewInSearchLink,
        onClick: onViewInSearchClicked,
        testId: $c3c7dc89c662ff68$export$a57d58e1d3aa81a7,
        interactionName: "auto-generated.jira-issue-view-common-views.child-issues-panel.view.child-issues-limit-panel.button.view-in-search"
    }, formatMessage((0, $7AQbf.default).viewInSearchButton)), (0, $4R6GH.fg)('jiv-chin-child-issue-limit-panel-header-enablement') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "default",
        href: bulkEditLink,
        onClick: onBulkEditClickedAnalytics(visibleIssuesCount),
        testId: $c3c7dc89c662ff68$export$c22142c0de832b0e,
        interactionName: "auto-generated.jira-issue-view-common-views.child-issues-panel.view.child-issues-limit-panel.button.bulk-edit"
    }, formatMessage((0, $7AQbf.default).bulkEditButton)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3c7dc89c662ff68$var$ChildrenLimitPanelContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _16qszucj _1e0c1txw _4cvr1h6o _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _bfhkhp5a _19pkutpp _otyru2gc",
            __cmplp.className
        ])
    });
});
const $c3c7dc89c662ff68$var$imageWrapperStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${6.125 * (0, $gwIPs.gridSize)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${8 * (0, $gwIPs.gridSize)}px`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3c7dc89c662ff68$var$ImgContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _18u0pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3c7dc89c662ff68$var$DescriptionContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jl1406 _1o9zkb7n _i0dlf1ug _19pkpxbi _2hwxpxbi _otyrpxbi _18u0pxbi _1nmz1hna",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3c7dc89c662ff68$var$LimitDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ect41gqc _19pku2gc _2hwxidpf _otyru2gc _18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7zeVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bfb7f48a24de9dd$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = gg9cjt4rjv6mhqjhkm7h7r9
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/gg9cjt4rjv6mhqjhkm7h7r9

var $dCLgq = parcelRequire("dCLgq");

var $5fwlr = parcelRequire("5fwlr");

var $8LQX9 = parcelRequire("8LQX9");
const $4bfb7f48a24de9dd$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8LQX9)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($5fwlr))
});
var $4bfb7f48a24de9dd$export$2e2bcd8739ae039 = $4bfb7f48a24de9dd$var$Illustration;
// for advanced use only
const $4bfb7f48a24de9dd$export$a179c88182cb9d56 = [
    0,
    0,
    203,
    214
];

});
parcelRegister("5fwlr", function(module, exports) {
module.exports = new URL("file-cabinet-open-darkmode.74362355.svg", import.meta.url).toString();

});

parcelRegister("8LQX9", function(module, exports) {
module.exports = new URL("file-cabinet-open.8ad490de.svg", import.meta.url).toString();

});


parcelRegister("7AQbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a73897fd0a4f553$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $2a73897fd0a4f553$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    // Child Issue Limit Panel Title
    oldChildIssuesLimitTitle: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.child-issues-limit-title-with-header-icons",
        "defaultMessage": "View child issues in search"
    },
    childIssuesLimitTitle: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.child-issues-limit-title",
        "defaultMessage": "View child issues using search"
    },
    oldChildIssuesLimitTitleIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.child-issues-limit-title-issue-term-refresh-with-header-icons",
        "defaultMessage": "View child work items in search"
    },
    childIssuesLimitTitleIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.child-issues-limit-title-issue-term-refresh",
        "defaultMessage": "View child work items using search"
    },
    // Description with Time Tracking
    oldWithTimetrackingChildIssuesLimitDescription: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.with-timetracking-child-issues-limit-description-with-limit-with-header-icons",
        "defaultMessage": "The issue view can only display up to {limit} child issues. You can still add and bulk edit them from here, but you'll have to view them in search and won't be able to include them in time tracking. {learnMoreLink}"
    },
    withTimetrackingChildIssuesLimitDescription: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.with-timetracking-child-issues-limit-description-with-limit",
        "defaultMessage": "Issues only display up to {limit} {learnMoreLink}. You can see them all using View in search (they won\u2019t be included in time tracking)."
    },
    oldWithTimetrackingChildIssuesLimitDescriptionIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.with-timetracking-child-issues-limit-description-with-limit-issue-term-refresh-with-header-icons",
        "defaultMessage": "The work item can only display up to {limit} child work items. You can still add and bulk edit them from here, but you'll have to view them in search and won't be able to include them in time tracking. {learnMoreLink}"
    },
    withTimetrackingChildIssuesLimitDescriptionIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.with-timetracking-child-issues-limit-description-with-limit-issue-term-refresh",
        "defaultMessage": "Work items only display up to {limit} {learnMoreLink}. You can see them all using View in search (they won\u2019t be included in time tracking)."
    },
    // Description without Time Tracking
    oldWithoutTimetrackingChildIssuesLimitDescription: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.without-timetracking-child-issues-limit-description-with-limit-with-header-icons",
        "defaultMessage": "The issue view can only display up to {limit} child issues. You can still add and bulk edit them from here, but you'll have to view them in search. {learnMoreLink}"
    },
    withoutTimetrackingChildIssuesLimitDescription: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.without-timetracking-child-issues-limit-description-with-limit",
        "defaultMessage": "Issues only display up to {limit} {learnMoreLink}. You can see them all using View in search."
    },
    oldWithoutTimetrackingChildIssuesLimitDescriptionIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.without-timetracking-child-issues-limit-description-with-limit-issue-term-refresh-with-header-icons",
        "defaultMessage": "The work item can only display up to {limit} child work item. You can still add and bulk edit them from here, but you'll have to view them in search. {learnMoreLink}"
    },
    withoutTimetrackingChildIssuesLimitDescriptionIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.without-timetracking-child-issues-limit-description-with-limit-issue-term-refresh",
        "defaultMessage": "Work items only display up to {limit} {learnMoreLink}. You can see them all using View in search."
    },
    // Learn more about child issues link
    oldLearnMoreAboutChildIssuesLink: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.learn-more-about-child-issues-link-with-header-icons",
        "defaultMessage": "Learn more about child issues"
    },
    learnMoreAboutChildIssuesLink: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.learn-more-about-child-issues-link",
        "defaultMessage": "child issues"
    },
    oldLearnMoreAboutChildIssuesLinkIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.learn-more-about-child-issues-link-issue-term-refresh-with-header-icons",
        "defaultMessage": "Find out more about child work items"
    },
    learnMoreAboutChildIssuesLinkIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.learn-more-about-child-issues-link-issue-term-refresh",
        "defaultMessage": "child work items"
    },
    // View in Seach Button
    viewInSearchButton: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.view-in-search-button",
        "defaultMessage": "View in search"
    },
    bulkEditButton: {
        "id": "issue.views.common.child-issues-panel.child-issues-limit-panel.bulk-edit-button",
        "defaultMessage": "Bulk edit"
    }
});

});



parcelRegister("1eLpT", function(module, exports) {

$parcel$export(module.exports, "AsyncConfigurableChildIssuesPanel", () => $9f414b9754c580ac$export$1eb15fc0dcb31b66);

var $i1xSm = parcelRequire("i1xSm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $hYRTO = parcelRequire("hYRTO");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7CMCs = parcelRequire("7CMCs");

var $cSD7y = parcelRequire("cSD7y");

var $2gCtH = parcelRequire("2gCtH");

var $czfFt = parcelRequire("czfFt");

var $cee7x = parcelRequire("cee7x");

var $koeKL = parcelRequire("koeKL");

var $kxZPA = parcelRequire("kxZPA");

var $38bVB = parcelRequire("38bVB");

var $6s1PB = parcelRequire("6s1PB");

var $kF1SN = parcelRequire("kF1SN");

var $cm5lq = parcelRequire("cm5lq");

var $aBLlP = parcelRequire("aBLlP");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9f414b9754c580ac$var$LazyConfigurableChildIssuesPanel = (0, $kxZPA.lazy)(()=>(parcelRequire("jHuXJ")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view-common-views/src/child-issues-panel/view/configurable-child-issues-panel/src/ui/index.tsx"
});
const $9f414b9754c580ac$var$Skeleton = (0, $cSD7y.componentWithFG)('jira-issue-view-child-issues-panel-skeleton', (0, $cee7x.ChildIssuesPanelSkeletonNew), (0, $cee7x.ChildIssuesPanelSkeleton));
const $9f414b9754c580ac$var$AsyncConfigurableChildIssuesPanelUsingLazy = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AsyncConfigurableChildIssuesPanel",
        packageName: "jiraIssueViewCommonViews",
        teamName: "bento",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "ConfigurableChildIssuesPanel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f414b9754c580ac$var$Skeleton, {
            rows: props.totalChildIssueCount,
            maxRows: (0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false) ? (0, $38bVB.getChildIssuesLimit)() : (0, $cee7x.MAX_ROWS)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f414b9754c580ac$var$LazyConfigurableChildIssuesPanel, props)));
};
const $9f414b9754c580ac$var$useConfigurableChildIssuesPanelEntryPoint = ({ filterSubtasks: filterSubtasks, hideDone: hideDone, rankFieldJql: rankFieldJql })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            variables: (0, $aBLlP.createConfigurableChildIssuesPanelQueryVariables)({
                cloudId: cloudId,
                jql: (0, $aBLlP.JQLBuilder)({
                    issueKey: issueKey,
                    filterSubtasks: filterSubtasks,
                    hideDone: hideDone ? 'true' : null,
                    sortColumn: rankFieldJql,
                    sortDirection: (0, $czfFt.SORT_ASC)
                }),
                fieldSetIds: [],
                issueKey: issueKey
            })
        }), [
        cloudId,
        filterSubtasks,
        hideDone,
        issueKey,
        rankFieldJql
    ]);
    const hasLoadedEntrypoint = (0, $5uXOq.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $cm5lq.configurableChildIssuesPanelEntryPoint), entryPointParams);
    if (!hasLoadedEntrypoint.current) {
        entryPointActions.load();
        hasLoadedEntrypoint.current = true;
    }
    return {
        entryPointReferenceSubject: entryPointReferenceSubject
    };
};
const $9f414b9754c580ac$var$AsyncConfigurableChildIssuesPanelUsingEntryPoint = ({ columnPickerRef: columnPickerRef, projectId: projectId, parentIssueTypeId: parentIssueTypeId, filterSubtasks: filterSubtasks, rootRelayFragment: rootRelayFragment, sourceName: sourceName, totalChildIssueCount: totalChildIssueCount })=>{
    const data = (0, $8Uumt.useFragment)((0, $i1xSm.default), rootRelayFragment?.jira ?? null);
    const rankFieldJql = data?.rankField?.jqlTerm || (0, $kF1SN.SORT_OPTION).CREATED;
    const isHideDoneFilterEnabled = Boolean(data?.userPreferences?.isIssueViewHideDoneChildIssuesFilterEnabled);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            columnPickerRef: columnPickerRef,
            filterSubtasks: filterSubtasks,
            projectId: projectId,
            parentIssueTypeId: parentIssueTypeId,
            rankFieldJql: rankFieldJql,
            rootRelayFragment: rootRelayFragment,
            isHideDoneFilterEnabled: isHideDoneFilterEnabled,
            sourceName: sourceName
        }), [
        columnPickerRef,
        filterSubtasks,
        projectId,
        parentIssueTypeId,
        rankFieldJql,
        rootRelayFragment,
        isHideDoneFilterEnabled,
        sourceName
    ]);
    const { entryPointReferenceSubject: entryPointReferenceSubject } = $9f414b9754c580ac$var$useConfigurableChildIssuesPanelEntryPoint({
        filterSubtasks: filterSubtasks,
        rankFieldJql: rankFieldJql,
        hideDone: isHideDoneFilterEnabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "AsyncConfigurableChildIssuesPanel",
        packageName: "jiraIssueViewCommonViews",
        teamName: "bento",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f414b9754c580ac$var$Skeleton, {
            rows: totalChildIssueCount,
            maxRows: (0, $6s1PB.expVal)('issue_view_ssr_perf_m2', 'isEnabled', false) ? (0, $38bVB.getChildIssuesLimit)() : (0, $cee7x.MAX_ROWS)
        }),
        runtimeProps: runtimeProps
    });
};
const $9f414b9754c580ac$export$1eb15fc0dcb31b66 = (0, $cSD7y.componentWithFG)('jira-issue-view-child-issues-panel-entrypoint', $9f414b9754c580ac$var$AsyncConfigurableChildIssuesPanelUsingEntryPoint, $9f414b9754c580ac$var$AsyncConfigurableChildIssuesPanelUsingLazy);

});
parcelRegister("i1xSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $274ad3024a4c1648$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d562f1c657a122a87b7df4a14d511876>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $274ad3024a4c1648$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "async_issueViewCommonViews_AsyncConfigurableChildIssuesPanelUsingEntryPoint",
        "selections": [
            {
                "args": v0 /*: any*/ ,
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isIssueViewHideDoneChildIssuesFilterEnabled"
                    }
                ]
            },
            {
                "args": v0 /*: any*/ ,
                "concreteType": "JiraJqlFieldWithAliases",
                "kind": "LinkedField",
                "name": "rankField",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$274ad3024a4c1648$var$node.hash = "4fa20f3c6f4db2528a3ff03b38d3501a";
var $274ad3024a4c1648$export$2e2bcd8739ae039 = $274ad3024a4c1648$var$node;

});

parcelRegister("czfFt", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $7f8ee02f08da8eac$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SORT_ASC", () => $7f8ee02f08da8eac$export$88956207daf9a17e);
$parcel$export(module.exports, "SORT_DESC", () => $7f8ee02f08da8eac$export$bc14f97913aaf2a);
$parcel$export(module.exports, "SORT_NONE", () => $7f8ee02f08da8eac$export$9c424bf3e8ffe64e);
$parcel$export(module.exports, "MODIFY_COLUMNS", () => $7f8ee02f08da8eac$export$1f921c78ce6d243c);
$parcel$export(module.exports, "REORDER_COLUMNS", () => $7f8ee02f08da8eac$export$83371d6c41a974aa);
$parcel$export(module.exports, "RESTORE_COLUMNS", () => $7f8ee02f08da8eac$export$3bfe53b79fc4f6ed);
$parcel$export(module.exports, "MOVE_COLUMN_FIRST", () => $7f8ee02f08da8eac$export$957d455bb65919d8);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT", () => $7f8ee02f08da8eac$export$2082861c970802b0);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT", () => $7f8ee02f08da8eac$export$21847d308b0769ad);
$parcel$export(module.exports, "MOVE_COLUMN_LAST", () => $7f8ee02f08da8eac$export$c32913bc261af82d);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $7f8ee02f08da8eac$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "ROW_HEIGHT", () => $7f8ee02f08da8eac$export$88e6c5bab2ff80e8);
$parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", () => $7f8ee02f08da8eac$export$de4c02b525d877fa);
$parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", () => $7f8ee02f08da8eac$export$c3266da279aa6b84);
$parcel$export(module.exports, "COLUMN_ID_CHECKBOX", () => $7f8ee02f08da8eac$export$66b2a4a5f67468ac);
$parcel$export(module.exports, "COLUMN_ID_INTERNAL_COLUMN", () => $7f8ee02f08da8eac$export$b4e9105b7f5f1b0f);
$parcel$export(module.exports, "ACTION_COLUMNS", () => $7f8ee02f08da8eac$export$3dbdc5c16825be4d);
$parcel$export(module.exports, "EXPAND_BUTTON_WIDTH", () => $7f8ee02f08da8eac$export$a1c171a82c45d53f);
$parcel$export(module.exports, "CREATE_CHILD_BUTTON_WIDTH", () => $7f8ee02f08da8eac$export$43ff8c492b8a2e1b);
$parcel$export(module.exports, "EXPAND_CELL_PADDING", () => $7f8ee02f08da8eac$export$9c5dd6078b37aac2);
$parcel$export(module.exports, "DEPTH_WIDTH", () => $7f8ee02f08da8eac$export$a8273d7d48e89fce);
$parcel$export(module.exports, "MAX_COLUMNS", () => $7f8ee02f08da8eac$export$7ec4af037f372df4);
$parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", () => $7f8ee02f08da8eac$export$d2372dfbd4e91a11);
$parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", () => $7f8ee02f08da8eac$export$1adf7afff96bbf16);
$parcel$export(module.exports, "COLUMN_TYPE_DATE_PICKER", () => $7f8ee02f08da8eac$export$c1d348661674e922);
$parcel$export(module.exports, "COLUMN_TYPE_SATISFACTION_FEEDBACK", () => $7f8ee02f08da8eac$export$67082d449d5ec91);
$parcel$export(module.exports, "COLUMN_TYPE_SENTIMENT", () => $7f8ee02f08da8eac$export$145a4a20f394acf9);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH_COMPACT", () => $7f8ee02f08da8eac$export$10016003aa27fa67);
$parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$5575b9e0ed3ff59f);
$parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$7c3f559e2ca95fa);
$parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$e1a42c2fefb5af25);
$parcel$export(module.exports, "MINIMUM_DATETIME_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$a194aa0e243a27f9);
$parcel$export(module.exports, "MINIMUM_MULTI_USER_SELECT_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$87a3548b97ce2540);
$parcel$export(module.exports, "MINIMUM_CONFLUENCE_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$d182a35496b19fb4);
$parcel$export(module.exports, "MINIMUM_DATEPICKER_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$4fd6711c21931f5b);
$parcel$export(module.exports, "MINIMUM_SATISFACTION_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$9b72110b9a7c0a39);
$parcel$export(module.exports, "MINIMUM_SENTIMENT_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$54c15048528650a8);
$parcel$export(module.exports, "MINIMUM_GOALS_COLUMN_WIDTH", () => $7f8ee02f08da8eac$export$7ed05c26fe24a805);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", () => $7f8ee02f08da8eac$export$bfe09a9186b98f8f);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", () => $7f8ee02f08da8eac$export$f2540f34b796306d);
$parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", () => $7f8ee02f08da8eac$export$954afb0fcf5a326);
$parcel$export(module.exports, "COLUMN_OPERATION_REORDER", () => $7f8ee02f08da8eac$export$93758649595b2d58);
$parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", () => $7f8ee02f08da8eac$export$cad8c6a0b6e78898);
$parcel$export(module.exports, "INSERT_COLUMN_BUTTON_Y_OFFSET", () => $7f8ee02f08da8eac$export$5252387dc65db584);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", () => $7f8ee02f08da8eac$export$754b76ac8fa63350);
$parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", () => $7f8ee02f08da8eac$export$fa5c7dad7ee16383);
$parcel$export(module.exports, "ROW_OPERATION_REORDER", () => $7f8ee02f08da8eac$export$4e8abe16cd1126dd);
$parcel$export(module.exports, "DENSITY_COMPACT", () => $7f8ee02f08da8eac$export$6c0a5a77457ca62);
$parcel$export(module.exports, "DENSITY_FULL", () => $7f8ee02f08da8eac$export$119d8ab9a5bc4b2);
$parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", () => $7f8ee02f08da8eac$export$9ef77944c441ad07);
$parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", () => $7f8ee02f08da8eac$export$c1f680390b97c9e1);
$parcel$export(module.exports, "CHILD_ITEMS_EXPERIENCE", () => $7f8ee02f08da8eac$export$e03155205bf92428);
$parcel$export(module.exports, "CHILD_ITEMS_LOAD_MORE_EXPERIENCE", () => $7f8ee02f08da8eac$export$311c64c0d94dcdf3);
$parcel$export(module.exports, "GROUPED_ITEMS_EXPERIENCE", () => $7f8ee02f08da8eac$export$f5d215df3c6473e9);
$parcel$export(module.exports, "GROUPED_LOAD_MORE_EXPERIENCE", () => $7f8ee02f08da8eac$export$b4fd503bf7cccacd);
$parcel$export(module.exports, "INLINE_ISSUE_CREATE_EXPERIENCE", () => $7f8ee02f08da8eac$export$70f80a241e016093);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $7f8ee02f08da8eac$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "MAKE_CHILD", () => $7f8ee02f08da8eac$export$5eb61e3ff74a4f58);
$parcel$export(module.exports, "REORDER_ABOVE", () => $7f8ee02f08da8eac$export$9213b5774112217f);
$parcel$export(module.exports, "REORDER_BELOW", () => $7f8ee02f08da8eac$export$118b06a03e2c672f);
$parcel$export(module.exports, "SUBTASK_HIERARCHY_LEVEL", () => $7f8ee02f08da8eac$export$5b388ccfa29be01);
$parcel$export(module.exports, "COLUMN_PICKER_CONFIGURATION_CONTAINER", () => $7f8ee02f08da8eac$export$f6d7582f33b86010);
$parcel$export(module.exports, "COLUMN_PICKER_ADD_COLUMN_CONTAINER", () => $7f8ee02f08da8eac$export$f92486d03c064eac);
$parcel$export(module.exports, "MAX_LINE_WRAP_OLD", () => $7f8ee02f08da8eac$export$139bffb2a576e8c0);
$parcel$export(module.exports, "MAX_LINE_WRAP_NEW", () => $7f8ee02f08da8eac$export$3b696b0ac06c2cc4);
$parcel$export(module.exports, "HIGHLIGHT_LINGER_DURATION_MS", () => $7f8ee02f08da8eac$export$6ba5aaedfd1b5319);
$parcel$export(module.exports, "SORT_A_TO_Z", () => $7f8ee02f08da8eac$export$1bc2edb2aa5e8282);
$parcel$export(module.exports, "SORT_Z_TO_A", () => $7f8ee02f08da8eac$export$c7b524b6c48f8273);
$parcel$export(module.exports, "SORT_LOWEST_TO_HIGHEST", () => $7f8ee02f08da8eac$export$9c60c93d5e95e80f);
$parcel$export(module.exports, "SORT_HIGHEST_TO_LOWEST", () => $7f8ee02f08da8eac$export$476f4bdd6eba4fb2);
$parcel$export(module.exports, "SORT_OLDEST_TO_NEWEST", () => $7f8ee02f08da8eac$export$fbcac9f513cf13f4);
$parcel$export(module.exports, "SORT_NEWEST_TO_OLDEST", () => $7f8ee02f08da8eac$export$d3c0241ce8ae9a73);
const $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
const $7f8ee02f08da8eac$export$d57b6b390e78d90f = 'empanada';
const $7f8ee02f08da8eac$export$88956207daf9a17e = 'ASC';
const $7f8ee02f08da8eac$export$bc14f97913aaf2a = 'DESC';
const $7f8ee02f08da8eac$export$9c424bf3e8ffe64e = 'NONE';
const $7f8ee02f08da8eac$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
const $7f8ee02f08da8eac$export$83371d6c41a974aa = 'REORDER_COLUMNS';
const $7f8ee02f08da8eac$export$3bfe53b79fc4f6ed = 'RESTORE_COLUMNS';
const $7f8ee02f08da8eac$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
const $7f8ee02f08da8eac$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
const $7f8ee02f08da8eac$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
const $7f8ee02f08da8eac$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
const $7f8ee02f08da8eac$export$e2bd4c1faded7921 = '1px';
const $7f8ee02f08da8eac$export$cdb7fd9d999c7168 = 40;
const $7f8ee02f08da8eac$export$88e6c5bab2ff80e8 = 40;
const $7f8ee02f08da8eac$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $7f8ee02f08da8eac$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $7f8ee02f08da8eac$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
const $7f8ee02f08da8eac$export$b4e9105b7f5f1b0f = '__issuetable_internal';
const $7f8ee02f08da8eac$export$3dbdc5c16825be4d = [
    $7f8ee02f08da8eac$export$c3266da279aa6b84,
    $7f8ee02f08da8eac$export$de4c02b525d877fa,
    $7f8ee02f08da8eac$export$66b2a4a5f67468ac
];
const $7f8ee02f08da8eac$export$a1c171a82c45d53f = 24;
const $7f8ee02f08da8eac$export$43ff8c492b8a2e1b = 24;
const $7f8ee02f08da8eac$export$9c5dd6078b37aac2 = 16;
const $7f8ee02f08da8eac$export$a8273d7d48e89fce = 24;
const $7f8ee02f08da8eac$export$7ec4af037f372df4 = 500;
const $7f8ee02f08da8eac$export$d2372dfbd4e91a11 = 50;
const $7f8ee02f08da8eac$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $7f8ee02f08da8eac$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
const $7f8ee02f08da8eac$export$c1d348661674e922 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $7f8ee02f08da8eac$export$67082d449d5ec91 = 'com.atlassian.servicedesk:sd-request-feedback';
const $7f8ee02f08da8eac$export$145a4a20f394acf9 = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $7f8ee02f08da8eac$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
const $7f8ee02f08da8eac$export$10016003aa27fa67 = 40; // 2 x 8px cell padding + 24px icon size
const $7f8ee02f08da8eac$export$5575b9e0ed3ff59f = 69; // 2 x 8px cell padding + 2 x 24px icon size + 4px gap + 1px border
const $7f8ee02f08da8eac$export$7c3f559e2ca95fa = 170;
const $7f8ee02f08da8eac$export$e1a42c2fefb5af25 = 999;
const $7f8ee02f08da8eac$export$a194aa0e243a27f9 = 148;
const $7f8ee02f08da8eac$export$87a3548b97ce2540 = 136;
const $7f8ee02f08da8eac$export$d182a35496b19fb4 = 112;
const $7f8ee02f08da8eac$export$4fd6711c21931f5b = 110;
const $7f8ee02f08da8eac$export$9b72110b9a7c0a39 = 102;
const $7f8ee02f08da8eac$export$54c15048528650a8 = 84;
const $7f8ee02f08da8eac$export$7ed05c26fe24a805 = 200;
const $7f8ee02f08da8eac$export$bfe09a9186b98f8f = 400;
const $7f8ee02f08da8eac$export$f2540f34b796306d = 300;
const $7f8ee02f08da8eac$export$954afb0fcf5a326 = 450;
const $7f8ee02f08da8eac$export$93758649595b2d58 = 'reorder';
const $7f8ee02f08da8eac$export$cad8c6a0b6e78898 = 'resize';
const $7f8ee02f08da8eac$export$5252387dc65db584 = -16;
const $7f8ee02f08da8eac$export$754b76ac8fa63350 = 'FULL_HEIGHT';
const $7f8ee02f08da8eac$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
const $7f8ee02f08da8eac$export$4e8abe16cd1126dd = 'rowReorder';
const $7f8ee02f08da8eac$export$6c0a5a77457ca62 = 'COMPACT';
const $7f8ee02f08da8eac$export$119d8ab9a5bc4b2 = 'FULL';
const $7f8ee02f08da8eac$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
const $7f8ee02f08da8eac$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';
const $7f8ee02f08da8eac$export$e03155205bf92428 = 'loadChildItems';
const $7f8ee02f08da8eac$export$311c64c0d94dcdf3 = 'loadMoreChildItems';
const $7f8ee02f08da8eac$export$f5d215df3c6473e9 = 'loadGroupChildren';
const $7f8ee02f08da8eac$export$b4fd503bf7cccacd = 'loadMoreGroupedItems';
const $7f8ee02f08da8eac$export$70f80a241e016093 = 'createIssue';
const $7f8ee02f08da8eac$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $7f8ee02f08da8eac$export$5eb61e3ff74a4f58 = 'make-child';
const $7f8ee02f08da8eac$export$9213b5774112217f = 'reorder-above';
const $7f8ee02f08da8eac$export$118b06a03e2c672f = 'reorder-below';
const $7f8ee02f08da8eac$export$5b388ccfa29be01 = -1;
const $7f8ee02f08da8eac$export$f6d7582f33b86010 = 'COLUMN_PICKER_CONFIGURATION_CONTAINER';
const $7f8ee02f08da8eac$export$f92486d03c064eac = 'COLUMN_PICKER_ADD_COLUMN_CONTAINER';
const $7f8ee02f08da8eac$export$139bffb2a576e8c0 = 2;
const $7f8ee02f08da8eac$export$3b696b0ac06c2cc4 = 1;
const $7f8ee02f08da8eac$export$6ba5aaedfd1b5319 = 2000;
const $7f8ee02f08da8eac$export$1bc2edb2aa5e8282 = 'a_to_z';
const $7f8ee02f08da8eac$export$c7b524b6c48f8273 = 'z_to_a';
const $7f8ee02f08da8eac$export$9c60c93d5e95e80f = 'lowest_to_highest';
const $7f8ee02f08da8eac$export$476f4bdd6eba4fb2 = 'highest_to_lowest';
const $7f8ee02f08da8eac$export$fbcac9f513cf13f4 = 'oldest_to_newest';
const $7f8ee02f08da8eac$export$d3c0241ce8ae9a73 = 'newest_to_oldest';

});

parcelRegister("cm5lq", function(module, exports) {

$parcel$export(module.exports, "configurableChildIssuesPanelEntryPoint", () => $c172567089cdc56c$export$e5791bfbf3e1a041);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $2ortv = parcelRequire("2ortv");

const $c172567089cdc56c$export$e5791bfbf3e1a041 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("jHuXJ")).then((module)=>module.ConfigurableChildIssuesPanelWithEntryPoint), {
        moduleId: "466cfd1a"
    }),
    getPreloadProps: ({ variables: variables })=>({
            queries: {
                childIssuesData: {
                    options: {
                        fetchKey: 'issue',
                        fetchPolicy: 'store-or-network',
                        name: 'issueViewCommon'
                    },
                    parameters: $2ortv.default,
                    variables: variables
                }
            }
        })
});

});
parcelRegister("2ortv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b11aca1b1ae9dfc5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f7a36d45aea51582ba25a8d347010b36>>
 * @relayHash cb079b0f07ae149e9ece86c3d40cfa00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 63d545cc6c24d428e842f373820cdaaa0fd9304fc2792afe13bcf29634796d5d

var $gY76A = parcelRequire("gY76A");

var $5oQtH = parcelRequire("5oQtH");

var $6xRgy = parcelRequire("6xRgy");

var $iMyvd = parcelRequire("iMyvd");

var $k3PJZ = parcelRequire("k3PJZ");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $hBvdF = parcelRequire("hBvdF");

var $kEAO6 = parcelRequire("kEAO6");
const $b11aca1b1ae9dfc5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v15 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v16 = {
        "kind": "ScalarField",
        "name": "type"
    }, v17 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v18 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v20 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            v20 /*: any*/ 
        ]
    }, v22 = [
        v13 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = [
        v11 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v27 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            v18 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v27 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v29 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v30 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v31 = {
        "kind": "ScalarField",
        "name": "name"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v31 /*: any*/ ,
                                    v13 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v33 = {
        "kind": "ScalarField",
        "name": "value"
    }, v34 = [
        v33 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v35 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v36 = {
        "kind": "ClientExtension",
        "selections": [
            v35 /*: any*/ 
        ]
    }, v37 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v38 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v39 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v40 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v41 = {
        "kind": "ScalarField",
        "name": "text"
    }, v42 = {
        "kind": "InlineFragment",
        "selections": [
            v41 /*: any*/ ,
            v31 /*: any*/ ,
            v36 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v43 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v13 /*: any*/ 
        ]
    }, v44 = [
        v43 /*: any*/ 
    ], v45 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v46 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v13 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v47 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v49 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v50 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "concreteType": "JiraCascadingOption",
                        "kind": "LinkedField",
                        "name": "cascadingOption",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "parentOptionValue",
                                "plural": false,
                                "selections": v34 /*: any*/ 
                            },
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "childOptionValue",
                                "plural": false,
                                "selections": v34 /*: any*/ 
                            }
                        ]
                    },
                    v36 /*: any*/ 
                ],
                "type": "JiraCascadingSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "args": v37 /*: any*/ ,
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v38 /*: any*/ ,
                                            v39 /*: any*/ ,
                                            v13 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedComponentsConnection(first:1000)"
                    },
                    v36 /*: any*/ 
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v40 /*: any*/ ,
                    v31 /*: any*/ ,
                    v36 /*: any*/ 
                ],
                "type": "JiraDateTimePickerField"
            },
            v42 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraCommentSummary",
                        "kind": "LinkedField",
                        "name": "commentSummary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "canAddComment"
                            },
                            v19 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraCommentSummaryField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "uri"
                    },
                    v36 /*: any*/ 
                ],
                "type": "JiraUrlField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "fieldOptions",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "fieldOption",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v44 /*: any*/ 
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v44 /*: any*/ 
                            },
                            v13 /*: any*/ ,
                            v45 /*: any*/ 
                        ]
                    },
                    v36 /*: any*/ 
                ],
                "type": "JiraSingleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v13 /*: any*/ ,
                                            v33 /*: any*/ ,
                                            v45 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v36 /*: any*/ 
                ],
                "type": "JiraMultipleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v46 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v36 /*: any*/ 
                ],
                "type": "JiraCheckboxesField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "concreteType": "JiraUserConnection",
                        "kind": "LinkedField",
                        "name": "selectedUsersConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v12 /*: any*/ ,
                                            v47 /*: any*/ ,
                                            v31 /*: any*/ ,
                                            v48 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v49 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "email"
                                                    }
                                                ],
                                                "type": "AtlassianAccountUser"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v36 /*: any*/ 
                ],
                "type": "JiraMultipleSelectUserPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "selectedTeam",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedName"
                            }
                        ]
                    },
                    v36 /*: any*/ 
                ],
                "type": "JiraTeamViewField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v13 /*: any*/ ,
                                    {
                                        "concreteType": "JiraEstimate",
                                        "kind": "LinkedField",
                                        "name": "originalEstimate",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "timeInSeconds"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "timeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingHoursPerDay"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingDaysPerWeek"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultFormat"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultUnit"
                                            }
                                        ]
                                    },
                                    v18 /*: any*/ ,
                                    v31 /*: any*/ ,
                                    v16 /*: any*/ ,
                                    v36 /*: any*/ 
                                ]
                            },
                            v13 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "selectedOption",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "label",
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            v13 /*: any*/ ,
                            v38 /*: any*/ 
                        ]
                    },
                    v36 /*: any*/ 
                ],
                "type": "JiraRadioSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "args": v37 /*: any*/ ,
                        "concreteType": "JiraVersionConnection",
                        "kind": "LinkedField",
                        "name": "selectedVersionsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v13 /*: any*/ ,
                                            v31 /*: any*/ ,
                                            v38 /*: any*/ ,
                                            v39 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedVersionsConnection(first:1000)"
                    },
                    v36 /*: any*/ 
                ],
                "type": "JiraMultipleVersionPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": v22 /*: any*/ 
                    },
                    {
                        "args": v37 /*: any*/ ,
                        "concreteType": "JiraGoalConnection",
                        "kind": "LinkedField",
                        "name": "selectedGoals",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v13 /*: any*/ ,
                                            v23 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v21 /*: any*/ 
                        ],
                        "storageKey": "selectedGoals(first:1000)"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            v20 /*: any*/ ,
                            v35 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraGoalsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "args": v37 /*: any*/ ,
                        "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                        "kind": "LinkedField",
                        "name": "confluenceRemoteIssueLinks",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v13 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "href"
                                            }
                                        ]
                                    }
                                ]
                            },
                            v19 /*: any*/ 
                        ],
                        "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                    },
                    v36 /*: any*/ 
                ],
                "type": "JiraConfluenceRemoteIssueLinksField"
            }
        ]
    }, v51 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v52 = [
        v31 /*: any*/ ,
        v13 /*: any*/ 
    ], v53 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "componentsOld",
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v52 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v41 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v54 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v55 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v31 /*: any*/ ,
            v54 /*: any*/ ,
            v36 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v56 = {
        "kind": "InlineFragment",
        "selections": [
            v40 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v57 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "summary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v13 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v58 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v59 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v26 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v27 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v61 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v37 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v31 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v19 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v31 /*: any*/ ,
            v36 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "small"
                            }
                        ]
                    },
                    v31 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v63 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v64 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v43 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v65 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v66 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v65 /*: any*/ ,
                    v31 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            },
            v13 /*: any*/ 
        ]
    }, v67 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v68 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v63 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v23 /*: any*/ ,
                            v64 /*: any*/ ,
                            v66 /*: any*/ ,
                            v63 /*: any*/ ,
                            v13 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v23 /*: any*/ ,
                            v64 /*: any*/ ,
                            v66 /*: any*/ ,
                            v63 /*: any*/ ,
                            v13 /*: any*/ ,
                            v25 /*: any*/ ,
                            v67 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v12 /*: any*/ ,
                                                    v13 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v18 /*: any*/ ,
                                                            v41 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v18 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v31 /*: any*/ ,
                                                                    v65 /*: any*/ ,
                                                                    v29 /*: any*/ ,
                                                                    v13 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v28 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v31 /*: any*/ ,
                    v36 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v69 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    v13 /*: any*/ 
                ]
            },
            v31 /*: any*/ ,
            v36 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v70 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v23 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v13 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v71 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v52 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v72 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v13 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v31 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v31 /*: any*/ ,
            v36 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v73 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    v47 /*: any*/ ,
                    v48 /*: any*/ ,
                    v31 /*: any*/ ,
                    v13 /*: any*/ ,
                    v49 /*: any*/ 
                ]
            },
            v31 /*: any*/ ,
            v54 /*: any*/ ,
            v36 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v74 = {
        "kind": "InlineFragment",
        "selections": [
            v31 /*: any*/ ,
            {
                "args": v37 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v52 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v75 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v76 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v65 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v77 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v67 /*: any*/ ,
                                            v23 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v12 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v27 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v13 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v13 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v13 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v78 = {
        "kind": "ScalarField",
        "name": "number"
    }, v79 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v78 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v78 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v78 /*: any*/ ,
                    v31 /*: any*/ ,
                    v36 /*: any*/ 
                ]
            },
            v36 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v80 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcusecsrforsupportedninfieldsrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "concreteType": "JiraGroupConnection",
                        "kind": "LinkedField",
                        "name": "selectedGroupsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGroupEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v13 /*: any*/ ,
                                            v31 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "groupId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v36 /*: any*/ 
                ],
                "type": "JiraMultipleGroupPickerField"
            }
        ]
    }, v81 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraFlag",
                        "kind": "LinkedField",
                        "name": "flag",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFlagged"
                            }
                        ]
                    }
                ],
                "type": "JiraFlagField"
            }
        ]
    }, v82 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        v15 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                v51 /*: any*/ ,
                                                v53 /*: any*/ ,
                                                v55 /*: any*/ ,
                                                v56 /*: any*/ ,
                                                v57 /*: any*/ ,
                                                v58 /*: any*/ ,
                                                v42 /*: any*/ ,
                                                v59 /*: any*/ ,
                                                v60 /*: any*/ ,
                                                v61 /*: any*/ ,
                                                v62 /*: any*/ ,
                                                v68 /*: any*/ ,
                                                v69 /*: any*/ ,
                                                v70 /*: any*/ ,
                                                v71 /*: any*/ ,
                                                v72 /*: any*/ ,
                                                v73 /*: any*/ ,
                                                v74 /*: any*/ ,
                                                v75 /*: any*/ ,
                                                v76 /*: any*/ ,
                                                v77 /*: any*/ ,
                                                v79 /*: any*/ ,
                                                v80 /*: any*/ ,
                                                v81 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v83 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ], v84 = [
        v19 /*: any*/ ,
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v23 /*: any*/ ,
                        v25 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isResolved"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "ids",
                                    "value": [
                                        "status"
                                    ]
                                }
                            ],
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fieldsById",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "fieldsById(ids:[\"status\"])"
                        },
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isHighlightedIssueRow"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "shouldQueryFieldSetsById",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "fieldSetIds",
                                                    "variableName": "fieldSetIds"
                                                },
                                                v14 /*: any*/ 
                                            ],
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSetsById",
                                            "plural": false,
                                            "selections": v82 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "shouldQueryFieldSetsById",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "context",
                                                    "variableName": "fieldSetsContext"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "filterId",
                                                    "variableName": "filterId"
                                                },
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "Variable",
                                                    "name": "namespace",
                                                    "variableName": "namespace"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "viewId",
                                                    "variableName": "viewId"
                                                }
                                            ],
                                            "concreteType": "JiraIssueFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSetsForIssueSearchView",
                                            "plural": false,
                                            "selections": v82 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                v21 /*: any*/ ,
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 500
                                }
                            ],
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSets",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldSetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldSet",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        v51 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v55 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v57 /*: any*/ ,
                                                                        v58 /*: any*/ ,
                                                                        v42 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v61 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v68 /*: any*/ ,
                                                                        v69 /*: any*/ ,
                                                                        v70 /*: any*/ ,
                                                                        v71 /*: any*/ ,
                                                                        v72 /*: any*/ ,
                                                                        v73 /*: any*/ ,
                                                                        v74 /*: any*/ ,
                                                                        v75 /*: any*/ ,
                                                                        v76 /*: any*/ ,
                                                                        v77 /*: any*/ ,
                                                                        v79 /*: any*/ ,
                                                                        v80 /*: any*/ ,
                                                                        v81 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOptionConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedOptions",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraOptionEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v46 /*: any*/ ,
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraCheckboxesField"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldOption",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v45 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraSingleSelectField"
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "fieldSets(first:500)"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "concreteType": "JiraIssueNavigatorPageInfo",
            "kind": "LinkedField",
            "name": "issueNavigatorPageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "firstIssuePosition"
                },
                {
                    "kind": "ScalarField",
                    "name": "lastIssuePosition"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "maxCursors",
                    "value": 7
                }
            ],
            "concreteType": "JiraPageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "first",
                    "plural": false,
                    "selections": v83 /*: any*/ 
                },
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "around",
                    "plural": true,
                    "selections": v83 /*: any*/ 
                },
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "last",
                    "plural": false,
                    "selections": v83 /*: any*/ 
                }
            ],
            "storageKey": "pageCursors(maxCursors:7)"
        },
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                v12 /*: any*/ 
            ]
        },
        v21 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_main_ConfigurableChildIssuesPanelWithEntryPointQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v10 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v9 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelissuesearchrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcusecsrforsupportedninfieldsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ui_main_ConfigurableChildIssuesPanelWithEntryPointQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v11 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "issueKey",
                                    "variableName": "issueKey"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "fieldSetViewQueryByProject",
                            "plural": false,
                            "selections": [
                                v12 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasDefaultFieldSets"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "fieldSetSelectedState": "SELECTED"
                                                    }
                                                },
                                                v14 /*: any*/ 
                                            ],
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                v16 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "jqlTerm"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isSortable"
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetPreferences",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "width"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsMetadata",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "canBeConfigured"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isPlaceHolderField"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldType",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v19 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraFieldSetView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v22 /*: any*/ ,
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "key",
                                            "variableName": "issueKey"
                                        }
                                    ],
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issueByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectField",
                                            "kind": "LinkedField",
                                            "name": "projectField",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": "editIssues",
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "type",
                                                                            "value": "EDIT_ISSUES"
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraProjectAction",
                                                                    "kind": "LinkedField",
                                                                    "name": "action",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canPerform"
                                                                        }
                                                                    ],
                                                                    "storageKey": "action(type:\"EDIT_ISSUES\")"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        v23 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ]
                                                },
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelissuesearchrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v24 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": v84 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelissuesearchrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v24 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearchStable",
                                    "plural": false,
                                    "selections": v84 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "63d545cc6c24d428e842f373820cdaaa0fd9304fc2792afe13bcf29634796d5d",
            "metadata": {},
            "name": "ui_main_ConfigurableChildIssuesPanelWithEntryPointQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelissuesearchrelayprovider": (0, $6xRgy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": (0, $iMyvd.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcusecsrforsupportedninfieldsrelayprovider": (0, $kEAO6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $gY76A.default)
            }
        }
    };
}();
$b11aca1b1ae9dfc5$var$node.hash = "eaf7d86aa3ee206c7a446414bfdf0a4f";
var $b11aca1b1ae9dfc5$export$2e2bcd8739ae039 = $b11aca1b1ae9dfc5$var$node;

});
parcelRegister("gY76A", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b308b8f84a32bbf$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $5b308b8f84a32bbf$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira_inline_field_config_gate');
    }
};

});

parcelRegister("5oQtH", function(module, exports) {

$parcel$export(module.exports, "default", () => $63783baa7e252f12$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
var $63783baa7e252f12$export$2e2bcd8739ae039 = {
    get () {
        return (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false);
    }
};

});

parcelRegister("6xRgy", function(module, exports) {

$parcel$export(module.exports, "default", () => $adb8238e9a0465f3$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $adb8238e9a0465f3$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira-issue-view-child-issues-panel-issuesearch');
    }
};

});

parcelRegister("iMyvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd515d7ae24a1bd$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $ccd515d7ae24a1bd$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira-issue-view-child-issues-panel-realtime-update');
    }
};

});

parcelRegister("k3PJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3084fb4096ebf03f$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3084fb4096ebf03f$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_list_reparenting');
    }
};

});

parcelRegister("l8ssf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6503957c800342c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $e6503957c800342c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jsc_inline_editing_flag_fix');
    }
};

});

parcelRegister("dttgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b98ab24c97dab4$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
const $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider = {
    get () {
        return (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes');
    }
};
var $c7b98ab24c97dab4$export$2e2bcd8739ae039 = $c7b98ab24c97dab4$var$JscM2FeChangesRelayProvider;

});

parcelRegister("kEAO6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c28e2aaadf05d1c$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $4c28e2aaadf05d1c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('use_csr_for_supported_nin_fields');
    }
};

});


parcelRegister("jHuXJ", function(module, exports) {

let $e57a0cf5e2446d3a$var$load = (parcelRequire("28QjX"))(4);


module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $e57a0cf5e2446d3a$var$load("lRPIy"),
            $e57a0cf5e2446d3a$var$load("fr9NE"),
            $e57a0cf5e2446d3a$var$load("cM9em"),
            $e57a0cf5e2446d3a$var$load("bYT2S"),
            $e57a0cf5e2446d3a$var$load("h2MrD")
        ]);
    }, function() {
        return Promise.all([
            $e57a0cf5e2446d3a$var$load("b9Yfw")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $e57a0cf5e2446d3a$var$load("2MFVe"),
            $e57a0cf5e2446d3a$var$load("fr9NE"),
            $e57a0cf5e2446d3a$var$load("cM9em")
        ]);
    }, function() {
        return Promise.all([
            $e57a0cf5e2446d3a$var$load("rwdx9")
        ]);
    }),
    $e57a0cf5e2446d3a$var$load("dsiAd"),
    $e57a0cf5e2446d3a$var$load("hPzOn"),
    $e57a0cf5e2446d3a$var$load("cM9em"),
    $e57a0cf5e2446d3a$var$load("fr9NE"),
    $e57a0cf5e2446d3a$var$load("h2MrD"),
    $e57a0cf5e2446d3a$var$load("bYT2S"),
    $e57a0cf5e2446d3a$var$load("iNhRd")
]).then(()=>parcelRequire('aggrw'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});



parcelRegister("aBLlP", function(module, exports) {

$parcel$export(module.exports, "JQLBuilder", () => $1838bdb8fc139aec$export$78a0bbe8e3931cd9);
$parcel$export(module.exports, "onChildIssueLoadErrorFlag", () => $1838bdb8fc139aec$export$24da1c8f64e28465);
$parcel$export(module.exports, "createConfigurableChildIssuesPanelQueryVariables", () => $1838bdb8fc139aec$export$589dd4cb8aa6c352);
$parcel$export(module.exports, "getColumnConfigOverrides", () => $1838bdb8fc139aec$export$ed1c7263cb52d59);

var $dAbX4 = parcelRequire("dAbX4");

var $6s1PB = parcelRequire("6s1PB");

var $czfFt = parcelRequire("czfFt");

var $65VLO = parcelRequire("65VLO");

var $fKCri = parcelRequire("fKCri");
const $1838bdb8fc139aec$export$78a0bbe8e3931cd9 = ({ issueKey: issueKey, hideDone: hideDone, sortColumn: sortColumn, sortDirection: sortDirection, filterSubtasks: filterSubtasks })=>{
    const hideDoneFlag = hideDone === 'true';
    const excludeDoneIssuesJQL = hideDoneFlag ? '& NOT statusCategory=Done' : '';
    // TODO: Remove on jira-issue-view-child-issues-panel-merge-subtasks cleanup
    const hierarchyLevelJQL = filterSubtasks === null ? '' : `AND hierarchyLevel ${filterSubtasks ? '=' : '!='} -1`;
    return `parent = ${issueKey} ${excludeDoneIssuesJQL} ${hierarchyLevelJQL} ORDER BY ${sortColumn} ${sortDirection}`;
};
const $1838bdb8fc139aec$export$24da1c8f64e28465 = {
    type: 'error',
    title: (0, $fKCri.default).getChildIssueErrorTitle,
    description: (0, $fKCri.default).getChildIssueErrorDescription,
    isAutoDismiss: true,
    messageId: 'issue-view-common-views.child-issues-panel.configurable-child-issues-panel.utils.on-child-issue-load-error-flag.error',
    messageType: 'transactional'
};
const $1838bdb8fc139aec$export$7cdcdac151ac7d0 = ({ cloudId: cloudId, activationId: activationId })=>(0, $dAbX4.JiraIssueSearchViewAri).create({
        siteId: cloudId,
        activationId: activationId,
        namespaceId: 'CHILD_ISSUE_PANEL',
        viewId: 'list_default'
    }).toString();
const $1838bdb8fc139aec$export$589dd4cb8aa6c352 = ({ cloudId: cloudId, jql: jql, fieldSetIds: fieldSetIds, issueKey: issueKey })=>({
        cloudId: cloudId,
        issueSearchInput: {
            jql: jql
        },
        amountOfColumns: (0, $czfFt.MAX_COLUMNS),
        namespace: 'CHILD_ISSUE_PANEL',
        options: {},
        fieldSetIds: fieldSetIds,
        shouldQueryFieldSetsById: false,
        fieldSetsInput: (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? {
            viewInput: {
                namespace: 'CHILD_ISSUE_PANEL',
                context: {
                    issueContext: {
                        issueKey: issueKey
                    }
                }
            }
        } : null,
        filterId: undefined,
        fieldSetsContext: {
            issueContext: {
                issueKey: issueKey
            }
        },
        issueKey: issueKey
    });
const $1838bdb8fc139aec$var$bigColumnWidth = {
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: 54,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY]: 80,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: 45,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).NUMBER]: 45,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).PRIORITY]: 112,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ASSIGNEE]: 132,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).STATUS]: 112,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: 32
};
const $1838bdb8fc139aec$var$smallColumnWidth = {
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: 40,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY]: 80,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: 45,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).NUMBER]: 45,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).PRIORITY]: 40,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ASSIGNEE]: 40,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).STATUS]: 112,
    [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: 32
};
const $1838bdb8fc139aec$export$40a21882702c4e3f = ()=>{
    return {
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_TYPE]: ()=>({
                defaultWidth: 40
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_KEY]: ()=>({
                defaultWidth: 80
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY]: ()=>({
                defaultWidth: 342
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).STORY_POINT_ESTIMATE]: ()=>({
                defaultWidth: 45
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).NUMBER]: ()=>({
                defaultWidth: 45
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).PRIORITY]: ()=>({
                defaultWidth: 40
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ASSIGNEE]: ()=>({
                defaultWidth: 40
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).STATUS]: ()=>({
                defaultWidth: 112
            }),
        [(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS]: ()=>({
                defaultWidth: 32
            })
    };
};
const $1838bdb8fc139aec$export$ed1c7263cb52d59 = (containerWidth)=>{
    if (!containerWidth) return $1838bdb8fc139aec$export$40a21882702c4e3f();
    const miscellaneous = 15; // padding/margin etc
    const calculatedResult = {};
    const defaultSummaryWidth = 342;
    // full page
    if (containerWidth > 760) {
        Object.entries($1838bdb8fc139aec$var$bigColumnWidth).forEach(([type, width])=>{
            calculatedResult[type] = ()=>({
                    defaultWidth: width
                });
        });
        calculatedResult[(0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY] = (allTypes)=>{
            if (allTypes) {
                const restWidth = allTypes.reduce((acc, current)=>{
                    return acc + ($1838bdb8fc139aec$var$bigColumnWidth[current] || 0);
                }, 0);
                return {
                    defaultWidth: Math.floor(containerWidth - restWidth - $1838bdb8fc139aec$var$bigColumnWidth[(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS] - miscellaneous)
                };
            }
            return {
                defaultWidth: defaultSummaryWidth
            };
        };
        return calculatedResult;
    }
    const minimumSummaryWidth = 100;
    Object.entries($1838bdb8fc139aec$var$smallColumnWidth).forEach(([type, width])=>{
        calculatedResult[type] = ()=>({
                defaultWidth: width
            });
    });
    calculatedResult[(0, $65VLO.KNOWN_COLUMN_TYPES).SUMMARY] = (allTypes)=>{
        if (allTypes) {
            const restWidth = allTypes.reduce((acc, current)=>{
                return acc + ($1838bdb8fc139aec$var$smallColumnWidth[current] || 0);
            }, 0);
            return {
                defaultWidth: Math.max(Math.floor(containerWidth - restWidth - $1838bdb8fc139aec$var$smallColumnWidth[(0, $65VLO.KNOWN_COLUMN_TYPES).ISSUE_OPERATIONS] - miscellaneous), minimumSummaryWidth)
            };
        }
        return {
            defaultWidth: defaultSummaryWidth
        };
    };
    return calculatedResult;
};

});
parcelRegister("dAbX4", function(module, exports) {

$parcel$export(module.exports, "JiraIssueSearchViewAri", () => $9e37e881d2d59c70$export$b7a84334c319d601);

var $4PmOU = parcelRequire("4PmOU");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/issue-search-view/manifest.ts
var $9e37e881d2d59c70$var$jiraIssueSearchViewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $4PmOU.JiraIssueSearchViewAriResourceOwner),
    resourceType: (0, $4PmOU.JiraIssueSearchViewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{namespaceId}/{viewId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        namespaceId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/,
        // eslint-disable-line no-useless-escape
        viewId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/issue-search-view/index.ts
var $9e37e881d2d59c70$export$b7a84334c319d601 = class _JiraIssueSearchViewAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._namespaceId = opts.resourceIdSegmentValues.namespaceId, this._viewId = opts.resourceIdSegmentValues.viewId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get namespaceId() {
        return this._namespaceId;
    }
    get viewId() {
        return this._viewId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $9e37e881d2d59c70$var$jiraIssueSearchViewAriStaticOpts.qualifier,
            platformQualifier: $9e37e881d2d59c70$var$jiraIssueSearchViewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $9e37e881d2d59c70$var$jiraIssueSearchViewAriStaticOpts.resourceOwner,
            resourceType: $9e37e881d2d59c70$var$jiraIssueSearchViewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.namespaceId}/${opts.viewId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                namespaceId: opts.namespaceId,
                viewId: opts.viewId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $9e37e881d2d59c70$var$jiraIssueSearchViewAriStaticOpts);
        return new _JiraIssueSearchViewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $9e37e881d2d59c70$var$jiraIssueSearchViewAriStaticOpts);
        return new _JiraIssueSearchViewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            namespaceId: this.namespaceId,
            viewId: this.viewId
        };
    }
};

});
parcelRegister("4PmOU", function(module, exports) {

$parcel$export(module.exports, "JiraIssueSearchViewAriResourceOwner", () => $383da075b23f9b48$export$b384c8149626eef3);
$parcel$export(module.exports, "JiraIssueSearchViewAriResourceType", () => $383da075b23f9b48$export$39acd84ed28a2768);
// src/jira/issue-search-view/types.ts
var $383da075b23f9b48$export$b384c8149626eef3 = "jira", $383da075b23f9b48$export$39acd84ed28a2768 = "issue-search-view";

});


parcelRegister("65VLO", function(module, exports) {

$parcel$export(module.exports, "KNOWN_COLUMN_TYPES", () => $1fec13ea3747c865$export$bbc2e8c301f97f97);
const $1fec13ea3747c865$export$bbc2e8c301f97f97 = {
    ASSIGNEE: 'assignee',
    CHECKBOX: '__issuetable_internal_checkbox',
    CHECKBOX_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    DESCRIPTION: 'description',
    ENVIRONMENT: 'environment',
    EXPAND_BUTTON: '__issuetable_internal_expand_button',
    ISSUE_KEY: 'issuekey',
    ISSUE_OPERATIONS: '__issuetable_internal_meatball',
    STATUS: 'status',
    SUMMARY: 'summary',
    ISSUE_TYPE: 'issuetype',
    RESOLUTION: 'resolution',
    PARENT: 'parent',
    LABELS: 'labels',
    COMPONENTS: 'components',
    FIX_VERSIONS: 'fixVersions',
    STATUS_CATEGORY: 'statusCategory',
    PROJECT: 'project',
    READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
    SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
    TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
    CREATED: 'created',
    RESOLUTION_DATE: 'resolutiondate',
    TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
    UPDATED: 'updated',
    DUE_DATE: 'duedate',
    REPORTER: 'reporter',
    CREATOR: 'creator',
    PRIORITY: 'priority',
    AFFECTS_VERSIONS: 'versions',
    REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
    NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
    STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points',
    USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
    CUSTOM_LABELS: 'com.atlassian.jira.plugin.system.customfieldtypes:labels',
    DATE_TIME: 'com.atlassian.jira.plugin.system.customfieldtypes:datetime',
    URL: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
    SINGLE_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
    MULTI_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    MULTI_USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker',
    TEAM: 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team',
    ORIGINAL_ESTIMATE: 'timeoriginalestimate',
    GOALS: 'com.atlassian.jira.plugin.system.customfieldtypes:goals',
    CASCADING_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
    CONFLUENCE_PAGES: 'confluenceRemoteIssueLinks',
    PEOPLE: 'com.atlassian.jira.plugin.system.customfieldtypes:people',
    DATE_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker'
};
const $1fec13ea3747c865$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $1fec13ea3747c865$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $1fec13ea3747c865$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';

});

parcelRegister("fKCri", function(module, exports) {

$parcel$export(module.exports, "default", () => $36a44fbc32badf5a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $36a44fbc32badf5a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    resetColumnsErrorTitle: {
        "id": "issue-view-common-views.child-issues-panel.configurable-child-issues-panel.reset-columns-error-title",
        "defaultMessage": "We couldn't restore the default columns"
    },
    getChildIssueErrorTitle: {
        "id": "issue-view-common-views.child-issues-panel.configurable-child-issues-panel.get-child-issue-error-title",
        "defaultMessage": "We couldn't get your child issues"
    },
    getChildIssueErrorDescription: {
        "id": "issue-view-common-views.child-issues-panel.configurable-child-issues-panel.get-child-issue-error-description",
        "defaultMessage": "Refresh and try again."
    },
    getChildIssueErrorTitleIssueTermRefresh: {
        "id": "issue-view-common-views.child-issues-panel.configurable-child-issues-panel.get-child-issue-error-title-issue-term-refresh",
        "defaultMessage": "We couldn't get your child work items"
    }
});

});



parcelRegister("GgZWv", function(module, exports) {

$parcel$export(module.exports, "HideDoneIconWithToolTip", () => $4a8cf5e6f7c3d079$export$3b6bd60b0a496586);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $6tRzQ = parcelRequire("6tRzQ");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $i1cfO = parcelRequire("i1cfO");
const $4a8cf5e6f7c3d079$export$3b6bd60b0a496586 = ({ completedChildIssuesCount: completedChildIssuesCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const TooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $i1cfO.default).hideDoneTooltipHiddenIssuesIssueTermRefresh : (0, $i1cfO.default).hideDoneTooltipHiddenIssues, {
        completedChildIssuesCount: completedChildIssuesCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), formatMessage((0, $i1cfO.default).hideDoneTooltipHowToShow));
    const oldHideDoneIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a8cf5e6f7c3d079$var$OldHideDoneInfoIconButton, {
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
        color: "var(--ds-icon-subtle, #626F86)",
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $i1cfO.default).hideDoneIconLabelIssueTermRefresh : (0, $i1cfO.default).hideDoneIconLabel, {
            completedChildIssuesCount: completedChildIssuesCount
        }),
        LEGACY_size: "large"
    }));
    const newHideDoneIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a8cf5e6f7c3d079$var$HideDoneInfoIconButton, {
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
        color: "var(--ds-icon-subtle, #626F86)",
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $i1cfO.default).hideDoneIconLabelIssueTermRefresh : (0, $i1cfO.default).hideDoneIconLabel, {
            completedChildIssuesCount: completedChildIssuesCount
        }),
        LEGACY_size: "large"
    }));
    const HideDoneIcon = (0, $6s1PB.expVal)('jira-issue-view-chin-ga', 'isChildIssueEnabled', false) ? newHideDoneIcon : oldHideDoneIcon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: TooltipContent
    }, HideDoneIcon);
};
// Currently using line version of the Editor Info Icon
// as global info icon only has filled and no line version.
// https://product-fabric.atlassian.net/browse/DSP-11293
// Width changes is necessary here since editor icon is smaller
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a8cf5e6f7c3d079$var$OldHideDoneInfoIconButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1ul9 _19lcglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a8cf5e6f7c3d079$var$HideDoneInfoIconButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2hwx12x7 _19lcglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i1cfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bab08a2aec974dcf$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $bab08a2aec974dcf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hideDoneTooltipHiddenIssues: {
        "id": "issue.views.common.child-issues-panel.hide-done-icon.tooltip.hidden-issues-info",
        "defaultMessage": "{completedChildIssuesCount, plural, one {# Done issue is hidden} other {# Done issues are hidden}}. "
    },
    hideDoneTooltipHowToShow: {
        "id": "issue.views.common.child-issues-panel.hide-done-icon.tooltip.how-to-show-info",
        "defaultMessage": "To show, go to (\u2022\u2022\u2022)"
    },
    hideDoneIconLabel: {
        "id": "issue.views.common.child-issues-panel.hide-done-icon.label",
        "defaultMessage": "Hide done information - {completedChildIssuesCount, plural, one {# Done issue is hidden} other {# Done issues are hidden}}. To show, go to (\u2022\u2022\u2022)"
    },
    hideDoneTooltipHiddenIssuesIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.hide-done-icon.tooltip.hidden-issues-info-issue-term-refresh",
        "defaultMessage": "{completedChildIssuesCount, plural, one {# Done work item is hidden} other {# Done work items are hidden}}. "
    },
    hideDoneIconLabelIssueTermRefresh: {
        "id": "issue.views.common.child-issues-panel.hide-done-icon.label-issue-term-refresh",
        "defaultMessage": "Hide done information - {completedChildIssuesCount, plural, one {# Done work item is hidden} other {# Done work items are hidden}}. To show, go to (\u2022\u2022\u2022)"
    }
});

});






//# sourceMappingURL=old.84b506e1.js.map
